/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const kuma = $root.kuma = (() => {

    /**
     * Namespace kuma.
     * @exports kuma
     * @namespace
     */
    const kuma = {};

    kuma.jp = (function() {

        /**
         * Namespace jp.
         * @memberof kuma
         * @namespace
         */
        const jp = {};

        jp.protobuf = (function() {

            /**
             * Namespace protobuf.
             * @memberof kuma.jp
             * @namespace
             */
            const protobuf = {};

            protobuf.common = (function() {

                /**
                 * Namespace common.
                 * @memberof kuma.jp.protobuf
                 * @namespace
                 */
                const common = {};

                /**
                 * AnnounceDisplayLocation enum.
                 * @name kuma.jp.protobuf.common.AnnounceDisplayLocation
                 * @enum {number}
                 * @property {number} TOP=0 TOP value
                 * @property {number} MIDDLE=1 MIDDLE value
                 * @property {number} LOW=2 LOW value
                 */
                common.AnnounceDisplayLocation = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "TOP"] = 0;
                    values[valuesById[1] = "MIDDLE"] = 1;
                    values[valuesById[2] = "LOW"] = 2;
                    return values;
                })();

                /**
                 * CampPitDialogType enum.
                 * @name kuma.jp.protobuf.common.CampPitDialogType
                 * @enum {number}
                 * @property {number} PRE=0 PRE value
                 * @property {number} PRE_AND_OK=1 PRE_AND_OK value
                 * @property {number} OK=2 OK value
                 * @property {number} INVALID=-2 INVALID value
                 */
                common.CampPitDialogType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "PRE"] = 0;
                    values[valuesById[1] = "PRE_AND_OK"] = 1;
                    values[valuesById[2] = "OK"] = 2;
                    values[valuesById[-2] = "INVALID"] = -2;
                    return values;
                })();

                common.KumaError = (function() {

                    /**
                     * Properties of a KumaError.
                     * @memberof kuma.jp.protobuf.common
                     * @interface IKumaError
                     * @property {number|null} [code] KumaError code
                     * @property {string|null} ["class"] KumaError class
                     * @property {string|null} [title] KumaError title
                     * @property {string|null} [info] KumaError info
                     * @property {string|null} [stackTrace] KumaError stackTrace
                     */

                    /**
                     * Constructs a new KumaError.
                     * @memberof kuma.jp.protobuf.common
                     * @classdesc Represents a KumaError.
                     * @implements IKumaError
                     * @constructor
                     * @param {kuma.jp.protobuf.common.IKumaError=} [properties] Properties to set
                     */
                    function KumaError(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * KumaError code.
                     * @member {number} code
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     */
                    KumaError.prototype.code = 0;

                    /**
                     * KumaError class.
                     * @member {string} class
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     */
                    KumaError.prototype["class"] = "";

                    /**
                     * KumaError title.
                     * @member {string} title
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     */
                    KumaError.prototype.title = "";

                    /**
                     * KumaError info.
                     * @member {string} info
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     */
                    KumaError.prototype.info = "";

                    /**
                     * KumaError stackTrace.
                     * @member {string} stackTrace
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     */
                    KumaError.prototype.stackTrace = "";

                    /**
                     * Creates a new KumaError instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {kuma.jp.protobuf.common.IKumaError=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.common.KumaError} KumaError instance
                     */
                    KumaError.create = function create(properties) {
                        return new KumaError(properties);
                    };

                    /**
                     * Encodes the specified KumaError message. Does not implicitly {@link kuma.jp.protobuf.common.KumaError.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {kuma.jp.protobuf.common.IKumaError} message KumaError message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaError.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message["class"] != null && Object.hasOwnProperty.call(message, "class"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message["class"]);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
                        if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.info);
                        if (message.stackTrace != null && Object.hasOwnProperty.call(message, "stackTrace"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.stackTrace);
                        return writer;
                    };

                    /**
                     * Encodes the specified KumaError message, length delimited. Does not implicitly {@link kuma.jp.protobuf.common.KumaError.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {kuma.jp.protobuf.common.IKumaError} message KumaError message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaError.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a KumaError message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.common.KumaError} KumaError
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaError.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.common.KumaError();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message["class"] = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.title = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.info = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.stackTrace = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a KumaError message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.common.KumaError} KumaError
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaError.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a KumaError message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    KumaError.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isInteger(message.code))
                                return "code: integer expected";
                        if (message["class"] != null && message.hasOwnProperty("class"))
                            if (!$util.isString(message["class"]))
                                return "class: string expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.info != null && message.hasOwnProperty("info"))
                            if (!$util.isString(message.info))
                                return "info: string expected";
                        if (message.stackTrace != null && message.hasOwnProperty("stackTrace"))
                            if (!$util.isString(message.stackTrace))
                                return "stackTrace: string expected";
                        return null;
                    };

                    /**
                     * Creates a KumaError message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.common.KumaError} KumaError
                     */
                    KumaError.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.common.KumaError)
                            return object;
                        let message = new $root.kuma.jp.protobuf.common.KumaError();
                        if (object.code != null)
                            message.code = object.code | 0;
                        if (object["class"] != null)
                            message["class"] = String(object["class"]);
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.info != null)
                            message.info = String(object.info);
                        if (object.stackTrace != null)
                            message.stackTrace = String(object.stackTrace);
                        return message;
                    };

                    /**
                     * Creates a plain object from a KumaError message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {kuma.jp.protobuf.common.KumaError} message KumaError
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    KumaError.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = 0;
                            object["class"] = "";
                            object.title = "";
                            object.info = "";
                            object.stackTrace = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message["class"] != null && message.hasOwnProperty("class"))
                            object["class"] = message["class"];
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.info != null && message.hasOwnProperty("info"))
                            object.info = message.info;
                        if (message.stackTrace != null && message.hasOwnProperty("stackTrace"))
                            object.stackTrace = message.stackTrace;
                        return object;
                    };

                    /**
                     * Converts this KumaError to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    KumaError.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for KumaError
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.common.KumaError
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    KumaError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.common.KumaError";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.common.KumaError.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=990002 COMMAND_NO value
                     */
                    KumaError.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[990002] = "COMMAND_NO"] = 990002;
                        return values;
                    })();

                    return KumaError;
                })();

                common.Maintenance = (function() {

                    /**
                     * Properties of a Maintenance.
                     * @memberof kuma.jp.protobuf.common
                     * @interface IMaintenance
                     * @property {string|null} [message] Maintenance message
                     */

                    /**
                     * Constructs a new Maintenance.
                     * @memberof kuma.jp.protobuf.common
                     * @classdesc Represents a Maintenance.
                     * @implements IMaintenance
                     * @constructor
                     * @param {kuma.jp.protobuf.common.IMaintenance=} [properties] Properties to set
                     */
                    function Maintenance(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Maintenance message.
                     * @member {string} message
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @instance
                     */
                    Maintenance.prototype.message = "";

                    /**
                     * Creates a new Maintenance instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {kuma.jp.protobuf.common.IMaintenance=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.common.Maintenance} Maintenance instance
                     */
                    Maintenance.create = function create(properties) {
                        return new Maintenance(properties);
                    };

                    /**
                     * Encodes the specified Maintenance message. Does not implicitly {@link kuma.jp.protobuf.common.Maintenance.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {kuma.jp.protobuf.common.IMaintenance} message Maintenance message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Maintenance.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Maintenance message, length delimited. Does not implicitly {@link kuma.jp.protobuf.common.Maintenance.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {kuma.jp.protobuf.common.IMaintenance} message Maintenance message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Maintenance.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Maintenance message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.common.Maintenance} Maintenance
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Maintenance.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.common.Maintenance();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Maintenance message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.common.Maintenance} Maintenance
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Maintenance.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Maintenance message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Maintenance.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Maintenance message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.common.Maintenance} Maintenance
                     */
                    Maintenance.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.common.Maintenance)
                            return object;
                        let message = new $root.kuma.jp.protobuf.common.Maintenance();
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Maintenance message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {kuma.jp.protobuf.common.Maintenance} message Maintenance
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Maintenance.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.message = "";
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Maintenance to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Maintenance.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Maintenance
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.common.Maintenance
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Maintenance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.common.Maintenance";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.common.Maintenance.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=990001 COMMAND_NO value
                     */
                    Maintenance.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[990001] = "COMMAND_NO"] = 990001;
                        return values;
                    })();

                    return Maintenance;
                })();

                /**
                 * PuriContentType enum.
                 * @name kuma.jp.protobuf.common.PuriContentType
                 * @enum {number}
                 * @property {number} OUT_JSON=0 OUT_JSON value
                 * @property {number} GRAFFITI_JSON=1 GRAFFITI_JSON value
                 * @property {number} FINAL_IMAGE=2 FINAL_IMAGE value
                 * @property {number} THUMBNAIL=3 THUMBNAIL value
                 * @property {number} BACKGROUND=4 BACKGROUND value
                 * @property {number} ORIGINAL_IMAGE=5 ORIGINAL_IMAGE value
                 * @property {number} OUT=6 OUT value
                 * @property {number} OUT_MASK=7 OUT_MASK value
                 * @property {number} OUT_SHADOW=8 OUT_SHADOW value
                 * @property {number} MAKEUP=9 MAKEUP value
                 * @property {number} MAKEUP_MASK=10 MAKEUP_MASK value
                 * @property {number} GRAFFITI=11 GRAFFITI value
                 * @property {number} GRAFFITI_MASK=12 GRAFFITI_MASK value
                 * @property {number} LIP_C0=13 LIP_C0 value
                 * @property {number} LIP_C1=14 LIP_C1 value
                 * @property {number} LIP_MA0=15 LIP_MA0 value
                 * @property {number} LIP_MA1=16 LIP_MA1 value
                 * @property {number} LIP_MB0=17 LIP_MB0 value
                 * @property {number} LIP_MB1=18 LIP_MB1 value
                 * @property {number} LIP_MC0=19 LIP_MC0 value
                 * @property {number} LIP_MC1=20 LIP_MC1 value
                 * @property {number} LIP_HA0=21 LIP_HA0 value
                 * @property {number} LIP_HA1=22 LIP_HA1 value
                 * @property {number} LIP_HB0=23 LIP_HB0 value
                 * @property {number} LIP_HB1=24 LIP_HB1 value
                 * @property {number} LIP_HC0=25 LIP_HC0 value
                 * @property {number} LIP_HC1=26 LIP_HC1 value
                 * @property {number} CHEEK_MA0=27 CHEEK_MA0 value
                 * @property {number} CHEEK_MA1=28 CHEEK_MA1 value
                 * @property {number} CHEEK_MB0=29 CHEEK_MB0 value
                 * @property {number} CHEEK_MB1=30 CHEEK_MB1 value
                 * @property {number} CHEEK_MC0=31 CHEEK_MC0 value
                 * @property {number} CHEEK_MC1=32 CHEEK_MC1 value
                 * @property {number} ORIGINAL_VIDEO=33 ORIGINAL_VIDEO value
                 * @property {number} FINAL_VIDEO=34 FINAL_VIDEO value
                 * @property {number} THUMBNAIL_BASE=35 THUMBNAIL_BASE value
                 * @property {number} MAKEUP1=36 MAKEUP1 value
                 * @property {number} MAKEUP1_MASK=37 MAKEUP1_MASK value
                 * @property {number} MAKEUP2=38 MAKEUP2 value
                 * @property {number} MAKEUP2_MASK=39 MAKEUP2_MASK value
                 * @property {number} MAKEUP_JSON=40 MAKEUP_JSON value
                 * @property {number} COLORLINER1_MASK=41 COLORLINER1_MASK value
                 * @property {number} COLORLINER2_MASK=42 COLORLINER2_MASK value
                 * @property {number} COLORLINER3_MASK=43 COLORLINER3_MASK value
                 * @property {number} COLORLINER4_MASK=44 COLORLINER4_MASK value
                 * @property {number} COLORDODGE=45 COLORDODGE value
                 * @property {number} MAKEUP_NOBG=46 MAKEUP_NOBG value
                 * @property {number} MAKEUP_NOBG_MASK=47 MAKEUP_NOBG_MASK value
                 * @property {number} MOSAIC=48 MOSAIC value
                 * @property {number} COLLABO=49 COLLABO value
                 * @property {number} BLENDORDER=50 BLENDORDER value
                 * @property {number} COPY_RIGHT=51 COPY_RIGHT value
                 * @property {number} CAMERA_FRAME=52 CAMERA_FRAME value
                 * @property {number} FINALBMGYYY_IMAGE=53 FINALBMGYYY_IMAGE value
                 * @property {number} FINALBMGYYN_IMAGE=54 FINALBMGYYN_IMAGE value
                 * @property {number} FINALBMGYNY_IMAGE=55 FINALBMGYNY_IMAGE value
                 * @property {number} FINALBMGYNN_IMAGE=56 FINALBMGYNN_IMAGE value
                 * @property {number} FINALBMGNYY_IMAGE=57 FINALBMGNYY_IMAGE value
                 * @property {number} FINALBMGNYN_IMAGE=58 FINALBMGNYN_IMAGE value
                 * @property {number} FINALBMGNNY_IMAGE=59 FINALBMGNNY_IMAGE value
                 * @property {number} FINALBMGNNN_IMAGE=60 FINALBMGNNN_IMAGE value
                 */
                common.PuriContentType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "OUT_JSON"] = 0;
                    values[valuesById[1] = "GRAFFITI_JSON"] = 1;
                    values[valuesById[2] = "FINAL_IMAGE"] = 2;
                    values[valuesById[3] = "THUMBNAIL"] = 3;
                    values[valuesById[4] = "BACKGROUND"] = 4;
                    values[valuesById[5] = "ORIGINAL_IMAGE"] = 5;
                    values[valuesById[6] = "OUT"] = 6;
                    values[valuesById[7] = "OUT_MASK"] = 7;
                    values[valuesById[8] = "OUT_SHADOW"] = 8;
                    values[valuesById[9] = "MAKEUP"] = 9;
                    values[valuesById[10] = "MAKEUP_MASK"] = 10;
                    values[valuesById[11] = "GRAFFITI"] = 11;
                    values[valuesById[12] = "GRAFFITI_MASK"] = 12;
                    values[valuesById[13] = "LIP_C0"] = 13;
                    values[valuesById[14] = "LIP_C1"] = 14;
                    values[valuesById[15] = "LIP_MA0"] = 15;
                    values[valuesById[16] = "LIP_MA1"] = 16;
                    values[valuesById[17] = "LIP_MB0"] = 17;
                    values[valuesById[18] = "LIP_MB1"] = 18;
                    values[valuesById[19] = "LIP_MC0"] = 19;
                    values[valuesById[20] = "LIP_MC1"] = 20;
                    values[valuesById[21] = "LIP_HA0"] = 21;
                    values[valuesById[22] = "LIP_HA1"] = 22;
                    values[valuesById[23] = "LIP_HB0"] = 23;
                    values[valuesById[24] = "LIP_HB1"] = 24;
                    values[valuesById[25] = "LIP_HC0"] = 25;
                    values[valuesById[26] = "LIP_HC1"] = 26;
                    values[valuesById[27] = "CHEEK_MA0"] = 27;
                    values[valuesById[28] = "CHEEK_MA1"] = 28;
                    values[valuesById[29] = "CHEEK_MB0"] = 29;
                    values[valuesById[30] = "CHEEK_MB1"] = 30;
                    values[valuesById[31] = "CHEEK_MC0"] = 31;
                    values[valuesById[32] = "CHEEK_MC1"] = 32;
                    values[valuesById[33] = "ORIGINAL_VIDEO"] = 33;
                    values[valuesById[34] = "FINAL_VIDEO"] = 34;
                    values[valuesById[35] = "THUMBNAIL_BASE"] = 35;
                    values[valuesById[36] = "MAKEUP1"] = 36;
                    values[valuesById[37] = "MAKEUP1_MASK"] = 37;
                    values[valuesById[38] = "MAKEUP2"] = 38;
                    values[valuesById[39] = "MAKEUP2_MASK"] = 39;
                    values[valuesById[40] = "MAKEUP_JSON"] = 40;
                    values[valuesById[41] = "COLORLINER1_MASK"] = 41;
                    values[valuesById[42] = "COLORLINER2_MASK"] = 42;
                    values[valuesById[43] = "COLORLINER3_MASK"] = 43;
                    values[valuesById[44] = "COLORLINER4_MASK"] = 44;
                    values[valuesById[45] = "COLORDODGE"] = 45;
                    values[valuesById[46] = "MAKEUP_NOBG"] = 46;
                    values[valuesById[47] = "MAKEUP_NOBG_MASK"] = 47;
                    values[valuesById[48] = "MOSAIC"] = 48;
                    values[valuesById[49] = "COLLABO"] = 49;
                    values[valuesById[50] = "BLENDORDER"] = 50;
                    values[valuesById[51] = "COPY_RIGHT"] = 51;
                    values[valuesById[52] = "CAMERA_FRAME"] = 52;
                    values[valuesById[53] = "FINALBMGYYY_IMAGE"] = 53;
                    values[valuesById[54] = "FINALBMGYYN_IMAGE"] = 54;
                    values[valuesById[55] = "FINALBMGYNY_IMAGE"] = 55;
                    values[valuesById[56] = "FINALBMGYNN_IMAGE"] = 56;
                    values[valuesById[57] = "FINALBMGNYY_IMAGE"] = 57;
                    values[valuesById[58] = "FINALBMGNYN_IMAGE"] = 58;
                    values[valuesById[59] = "FINALBMGNNY_IMAGE"] = 59;
                    values[valuesById[60] = "FINALBMGNNN_IMAGE"] = 60;
                    return values;
                })();

                return common;
            })();

            protobuf.web = (function() {

                /**
                 * Namespace web.
                 * @memberof kuma.jp.protobuf
                 * @namespace
                 */
                const web = {};

                web.AlbumPuriContentUpdateReq = (function() {

                    /**
                     * Properties of an AlbumPuriContentUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAlbumPuriContentUpdateReq
                     * @property {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.ActionType|null} [actionType] AlbumPuriContentUpdateReq actionType
                     * @property {number|Long|null} [contentId] AlbumPuriContentUpdateReq contentId
                     */

                    /**
                     * Constructs a new AlbumPuriContentUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AlbumPuriContentUpdateReq.
                     * @implements IAlbumPuriContentUpdateReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateReq=} [properties] Properties to set
                     */
                    function AlbumPuriContentUpdateReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AlbumPuriContentUpdateReq actionType.
                     * @member {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.ActionType} actionType
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @instance
                     */
                    AlbumPuriContentUpdateReq.prototype.actionType = 0;

                    /**
                     * AlbumPuriContentUpdateReq contentId.
                     * @member {number|Long} contentId
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @instance
                     */
                    AlbumPuriContentUpdateReq.prototype.contentId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new AlbumPuriContentUpdateReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq} AlbumPuriContentUpdateReq instance
                     */
                    AlbumPuriContentUpdateReq.create = function create(properties) {
                        return new AlbumPuriContentUpdateReq(properties);
                    };

                    /**
                     * Encodes the specified AlbumPuriContentUpdateReq message. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateReq} message AlbumPuriContentUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriContentUpdateReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.actionType);
                        if (message.contentId != null && Object.hasOwnProperty.call(message, "contentId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.contentId);
                        return writer;
                    };

                    /**
                     * Encodes the specified AlbumPuriContentUpdateReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateReq} message AlbumPuriContentUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriContentUpdateReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AlbumPuriContentUpdateReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq} AlbumPuriContentUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriContentUpdateReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.actionType = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.contentId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AlbumPuriContentUpdateReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq} AlbumPuriContentUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriContentUpdateReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AlbumPuriContentUpdateReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AlbumPuriContentUpdateReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            switch (message.actionType) {
                            default:
                                return "actionType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.contentId != null && message.hasOwnProperty("contentId"))
                            if (!$util.isInteger(message.contentId) && !(message.contentId && $util.isInteger(message.contentId.low) && $util.isInteger(message.contentId.high)))
                                return "contentId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates an AlbumPuriContentUpdateReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq} AlbumPuriContentUpdateReq
                     */
                    AlbumPuriContentUpdateReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateReq();
                        switch (object.actionType) {
                        default:
                            if (typeof object.actionType === "number") {
                                message.actionType = object.actionType;
                                break;
                            }
                            break;
                        case "ADD":
                        case 0:
                            message.actionType = 0;
                            break;
                        case "DELETE":
                        case 1:
                            message.actionType = 1;
                            break;
                        }
                        if (object.contentId != null)
                            if ($util.Long)
                                (message.contentId = $util.Long.fromValue(object.contentId)).unsigned = false;
                            else if (typeof object.contentId === "string")
                                message.contentId = parseInt(object.contentId, 10);
                            else if (typeof object.contentId === "number")
                                message.contentId = object.contentId;
                            else if (typeof object.contentId === "object")
                                message.contentId = new $util.LongBits(object.contentId.low >>> 0, object.contentId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from an AlbumPuriContentUpdateReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.AlbumPuriContentUpdateReq} message AlbumPuriContentUpdateReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AlbumPuriContentUpdateReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.actionType = options.enums === String ? "ADD" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.contentId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contentId = options.longs === String ? "0" : 0;
                        }
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = options.enums === String ? $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.ActionType[message.actionType] === undefined ? message.actionType : $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.ActionType[message.actionType] : message.actionType;
                        if (message.contentId != null && message.hasOwnProperty("contentId"))
                            if (typeof message.contentId === "number")
                                object.contentId = options.longs === String ? String(message.contentId) : message.contentId;
                            else
                                object.contentId = options.longs === String ? $util.Long.prototype.toString.call(message.contentId) : options.longs === Number ? new $util.LongBits(message.contentId.low >>> 0, message.contentId.high >>> 0).toNumber() : message.contentId;
                        return object;
                    };

                    /**
                     * Converts this AlbumPuriContentUpdateReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AlbumPuriContentUpdateReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AlbumPuriContentUpdateReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AlbumPuriContentUpdateReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AlbumPuriContentUpdateReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20204 COMMAND_NO value
                     */
                    AlbumPuriContentUpdateReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20204] = "COMMAND_NO"] = 20204;
                        return values;
                    })();

                    /**
                     * ActionType enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriContentUpdateReq.ActionType
                     * @enum {number}
                     * @property {number} ADD=0 ADD value
                     * @property {number} DELETE=1 DELETE value
                     */
                    AlbumPuriContentUpdateReq.ActionType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ADD"] = 0;
                        values[valuesById[1] = "DELETE"] = 1;
                        return values;
                    })();

                    return AlbumPuriContentUpdateReq;
                })();

                web.AlbumPuriContentUpdateResp = (function() {

                    /**
                     * Properties of an AlbumPuriContentUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAlbumPuriContentUpdateResp
                     * @property {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.Status|null} [status] AlbumPuriContentUpdateResp status
                     */

                    /**
                     * Constructs a new AlbumPuriContentUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AlbumPuriContentUpdateResp.
                     * @implements IAlbumPuriContentUpdateResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateResp=} [properties] Properties to set
                     */
                    function AlbumPuriContentUpdateResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AlbumPuriContentUpdateResp status.
                     * @member {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.Status} status
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @instance
                     */
                    AlbumPuriContentUpdateResp.prototype.status = 0;

                    /**
                     * Creates a new AlbumPuriContentUpdateResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp} AlbumPuriContentUpdateResp instance
                     */
                    AlbumPuriContentUpdateResp.create = function create(properties) {
                        return new AlbumPuriContentUpdateResp(properties);
                    };

                    /**
                     * Encodes the specified AlbumPuriContentUpdateResp message. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateResp} message AlbumPuriContentUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriContentUpdateResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified AlbumPuriContentUpdateResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriContentUpdateResp} message AlbumPuriContentUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriContentUpdateResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AlbumPuriContentUpdateResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp} AlbumPuriContentUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriContentUpdateResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AlbumPuriContentUpdateResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp} AlbumPuriContentUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriContentUpdateResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AlbumPuriContentUpdateResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AlbumPuriContentUpdateResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates an AlbumPuriContentUpdateResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp} AlbumPuriContentUpdateResp
                     */
                    AlbumPuriContentUpdateResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an AlbumPuriContentUpdateResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.AlbumPuriContentUpdateResp} message AlbumPuriContentUpdateResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AlbumPuriContentUpdateResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this AlbumPuriContentUpdateResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AlbumPuriContentUpdateResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AlbumPuriContentUpdateResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AlbumPuriContentUpdateResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AlbumPuriContentUpdateResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AlbumPuriContentUpdateResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20205 COMMAND_NO value
                     */
                    AlbumPuriContentUpdateResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20205] = "COMMAND_NO"] = 20205;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriContentUpdateResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    AlbumPuriContentUpdateResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return AlbumPuriContentUpdateResp;
                })();

                web.AlbumPuriListReq = (function() {

                    /**
                     * Properties of an AlbumPuriListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAlbumPuriListReq
                     */

                    /**
                     * Constructs a new AlbumPuriListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AlbumPuriListReq.
                     * @implements IAlbumPuriListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListReq=} [properties] Properties to set
                     */
                    function AlbumPuriListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new AlbumPuriListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListReq} AlbumPuriListReq instance
                     */
                    AlbumPuriListReq.create = function create(properties) {
                        return new AlbumPuriListReq(properties);
                    };

                    /**
                     * Encodes the specified AlbumPuriListReq message. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListReq} message AlbumPuriListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified AlbumPuriListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListReq} message AlbumPuriListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AlbumPuriListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListReq} AlbumPuriListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AlbumPuriListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AlbumPuriListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListReq} AlbumPuriListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AlbumPuriListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AlbumPuriListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates an AlbumPuriListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListReq} AlbumPuriListReq
                     */
                    AlbumPuriListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AlbumPuriListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.AlbumPuriListReq();
                    };

                    /**
                     * Creates a plain object from an AlbumPuriListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.AlbumPuriListReq} message AlbumPuriListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AlbumPuriListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this AlbumPuriListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AlbumPuriListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AlbumPuriListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AlbumPuriListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AlbumPuriListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=21000 COMMAND_NO value
                     */
                    AlbumPuriListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[21000] = "COMMAND_NO"] = 21000;
                        return values;
                    })();

                    return AlbumPuriListReq;
                })();

                web.AlbumPuriListResp = (function() {

                    /**
                     * Properties of an AlbumPuriListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAlbumPuriListResp
                     * @property {Array.<kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem>|null} [items] AlbumPuriListResp items
                     */

                    /**
                     * Constructs a new AlbumPuriListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AlbumPuriListResp.
                     * @implements IAlbumPuriListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListResp=} [properties] Properties to set
                     */
                    function AlbumPuriListResp(properties) {
                        this.items = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AlbumPuriListResp items.
                     * @member {Array.<kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem>} items
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @instance
                     */
                    AlbumPuriListResp.prototype.items = $util.emptyArray;

                    /**
                     * Creates a new AlbumPuriListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListResp} AlbumPuriListResp instance
                     */
                    AlbumPuriListResp.create = function create(properties) {
                        return new AlbumPuriListResp(properties);
                    };

                    /**
                     * Encodes the specified AlbumPuriListResp message. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListResp} message AlbumPuriListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (let i = 0; i < message.items.length; ++i)
                                $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified AlbumPuriListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAlbumPuriListResp} message AlbumPuriListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AlbumPuriListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AlbumPuriListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListResp} AlbumPuriListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AlbumPuriListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.items && message.items.length))
                                        message.items = [];
                                    message.items.push($root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AlbumPuriListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListResp} AlbumPuriListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AlbumPuriListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AlbumPuriListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AlbumPuriListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (let i = 0; i < message.items.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates an AlbumPuriListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AlbumPuriListResp} AlbumPuriListResp
                     */
                    AlbumPuriListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AlbumPuriListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.AlbumPuriListResp();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".kuma.jp.protobuf.web.AlbumPuriListResp.items: array expected");
                            message.items = [];
                            for (let i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.AlbumPuriListResp.items: object expected");
                                message.items[i] = $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an AlbumPuriListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.AlbumPuriListResp} message AlbumPuriListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AlbumPuriListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (let j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.toObject(message.items[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this AlbumPuriListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AlbumPuriListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AlbumPuriListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AlbumPuriListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AlbumPuriListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AlbumPuriListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=21001 COMMAND_NO value
                     */
                    AlbumPuriListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[21001] = "COMMAND_NO"] = 21001;
                        return values;
                    })();

                    AlbumPuriListResp.PuriItem = (function() {

                        /**
                         * Properties of a PuriItem.
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                         * @interface IPuriItem
                         * @property {number|Long|null} [id] PuriItem id
                         * @property {number|Long|null} [sheetId] PuriItem sheetId
                         * @property {string|null} [shopName] PuriItem shopName
                         * @property {string|null} [arcadeName] PuriItem arcadeName
                         * @property {boolean|null} [surprise] PuriItem surprise
                         * @property {number|Long|null} [time] PuriItem time
                         * @property {number|null} [seqIndex] PuriItem seqIndex
                         * @property {number|null} [arcadeId] PuriItem arcadeId
                         * @property {boolean|null} [enableColorLiner] PuriItem enableColorLiner
                         * @property {boolean|null} [surprise2] PuriItem surprise2
                         * @property {number|null} [purimottoId] PuriItem purimottoId
                         */

                        /**
                         * Constructs a new PuriItem.
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp
                         * @classdesc Represents a PuriItem.
                         * @implements IPuriItem
                         * @constructor
                         * @param {kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem=} [properties] Properties to set
                         */
                        function PuriItem(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * PuriItem id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * PuriItem sheetId.
                         * @member {number|Long} sheetId
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.sheetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * PuriItem shopName.
                         * @member {string} shopName
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.shopName = "";

                        /**
                         * PuriItem arcadeName.
                         * @member {string} arcadeName
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.arcadeName = "";

                        /**
                         * PuriItem surprise.
                         * @member {boolean} surprise
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.surprise = false;

                        /**
                         * PuriItem time.
                         * @member {number|Long} time
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * PuriItem seqIndex.
                         * @member {number} seqIndex
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.seqIndex = 0;

                        /**
                         * PuriItem arcadeId.
                         * @member {number} arcadeId
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.arcadeId = 0;

                        /**
                         * PuriItem enableColorLiner.
                         * @member {boolean} enableColorLiner
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.enableColorLiner = false;

                        /**
                         * PuriItem surprise2.
                         * @member {boolean} surprise2
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.surprise2 = false;

                        /**
                         * PuriItem purimottoId.
                         * @member {number} purimottoId
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         */
                        PuriItem.prototype.purimottoId = 0;

                        /**
                         * Creates a new PuriItem instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem} PuriItem instance
                         */
                        PuriItem.create = function create(properties) {
                            return new PuriItem(properties);
                        };

                        /**
                         * Encodes the specified PuriItem message. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem} message PuriItem message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PuriItem.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.sheetId != null && Object.hasOwnProperty.call(message, "sheetId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sheetId);
                            if (message.shopName != null && Object.hasOwnProperty.call(message, "shopName"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.shopName);
                            if (message.arcadeName != null && Object.hasOwnProperty.call(message, "arcadeName"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.arcadeName);
                            if (message.surprise != null && Object.hasOwnProperty.call(message, "surprise"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.surprise);
                            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.time);
                            if (message.seqIndex != null && Object.hasOwnProperty.call(message, "seqIndex"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.seqIndex);
                            if (message.arcadeId != null && Object.hasOwnProperty.call(message, "arcadeId"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.arcadeId);
                            if (message.enableColorLiner != null && Object.hasOwnProperty.call(message, "enableColorLiner"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.enableColorLiner);
                            if (message.surprise2 != null && Object.hasOwnProperty.call(message, "surprise2"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.surprise2);
                            if (message.purimottoId != null && Object.hasOwnProperty.call(message, "purimottoId"))
                                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.purimottoId);
                            return writer;
                        };

                        /**
                         * Encodes the specified PuriItem message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {kuma.jp.protobuf.web.AlbumPuriListResp.IPuriItem} message PuriItem message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PuriItem.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a PuriItem message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem} PuriItem
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PuriItem.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.sheetId = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.shopName = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.arcadeName = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.surprise = reader.bool();
                                        break;
                                    }
                                case 6: {
                                        message.time = reader.int64();
                                        break;
                                    }
                                case 7: {
                                        message.seqIndex = reader.int32();
                                        break;
                                    }
                                case 8: {
                                        message.arcadeId = reader.int32();
                                        break;
                                    }
                                case 9: {
                                        message.enableColorLiner = reader.bool();
                                        break;
                                    }
                                case 10: {
                                        message.surprise2 = reader.bool();
                                        break;
                                    }
                                case 11: {
                                        message.purimottoId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a PuriItem message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem} PuriItem
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PuriItem.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a PuriItem message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PuriItem.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.sheetId != null && message.hasOwnProperty("sheetId"))
                                if (!$util.isInteger(message.sheetId) && !(message.sheetId && $util.isInteger(message.sheetId.low) && $util.isInteger(message.sheetId.high)))
                                    return "sheetId: integer|Long expected";
                            if (message.shopName != null && message.hasOwnProperty("shopName"))
                                if (!$util.isString(message.shopName))
                                    return "shopName: string expected";
                            if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                                if (!$util.isString(message.arcadeName))
                                    return "arcadeName: string expected";
                            if (message.surprise != null && message.hasOwnProperty("surprise"))
                                if (typeof message.surprise !== "boolean")
                                    return "surprise: boolean expected";
                            if (message.time != null && message.hasOwnProperty("time"))
                                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                                    return "time: integer|Long expected";
                            if (message.seqIndex != null && message.hasOwnProperty("seqIndex"))
                                if (!$util.isInteger(message.seqIndex))
                                    return "seqIndex: integer expected";
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                if (!$util.isInteger(message.arcadeId))
                                    return "arcadeId: integer expected";
                            if (message.enableColorLiner != null && message.hasOwnProperty("enableColorLiner"))
                                if (typeof message.enableColorLiner !== "boolean")
                                    return "enableColorLiner: boolean expected";
                            if (message.surprise2 != null && message.hasOwnProperty("surprise2"))
                                if (typeof message.surprise2 !== "boolean")
                                    return "surprise2: boolean expected";
                            if (message.purimottoId != null && message.hasOwnProperty("purimottoId"))
                                if (!$util.isInteger(message.purimottoId))
                                    return "purimottoId: integer expected";
                            return null;
                        };

                        /**
                         * Creates a PuriItem message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem} PuriItem
                         */
                        PuriItem.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.sheetId != null)
                                if ($util.Long)
                                    (message.sheetId = $util.Long.fromValue(object.sheetId)).unsigned = false;
                                else if (typeof object.sheetId === "string")
                                    message.sheetId = parseInt(object.sheetId, 10);
                                else if (typeof object.sheetId === "number")
                                    message.sheetId = object.sheetId;
                                else if (typeof object.sheetId === "object")
                                    message.sheetId = new $util.LongBits(object.sheetId.low >>> 0, object.sheetId.high >>> 0).toNumber();
                            if (object.shopName != null)
                                message.shopName = String(object.shopName);
                            if (object.arcadeName != null)
                                message.arcadeName = String(object.arcadeName);
                            if (object.surprise != null)
                                message.surprise = Boolean(object.surprise);
                            if (object.time != null)
                                if ($util.Long)
                                    (message.time = $util.Long.fromValue(object.time)).unsigned = false;
                                else if (typeof object.time === "string")
                                    message.time = parseInt(object.time, 10);
                                else if (typeof object.time === "number")
                                    message.time = object.time;
                                else if (typeof object.time === "object")
                                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
                            if (object.seqIndex != null)
                                message.seqIndex = object.seqIndex | 0;
                            if (object.arcadeId != null)
                                message.arcadeId = object.arcadeId | 0;
                            if (object.enableColorLiner != null)
                                message.enableColorLiner = Boolean(object.enableColorLiner);
                            if (object.surprise2 != null)
                                message.surprise2 = Boolean(object.surprise2);
                            if (object.purimottoId != null)
                                message.purimottoId = object.purimottoId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a PuriItem message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem} message PuriItem
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PuriItem.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sheetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sheetId = options.longs === String ? "0" : 0;
                                object.shopName = "";
                                object.arcadeName = "";
                                object.surprise = false;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.time = options.longs === String ? "0" : 0;
                                object.seqIndex = 0;
                                object.arcadeId = 0;
                                object.enableColorLiner = false;
                                object.surprise2 = false;
                                object.purimottoId = 0;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.sheetId != null && message.hasOwnProperty("sheetId"))
                                if (typeof message.sheetId === "number")
                                    object.sheetId = options.longs === String ? String(message.sheetId) : message.sheetId;
                                else
                                    object.sheetId = options.longs === String ? $util.Long.prototype.toString.call(message.sheetId) : options.longs === Number ? new $util.LongBits(message.sheetId.low >>> 0, message.sheetId.high >>> 0).toNumber() : message.sheetId;
                            if (message.shopName != null && message.hasOwnProperty("shopName"))
                                object.shopName = message.shopName;
                            if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                                object.arcadeName = message.arcadeName;
                            if (message.surprise != null && message.hasOwnProperty("surprise"))
                                object.surprise = message.surprise;
                            if (message.time != null && message.hasOwnProperty("time"))
                                if (typeof message.time === "number")
                                    object.time = options.longs === String ? String(message.time) : message.time;
                                else
                                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
                            if (message.seqIndex != null && message.hasOwnProperty("seqIndex"))
                                object.seqIndex = message.seqIndex;
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                object.arcadeId = message.arcadeId;
                            if (message.enableColorLiner != null && message.hasOwnProperty("enableColorLiner"))
                                object.enableColorLiner = message.enableColorLiner;
                            if (message.surprise2 != null && message.hasOwnProperty("surprise2"))
                                object.surprise2 = message.surprise2;
                            if (message.purimottoId != null && message.hasOwnProperty("purimottoId"))
                                object.purimottoId = message.purimottoId;
                            return object;
                        };

                        /**
                         * Converts this PuriItem to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PuriItem.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for PuriItem
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        PuriItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.AlbumPuriListResp.PuriItem";
                        };

                        return PuriItem;
                    })();

                    return AlbumPuriListResp;
                })();

                web.AnnounceReq = (function() {

                    /**
                     * Properties of an AnnounceReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAnnounceReq
                     */

                    /**
                     * Constructs a new AnnounceReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AnnounceReq.
                     * @implements IAnnounceReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAnnounceReq=} [properties] Properties to set
                     */
                    function AnnounceReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new AnnounceReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AnnounceReq} AnnounceReq instance
                     */
                    AnnounceReq.create = function create(properties) {
                        return new AnnounceReq(properties);
                    };

                    /**
                     * Encodes the specified AnnounceReq message. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceReq} message AnnounceReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnnounceReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified AnnounceReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceReq} message AnnounceReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnnounceReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AnnounceReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AnnounceReq} AnnounceReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnnounceReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AnnounceReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AnnounceReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AnnounceReq} AnnounceReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnnounceReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AnnounceReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AnnounceReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates an AnnounceReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AnnounceReq} AnnounceReq
                     */
                    AnnounceReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AnnounceReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.AnnounceReq();
                    };

                    /**
                     * Creates a plain object from an AnnounceReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {kuma.jp.protobuf.web.AnnounceReq} message AnnounceReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AnnounceReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this AnnounceReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AnnounceReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AnnounceReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AnnounceReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AnnounceReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AnnounceReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AnnounceReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40800 COMMAND_NO value
                     */
                    AnnounceReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40800] = "COMMAND_NO"] = 40800;
                        return values;
                    })();

                    return AnnounceReq;
                })();

                web.AnnounceResp = (function() {

                    /**
                     * Properties of an AnnounceResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IAnnounceResp
                     * @property {kuma.jp.protobuf.web.AnnounceResp.Status|null} [status] AnnounceResp status
                     * @property {Array.<kuma.jp.protobuf.web.AnnounceResp.IAnnounce>|null} [announces] AnnounceResp announces
                     */

                    /**
                     * Constructs a new AnnounceResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents an AnnounceResp.
                     * @implements IAnnounceResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IAnnounceResp=} [properties] Properties to set
                     */
                    function AnnounceResp(properties) {
                        this.announces = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AnnounceResp status.
                     * @member {kuma.jp.protobuf.web.AnnounceResp.Status} status
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @instance
                     */
                    AnnounceResp.prototype.status = 0;

                    /**
                     * AnnounceResp announces.
                     * @member {Array.<kuma.jp.protobuf.web.AnnounceResp.IAnnounce>} announces
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @instance
                     */
                    AnnounceResp.prototype.announces = $util.emptyArray;

                    /**
                     * Creates a new AnnounceResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.AnnounceResp} AnnounceResp instance
                     */
                    AnnounceResp.create = function create(properties) {
                        return new AnnounceResp(properties);
                    };

                    /**
                     * Encodes the specified AnnounceResp message. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceResp} message AnnounceResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnnounceResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.announces != null && message.announces.length)
                            for (let i = 0; i < message.announces.length; ++i)
                                $root.kuma.jp.protobuf.web.AnnounceResp.Announce.encode(message.announces[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified AnnounceResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IAnnounceResp} message AnnounceResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnnounceResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AnnounceResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.AnnounceResp} AnnounceResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnnounceResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AnnounceResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.announces && message.announces.length))
                                        message.announces = [];
                                    message.announces.push($root.kuma.jp.protobuf.web.AnnounceResp.Announce.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AnnounceResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.AnnounceResp} AnnounceResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnnounceResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AnnounceResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AnnounceResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.announces != null && message.hasOwnProperty("announces")) {
                            if (!Array.isArray(message.announces))
                                return "announces: array expected";
                            for (let i = 0; i < message.announces.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.AnnounceResp.Announce.verify(message.announces[i]);
                                if (error)
                                    return "announces." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates an AnnounceResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.AnnounceResp} AnnounceResp
                     */
                    AnnounceResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.AnnounceResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.AnnounceResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.announces) {
                            if (!Array.isArray(object.announces))
                                throw TypeError(".kuma.jp.protobuf.web.AnnounceResp.announces: array expected");
                            message.announces = [];
                            for (let i = 0; i < object.announces.length; ++i) {
                                if (typeof object.announces[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.AnnounceResp.announces: object expected");
                                message.announces[i] = $root.kuma.jp.protobuf.web.AnnounceResp.Announce.fromObject(object.announces[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an AnnounceResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {kuma.jp.protobuf.web.AnnounceResp} message AnnounceResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AnnounceResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.announces = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.AnnounceResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.AnnounceResp.Status[message.status] : message.status;
                        if (message.announces && message.announces.length) {
                            object.announces = [];
                            for (let j = 0; j < message.announces.length; ++j)
                                object.announces[j] = $root.kuma.jp.protobuf.web.AnnounceResp.Announce.toObject(message.announces[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this AnnounceResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AnnounceResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AnnounceResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.AnnounceResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AnnounceResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.AnnounceResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.AnnounceResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40801 COMMAND_NO value
                     */
                    AnnounceResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40801] = "COMMAND_NO"] = 40801;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.AnnounceResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    AnnounceResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    AnnounceResp.Announce = (function() {

                        /**
                         * Properties of an Announce.
                         * @memberof kuma.jp.protobuf.web.AnnounceResp
                         * @interface IAnnounce
                         * @property {number|null} [id] Announce id
                         * @property {number|null} [type] Announce type
                         * @property {number|null} [optionId01] Announce optionId01
                         * @property {string|null} [title] Announce title
                         * @property {string|null} [imgPath] Announce imgPath
                         * @property {number|null} [priority] Announce priority
                         * @property {number|Long|null} [startTime] Announce startTime
                         * @property {number|Long|null} [endTime] Announce endTime
                         * @property {kuma.jp.protobuf.common.AnnounceDisplayLocation|null} [displayLocation] Announce displayLocation
                         * @property {string|null} [url] Announce url
                         */

                        /**
                         * Constructs a new Announce.
                         * @memberof kuma.jp.protobuf.web.AnnounceResp
                         * @classdesc Represents an Announce.
                         * @implements IAnnounce
                         * @constructor
                         * @param {kuma.jp.protobuf.web.AnnounceResp.IAnnounce=} [properties] Properties to set
                         */
                        function Announce(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Announce id.
                         * @member {number} id
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.id = 0;

                        /**
                         * Announce type.
                         * @member {number} type
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.type = 0;

                        /**
                         * Announce optionId01.
                         * @member {number} optionId01
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.optionId01 = 0;

                        /**
                         * Announce title.
                         * @member {string} title
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.title = "";

                        /**
                         * Announce imgPath.
                         * @member {string} imgPath
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.imgPath = "";

                        /**
                         * Announce priority.
                         * @member {number} priority
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.priority = 0;

                        /**
                         * Announce startTime.
                         * @member {number|Long} startTime
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Announce endTime.
                         * @member {number|Long} endTime
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Announce displayLocation.
                         * @member {kuma.jp.protobuf.common.AnnounceDisplayLocation} displayLocation
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.displayLocation = 0;

                        /**
                         * Announce url.
                         * @member {string} url
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         */
                        Announce.prototype.url = "";

                        /**
                         * Creates a new Announce instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {kuma.jp.protobuf.web.AnnounceResp.IAnnounce=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.AnnounceResp.Announce} Announce instance
                         */
                        Announce.create = function create(properties) {
                            return new Announce(properties);
                        };

                        /**
                         * Encodes the specified Announce message. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceResp.Announce.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {kuma.jp.protobuf.web.AnnounceResp.IAnnounce} message Announce message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Announce.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                            if (message.optionId01 != null && Object.hasOwnProperty.call(message, "optionId01"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.optionId01);
                            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
                            if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.imgPath);
                            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.priority);
                            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.startTime);
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.endTime);
                            if (message.displayLocation != null && Object.hasOwnProperty.call(message, "displayLocation"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.displayLocation);
                            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.url);
                            return writer;
                        };

                        /**
                         * Encodes the specified Announce message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.AnnounceResp.Announce.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {kuma.jp.protobuf.web.AnnounceResp.IAnnounce} message Announce message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Announce.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Announce message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.AnnounceResp.Announce} Announce
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Announce.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.AnnounceResp.Announce();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.optionId01 = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.title = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.imgPath = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.priority = reader.int32();
                                        break;
                                    }
                                case 7: {
                                        message.startTime = reader.int64();
                                        break;
                                    }
                                case 8: {
                                        message.endTime = reader.int64();
                                        break;
                                    }
                                case 9: {
                                        message.displayLocation = reader.int32();
                                        break;
                                    }
                                case 10: {
                                        message.url = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Announce message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.AnnounceResp.Announce} Announce
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Announce.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Announce message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Announce.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id))
                                    return "id: integer expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                if (!$util.isInteger(message.type))
                                    return "type: integer expected";
                            if (message.optionId01 != null && message.hasOwnProperty("optionId01"))
                                if (!$util.isInteger(message.optionId01))
                                    return "optionId01: integer expected";
                            if (message.title != null && message.hasOwnProperty("title"))
                                if (!$util.isString(message.title))
                                    return "title: string expected";
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                if (!$util.isString(message.imgPath))
                                    return "imgPath: string expected";
                            if (message.priority != null && message.hasOwnProperty("priority"))
                                if (!$util.isInteger(message.priority))
                                    return "priority: integer expected";
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                    return "startTime: integer|Long expected";
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                    return "endTime: integer|Long expected";
                            if (message.displayLocation != null && message.hasOwnProperty("displayLocation"))
                                switch (message.displayLocation) {
                                default:
                                    return "displayLocation: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.url != null && message.hasOwnProperty("url"))
                                if (!$util.isString(message.url))
                                    return "url: string expected";
                            return null;
                        };

                        /**
                         * Creates an Announce message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.AnnounceResp.Announce} Announce
                         */
                        Announce.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.AnnounceResp.Announce)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.AnnounceResp.Announce();
                            if (object.id != null)
                                message.id = object.id | 0;
                            if (object.type != null)
                                message.type = object.type | 0;
                            if (object.optionId01 != null)
                                message.optionId01 = object.optionId01 | 0;
                            if (object.title != null)
                                message.title = String(object.title);
                            if (object.imgPath != null)
                                message.imgPath = String(object.imgPath);
                            if (object.priority != null)
                                message.priority = object.priority | 0;
                            if (object.startTime != null)
                                if ($util.Long)
                                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                                else if (typeof object.startTime === "string")
                                    message.startTime = parseInt(object.startTime, 10);
                                else if (typeof object.startTime === "number")
                                    message.startTime = object.startTime;
                                else if (typeof object.startTime === "object")
                                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                            if (object.endTime != null)
                                if ($util.Long)
                                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                                else if (typeof object.endTime === "string")
                                    message.endTime = parseInt(object.endTime, 10);
                                else if (typeof object.endTime === "number")
                                    message.endTime = object.endTime;
                                else if (typeof object.endTime === "object")
                                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                            switch (object.displayLocation) {
                            default:
                                if (typeof object.displayLocation === "number") {
                                    message.displayLocation = object.displayLocation;
                                    break;
                                }
                                break;
                            case "TOP":
                            case 0:
                                message.displayLocation = 0;
                                break;
                            case "MIDDLE":
                            case 1:
                                message.displayLocation = 1;
                                break;
                            case "LOW":
                            case 2:
                                message.displayLocation = 2;
                                break;
                            }
                            if (object.url != null)
                                message.url = String(object.url);
                            return message;
                        };

                        /**
                         * Creates a plain object from an Announce message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {kuma.jp.protobuf.web.AnnounceResp.Announce} message Announce
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Announce.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.id = 0;
                                object.type = 0;
                                object.optionId01 = 0;
                                object.title = "";
                                object.imgPath = "";
                                object.priority = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startTime = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endTime = options.longs === String ? "0" : 0;
                                object.displayLocation = options.enums === String ? "TOP" : 0;
                                object.url = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = message.type;
                            if (message.optionId01 != null && message.hasOwnProperty("optionId01"))
                                object.optionId01 = message.optionId01;
                            if (message.title != null && message.hasOwnProperty("title"))
                                object.title = message.title;
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                object.imgPath = message.imgPath;
                            if (message.priority != null && message.hasOwnProperty("priority"))
                                object.priority = message.priority;
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (typeof message.startTime === "number")
                                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                                else
                                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (typeof message.endTime === "number")
                                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                                else
                                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                            if (message.displayLocation != null && message.hasOwnProperty("displayLocation"))
                                object.displayLocation = options.enums === String ? $root.kuma.jp.protobuf.common.AnnounceDisplayLocation[message.displayLocation] === undefined ? message.displayLocation : $root.kuma.jp.protobuf.common.AnnounceDisplayLocation[message.displayLocation] : message.displayLocation;
                            if (message.url != null && message.hasOwnProperty("url"))
                                object.url = message.url;
                            return object;
                        };

                        /**
                         * Converts this Announce to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Announce.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Announce
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.AnnounceResp.Announce
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Announce.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.AnnounceResp.Announce";
                        };

                        return Announce;
                    })();

                    return AnnounceResp;
                })();

                web.BannerListReq = (function() {

                    /**
                     * Properties of a BannerListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBannerListReq
                     * @property {kuma.jp.protobuf.web.BannerListReq.Type|null} [type] BannerListReq type
                     */

                    /**
                     * Constructs a new BannerListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BannerListReq.
                     * @implements IBannerListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBannerListReq=} [properties] Properties to set
                     */
                    function BannerListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BannerListReq type.
                     * @member {kuma.jp.protobuf.web.BannerListReq.Type} type
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @instance
                     */
                    BannerListReq.prototype.type = 0;

                    /**
                     * Creates a new BannerListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BannerListReq} BannerListReq instance
                     */
                    BannerListReq.create = function create(properties) {
                        return new BannerListReq(properties);
                    };

                    /**
                     * Encodes the specified BannerListReq message. Does not implicitly {@link kuma.jp.protobuf.web.BannerListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListReq} message BannerListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        return writer;
                    };

                    /**
                     * Encodes the specified BannerListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BannerListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListReq} message BannerListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BannerListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BannerListReq} BannerListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BannerListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.type = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BannerListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BannerListReq} BannerListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BannerListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BannerListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a BannerListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BannerListReq} BannerListReq
                     */
                    BannerListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BannerListReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BannerListReq();
                        switch (object.type) {
                        default:
                            if (typeof object.type === "number") {
                                message.type = object.type;
                                break;
                            }
                            break;
                        case "HOME":
                        case 0:
                            message.type = 0;
                            break;
                        case "PURIDL":
                        case 1:
                            message.type = 1;
                            break;
                        case "ALBUM":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BannerListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BannerListReq} message BannerListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BannerListReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.type = options.enums === String ? "HOME" : 0;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.kuma.jp.protobuf.web.BannerListReq.Type[message.type] === undefined ? message.type : $root.kuma.jp.protobuf.web.BannerListReq.Type[message.type] : message.type;
                        return object;
                    };

                    /**
                     * Converts this BannerListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BannerListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BannerListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BannerListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BannerListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BannerListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BannerListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40000 COMMAND_NO value
                     */
                    BannerListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40000] = "COMMAND_NO"] = 40000;
                        return values;
                    })();

                    /**
                     * Type enum.
                     * @name kuma.jp.protobuf.web.BannerListReq.Type
                     * @enum {number}
                     * @property {number} HOME=0 HOME value
                     * @property {number} PURIDL=1 PURIDL value
                     * @property {number} ALBUM=2 ALBUM value
                     */
                    BannerListReq.Type = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "HOME"] = 0;
                        values[valuesById[1] = "PURIDL"] = 1;
                        values[valuesById[2] = "ALBUM"] = 2;
                        return values;
                    })();

                    return BannerListReq;
                })();

                web.BannerListResp = (function() {

                    /**
                     * Properties of a BannerListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBannerListResp
                     * @property {kuma.jp.protobuf.web.BannerListResp.Status|null} [status] BannerListResp status
                     * @property {Array.<kuma.jp.protobuf.web.BannerListResp.IBanner>|null} [bannerList] BannerListResp bannerList
                     */

                    /**
                     * Constructs a new BannerListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BannerListResp.
                     * @implements IBannerListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBannerListResp=} [properties] Properties to set
                     */
                    function BannerListResp(properties) {
                        this.bannerList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BannerListResp status.
                     * @member {kuma.jp.protobuf.web.BannerListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @instance
                     */
                    BannerListResp.prototype.status = 0;

                    /**
                     * BannerListResp bannerList.
                     * @member {Array.<kuma.jp.protobuf.web.BannerListResp.IBanner>} bannerList
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @instance
                     */
                    BannerListResp.prototype.bannerList = $util.emptyArray;

                    /**
                     * Creates a new BannerListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BannerListResp} BannerListResp instance
                     */
                    BannerListResp.create = function create(properties) {
                        return new BannerListResp(properties);
                    };

                    /**
                     * Encodes the specified BannerListResp message. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListResp} message BannerListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.bannerList != null && message.bannerList.length)
                            for (let i = 0; i < message.bannerList.length; ++i)
                                $root.kuma.jp.protobuf.web.BannerListResp.Banner.encode(message.bannerList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BannerListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBannerListResp} message BannerListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BannerListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BannerListResp} BannerListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BannerListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.bannerList && message.bannerList.length))
                                        message.bannerList = [];
                                    message.bannerList.push($root.kuma.jp.protobuf.web.BannerListResp.Banner.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BannerListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BannerListResp} BannerListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BannerListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BannerListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.bannerList != null && message.hasOwnProperty("bannerList")) {
                            if (!Array.isArray(message.bannerList))
                                return "bannerList: array expected";
                            for (let i = 0; i < message.bannerList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.BannerListResp.Banner.verify(message.bannerList[i]);
                                if (error)
                                    return "bannerList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a BannerListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BannerListResp} BannerListResp
                     */
                    BannerListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BannerListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BannerListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.bannerList) {
                            if (!Array.isArray(object.bannerList))
                                throw TypeError(".kuma.jp.protobuf.web.BannerListResp.bannerList: array expected");
                            message.bannerList = [];
                            for (let i = 0; i < object.bannerList.length; ++i) {
                                if (typeof object.bannerList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.BannerListResp.bannerList: object expected");
                                message.bannerList[i] = $root.kuma.jp.protobuf.web.BannerListResp.Banner.fromObject(object.bannerList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BannerListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BannerListResp} message BannerListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BannerListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.bannerList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BannerListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BannerListResp.Status[message.status] : message.status;
                        if (message.bannerList && message.bannerList.length) {
                            object.bannerList = [];
                            for (let j = 0; j < message.bannerList.length; ++j)
                                object.bannerList[j] = $root.kuma.jp.protobuf.web.BannerListResp.Banner.toObject(message.bannerList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this BannerListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BannerListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BannerListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BannerListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BannerListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BannerListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BannerListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40001 COMMAND_NO value
                     */
                    BannerListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40001] = "COMMAND_NO"] = 40001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BannerListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    BannerListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    BannerListResp.Image = (function() {

                        /**
                         * Properties of an Image.
                         * @memberof kuma.jp.protobuf.web.BannerListResp
                         * @interface IImage
                         * @property {number|Long|null} [id] Image id
                         * @property {string|null} [path] Image path
                         * @property {number|Long|null} [width] Image width
                         * @property {number|Long|null} [height] Image height
                         * @property {string|null} [thumbnail] Image thumbnail
                         */

                        /**
                         * Constructs a new Image.
                         * @memberof kuma.jp.protobuf.web.BannerListResp
                         * @classdesc Represents an Image.
                         * @implements IImage
                         * @constructor
                         * @param {kuma.jp.protobuf.web.BannerListResp.IImage=} [properties] Properties to set
                         */
                        function Image(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Image id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         */
                        Image.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Image path.
                         * @member {string} path
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         */
                        Image.prototype.path = "";

                        /**
                         * Image width.
                         * @member {number|Long} width
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         */
                        Image.prototype.width = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Image height.
                         * @member {number|Long} height
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         */
                        Image.prototype.height = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Image thumbnail.
                         * @member {string} thumbnail
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         */
                        Image.prototype.thumbnail = "";

                        /**
                         * Creates a new Image instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IImage=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Image} Image instance
                         */
                        Image.create = function create(properties) {
                            return new Image(properties);
                        };

                        /**
                         * Encodes the specified Image message. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.Image.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IImage} message Image message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Image.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                            if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.width);
                            if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.height);
                            if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.thumbnail);
                            return writer;
                        };

                        /**
                         * Encodes the specified Image message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.Image.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IImage} message Image message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Image.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Image message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Image} Image
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Image.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BannerListResp.Image();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.path = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.width = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.height = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.thumbnail = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Image message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Image} Image
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Image.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Image message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Image.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.path != null && message.hasOwnProperty("path"))
                                if (!$util.isString(message.path))
                                    return "path: string expected";
                            if (message.width != null && message.hasOwnProperty("width"))
                                if (!$util.isInteger(message.width) && !(message.width && $util.isInteger(message.width.low) && $util.isInteger(message.width.high)))
                                    return "width: integer|Long expected";
                            if (message.height != null && message.hasOwnProperty("height"))
                                if (!$util.isInteger(message.height) && !(message.height && $util.isInteger(message.height.low) && $util.isInteger(message.height.high)))
                                    return "height: integer|Long expected";
                            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                                if (!$util.isString(message.thumbnail))
                                    return "thumbnail: string expected";
                            return null;
                        };

                        /**
                         * Creates an Image message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Image} Image
                         */
                        Image.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.BannerListResp.Image)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.BannerListResp.Image();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.path != null)
                                message.path = String(object.path);
                            if (object.width != null)
                                if ($util.Long)
                                    (message.width = $util.Long.fromValue(object.width)).unsigned = false;
                                else if (typeof object.width === "string")
                                    message.width = parseInt(object.width, 10);
                                else if (typeof object.width === "number")
                                    message.width = object.width;
                                else if (typeof object.width === "object")
                                    message.width = new $util.LongBits(object.width.low >>> 0, object.width.high >>> 0).toNumber();
                            if (object.height != null)
                                if ($util.Long)
                                    (message.height = $util.Long.fromValue(object.height)).unsigned = false;
                                else if (typeof object.height === "string")
                                    message.height = parseInt(object.height, 10);
                                else if (typeof object.height === "number")
                                    message.height = object.height;
                                else if (typeof object.height === "object")
                                    message.height = new $util.LongBits(object.height.low >>> 0, object.height.high >>> 0).toNumber();
                            if (object.thumbnail != null)
                                message.thumbnail = String(object.thumbnail);
                            return message;
                        };

                        /**
                         * Creates a plain object from an Image message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.Image} message Image
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Image.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                object.path = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.width = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.width = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.height = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.height = options.longs === String ? "0" : 0;
                                object.thumbnail = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.path != null && message.hasOwnProperty("path"))
                                object.path = message.path;
                            if (message.width != null && message.hasOwnProperty("width"))
                                if (typeof message.width === "number")
                                    object.width = options.longs === String ? String(message.width) : message.width;
                                else
                                    object.width = options.longs === String ? $util.Long.prototype.toString.call(message.width) : options.longs === Number ? new $util.LongBits(message.width.low >>> 0, message.width.high >>> 0).toNumber() : message.width;
                            if (message.height != null && message.hasOwnProperty("height"))
                                if (typeof message.height === "number")
                                    object.height = options.longs === String ? String(message.height) : message.height;
                                else
                                    object.height = options.longs === String ? $util.Long.prototype.toString.call(message.height) : options.longs === Number ? new $util.LongBits(message.height.low >>> 0, message.height.high >>> 0).toNumber() : message.height;
                            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                                object.thumbnail = message.thumbnail;
                            return object;
                        };

                        /**
                         * Converts this Image to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Image.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Image
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Image
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Image.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.BannerListResp.Image";
                        };

                        return Image;
                    })();

                    BannerListResp.Banner = (function() {

                        /**
                         * Properties of a Banner.
                         * @memberof kuma.jp.protobuf.web.BannerListResp
                         * @interface IBanner
                         * @property {number|Long|null} [id] Banner id
                         * @property {kuma.jp.protobuf.web.BannerListResp.IImage|null} [img] Banner img
                         * @property {number|null} [bannerIdx] Banner bannerIdx
                         * @property {number|Long|null} [startDate] Banner startDate
                         * @property {number|Long|null} [endDate] Banner endDate
                         * @property {string|null} [url] Banner url
                         * @property {Array.<string>|null} [color] Banner color
                         */

                        /**
                         * Constructs a new Banner.
                         * @memberof kuma.jp.protobuf.web.BannerListResp
                         * @classdesc Represents a Banner.
                         * @implements IBanner
                         * @constructor
                         * @param {kuma.jp.protobuf.web.BannerListResp.IBanner=} [properties] Properties to set
                         */
                        function Banner(properties) {
                            this.color = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Banner id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Banner img.
                         * @member {kuma.jp.protobuf.web.BannerListResp.IImage|null|undefined} img
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.img = null;

                        /**
                         * Banner bannerIdx.
                         * @member {number} bannerIdx
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.bannerIdx = 0;

                        /**
                         * Banner startDate.
                         * @member {number|Long} startDate
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.startDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Banner endDate.
                         * @member {number|Long} endDate
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.endDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Banner url.
                         * @member {string} url
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.url = "";

                        /**
                         * Banner color.
                         * @member {Array.<string>} color
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         */
                        Banner.prototype.color = $util.emptyArray;

                        /**
                         * Creates a new Banner instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IBanner=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Banner} Banner instance
                         */
                        Banner.create = function create(properties) {
                            return new Banner(properties);
                        };

                        /**
                         * Encodes the specified Banner message. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.Banner.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IBanner} message Banner message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Banner.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.img != null && Object.hasOwnProperty.call(message, "img"))
                                $root.kuma.jp.protobuf.web.BannerListResp.Image.encode(message.img, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.bannerIdx != null && Object.hasOwnProperty.call(message, "bannerIdx"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bannerIdx);
                            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.startDate);
                            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.endDate);
                            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.url);
                            if (message.color != null && message.color.length)
                                for (let i = 0; i < message.color.length; ++i)
                                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.color[i]);
                            return writer;
                        };

                        /**
                         * Encodes the specified Banner message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BannerListResp.Banner.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.IBanner} message Banner message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Banner.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Banner message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Banner} Banner
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Banner.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BannerListResp.Banner();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.img = $root.kuma.jp.protobuf.web.BannerListResp.Image.decode(reader, reader.uint32());
                                        break;
                                    }
                                case 3: {
                                        message.bannerIdx = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.startDate = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.endDate = reader.int64();
                                        break;
                                    }
                                case 6: {
                                        message.url = reader.string();
                                        break;
                                    }
                                case 7: {
                                        if (!(message.color && message.color.length))
                                            message.color = [];
                                        message.color.push(reader.string());
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Banner message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Banner} Banner
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Banner.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Banner message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Banner.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.img != null && message.hasOwnProperty("img")) {
                                let error = $root.kuma.jp.protobuf.web.BannerListResp.Image.verify(message.img);
                                if (error)
                                    return "img." + error;
                            }
                            if (message.bannerIdx != null && message.hasOwnProperty("bannerIdx"))
                                if (!$util.isInteger(message.bannerIdx))
                                    return "bannerIdx: integer expected";
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (!$util.isInteger(message.startDate) && !(message.startDate && $util.isInteger(message.startDate.low) && $util.isInteger(message.startDate.high)))
                                    return "startDate: integer|Long expected";
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (!$util.isInteger(message.endDate) && !(message.endDate && $util.isInteger(message.endDate.low) && $util.isInteger(message.endDate.high)))
                                    return "endDate: integer|Long expected";
                            if (message.url != null && message.hasOwnProperty("url"))
                                if (!$util.isString(message.url))
                                    return "url: string expected";
                            if (message.color != null && message.hasOwnProperty("color")) {
                                if (!Array.isArray(message.color))
                                    return "color: array expected";
                                for (let i = 0; i < message.color.length; ++i)
                                    if (!$util.isString(message.color[i]))
                                        return "color: string[] expected";
                            }
                            return null;
                        };

                        /**
                         * Creates a Banner message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.BannerListResp.Banner} Banner
                         */
                        Banner.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.BannerListResp.Banner)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.BannerListResp.Banner();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.img != null) {
                                if (typeof object.img !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.BannerListResp.Banner.img: object expected");
                                message.img = $root.kuma.jp.protobuf.web.BannerListResp.Image.fromObject(object.img);
                            }
                            if (object.bannerIdx != null)
                                message.bannerIdx = object.bannerIdx | 0;
                            if (object.startDate != null)
                                if ($util.Long)
                                    (message.startDate = $util.Long.fromValue(object.startDate)).unsigned = false;
                                else if (typeof object.startDate === "string")
                                    message.startDate = parseInt(object.startDate, 10);
                                else if (typeof object.startDate === "number")
                                    message.startDate = object.startDate;
                                else if (typeof object.startDate === "object")
                                    message.startDate = new $util.LongBits(object.startDate.low >>> 0, object.startDate.high >>> 0).toNumber();
                            if (object.endDate != null)
                                if ($util.Long)
                                    (message.endDate = $util.Long.fromValue(object.endDate)).unsigned = false;
                                else if (typeof object.endDate === "string")
                                    message.endDate = parseInt(object.endDate, 10);
                                else if (typeof object.endDate === "number")
                                    message.endDate = object.endDate;
                                else if (typeof object.endDate === "object")
                                    message.endDate = new $util.LongBits(object.endDate.low >>> 0, object.endDate.high >>> 0).toNumber();
                            if (object.url != null)
                                message.url = String(object.url);
                            if (object.color) {
                                if (!Array.isArray(object.color))
                                    throw TypeError(".kuma.jp.protobuf.web.BannerListResp.Banner.color: array expected");
                                message.color = [];
                                for (let i = 0; i < object.color.length; ++i)
                                    message.color[i] = String(object.color[i]);
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a Banner message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {kuma.jp.protobuf.web.BannerListResp.Banner} message Banner
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Banner.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.color = [];
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                object.img = null;
                                object.bannerIdx = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startDate = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endDate = options.longs === String ? "0" : 0;
                                object.url = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.img != null && message.hasOwnProperty("img"))
                                object.img = $root.kuma.jp.protobuf.web.BannerListResp.Image.toObject(message.img, options);
                            if (message.bannerIdx != null && message.hasOwnProperty("bannerIdx"))
                                object.bannerIdx = message.bannerIdx;
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (typeof message.startDate === "number")
                                    object.startDate = options.longs === String ? String(message.startDate) : message.startDate;
                                else
                                    object.startDate = options.longs === String ? $util.Long.prototype.toString.call(message.startDate) : options.longs === Number ? new $util.LongBits(message.startDate.low >>> 0, message.startDate.high >>> 0).toNumber() : message.startDate;
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (typeof message.endDate === "number")
                                    object.endDate = options.longs === String ? String(message.endDate) : message.endDate;
                                else
                                    object.endDate = options.longs === String ? $util.Long.prototype.toString.call(message.endDate) : options.longs === Number ? new $util.LongBits(message.endDate.low >>> 0, message.endDate.high >>> 0).toNumber() : message.endDate;
                            if (message.url != null && message.hasOwnProperty("url"))
                                object.url = message.url;
                            if (message.color && message.color.length) {
                                object.color = [];
                                for (let j = 0; j < message.color.length; ++j)
                                    object.color[j] = message.color[j];
                            }
                            return object;
                        };

                        /**
                         * Converts this Banner to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Banner.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Banner
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.BannerListResp.Banner
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Banner.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.BannerListResp.Banner";
                        };

                        return Banner;
                    })();

                    return BannerListResp;
                })();

                web.BonusReq = (function() {

                    /**
                     * Properties of a BonusReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBonusReq
                     */

                    /**
                     * Constructs a new BonusReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BonusReq.
                     * @implements IBonusReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBonusReq=} [properties] Properties to set
                     */
                    function BonusReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BonusReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BonusReq} BonusReq instance
                     */
                    BonusReq.create = function create(properties) {
                        return new BonusReq(properties);
                    };

                    /**
                     * Encodes the specified BonusReq message. Does not implicitly {@link kuma.jp.protobuf.web.BonusReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusReq} message BonusReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BonusReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BonusReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BonusReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusReq} message BonusReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BonusReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BonusReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BonusReq} BonusReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BonusReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BonusReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BonusReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BonusReq} BonusReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BonusReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BonusReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BonusReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BonusReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BonusReq} BonusReq
                     */
                    BonusReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BonusReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BonusReq();
                    };

                    /**
                     * Creates a plain object from a BonusReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BonusReq} message BonusReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BonusReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BonusReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BonusReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BonusReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BonusReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BonusReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BonusReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BonusReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=42000 COMMAND_NO value
                     */
                    BonusReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[42000] = "COMMAND_NO"] = 42000;
                        return values;
                    })();

                    return BonusReq;
                })();

                web.BonusResp = (function() {

                    /**
                     * Properties of a BonusResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBonusResp
                     * @property {kuma.jp.protobuf.web.BonusResp.Status|null} [status] BonusResp status
                     * @property {Array.<kuma.jp.protobuf.web.BonusResp.IItem>|null} [items] BonusResp items
                     */

                    /**
                     * Constructs a new BonusResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BonusResp.
                     * @implements IBonusResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBonusResp=} [properties] Properties to set
                     */
                    function BonusResp(properties) {
                        this.items = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BonusResp status.
                     * @member {kuma.jp.protobuf.web.BonusResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @instance
                     */
                    BonusResp.prototype.status = 0;

                    /**
                     * BonusResp items.
                     * @member {Array.<kuma.jp.protobuf.web.BonusResp.IItem>} items
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @instance
                     */
                    BonusResp.prototype.items = $util.emptyArray;

                    /**
                     * Creates a new BonusResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BonusResp} BonusResp instance
                     */
                    BonusResp.create = function create(properties) {
                        return new BonusResp(properties);
                    };

                    /**
                     * Encodes the specified BonusResp message. Does not implicitly {@link kuma.jp.protobuf.web.BonusResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusResp} message BonusResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BonusResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.items != null && message.items.length)
                            for (let i = 0; i < message.items.length; ++i)
                                $root.kuma.jp.protobuf.web.BonusResp.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BonusResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BonusResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBonusResp} message BonusResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BonusResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BonusResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BonusResp} BonusResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BonusResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BonusResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.items && message.items.length))
                                        message.items = [];
                                    message.items.push($root.kuma.jp.protobuf.web.BonusResp.Item.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BonusResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BonusResp} BonusResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BonusResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BonusResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BonusResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (let i = 0; i < message.items.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.BonusResp.Item.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a BonusResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BonusResp} BonusResp
                     */
                    BonusResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BonusResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BonusResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".kuma.jp.protobuf.web.BonusResp.items: array expected");
                            message.items = [];
                            for (let i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.BonusResp.items: object expected");
                                message.items[i] = $root.kuma.jp.protobuf.web.BonusResp.Item.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BonusResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BonusResp} message BonusResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BonusResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BonusResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BonusResp.Status[message.status] : message.status;
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (let j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.kuma.jp.protobuf.web.BonusResp.Item.toObject(message.items[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this BonusResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BonusResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BonusResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BonusResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BonusResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BonusResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BonusResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=42001 COMMAND_NO value
                     */
                    BonusResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[42001] = "COMMAND_NO"] = 42001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BonusResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    BonusResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    BonusResp.Item = (function() {

                        /**
                         * Properties of an Item.
                         * @memberof kuma.jp.protobuf.web.BonusResp
                         * @interface IItem
                         * @property {number|null} [bonusType] Item bonusType
                         * @property {number|null} [itemId] Item itemId
                         * @property {string|null} [itemNum] Item itemNum
                         * @property {string|null} [name] Item name
                         * @property {string|null} [imagePath] Item imagePath
                         * @property {number|null} [type] Item type
                         * @property {number|null} [kind] Item kind
                         * @property {string|null} [kindText] Item kindText
                         * @property {string|null} [description] Item description
                         * @property {string|null} [advertise] Item advertise
                         * @property {number|Long|null} [startTime] Item startTime
                         * @property {number|Long|null} [endTime] Item endTime
                         * @property {number|null} [optionId] Item optionId
                         */

                        /**
                         * Constructs a new Item.
                         * @memberof kuma.jp.protobuf.web.BonusResp
                         * @classdesc Represents an Item.
                         * @implements IItem
                         * @constructor
                         * @param {kuma.jp.protobuf.web.BonusResp.IItem=} [properties] Properties to set
                         */
                        function Item(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Item bonusType.
                         * @member {number} bonusType
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.bonusType = 0;

                        /**
                         * Item itemId.
                         * @member {number} itemId
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.itemId = 0;

                        /**
                         * Item itemNum.
                         * @member {string} itemNum
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.itemNum = "";

                        /**
                         * Item name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.name = "";

                        /**
                         * Item imagePath.
                         * @member {string} imagePath
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.imagePath = "";

                        /**
                         * Item type.
                         * @member {number} type
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.type = 0;

                        /**
                         * Item kind.
                         * @member {number} kind
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.kind = 0;

                        /**
                         * Item kindText.
                         * @member {string} kindText
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.kindText = "";

                        /**
                         * Item description.
                         * @member {string} description
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.description = "";

                        /**
                         * Item advertise.
                         * @member {string} advertise
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.advertise = "";

                        /**
                         * Item startTime.
                         * @member {number|Long} startTime
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Item endTime.
                         * @member {number|Long} endTime
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Item optionId.
                         * @member {number} optionId
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         */
                        Item.prototype.optionId = 0;

                        /**
                         * Creates a new Item instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {kuma.jp.protobuf.web.BonusResp.IItem=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.BonusResp.Item} Item instance
                         */
                        Item.create = function create(properties) {
                            return new Item(properties);
                        };

                        /**
                         * Encodes the specified Item message. Does not implicitly {@link kuma.jp.protobuf.web.BonusResp.Item.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {kuma.jp.protobuf.web.BonusResp.IItem} message Item message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Item.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.bonusType != null && Object.hasOwnProperty.call(message, "bonusType"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.bonusType);
                            if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.itemId);
                            if (message.itemNum != null && Object.hasOwnProperty.call(message, "itemNum"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.itemNum);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                            if (message.imagePath != null && Object.hasOwnProperty.call(message, "imagePath"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.imagePath);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                            if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.kind);
                            if (message.kindText != null && Object.hasOwnProperty.call(message, "kindText"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.kindText);
                            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                                writer.uint32(/* id 9, wireType 2 =*/74).string(message.description);
                            if (message.advertise != null && Object.hasOwnProperty.call(message, "advertise"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.advertise);
                            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.startTime);
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.endTime);
                            if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.optionId);
                            return writer;
                        };

                        /**
                         * Encodes the specified Item message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BonusResp.Item.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {kuma.jp.protobuf.web.BonusResp.IItem} message Item message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Item.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Item message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.BonusResp.Item} Item
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Item.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BonusResp.Item();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.bonusType = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.itemId = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.itemNum = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.imagePath = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 7: {
                                        message.kind = reader.int32();
                                        break;
                                    }
                                case 8: {
                                        message.kindText = reader.string();
                                        break;
                                    }
                                case 9: {
                                        message.description = reader.string();
                                        break;
                                    }
                                case 10: {
                                        message.advertise = reader.string();
                                        break;
                                    }
                                case 11: {
                                        message.startTime = reader.int64();
                                        break;
                                    }
                                case 12: {
                                        message.endTime = reader.int64();
                                        break;
                                    }
                                case 13: {
                                        message.optionId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Item message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.BonusResp.Item} Item
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Item.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Item message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Item.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                if (!$util.isInteger(message.bonusType))
                                    return "bonusType: integer expected";
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                if (!$util.isInteger(message.itemId))
                                    return "itemId: integer expected";
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                if (!$util.isString(message.itemNum))
                                    return "itemNum: string expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                if (!$util.isString(message.imagePath))
                                    return "imagePath: string expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                if (!$util.isInteger(message.type))
                                    return "type: integer expected";
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                if (!$util.isInteger(message.kind))
                                    return "kind: integer expected";
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                if (!$util.isString(message.kindText))
                                    return "kindText: string expected";
                            if (message.description != null && message.hasOwnProperty("description"))
                                if (!$util.isString(message.description))
                                    return "description: string expected";
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                if (!$util.isString(message.advertise))
                                    return "advertise: string expected";
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                    return "startTime: integer|Long expected";
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                    return "endTime: integer|Long expected";
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                if (!$util.isInteger(message.optionId))
                                    return "optionId: integer expected";
                            return null;
                        };

                        /**
                         * Creates an Item message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.BonusResp.Item} Item
                         */
                        Item.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.BonusResp.Item)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.BonusResp.Item();
                            if (object.bonusType != null)
                                message.bonusType = object.bonusType | 0;
                            if (object.itemId != null)
                                message.itemId = object.itemId | 0;
                            if (object.itemNum != null)
                                message.itemNum = String(object.itemNum);
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.imagePath != null)
                                message.imagePath = String(object.imagePath);
                            if (object.type != null)
                                message.type = object.type | 0;
                            if (object.kind != null)
                                message.kind = object.kind | 0;
                            if (object.kindText != null)
                                message.kindText = String(object.kindText);
                            if (object.description != null)
                                message.description = String(object.description);
                            if (object.advertise != null)
                                message.advertise = String(object.advertise);
                            if (object.startTime != null)
                                if ($util.Long)
                                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                                else if (typeof object.startTime === "string")
                                    message.startTime = parseInt(object.startTime, 10);
                                else if (typeof object.startTime === "number")
                                    message.startTime = object.startTime;
                                else if (typeof object.startTime === "object")
                                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                            if (object.endTime != null)
                                if ($util.Long)
                                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                                else if (typeof object.endTime === "string")
                                    message.endTime = parseInt(object.endTime, 10);
                                else if (typeof object.endTime === "number")
                                    message.endTime = object.endTime;
                                else if (typeof object.endTime === "object")
                                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                            if (object.optionId != null)
                                message.optionId = object.optionId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from an Item message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {kuma.jp.protobuf.web.BonusResp.Item} message Item
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Item.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.bonusType = 0;
                                object.itemId = 0;
                                object.itemNum = "";
                                object.name = "";
                                object.imagePath = "";
                                object.type = 0;
                                object.kind = 0;
                                object.kindText = "";
                                object.description = "";
                                object.advertise = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startTime = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endTime = options.longs === String ? "0" : 0;
                                object.optionId = 0;
                            }
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                object.bonusType = message.bonusType;
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                object.itemId = message.itemId;
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                object.itemNum = message.itemNum;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                object.imagePath = message.imagePath;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = message.type;
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                object.kind = message.kind;
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                object.kindText = message.kindText;
                            if (message.description != null && message.hasOwnProperty("description"))
                                object.description = message.description;
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                object.advertise = message.advertise;
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (typeof message.startTime === "number")
                                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                                else
                                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (typeof message.endTime === "number")
                                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                                else
                                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                object.optionId = message.optionId;
                            return object;
                        };

                        /**
                         * Converts this Item to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Item.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Item
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.BonusResp.Item
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.BonusResp.Item";
                        };

                        return Item;
                    })();

                    return BonusResp;
                })();

                web.BuyCardUpdateReq = (function() {

                    /**
                     * Properties of a BuyCardUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyCardUpdateReq
                     */

                    /**
                     * Constructs a new BuyCardUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyCardUpdateReq.
                     * @implements IBuyCardUpdateReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateReq=} [properties] Properties to set
                     */
                    function BuyCardUpdateReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BuyCardUpdateReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateReq} BuyCardUpdateReq instance
                     */
                    BuyCardUpdateReq.create = function create(properties) {
                        return new BuyCardUpdateReq(properties);
                    };

                    /**
                     * Encodes the specified BuyCardUpdateReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyCardUpdateReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateReq} message BuyCardUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyCardUpdateReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyCardUpdateReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyCardUpdateReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateReq} message BuyCardUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyCardUpdateReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyCardUpdateReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateReq} BuyCardUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyCardUpdateReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyCardUpdateReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyCardUpdateReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateReq} BuyCardUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyCardUpdateReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyCardUpdateReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyCardUpdateReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BuyCardUpdateReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateReq} BuyCardUpdateReq
                     */
                    BuyCardUpdateReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyCardUpdateReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BuyCardUpdateReq();
                    };

                    /**
                     * Creates a plain object from a BuyCardUpdateReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyCardUpdateReq} message BuyCardUpdateReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyCardUpdateReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BuyCardUpdateReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyCardUpdateReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyCardUpdateReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyCardUpdateReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyCardUpdateReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyCardUpdateReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70500 COMMAND_NO value
                     */
                    BuyCardUpdateReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70500] = "COMMAND_NO"] = 70500;
                        return values;
                    })();

                    return BuyCardUpdateReq;
                })();

                web.BuyCardUpdateResp = (function() {

                    /**
                     * Properties of a BuyCardUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyCardUpdateResp
                     * @property {kuma.jp.protobuf.web.BuyCardUpdateResp.Status|null} [status] BuyCardUpdateResp status
                     * @property {string|null} [url] BuyCardUpdateResp url
                     * @property {string|null} [postJson] BuyCardUpdateResp postJson
                     */

                    /**
                     * Constructs a new BuyCardUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyCardUpdateResp.
                     * @implements IBuyCardUpdateResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateResp=} [properties] Properties to set
                     */
                    function BuyCardUpdateResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyCardUpdateResp status.
                     * @member {kuma.jp.protobuf.web.BuyCardUpdateResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @instance
                     */
                    BuyCardUpdateResp.prototype.status = 0;

                    /**
                     * BuyCardUpdateResp url.
                     * @member {string} url
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @instance
                     */
                    BuyCardUpdateResp.prototype.url = "";

                    /**
                     * BuyCardUpdateResp postJson.
                     * @member {string} postJson
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @instance
                     */
                    BuyCardUpdateResp.prototype.postJson = "";

                    /**
                     * Creates a new BuyCardUpdateResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateResp} BuyCardUpdateResp instance
                     */
                    BuyCardUpdateResp.create = function create(properties) {
                        return new BuyCardUpdateResp(properties);
                    };

                    /**
                     * Encodes the specified BuyCardUpdateResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyCardUpdateResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateResp} message BuyCardUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyCardUpdateResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                        if (message.postJson != null && Object.hasOwnProperty.call(message, "postJson"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.postJson);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyCardUpdateResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyCardUpdateResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyCardUpdateResp} message BuyCardUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyCardUpdateResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyCardUpdateResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateResp} BuyCardUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyCardUpdateResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyCardUpdateResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.url = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.postJson = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyCardUpdateResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateResp} BuyCardUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyCardUpdateResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyCardUpdateResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyCardUpdateResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        if (message.postJson != null && message.hasOwnProperty("postJson"))
                            if (!$util.isString(message.postJson))
                                return "postJson: string expected";
                        return null;
                    };

                    /**
                     * Creates a BuyCardUpdateResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyCardUpdateResp} BuyCardUpdateResp
                     */
                    BuyCardUpdateResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyCardUpdateResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyCardUpdateResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.url != null)
                            message.url = String(object.url);
                        if (object.postJson != null)
                            message.postJson = String(object.postJson);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyCardUpdateResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyCardUpdateResp} message BuyCardUpdateResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyCardUpdateResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.url = "";
                            object.postJson = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BuyCardUpdateResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BuyCardUpdateResp.Status[message.status] : message.status;
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        if (message.postJson != null && message.hasOwnProperty("postJson"))
                            object.postJson = message.postJson;
                        return object;
                    };

                    /**
                     * Converts this BuyCardUpdateResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyCardUpdateResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyCardUpdateResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyCardUpdateResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyCardUpdateResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyCardUpdateResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyCardUpdateResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70501 COMMAND_NO value
                     */
                    BuyCardUpdateResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70501] = "COMMAND_NO"] = 70501;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BuyCardUpdateResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    BuyCardUpdateResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    return BuyCardUpdateResp;
                })();

                web.BuyMembershipListReq = (function() {

                    /**
                     * Properties of a BuyMembershipListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipListReq
                     */

                    /**
                     * Constructs a new BuyMembershipListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipListReq.
                     * @implements IBuyMembershipListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListReq=} [properties] Properties to set
                     */
                    function BuyMembershipListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BuyMembershipListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListReq} BuyMembershipListReq instance
                     */
                    BuyMembershipListReq.create = function create(properties) {
                        return new BuyMembershipListReq(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipListReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListReq} message BuyMembershipListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListReq} message BuyMembershipListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListReq} BuyMembershipListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListReq} BuyMembershipListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListReq} BuyMembershipListReq
                     */
                    BuyMembershipListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BuyMembershipListReq();
                    };

                    /**
                     * Creates a plain object from a BuyMembershipListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipListReq} message BuyMembershipListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BuyMembershipListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70600 COMMAND_NO value
                     */
                    BuyMembershipListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70600] = "COMMAND_NO"] = 70600;
                        return values;
                    })();

                    return BuyMembershipListReq;
                })();

                web.BuyMembershipListResp = (function() {

                    /**
                     * Properties of a BuyMembershipListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipListResp
                     * @property {kuma.jp.protobuf.web.BuyMembershipListResp.Status|null} [status] BuyMembershipListResp status
                     * @property {Array.<kuma.jp.protobuf.web.BuyMembershipListResp.IMembership>|null} [membership] BuyMembershipListResp membership
                     * @property {boolean|null} [disableMembership] BuyMembershipListResp disableMembership
                     * @property {string|null} [disableMessage] BuyMembershipListResp disableMessage
                     * @property {string|null} [imgPath] BuyMembershipListResp imgPath
                     */

                    /**
                     * Constructs a new BuyMembershipListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipListResp.
                     * @implements IBuyMembershipListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListResp=} [properties] Properties to set
                     */
                    function BuyMembershipListResp(properties) {
                        this.membership = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipListResp status.
                     * @member {kuma.jp.protobuf.web.BuyMembershipListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     */
                    BuyMembershipListResp.prototype.status = 0;

                    /**
                     * BuyMembershipListResp membership.
                     * @member {Array.<kuma.jp.protobuf.web.BuyMembershipListResp.IMembership>} membership
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     */
                    BuyMembershipListResp.prototype.membership = $util.emptyArray;

                    /**
                     * BuyMembershipListResp disableMembership.
                     * @member {boolean} disableMembership
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     */
                    BuyMembershipListResp.prototype.disableMembership = false;

                    /**
                     * BuyMembershipListResp disableMessage.
                     * @member {string} disableMessage
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     */
                    BuyMembershipListResp.prototype.disableMessage = "";

                    /**
                     * BuyMembershipListResp imgPath.
                     * @member {string} imgPath
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     */
                    BuyMembershipListResp.prototype.imgPath = "";

                    /**
                     * Creates a new BuyMembershipListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListResp} BuyMembershipListResp instance
                     */
                    BuyMembershipListResp.create = function create(properties) {
                        return new BuyMembershipListResp(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipListResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListResp} message BuyMembershipListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.membership != null && message.membership.length)
                            for (let i = 0; i < message.membership.length; ++i)
                                $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership.encode(message.membership[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.disableMembership != null && Object.hasOwnProperty.call(message, "disableMembership"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.disableMembership);
                        if (message.disableMessage != null && Object.hasOwnProperty.call(message, "disableMessage"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.disableMessage);
                        if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.imgPath);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipListResp} message BuyMembershipListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListResp} BuyMembershipListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.membership && message.membership.length))
                                        message.membership = [];
                                    message.membership.push($root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 3: {
                                    message.disableMembership = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.disableMessage = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.imgPath = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListResp} BuyMembershipListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.membership != null && message.hasOwnProperty("membership")) {
                            if (!Array.isArray(message.membership))
                                return "membership: array expected";
                            for (let i = 0; i < message.membership.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership.verify(message.membership[i]);
                                if (error)
                                    return "membership." + error;
                            }
                        }
                        if (message.disableMembership != null && message.hasOwnProperty("disableMembership"))
                            if (typeof message.disableMembership !== "boolean")
                                return "disableMembership: boolean expected";
                        if (message.disableMessage != null && message.hasOwnProperty("disableMessage"))
                            if (!$util.isString(message.disableMessage))
                                return "disableMessage: string expected";
                        if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                            if (!$util.isString(message.imgPath))
                                return "imgPath: string expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipListResp} BuyMembershipListResp
                     */
                    BuyMembershipListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.membership) {
                            if (!Array.isArray(object.membership))
                                throw TypeError(".kuma.jp.protobuf.web.BuyMembershipListResp.membership: array expected");
                            message.membership = [];
                            for (let i = 0; i < object.membership.length; ++i) {
                                if (typeof object.membership[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.BuyMembershipListResp.membership: object expected");
                                message.membership[i] = $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership.fromObject(object.membership[i]);
                            }
                        }
                        if (object.disableMembership != null)
                            message.disableMembership = Boolean(object.disableMembership);
                        if (object.disableMessage != null)
                            message.disableMessage = String(object.disableMessage);
                        if (object.imgPath != null)
                            message.imgPath = String(object.imgPath);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipListResp} message BuyMembershipListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.membership = [];
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.disableMembership = false;
                            object.disableMessage = "";
                            object.imgPath = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BuyMembershipListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BuyMembershipListResp.Status[message.status] : message.status;
                        if (message.membership && message.membership.length) {
                            object.membership = [];
                            for (let j = 0; j < message.membership.length; ++j)
                                object.membership[j] = $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership.toObject(message.membership[j], options);
                        }
                        if (message.disableMembership != null && message.hasOwnProperty("disableMembership"))
                            object.disableMembership = message.disableMembership;
                        if (message.disableMessage != null && message.hasOwnProperty("disableMessage"))
                            object.disableMessage = message.disableMessage;
                        if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                            object.imgPath = message.imgPath;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70601 COMMAND_NO value
                     */
                    BuyMembershipListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70601] = "COMMAND_NO"] = 70601;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    BuyMembershipListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    BuyMembershipListResp.Membership = (function() {

                        /**
                         * Properties of a Membership.
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                         * @interface IMembership
                         * @property {number|Long|null} [id] Membership id
                         * @property {string|null} [storeProductId] Membership storeProductId
                         * @property {string|null} [name] Membership name
                         * @property {number|null} [price] Membership price
                         */

                        /**
                         * Constructs a new Membership.
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp
                         * @classdesc Represents a Membership.
                         * @implements IMembership
                         * @constructor
                         * @param {kuma.jp.protobuf.web.BuyMembershipListResp.IMembership=} [properties] Properties to set
                         */
                        function Membership(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Membership id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @instance
                         */
                        Membership.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Membership storeProductId.
                         * @member {string} storeProductId
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @instance
                         */
                        Membership.prototype.storeProductId = "";

                        /**
                         * Membership name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @instance
                         */
                        Membership.prototype.name = "";

                        /**
                         * Membership price.
                         * @member {number} price
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @instance
                         */
                        Membership.prototype.price = 0;

                        /**
                         * Creates a new Membership instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {kuma.jp.protobuf.web.BuyMembershipListResp.IMembership=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.BuyMembershipListResp.Membership} Membership instance
                         */
                        Membership.create = function create(properties) {
                            return new Membership(properties);
                        };

                        /**
                         * Encodes the specified Membership message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListResp.Membership.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {kuma.jp.protobuf.web.BuyMembershipListResp.IMembership} message Membership message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Membership.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.storeProductId != null && Object.hasOwnProperty.call(message, "storeProductId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeProductId);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.price);
                            return writer;
                        };

                        /**
                         * Encodes the specified Membership message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipListResp.Membership.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {kuma.jp.protobuf.web.BuyMembershipListResp.IMembership} message Membership message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Membership.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Membership message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.BuyMembershipListResp.Membership} Membership
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Membership.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.storeProductId = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.price = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Membership message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.BuyMembershipListResp.Membership} Membership
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Membership.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Membership message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Membership.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.storeProductId != null && message.hasOwnProperty("storeProductId"))
                                if (!$util.isString(message.storeProductId))
                                    return "storeProductId: string expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.price != null && message.hasOwnProperty("price"))
                                if (!$util.isInteger(message.price))
                                    return "price: integer expected";
                            return null;
                        };

                        /**
                         * Creates a Membership message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.BuyMembershipListResp.Membership} Membership
                         */
                        Membership.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.BuyMembershipListResp.Membership();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.storeProductId != null)
                                message.storeProductId = String(object.storeProductId);
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.price != null)
                                message.price = object.price | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a Membership message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {kuma.jp.protobuf.web.BuyMembershipListResp.Membership} message Membership
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Membership.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                object.storeProductId = "";
                                object.name = "";
                                object.price = 0;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.storeProductId != null && message.hasOwnProperty("storeProductId"))
                                object.storeProductId = message.storeProductId;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.price != null && message.hasOwnProperty("price"))
                                object.price = message.price;
                            return object;
                        };

                        /**
                         * Converts this Membership to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Membership.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Membership
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.BuyMembershipListResp.Membership
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Membership.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipListResp.Membership";
                        };

                        return Membership;
                    })();

                    return BuyMembershipListResp;
                })();

                web.BuyMembershipResultReq = (function() {

                    /**
                     * Properties of a BuyMembershipResultReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipResultReq
                     */

                    /**
                     * Constructs a new BuyMembershipResultReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipResultReq.
                     * @implements IBuyMembershipResultReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultReq=} [properties] Properties to set
                     */
                    function BuyMembershipResultReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BuyMembershipResultReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultReq} BuyMembershipResultReq instance
                     */
                    BuyMembershipResultReq.create = function create(properties) {
                        return new BuyMembershipResultReq(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipResultReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipResultReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultReq} message BuyMembershipResultReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipResultReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipResultReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipResultReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultReq} message BuyMembershipResultReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipResultReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipResultReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultReq} BuyMembershipResultReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipResultReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipResultReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipResultReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultReq} BuyMembershipResultReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipResultReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipResultReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipResultReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipResultReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultReq} BuyMembershipResultReq
                     */
                    BuyMembershipResultReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipResultReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BuyMembershipResultReq();
                    };

                    /**
                     * Creates a plain object from a BuyMembershipResultReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipResultReq} message BuyMembershipResultReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipResultReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BuyMembershipResultReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipResultReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipResultReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipResultReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipResultReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipResultReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70300 COMMAND_NO value
                     */
                    BuyMembershipResultReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70300] = "COMMAND_NO"] = 70300;
                        return values;
                    })();

                    return BuyMembershipResultReq;
                })();

                web.BuyMembershipResultResp = (function() {

                    /**
                     * Properties of a BuyMembershipResultResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipResultResp
                     * @property {number|null} [subscribeStatus] BuyMembershipResultResp subscribeStatus
                     * @property {number|null} [membershipGrade] BuyMembershipResultResp membershipGrade
                     */

                    /**
                     * Constructs a new BuyMembershipResultResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipResultResp.
                     * @implements IBuyMembershipResultResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultResp=} [properties] Properties to set
                     */
                    function BuyMembershipResultResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipResultResp subscribeStatus.
                     * @member {number} subscribeStatus
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @instance
                     */
                    BuyMembershipResultResp.prototype.subscribeStatus = 0;

                    /**
                     * BuyMembershipResultResp membershipGrade.
                     * @member {number} membershipGrade
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @instance
                     */
                    BuyMembershipResultResp.prototype.membershipGrade = 0;

                    /**
                     * Creates a new BuyMembershipResultResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultResp} BuyMembershipResultResp instance
                     */
                    BuyMembershipResultResp.create = function create(properties) {
                        return new BuyMembershipResultResp(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipResultResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipResultResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultResp} message BuyMembershipResultResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipResultResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.subscribeStatus != null && Object.hasOwnProperty.call(message, "subscribeStatus"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.subscribeStatus);
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.membershipGrade);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipResultResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipResultResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipResultResp} message BuyMembershipResultResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipResultResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipResultResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultResp} BuyMembershipResultResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipResultResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipResultResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.subscribeStatus = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipResultResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultResp} BuyMembershipResultResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipResultResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipResultResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipResultResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.subscribeStatus != null && message.hasOwnProperty("subscribeStatus"))
                            if (!$util.isInteger(message.subscribeStatus))
                                return "subscribeStatus: integer expected";
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            if (!$util.isInteger(message.membershipGrade))
                                return "membershipGrade: integer expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipResultResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipResultResp} BuyMembershipResultResp
                     */
                    BuyMembershipResultResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipResultResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipResultResp();
                        if (object.subscribeStatus != null)
                            message.subscribeStatus = object.subscribeStatus | 0;
                        if (object.membershipGrade != null)
                            message.membershipGrade = object.membershipGrade | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipResultResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipResultResp} message BuyMembershipResultResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipResultResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.subscribeStatus = 0;
                            object.membershipGrade = 0;
                        }
                        if (message.subscribeStatus != null && message.hasOwnProperty("subscribeStatus"))
                            object.subscribeStatus = message.subscribeStatus;
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = message.membershipGrade;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipResultResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipResultResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipResultResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipResultResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipResultResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipResultResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipResultResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70301 COMMAND_NO value
                     */
                    BuyMembershipResultResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70301] = "COMMAND_NO"] = 70301;
                        return values;
                    })();

                    return BuyMembershipResultResp;
                })();

                web.BuyMembershipStartReq = (function() {

                    /**
                     * Properties of a BuyMembershipStartReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipStartReq
                     * @property {number|null} [membershipGrade] BuyMembershipStartReq membershipGrade
                     * @property {number|null} [payType] BuyMembershipStartReq payType
                     */

                    /**
                     * Constructs a new BuyMembershipStartReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipStartReq.
                     * @implements IBuyMembershipStartReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartReq=} [properties] Properties to set
                     */
                    function BuyMembershipStartReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipStartReq membershipGrade.
                     * @member {number} membershipGrade
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @instance
                     */
                    BuyMembershipStartReq.prototype.membershipGrade = 0;

                    /**
                     * BuyMembershipStartReq payType.
                     * @member {number} payType
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @instance
                     */
                    BuyMembershipStartReq.prototype.payType = 0;

                    /**
                     * Creates a new BuyMembershipStartReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartReq} BuyMembershipStartReq instance
                     */
                    BuyMembershipStartReq.create = function create(properties) {
                        return new BuyMembershipStartReq(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipStartReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipStartReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartReq} message BuyMembershipStartReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipStartReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.membershipGrade);
                        if (message.payType != null && Object.hasOwnProperty.call(message, "payType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.payType);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipStartReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipStartReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartReq} message BuyMembershipStartReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipStartReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipStartReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartReq} BuyMembershipStartReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipStartReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipStartReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.payType = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipStartReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartReq} BuyMembershipStartReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipStartReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipStartReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipStartReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            if (!$util.isInteger(message.membershipGrade))
                                return "membershipGrade: integer expected";
                        if (message.payType != null && message.hasOwnProperty("payType"))
                            if (!$util.isInteger(message.payType))
                                return "payType: integer expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipStartReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartReq} BuyMembershipStartReq
                     */
                    BuyMembershipStartReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipStartReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipStartReq();
                        if (object.membershipGrade != null)
                            message.membershipGrade = object.membershipGrade | 0;
                        if (object.payType != null)
                            message.payType = object.payType | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipStartReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipStartReq} message BuyMembershipStartReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipStartReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.membershipGrade = 0;
                            object.payType = 0;
                        }
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = message.membershipGrade;
                        if (message.payType != null && message.hasOwnProperty("payType"))
                            object.payType = message.payType;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipStartReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipStartReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipStartReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipStartReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipStartReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipStartReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70000 COMMAND_NO value
                     */
                    BuyMembershipStartReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70000] = "COMMAND_NO"] = 70000;
                        return values;
                    })();

                    return BuyMembershipStartReq;
                })();

                web.BuyMembershipStartResp = (function() {

                    /**
                     * Properties of a BuyMembershipStartResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipStartResp
                     * @property {kuma.jp.protobuf.web.BuyMembershipStartResp.Status|null} [status] BuyMembershipStartResp status
                     * @property {string|null} [url] BuyMembershipStartResp url
                     * @property {string|null} [postJson] BuyMembershipStartResp postJson
                     */

                    /**
                     * Constructs a new BuyMembershipStartResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipStartResp.
                     * @implements IBuyMembershipStartResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartResp=} [properties] Properties to set
                     */
                    function BuyMembershipStartResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipStartResp status.
                     * @member {kuma.jp.protobuf.web.BuyMembershipStartResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @instance
                     */
                    BuyMembershipStartResp.prototype.status = 0;

                    /**
                     * BuyMembershipStartResp url.
                     * @member {string} url
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @instance
                     */
                    BuyMembershipStartResp.prototype.url = "";

                    /**
                     * BuyMembershipStartResp postJson.
                     * @member {string} postJson
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @instance
                     */
                    BuyMembershipStartResp.prototype.postJson = "";

                    /**
                     * Creates a new BuyMembershipStartResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartResp} BuyMembershipStartResp instance
                     */
                    BuyMembershipStartResp.create = function create(properties) {
                        return new BuyMembershipStartResp(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipStartResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipStartResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartResp} message BuyMembershipStartResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipStartResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                        if (message.postJson != null && Object.hasOwnProperty.call(message, "postJson"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.postJson);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipStartResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipStartResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipStartResp} message BuyMembershipStartResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipStartResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipStartResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartResp} BuyMembershipStartResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipStartResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipStartResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.url = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.postJson = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipStartResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartResp} BuyMembershipStartResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipStartResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipStartResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipStartResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        if (message.postJson != null && message.hasOwnProperty("postJson"))
                            if (!$util.isString(message.postJson))
                                return "postJson: string expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipStartResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipStartResp} BuyMembershipStartResp
                     */
                    BuyMembershipStartResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipStartResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipStartResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        case "ALREADY_PURCHASED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.url != null)
                            message.url = String(object.url);
                        if (object.postJson != null)
                            message.postJson = String(object.postJson);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipStartResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipStartResp} message BuyMembershipStartResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipStartResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.url = "";
                            object.postJson = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BuyMembershipStartResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BuyMembershipStartResp.Status[message.status] : message.status;
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        if (message.postJson != null && message.hasOwnProperty("postJson"))
                            object.postJson = message.postJson;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipStartResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipStartResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipStartResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipStartResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipStartResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipStartResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipStartResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70001 COMMAND_NO value
                     */
                    BuyMembershipStartResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70001] = "COMMAND_NO"] = 70001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipStartResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     * @property {number} ALREADY_PURCHASED=3 ALREADY_PURCHASED value
                     */
                    BuyMembershipStartResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        values[valuesById[3] = "ALREADY_PURCHASED"] = 3;
                        return values;
                    })();

                    return BuyMembershipStartResp;
                })();

                web.BuyMembershipUnsubscribeReq = (function() {

                    /**
                     * Properties of a BuyMembershipUnsubscribeReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipUnsubscribeReq
                     */

                    /**
                     * Constructs a new BuyMembershipUnsubscribeReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipUnsubscribeReq.
                     * @implements IBuyMembershipUnsubscribeReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeReq=} [properties] Properties to set
                     */
                    function BuyMembershipUnsubscribeReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BuyMembershipUnsubscribeReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq} BuyMembershipUnsubscribeReq instance
                     */
                    BuyMembershipUnsubscribeReq.create = function create(properties) {
                        return new BuyMembershipUnsubscribeReq(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipUnsubscribeReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeReq} message BuyMembershipUnsubscribeReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUnsubscribeReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipUnsubscribeReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeReq} message BuyMembershipUnsubscribeReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUnsubscribeReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipUnsubscribeReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq} BuyMembershipUnsubscribeReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUnsubscribeReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipUnsubscribeReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq} BuyMembershipUnsubscribeReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUnsubscribeReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipUnsubscribeReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipUnsubscribeReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipUnsubscribeReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq} BuyMembershipUnsubscribeReq
                     */
                    BuyMembershipUnsubscribeReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq();
                    };

                    /**
                     * Creates a plain object from a BuyMembershipUnsubscribeReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq} message BuyMembershipUnsubscribeReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipUnsubscribeReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BuyMembershipUnsubscribeReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipUnsubscribeReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipUnsubscribeReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipUnsubscribeReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipUnsubscribeReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70700 COMMAND_NO value
                     */
                    BuyMembershipUnsubscribeReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70700] = "COMMAND_NO"] = 70700;
                        return values;
                    })();

                    return BuyMembershipUnsubscribeReq;
                })();

                web.BuyMembershipUnsubscribeResp = (function() {

                    /**
                     * Properties of a BuyMembershipUnsubscribeResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipUnsubscribeResp
                     * @property {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.Status|null} [status] BuyMembershipUnsubscribeResp status
                     * @property {number|null} [membershipGrade] BuyMembershipUnsubscribeResp membershipGrade
                     */

                    /**
                     * Constructs a new BuyMembershipUnsubscribeResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipUnsubscribeResp.
                     * @implements IBuyMembershipUnsubscribeResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeResp=} [properties] Properties to set
                     */
                    function BuyMembershipUnsubscribeResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipUnsubscribeResp status.
                     * @member {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.Status} status
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @instance
                     */
                    BuyMembershipUnsubscribeResp.prototype.status = 0;

                    /**
                     * BuyMembershipUnsubscribeResp membershipGrade.
                     * @member {number} membershipGrade
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @instance
                     */
                    BuyMembershipUnsubscribeResp.prototype.membershipGrade = 0;

                    /**
                     * Creates a new BuyMembershipUnsubscribeResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp} BuyMembershipUnsubscribeResp instance
                     */
                    BuyMembershipUnsubscribeResp.create = function create(properties) {
                        return new BuyMembershipUnsubscribeResp(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipUnsubscribeResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeResp} message BuyMembershipUnsubscribeResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUnsubscribeResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.membershipGrade);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipUnsubscribeResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUnsubscribeResp} message BuyMembershipUnsubscribeResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUnsubscribeResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipUnsubscribeResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp} BuyMembershipUnsubscribeResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUnsubscribeResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipUnsubscribeResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp} BuyMembershipUnsubscribeResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUnsubscribeResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipUnsubscribeResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipUnsubscribeResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            if (!$util.isInteger(message.membershipGrade))
                                return "membershipGrade: integer expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipUnsubscribeResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp} BuyMembershipUnsubscribeResp
                     */
                    BuyMembershipUnsubscribeResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.membershipGrade != null)
                            message.membershipGrade = object.membershipGrade | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipUnsubscribeResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp} message BuyMembershipUnsubscribeResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipUnsubscribeResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.membershipGrade = 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.Status[message.status] : message.status;
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = message.membershipGrade;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipUnsubscribeResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipUnsubscribeResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipUnsubscribeResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipUnsubscribeResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70701 COMMAND_NO value
                     */
                    BuyMembershipUnsubscribeResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70701] = "COMMAND_NO"] = 70701;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipUnsubscribeResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    BuyMembershipUnsubscribeResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    return BuyMembershipUnsubscribeResp;
                })();

                web.BuyMembershipUpdateReq = (function() {

                    /**
                     * Properties of a BuyMembershipUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipUpdateReq
                     */

                    /**
                     * Constructs a new BuyMembershipUpdateReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipUpdateReq.
                     * @implements IBuyMembershipUpdateReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateReq=} [properties] Properties to set
                     */
                    function BuyMembershipUpdateReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new BuyMembershipUpdateReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateReq} BuyMembershipUpdateReq instance
                     */
                    BuyMembershipUpdateReq.create = function create(properties) {
                        return new BuyMembershipUpdateReq(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipUpdateReq message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUpdateReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateReq} message BuyMembershipUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUpdateReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipUpdateReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUpdateReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateReq} message BuyMembershipUpdateReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUpdateReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipUpdateReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateReq} BuyMembershipUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUpdateReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipUpdateReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipUpdateReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateReq} BuyMembershipUpdateReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUpdateReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipUpdateReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipUpdateReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipUpdateReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateReq} BuyMembershipUpdateReq
                     */
                    BuyMembershipUpdateReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipUpdateReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.BuyMembershipUpdateReq();
                    };

                    /**
                     * Creates a plain object from a BuyMembershipUpdateReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipUpdateReq} message BuyMembershipUpdateReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipUpdateReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this BuyMembershipUpdateReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipUpdateReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipUpdateReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipUpdateReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipUpdateReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipUpdateReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70400 COMMAND_NO value
                     */
                    BuyMembershipUpdateReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70400] = "COMMAND_NO"] = 70400;
                        return values;
                    })();

                    return BuyMembershipUpdateReq;
                })();

                web.BuyMembershipUpdateResp = (function() {

                    /**
                     * Properties of a BuyMembershipUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IBuyMembershipUpdateResp
                     * @property {number|null} [receiptStatus] BuyMembershipUpdateResp receiptStatus
                     * @property {number|null} [subscribeStatus] BuyMembershipUpdateResp subscribeStatus
                     * @property {number|null} [membershipGrade] BuyMembershipUpdateResp membershipGrade
                     */

                    /**
                     * Constructs a new BuyMembershipUpdateResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a BuyMembershipUpdateResp.
                     * @implements IBuyMembershipUpdateResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateResp=} [properties] Properties to set
                     */
                    function BuyMembershipUpdateResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BuyMembershipUpdateResp receiptStatus.
                     * @member {number} receiptStatus
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @instance
                     */
                    BuyMembershipUpdateResp.prototype.receiptStatus = 0;

                    /**
                     * BuyMembershipUpdateResp subscribeStatus.
                     * @member {number} subscribeStatus
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @instance
                     */
                    BuyMembershipUpdateResp.prototype.subscribeStatus = 0;

                    /**
                     * BuyMembershipUpdateResp membershipGrade.
                     * @member {number} membershipGrade
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @instance
                     */
                    BuyMembershipUpdateResp.prototype.membershipGrade = 0;

                    /**
                     * Creates a new BuyMembershipUpdateResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateResp} BuyMembershipUpdateResp instance
                     */
                    BuyMembershipUpdateResp.create = function create(properties) {
                        return new BuyMembershipUpdateResp(properties);
                    };

                    /**
                     * Encodes the specified BuyMembershipUpdateResp message. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUpdateResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateResp} message BuyMembershipUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUpdateResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.receiptStatus != null && Object.hasOwnProperty.call(message, "receiptStatus"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.receiptStatus);
                        if (message.subscribeStatus != null && Object.hasOwnProperty.call(message, "subscribeStatus"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.subscribeStatus);
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.membershipGrade);
                        return writer;
                    };

                    /**
                     * Encodes the specified BuyMembershipUpdateResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.BuyMembershipUpdateResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IBuyMembershipUpdateResp} message BuyMembershipUpdateResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuyMembershipUpdateResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BuyMembershipUpdateResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateResp} BuyMembershipUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUpdateResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.BuyMembershipUpdateResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.receiptStatus = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.subscribeStatus = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BuyMembershipUpdateResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateResp} BuyMembershipUpdateResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuyMembershipUpdateResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BuyMembershipUpdateResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuyMembershipUpdateResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.receiptStatus != null && message.hasOwnProperty("receiptStatus"))
                            if (!$util.isInteger(message.receiptStatus))
                                return "receiptStatus: integer expected";
                        if (message.subscribeStatus != null && message.hasOwnProperty("subscribeStatus"))
                            if (!$util.isInteger(message.subscribeStatus))
                                return "subscribeStatus: integer expected";
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            if (!$util.isInteger(message.membershipGrade))
                                return "membershipGrade: integer expected";
                        return null;
                    };

                    /**
                     * Creates a BuyMembershipUpdateResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.BuyMembershipUpdateResp} BuyMembershipUpdateResp
                     */
                    BuyMembershipUpdateResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.BuyMembershipUpdateResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.BuyMembershipUpdateResp();
                        if (object.receiptStatus != null)
                            message.receiptStatus = object.receiptStatus | 0;
                        if (object.subscribeStatus != null)
                            message.subscribeStatus = object.subscribeStatus | 0;
                        if (object.membershipGrade != null)
                            message.membershipGrade = object.membershipGrade | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a BuyMembershipUpdateResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {kuma.jp.protobuf.web.BuyMembershipUpdateResp} message BuyMembershipUpdateResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuyMembershipUpdateResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.receiptStatus = 0;
                            object.subscribeStatus = 0;
                            object.membershipGrade = 0;
                        }
                        if (message.receiptStatus != null && message.hasOwnProperty("receiptStatus"))
                            object.receiptStatus = message.receiptStatus;
                        if (message.subscribeStatus != null && message.hasOwnProperty("subscribeStatus"))
                            object.subscribeStatus = message.subscribeStatus;
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = message.membershipGrade;
                        return object;
                    };

                    /**
                     * Converts this BuyMembershipUpdateResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuyMembershipUpdateResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BuyMembershipUpdateResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.BuyMembershipUpdateResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BuyMembershipUpdateResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.BuyMembershipUpdateResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.BuyMembershipUpdateResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=70401 COMMAND_NO value
                     */
                    BuyMembershipUpdateResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[70401] = "COMMAND_NO"] = 70401;
                        return values;
                    })();

                    return BuyMembershipUpdateResp;
                })();

                web.CampaignFriendHistoryReq = (function() {

                    /**
                     * Properties of a CampaignFriendHistoryReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendHistoryReq
                     */

                    /**
                     * Constructs a new CampaignFriendHistoryReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendHistoryReq.
                     * @implements ICampaignFriendHistoryReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryReq=} [properties] Properties to set
                     */
                    function CampaignFriendHistoryReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new CampaignFriendHistoryReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryReq} CampaignFriendHistoryReq instance
                     */
                    CampaignFriendHistoryReq.create = function create(properties) {
                        return new CampaignFriendHistoryReq(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendHistoryReq message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryReq} message CampaignFriendHistoryReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendHistoryReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendHistoryReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryReq} message CampaignFriendHistoryReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendHistoryReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendHistoryReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryReq} CampaignFriendHistoryReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendHistoryReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendHistoryReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendHistoryReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryReq} CampaignFriendHistoryReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendHistoryReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendHistoryReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendHistoryReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendHistoryReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryReq} CampaignFriendHistoryReq
                     */
                    CampaignFriendHistoryReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendHistoryReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.CampaignFriendHistoryReq();
                    };

                    /**
                     * Creates a plain object from a CampaignFriendHistoryReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendHistoryReq} message CampaignFriendHistoryReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendHistoryReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this CampaignFriendHistoryReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendHistoryReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendHistoryReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendHistoryReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendHistoryReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendHistoryReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43200 COMMAND_NO value
                     */
                    CampaignFriendHistoryReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43200] = "COMMAND_NO"] = 43200;
                        return values;
                    })();

                    return CampaignFriendHistoryReq;
                })();

                web.CampaignFriendHistoryResp = (function() {

                    /**
                     * Properties of a CampaignFriendHistoryResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendHistoryResp
                     * @property {kuma.jp.protobuf.web.CampaignFriendHistoryResp.Status|null} [status] CampaignFriendHistoryResp status
                     * @property {Array.<kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog>|null} [playLogList] CampaignFriendHistoryResp playLogList
                     */

                    /**
                     * Constructs a new CampaignFriendHistoryResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendHistoryResp.
                     * @implements ICampaignFriendHistoryResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryResp=} [properties] Properties to set
                     */
                    function CampaignFriendHistoryResp(properties) {
                        this.playLogList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CampaignFriendHistoryResp status.
                     * @member {kuma.jp.protobuf.web.CampaignFriendHistoryResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @instance
                     */
                    CampaignFriendHistoryResp.prototype.status = 0;

                    /**
                     * CampaignFriendHistoryResp playLogList.
                     * @member {Array.<kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog>} playLogList
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @instance
                     */
                    CampaignFriendHistoryResp.prototype.playLogList = $util.emptyArray;

                    /**
                     * Creates a new CampaignFriendHistoryResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp} CampaignFriendHistoryResp instance
                     */
                    CampaignFriendHistoryResp.create = function create(properties) {
                        return new CampaignFriendHistoryResp(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendHistoryResp message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryResp} message CampaignFriendHistoryResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendHistoryResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.playLogList != null && message.playLogList.length)
                            for (let i = 0; i < message.playLogList.length; ++i)
                                $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.encode(message.playLogList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendHistoryResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendHistoryResp} message CampaignFriendHistoryResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendHistoryResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendHistoryResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp} CampaignFriendHistoryResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendHistoryResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.playLogList && message.playLogList.length))
                                        message.playLogList = [];
                                    message.playLogList.push($root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendHistoryResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp} CampaignFriendHistoryResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendHistoryResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendHistoryResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendHistoryResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.playLogList != null && message.hasOwnProperty("playLogList")) {
                            if (!Array.isArray(message.playLogList))
                                return "playLogList: array expected";
                            for (let i = 0; i < message.playLogList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.verify(message.playLogList[i]);
                                if (error)
                                    return "playLogList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendHistoryResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp} CampaignFriendHistoryResp
                     */
                    CampaignFriendHistoryResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "NO_CAMPAIGN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.playLogList) {
                            if (!Array.isArray(object.playLogList))
                                throw TypeError(".kuma.jp.protobuf.web.CampaignFriendHistoryResp.playLogList: array expected");
                            message.playLogList = [];
                            for (let i = 0; i < object.playLogList.length; ++i) {
                                if (typeof object.playLogList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.CampaignFriendHistoryResp.playLogList: object expected");
                                message.playLogList[i] = $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.fromObject(object.playLogList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CampaignFriendHistoryResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp} message CampaignFriendHistoryResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendHistoryResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.playLogList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.Status[message.status] : message.status;
                        if (message.playLogList && message.playLogList.length) {
                            object.playLogList = [];
                            for (let j = 0; j < message.playLogList.length; ++j)
                                object.playLogList[j] = $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.toObject(message.playLogList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this CampaignFriendHistoryResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendHistoryResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendHistoryResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendHistoryResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendHistoryResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendHistoryResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43201 COMMAND_NO value
                     */
                    CampaignFriendHistoryResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43201] = "COMMAND_NO"] = 43201;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendHistoryResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} NO_CAMPAIGN=2 NO_CAMPAIGN value
                     */
                    CampaignFriendHistoryResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "NO_CAMPAIGN"] = 2;
                        return values;
                    })();

                    CampaignFriendHistoryResp.PlayLog = (function() {

                        /**
                         * Properties of a PlayLog.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                         * @interface IPlayLog
                         * @property {Array.<string>|null} [friendName] PlayLog friendName
                         * @property {number|Long|null} [createTime] PlayLog createTime
                         */

                        /**
                         * Constructs a new PlayLog.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp
                         * @classdesc Represents a PlayLog.
                         * @implements IPlayLog
                         * @constructor
                         * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog=} [properties] Properties to set
                         */
                        function PlayLog(properties) {
                            this.friendName = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * PlayLog friendName.
                         * @member {Array.<string>} friendName
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @instance
                         */
                        PlayLog.prototype.friendName = $util.emptyArray;

                        /**
                         * PlayLog createTime.
                         * @member {number|Long} createTime
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @instance
                         */
                        PlayLog.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Creates a new PlayLog instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog} PlayLog instance
                         */
                        PlayLog.create = function create(properties) {
                            return new PlayLog(properties);
                        };

                        /**
                         * Encodes the specified PlayLog message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog} message PlayLog message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PlayLog.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.friendName != null && message.friendName.length)
                                for (let i = 0; i < message.friendName.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.friendName[i]);
                            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.createTime);
                            return writer;
                        };

                        /**
                         * Encodes the specified PlayLog message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp.IPlayLog} message PlayLog message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PlayLog.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a PlayLog message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog} PlayLog
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PlayLog.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        if (!(message.friendName && message.friendName.length))
                                            message.friendName = [];
                                        message.friendName.push(reader.string());
                                        break;
                                    }
                                case 2: {
                                        message.createTime = reader.int64();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a PlayLog message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog} PlayLog
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PlayLog.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a PlayLog message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PlayLog.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.friendName != null && message.hasOwnProperty("friendName")) {
                                if (!Array.isArray(message.friendName))
                                    return "friendName: array expected";
                                for (let i = 0; i < message.friendName.length; ++i)
                                    if (!$util.isString(message.friendName[i]))
                                        return "friendName: string[] expected";
                            }
                            if (message.createTime != null && message.hasOwnProperty("createTime"))
                                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                                    return "createTime: integer|Long expected";
                            return null;
                        };

                        /**
                         * Creates a PlayLog message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog} PlayLog
                         */
                        PlayLog.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog();
                            if (object.friendName) {
                                if (!Array.isArray(object.friendName))
                                    throw TypeError(".kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog.friendName: array expected");
                                message.friendName = [];
                                for (let i = 0; i < object.friendName.length; ++i)
                                    message.friendName[i] = String(object.friendName[i]);
                            }
                            if (object.createTime != null)
                                if ($util.Long)
                                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                                else if (typeof object.createTime === "string")
                                    message.createTime = parseInt(object.createTime, 10);
                                else if (typeof object.createTime === "number")
                                    message.createTime = object.createTime;
                                else if (typeof object.createTime === "object")
                                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                            return message;
                        };

                        /**
                         * Creates a plain object from a PlayLog message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog} message PlayLog
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PlayLog.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.friendName = [];
                            if (options.defaults)
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.createTime = options.longs === String ? "0" : 0;
                            if (message.friendName && message.friendName.length) {
                                object.friendName = [];
                                for (let j = 0; j < message.friendName.length; ++j)
                                    object.friendName[j] = message.friendName[j];
                            }
                            if (message.createTime != null && message.hasOwnProperty("createTime"))
                                if (typeof message.createTime === "number")
                                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                                else
                                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                            return object;
                        };

                        /**
                         * Converts this PlayLog to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PlayLog.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for PlayLog
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        PlayLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendHistoryResp.PlayLog";
                        };

                        return PlayLog;
                    })();

                    return CampaignFriendHistoryResp;
                })();

                web.CampaignFriendItemGetReq = (function() {

                    /**
                     * Properties of a CampaignFriendItemGetReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendItemGetReq
                     * @property {number|null} [stepId] CampaignFriendItemGetReq stepId
                     */

                    /**
                     * Constructs a new CampaignFriendItemGetReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendItemGetReq.
                     * @implements ICampaignFriendItemGetReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetReq=} [properties] Properties to set
                     */
                    function CampaignFriendItemGetReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CampaignFriendItemGetReq stepId.
                     * @member {number} stepId
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @instance
                     */
                    CampaignFriendItemGetReq.prototype.stepId = 0;

                    /**
                     * Creates a new CampaignFriendItemGetReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetReq} CampaignFriendItemGetReq instance
                     */
                    CampaignFriendItemGetReq.create = function create(properties) {
                        return new CampaignFriendItemGetReq(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendItemGetReq message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetReq} message CampaignFriendItemGetReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendItemGetReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.stepId != null && Object.hasOwnProperty.call(message, "stepId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.stepId);
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendItemGetReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetReq} message CampaignFriendItemGetReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendItemGetReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendItemGetReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetReq} CampaignFriendItemGetReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendItemGetReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.stepId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendItemGetReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetReq} CampaignFriendItemGetReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendItemGetReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendItemGetReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendItemGetReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.stepId != null && message.hasOwnProperty("stepId"))
                            if (!$util.isInteger(message.stepId))
                                return "stepId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendItemGetReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetReq} CampaignFriendItemGetReq
                     */
                    CampaignFriendItemGetReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendItemGetReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetReq();
                        if (object.stepId != null)
                            message.stepId = object.stepId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a CampaignFriendItemGetReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendItemGetReq} message CampaignFriendItemGetReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendItemGetReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.stepId = 0;
                        if (message.stepId != null && message.hasOwnProperty("stepId"))
                            object.stepId = message.stepId;
                        return object;
                    };

                    /**
                     * Converts this CampaignFriendItemGetReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendItemGetReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendItemGetReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendItemGetReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendItemGetReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendItemGetReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43100 COMMAND_NO value
                     */
                    CampaignFriendItemGetReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43100] = "COMMAND_NO"] = 43100;
                        return values;
                    })();

                    return CampaignFriendItemGetReq;
                })();

                web.CampaignFriendItemGetResp = (function() {

                    /**
                     * Properties of a CampaignFriendItemGetResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendItemGetResp
                     * @property {kuma.jp.protobuf.web.CampaignFriendItemGetResp.Status|null} [status] CampaignFriendItemGetResp status
                     * @property {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null} [stepBoarderInfo] CampaignFriendItemGetResp stepBoarderInfo
                     * @property {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null} [completeBoarderInfo] CampaignFriendItemGetResp completeBoarderInfo
                     * @property {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null} [nextBoarderInfo] CampaignFriendItemGetResp nextBoarderInfo
                     */

                    /**
                     * Constructs a new CampaignFriendItemGetResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendItemGetResp.
                     * @implements ICampaignFriendItemGetResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetResp=} [properties] Properties to set
                     */
                    function CampaignFriendItemGetResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CampaignFriendItemGetResp status.
                     * @member {kuma.jp.protobuf.web.CampaignFriendItemGetResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @instance
                     */
                    CampaignFriendItemGetResp.prototype.status = 0;

                    /**
                     * CampaignFriendItemGetResp stepBoarderInfo.
                     * @member {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null|undefined} stepBoarderInfo
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @instance
                     */
                    CampaignFriendItemGetResp.prototype.stepBoarderInfo = null;

                    /**
                     * CampaignFriendItemGetResp completeBoarderInfo.
                     * @member {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null|undefined} completeBoarderInfo
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @instance
                     */
                    CampaignFriendItemGetResp.prototype.completeBoarderInfo = null;

                    /**
                     * CampaignFriendItemGetResp nextBoarderInfo.
                     * @member {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo|null|undefined} nextBoarderInfo
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @instance
                     */
                    CampaignFriendItemGetResp.prototype.nextBoarderInfo = null;

                    /**
                     * Creates a new CampaignFriendItemGetResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp} CampaignFriendItemGetResp instance
                     */
                    CampaignFriendItemGetResp.create = function create(properties) {
                        return new CampaignFriendItemGetResp(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendItemGetResp message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetResp} message CampaignFriendItemGetResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendItemGetResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.stepBoarderInfo != null && Object.hasOwnProperty.call(message, "stepBoarderInfo"))
                            $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.encode(message.stepBoarderInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.completeBoarderInfo != null && Object.hasOwnProperty.call(message, "completeBoarderInfo"))
                            $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.encode(message.completeBoarderInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.nextBoarderInfo != null && Object.hasOwnProperty.call(message, "nextBoarderInfo"))
                            $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.encode(message.nextBoarderInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendItemGetResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendItemGetResp} message CampaignFriendItemGetResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendItemGetResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendItemGetResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp} CampaignFriendItemGetResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendItemGetResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.stepBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.decode(reader, reader.uint32());
                                    break;
                                }
                            case 3: {
                                    message.completeBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.decode(reader, reader.uint32());
                                    break;
                                }
                            case 4: {
                                    message.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendItemGetResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp} CampaignFriendItemGetResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendItemGetResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendItemGetResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendItemGetResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.stepBoarderInfo != null && message.hasOwnProperty("stepBoarderInfo")) {
                            let error = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.verify(message.stepBoarderInfo);
                            if (error)
                                return "stepBoarderInfo." + error;
                        }
                        if (message.completeBoarderInfo != null && message.hasOwnProperty("completeBoarderInfo")) {
                            let error = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.verify(message.completeBoarderInfo);
                            if (error)
                                return "completeBoarderInfo." + error;
                        }
                        if (message.nextBoarderInfo != null && message.hasOwnProperty("nextBoarderInfo")) {
                            let error = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.verify(message.nextBoarderInfo);
                            if (error)
                                return "nextBoarderInfo." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendItemGetResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp} CampaignFriendItemGetResp
                     */
                    CampaignFriendItemGetResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "NO_CAMPAIGN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.stepBoarderInfo != null) {
                            if (typeof object.stepBoarderInfo !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.CampaignFriendItemGetResp.stepBoarderInfo: object expected");
                            message.stepBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.fromObject(object.stepBoarderInfo);
                        }
                        if (object.completeBoarderInfo != null) {
                            if (typeof object.completeBoarderInfo !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.CampaignFriendItemGetResp.completeBoarderInfo: object expected");
                            message.completeBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.fromObject(object.completeBoarderInfo);
                        }
                        if (object.nextBoarderInfo != null) {
                            if (typeof object.nextBoarderInfo !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.CampaignFriendItemGetResp.nextBoarderInfo: object expected");
                            message.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.fromObject(object.nextBoarderInfo);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CampaignFriendItemGetResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp} message CampaignFriendItemGetResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendItemGetResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.stepBoarderInfo = null;
                            object.completeBoarderInfo = null;
                            object.nextBoarderInfo = null;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.Status[message.status] : message.status;
                        if (message.stepBoarderInfo != null && message.hasOwnProperty("stepBoarderInfo"))
                            object.stepBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.toObject(message.stepBoarderInfo, options);
                        if (message.completeBoarderInfo != null && message.hasOwnProperty("completeBoarderInfo"))
                            object.completeBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.toObject(message.completeBoarderInfo, options);
                        if (message.nextBoarderInfo != null && message.hasOwnProperty("nextBoarderInfo"))
                            object.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.toObject(message.nextBoarderInfo, options);
                        return object;
                    };

                    /**
                     * Converts this CampaignFriendItemGetResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendItemGetResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendItemGetResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendItemGetResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendItemGetResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendItemGetResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43101 COMMAND_NO value
                     */
                    CampaignFriendItemGetResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43101] = "COMMAND_NO"] = 43101;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendItemGetResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} NO_CAMPAIGN=2 NO_CAMPAIGN value
                     */
                    CampaignFriendItemGetResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "NO_CAMPAIGN"] = 2;
                        return values;
                    })();

                    CampaignFriendItemGetResp.BoarderInfo = (function() {

                        /**
                         * Properties of a BoarderInfo.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                         * @interface IBoarderInfo
                         * @property {number|null} [stepId] BoarderInfo stepId
                         * @property {number|null} [boarderPoint] BoarderInfo boarderPoint
                         * @property {number|null} [bonusType] BoarderInfo bonusType
                         * @property {number|null} [itemId] BoarderInfo itemId
                         * @property {string|null} [itemNum] BoarderInfo itemNum
                         * @property {string|null} [name] BoarderInfo name
                         * @property {string|null} [imagePath] BoarderInfo imagePath
                         * @property {number|null} [type] BoarderInfo type
                         * @property {number|null} [kind] BoarderInfo kind
                         * @property {string|null} [kindText] BoarderInfo kindText
                         * @property {string|null} [description] BoarderInfo description
                         * @property {string|null} [advertise] BoarderInfo advertise
                         * @property {number|Long|null} [startTime] BoarderInfo startTime
                         * @property {number|Long|null} [endTime] BoarderInfo endTime
                         * @property {number|null} [optionId] BoarderInfo optionId
                         */

                        /**
                         * Constructs a new BoarderInfo.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp
                         * @classdesc Represents a BoarderInfo.
                         * @implements IBoarderInfo
                         * @constructor
                         * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo=} [properties] Properties to set
                         */
                        function BoarderInfo(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * BoarderInfo stepId.
                         * @member {number} stepId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.stepId = 0;

                        /**
                         * BoarderInfo boarderPoint.
                         * @member {number} boarderPoint
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.boarderPoint = 0;

                        /**
                         * BoarderInfo bonusType.
                         * @member {number} bonusType
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.bonusType = 0;

                        /**
                         * BoarderInfo itemId.
                         * @member {number} itemId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.itemId = 0;

                        /**
                         * BoarderInfo itemNum.
                         * @member {string} itemNum
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.itemNum = "";

                        /**
                         * BoarderInfo name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.name = "";

                        /**
                         * BoarderInfo imagePath.
                         * @member {string} imagePath
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.imagePath = "";

                        /**
                         * BoarderInfo type.
                         * @member {number} type
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.type = 0;

                        /**
                         * BoarderInfo kind.
                         * @member {number} kind
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.kind = 0;

                        /**
                         * BoarderInfo kindText.
                         * @member {string} kindText
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.kindText = "";

                        /**
                         * BoarderInfo description.
                         * @member {string} description
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.description = "";

                        /**
                         * BoarderInfo advertise.
                         * @member {string} advertise
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.advertise = "";

                        /**
                         * BoarderInfo startTime.
                         * @member {number|Long} startTime
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BoarderInfo endTime.
                         * @member {number|Long} endTime
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BoarderInfo optionId.
                         * @member {number} optionId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.optionId = 0;

                        /**
                         * Creates a new BoarderInfo instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo} BoarderInfo instance
                         */
                        BoarderInfo.create = function create(properties) {
                            return new BoarderInfo(properties);
                        };

                        /**
                         * Encodes the specified BoarderInfo message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo} message BoarderInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoarderInfo.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.stepId != null && Object.hasOwnProperty.call(message, "stepId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.stepId);
                            if (message.boarderPoint != null && Object.hasOwnProperty.call(message, "boarderPoint"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.boarderPoint);
                            if (message.bonusType != null && Object.hasOwnProperty.call(message, "bonusType"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bonusType);
                            if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.itemId);
                            if (message.itemNum != null && Object.hasOwnProperty.call(message, "itemNum"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.itemNum);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
                            if (message.imagePath != null && Object.hasOwnProperty.call(message, "imagePath"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.imagePath);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.type);
                            if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.kind);
                            if (message.kindText != null && Object.hasOwnProperty.call(message, "kindText"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.kindText);
                            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.description);
                            if (message.advertise != null && Object.hasOwnProperty.call(message, "advertise"))
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.advertise);
                            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.startTime);
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.endTime);
                            if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.optionId);
                            return writer;
                        };

                        /**
                         * Encodes the specified BoarderInfo message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp.IBoarderInfo} message BoarderInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoarderInfo.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a BoarderInfo message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo} BoarderInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoarderInfo.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.stepId = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.boarderPoint = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.bonusType = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.itemId = reader.int32();
                                        break;
                                    }
                                case 5: {
                                        message.itemNum = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 7: {
                                        message.imagePath = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 9: {
                                        message.kind = reader.int32();
                                        break;
                                    }
                                case 10: {
                                        message.kindText = reader.string();
                                        break;
                                    }
                                case 11: {
                                        message.description = reader.string();
                                        break;
                                    }
                                case 12: {
                                        message.advertise = reader.string();
                                        break;
                                    }
                                case 13: {
                                        message.startTime = reader.int64();
                                        break;
                                    }
                                case 14: {
                                        message.endTime = reader.int64();
                                        break;
                                    }
                                case 15: {
                                        message.optionId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a BoarderInfo message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo} BoarderInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoarderInfo.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a BoarderInfo message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BoarderInfo.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.stepId != null && message.hasOwnProperty("stepId"))
                                if (!$util.isInteger(message.stepId))
                                    return "stepId: integer expected";
                            if (message.boarderPoint != null && message.hasOwnProperty("boarderPoint"))
                                if (!$util.isInteger(message.boarderPoint))
                                    return "boarderPoint: integer expected";
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                if (!$util.isInteger(message.bonusType))
                                    return "bonusType: integer expected";
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                if (!$util.isInteger(message.itemId))
                                    return "itemId: integer expected";
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                if (!$util.isString(message.itemNum))
                                    return "itemNum: string expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                if (!$util.isString(message.imagePath))
                                    return "imagePath: string expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                if (!$util.isInteger(message.type))
                                    return "type: integer expected";
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                if (!$util.isInteger(message.kind))
                                    return "kind: integer expected";
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                if (!$util.isString(message.kindText))
                                    return "kindText: string expected";
                            if (message.description != null && message.hasOwnProperty("description"))
                                if (!$util.isString(message.description))
                                    return "description: string expected";
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                if (!$util.isString(message.advertise))
                                    return "advertise: string expected";
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                    return "startTime: integer|Long expected";
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                    return "endTime: integer|Long expected";
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                if (!$util.isInteger(message.optionId))
                                    return "optionId: integer expected";
                            return null;
                        };

                        /**
                         * Creates a BoarderInfo message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo} BoarderInfo
                         */
                        BoarderInfo.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo();
                            if (object.stepId != null)
                                message.stepId = object.stepId | 0;
                            if (object.boarderPoint != null)
                                message.boarderPoint = object.boarderPoint | 0;
                            if (object.bonusType != null)
                                message.bonusType = object.bonusType | 0;
                            if (object.itemId != null)
                                message.itemId = object.itemId | 0;
                            if (object.itemNum != null)
                                message.itemNum = String(object.itemNum);
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.imagePath != null)
                                message.imagePath = String(object.imagePath);
                            if (object.type != null)
                                message.type = object.type | 0;
                            if (object.kind != null)
                                message.kind = object.kind | 0;
                            if (object.kindText != null)
                                message.kindText = String(object.kindText);
                            if (object.description != null)
                                message.description = String(object.description);
                            if (object.advertise != null)
                                message.advertise = String(object.advertise);
                            if (object.startTime != null)
                                if ($util.Long)
                                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                                else if (typeof object.startTime === "string")
                                    message.startTime = parseInt(object.startTime, 10);
                                else if (typeof object.startTime === "number")
                                    message.startTime = object.startTime;
                                else if (typeof object.startTime === "object")
                                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                            if (object.endTime != null)
                                if ($util.Long)
                                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                                else if (typeof object.endTime === "string")
                                    message.endTime = parseInt(object.endTime, 10);
                                else if (typeof object.endTime === "number")
                                    message.endTime = object.endTime;
                                else if (typeof object.endTime === "object")
                                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                            if (object.optionId != null)
                                message.optionId = object.optionId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a BoarderInfo message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo} message BoarderInfo
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BoarderInfo.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.stepId = 0;
                                object.boarderPoint = 0;
                                object.bonusType = 0;
                                object.itemId = 0;
                                object.itemNum = "";
                                object.name = "";
                                object.imagePath = "";
                                object.type = 0;
                                object.kind = 0;
                                object.kindText = "";
                                object.description = "";
                                object.advertise = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startTime = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endTime = options.longs === String ? "0" : 0;
                                object.optionId = 0;
                            }
                            if (message.stepId != null && message.hasOwnProperty("stepId"))
                                object.stepId = message.stepId;
                            if (message.boarderPoint != null && message.hasOwnProperty("boarderPoint"))
                                object.boarderPoint = message.boarderPoint;
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                object.bonusType = message.bonusType;
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                object.itemId = message.itemId;
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                object.itemNum = message.itemNum;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                object.imagePath = message.imagePath;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = message.type;
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                object.kind = message.kind;
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                object.kindText = message.kindText;
                            if (message.description != null && message.hasOwnProperty("description"))
                                object.description = message.description;
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                object.advertise = message.advertise;
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (typeof message.startTime === "number")
                                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                                else
                                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (typeof message.endTime === "number")
                                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                                else
                                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                object.optionId = message.optionId;
                            return object;
                        };

                        /**
                         * Converts this BoarderInfo to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BoarderInfo.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for BoarderInfo
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        BoarderInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendItemGetResp.BoarderInfo";
                        };

                        return BoarderInfo;
                    })();

                    return CampaignFriendItemGetResp;
                })();

                web.CampaignFriendPointReq = (function() {

                    /**
                     * Properties of a CampaignFriendPointReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendPointReq
                     */

                    /**
                     * Constructs a new CampaignFriendPointReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendPointReq.
                     * @implements ICampaignFriendPointReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointReq=} [properties] Properties to set
                     */
                    function CampaignFriendPointReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new CampaignFriendPointReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointReq} CampaignFriendPointReq instance
                     */
                    CampaignFriendPointReq.create = function create(properties) {
                        return new CampaignFriendPointReq(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendPointReq message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointReq} message CampaignFriendPointReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendPointReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendPointReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointReq} message CampaignFriendPointReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendPointReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendPointReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointReq} CampaignFriendPointReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendPointReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendPointReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendPointReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointReq} CampaignFriendPointReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendPointReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendPointReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendPointReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendPointReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointReq} CampaignFriendPointReq
                     */
                    CampaignFriendPointReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendPointReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.CampaignFriendPointReq();
                    };

                    /**
                     * Creates a plain object from a CampaignFriendPointReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendPointReq} message CampaignFriendPointReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendPointReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this CampaignFriendPointReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendPointReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendPointReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendPointReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendPointReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendPointReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43000 COMMAND_NO value
                     */
                    CampaignFriendPointReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43000] = "COMMAND_NO"] = 43000;
                        return values;
                    })();

                    return CampaignFriendPointReq;
                })();

                web.CampaignFriendPointResp = (function() {

                    /**
                     * Properties of a CampaignFriendPointResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICampaignFriendPointResp
                     * @property {kuma.jp.protobuf.web.CampaignFriendPointResp.Status|null} [status] CampaignFriendPointResp status
                     * @property {number|null} [point] CampaignFriendPointResp point
                     * @property {number|null} [stepId] CampaignFriendPointResp stepId
                     * @property {string|null} [title] CampaignFriendPointResp title
                     * @property {number|Long|null} [startTime] CampaignFriendPointResp startTime
                     * @property {number|Long|null} [endTime] CampaignFriendPointResp endTime
                     * @property {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo|null} [nextBoarderInfo] CampaignFriendPointResp nextBoarderInfo
                     * @property {number|Long|null} [recievEndTime] CampaignFriendPointResp recievEndTime
                     * @property {boolean|null} [receiveTerm] CampaignFriendPointResp receiveTerm
                     * @property {number|null} [maxStepId] CampaignFriendPointResp maxStepId
                     * @property {number|null} [firstPoint] CampaignFriendPointResp firstPoint
                     * @property {number|null} [secondPoint] CampaignFriendPointResp secondPoint
                     */

                    /**
                     * Constructs a new CampaignFriendPointResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CampaignFriendPointResp.
                     * @implements ICampaignFriendPointResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointResp=} [properties] Properties to set
                     */
                    function CampaignFriendPointResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CampaignFriendPointResp status.
                     * @member {kuma.jp.protobuf.web.CampaignFriendPointResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.status = 0;

                    /**
                     * CampaignFriendPointResp point.
                     * @member {number} point
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.point = 0;

                    /**
                     * CampaignFriendPointResp stepId.
                     * @member {number} stepId
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.stepId = 0;

                    /**
                     * CampaignFriendPointResp title.
                     * @member {string} title
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.title = "";

                    /**
                     * CampaignFriendPointResp startTime.
                     * @member {number|Long} startTime
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CampaignFriendPointResp endTime.
                     * @member {number|Long} endTime
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CampaignFriendPointResp nextBoarderInfo.
                     * @member {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo|null|undefined} nextBoarderInfo
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.nextBoarderInfo = null;

                    /**
                     * CampaignFriendPointResp recievEndTime.
                     * @member {number|Long} recievEndTime
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.recievEndTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CampaignFriendPointResp receiveTerm.
                     * @member {boolean} receiveTerm
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.receiveTerm = false;

                    /**
                     * CampaignFriendPointResp maxStepId.
                     * @member {number} maxStepId
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.maxStepId = 0;

                    /**
                     * CampaignFriendPointResp firstPoint.
                     * @member {number} firstPoint
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.firstPoint = 0;

                    /**
                     * CampaignFriendPointResp secondPoint.
                     * @member {number} secondPoint
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     */
                    CampaignFriendPointResp.prototype.secondPoint = 0;

                    /**
                     * Creates a new CampaignFriendPointResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp} CampaignFriendPointResp instance
                     */
                    CampaignFriendPointResp.create = function create(properties) {
                        return new CampaignFriendPointResp(properties);
                    };

                    /**
                     * Encodes the specified CampaignFriendPointResp message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointResp} message CampaignFriendPointResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendPointResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.point);
                        if (message.stepId != null && Object.hasOwnProperty.call(message, "stepId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.stepId);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.endTime);
                        if (message.nextBoarderInfo != null && Object.hasOwnProperty.call(message, "nextBoarderInfo"))
                            $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.encode(message.nextBoarderInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.recievEndTime != null && Object.hasOwnProperty.call(message, "recievEndTime"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.recievEndTime);
                        if (message.receiveTerm != null && Object.hasOwnProperty.call(message, "receiveTerm"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.receiveTerm);
                        if (message.maxStepId != null && Object.hasOwnProperty.call(message, "maxStepId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.maxStepId);
                        if (message.firstPoint != null && Object.hasOwnProperty.call(message, "firstPoint"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.firstPoint);
                        if (message.secondPoint != null && Object.hasOwnProperty.call(message, "secondPoint"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.secondPoint);
                        return writer;
                    };

                    /**
                     * Encodes the specified CampaignFriendPointResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICampaignFriendPointResp} message CampaignFriendPointResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CampaignFriendPointResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CampaignFriendPointResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp} CampaignFriendPointResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendPointResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendPointResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.point = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.stepId = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.title = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.startTime = reader.int64();
                                    break;
                                }
                            case 6: {
                                    message.endTime = reader.int64();
                                    break;
                                }
                            case 7: {
                                    message.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.decode(reader, reader.uint32());
                                    break;
                                }
                            case 8: {
                                    message.recievEndTime = reader.int64();
                                    break;
                                }
                            case 9: {
                                    message.receiveTerm = reader.bool();
                                    break;
                                }
                            case 10: {
                                    message.maxStepId = reader.int32();
                                    break;
                                }
                            case 11: {
                                    message.firstPoint = reader.int32();
                                    break;
                                }
                            case 12: {
                                    message.secondPoint = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CampaignFriendPointResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp} CampaignFriendPointResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CampaignFriendPointResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CampaignFriendPointResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CampaignFriendPointResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.point != null && message.hasOwnProperty("point"))
                            if (!$util.isInteger(message.point))
                                return "point: integer expected";
                        if (message.stepId != null && message.hasOwnProperty("stepId"))
                            if (!$util.isInteger(message.stepId))
                                return "stepId: integer expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                return "startTime: integer|Long expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                return "endTime: integer|Long expected";
                        if (message.nextBoarderInfo != null && message.hasOwnProperty("nextBoarderInfo")) {
                            let error = $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.verify(message.nextBoarderInfo);
                            if (error)
                                return "nextBoarderInfo." + error;
                        }
                        if (message.recievEndTime != null && message.hasOwnProperty("recievEndTime"))
                            if (!$util.isInteger(message.recievEndTime) && !(message.recievEndTime && $util.isInteger(message.recievEndTime.low) && $util.isInteger(message.recievEndTime.high)))
                                return "recievEndTime: integer|Long expected";
                        if (message.receiveTerm != null && message.hasOwnProperty("receiveTerm"))
                            if (typeof message.receiveTerm !== "boolean")
                                return "receiveTerm: boolean expected";
                        if (message.maxStepId != null && message.hasOwnProperty("maxStepId"))
                            if (!$util.isInteger(message.maxStepId))
                                return "maxStepId: integer expected";
                        if (message.firstPoint != null && message.hasOwnProperty("firstPoint"))
                            if (!$util.isInteger(message.firstPoint))
                                return "firstPoint: integer expected";
                        if (message.secondPoint != null && message.hasOwnProperty("secondPoint"))
                            if (!$util.isInteger(message.secondPoint))
                                return "secondPoint: integer expected";
                        return null;
                    };

                    /**
                     * Creates a CampaignFriendPointResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp} CampaignFriendPointResp
                     */
                    CampaignFriendPointResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendPointResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CampaignFriendPointResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "NO_CAMPAIGN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.point != null)
                            message.point = object.point | 0;
                        if (object.stepId != null)
                            message.stepId = object.stepId | 0;
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.startTime != null)
                            if ($util.Long)
                                (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                            else if (typeof object.startTime === "string")
                                message.startTime = parseInt(object.startTime, 10);
                            else if (typeof object.startTime === "number")
                                message.startTime = object.startTime;
                            else if (typeof object.startTime === "object")
                                message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                        if (object.endTime != null)
                            if ($util.Long)
                                (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                            else if (typeof object.endTime === "string")
                                message.endTime = parseInt(object.endTime, 10);
                            else if (typeof object.endTime === "number")
                                message.endTime = object.endTime;
                            else if (typeof object.endTime === "object")
                                message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                        if (object.nextBoarderInfo != null) {
                            if (typeof object.nextBoarderInfo !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.CampaignFriendPointResp.nextBoarderInfo: object expected");
                            message.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.fromObject(object.nextBoarderInfo);
                        }
                        if (object.recievEndTime != null)
                            if ($util.Long)
                                (message.recievEndTime = $util.Long.fromValue(object.recievEndTime)).unsigned = false;
                            else if (typeof object.recievEndTime === "string")
                                message.recievEndTime = parseInt(object.recievEndTime, 10);
                            else if (typeof object.recievEndTime === "number")
                                message.recievEndTime = object.recievEndTime;
                            else if (typeof object.recievEndTime === "object")
                                message.recievEndTime = new $util.LongBits(object.recievEndTime.low >>> 0, object.recievEndTime.high >>> 0).toNumber();
                        if (object.receiveTerm != null)
                            message.receiveTerm = Boolean(object.receiveTerm);
                        if (object.maxStepId != null)
                            message.maxStepId = object.maxStepId | 0;
                        if (object.firstPoint != null)
                            message.firstPoint = object.firstPoint | 0;
                        if (object.secondPoint != null)
                            message.secondPoint = object.secondPoint | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a CampaignFriendPointResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CampaignFriendPointResp} message CampaignFriendPointResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CampaignFriendPointResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.point = 0;
                            object.stepId = 0;
                            object.title = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startTime = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.endTime = options.longs === String ? "0" : 0;
                            object.nextBoarderInfo = null;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.recievEndTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.recievEndTime = options.longs === String ? "0" : 0;
                            object.receiveTerm = false;
                            object.maxStepId = 0;
                            object.firstPoint = 0;
                            object.secondPoint = 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CampaignFriendPointResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CampaignFriendPointResp.Status[message.status] : message.status;
                        if (message.point != null && message.hasOwnProperty("point"))
                            object.point = message.point;
                        if (message.stepId != null && message.hasOwnProperty("stepId"))
                            object.stepId = message.stepId;
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (typeof message.startTime === "number")
                                object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                            else
                                object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (typeof message.endTime === "number")
                                object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                            else
                                object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                        if (message.nextBoarderInfo != null && message.hasOwnProperty("nextBoarderInfo"))
                            object.nextBoarderInfo = $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.toObject(message.nextBoarderInfo, options);
                        if (message.recievEndTime != null && message.hasOwnProperty("recievEndTime"))
                            if (typeof message.recievEndTime === "number")
                                object.recievEndTime = options.longs === String ? String(message.recievEndTime) : message.recievEndTime;
                            else
                                object.recievEndTime = options.longs === String ? $util.Long.prototype.toString.call(message.recievEndTime) : options.longs === Number ? new $util.LongBits(message.recievEndTime.low >>> 0, message.recievEndTime.high >>> 0).toNumber() : message.recievEndTime;
                        if (message.receiveTerm != null && message.hasOwnProperty("receiveTerm"))
                            object.receiveTerm = message.receiveTerm;
                        if (message.maxStepId != null && message.hasOwnProperty("maxStepId"))
                            object.maxStepId = message.maxStepId;
                        if (message.firstPoint != null && message.hasOwnProperty("firstPoint"))
                            object.firstPoint = message.firstPoint;
                        if (message.secondPoint != null && message.hasOwnProperty("secondPoint"))
                            object.secondPoint = message.secondPoint;
                        return object;
                    };

                    /**
                     * Converts this CampaignFriendPointResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CampaignFriendPointResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CampaignFriendPointResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CampaignFriendPointResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendPointResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendPointResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=43001 COMMAND_NO value
                     */
                    CampaignFriendPointResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[43001] = "COMMAND_NO"] = 43001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CampaignFriendPointResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} NO_CAMPAIGN=2 NO_CAMPAIGN value
                     */
                    CampaignFriendPointResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "NO_CAMPAIGN"] = 2;
                        return values;
                    })();

                    CampaignFriendPointResp.BoarderInfo = (function() {

                        /**
                         * Properties of a BoarderInfo.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                         * @interface IBoarderInfo
                         * @property {number|null} [stepId] BoarderInfo stepId
                         * @property {number|null} [boarderPoint] BoarderInfo boarderPoint
                         * @property {number|null} [bonusType] BoarderInfo bonusType
                         * @property {number|null} [itemId] BoarderInfo itemId
                         * @property {string|null} [itemNum] BoarderInfo itemNum
                         * @property {string|null} [name] BoarderInfo name
                         * @property {string|null} [imagePath] BoarderInfo imagePath
                         * @property {number|null} [type] BoarderInfo type
                         * @property {number|null} [kind] BoarderInfo kind
                         * @property {string|null} [kindText] BoarderInfo kindText
                         * @property {string|null} [description] BoarderInfo description
                         * @property {string|null} [advertise] BoarderInfo advertise
                         * @property {number|Long|null} [startTime] BoarderInfo startTime
                         * @property {number|Long|null} [endTime] BoarderInfo endTime
                         * @property {number|null} [optionId] BoarderInfo optionId
                         */

                        /**
                         * Constructs a new BoarderInfo.
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp
                         * @classdesc Represents a BoarderInfo.
                         * @implements IBoarderInfo
                         * @constructor
                         * @param {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo=} [properties] Properties to set
                         */
                        function BoarderInfo(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * BoarderInfo stepId.
                         * @member {number} stepId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.stepId = 0;

                        /**
                         * BoarderInfo boarderPoint.
                         * @member {number} boarderPoint
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.boarderPoint = 0;

                        /**
                         * BoarderInfo bonusType.
                         * @member {number} bonusType
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.bonusType = 0;

                        /**
                         * BoarderInfo itemId.
                         * @member {number} itemId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.itemId = 0;

                        /**
                         * BoarderInfo itemNum.
                         * @member {string} itemNum
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.itemNum = "";

                        /**
                         * BoarderInfo name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.name = "";

                        /**
                         * BoarderInfo imagePath.
                         * @member {string} imagePath
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.imagePath = "";

                        /**
                         * BoarderInfo type.
                         * @member {number} type
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.type = 0;

                        /**
                         * BoarderInfo kind.
                         * @member {number} kind
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.kind = 0;

                        /**
                         * BoarderInfo kindText.
                         * @member {string} kindText
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.kindText = "";

                        /**
                         * BoarderInfo description.
                         * @member {string} description
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.description = "";

                        /**
                         * BoarderInfo advertise.
                         * @member {string} advertise
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.advertise = "";

                        /**
                         * BoarderInfo startTime.
                         * @member {number|Long} startTime
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BoarderInfo endTime.
                         * @member {number|Long} endTime
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BoarderInfo optionId.
                         * @member {number} optionId
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         */
                        BoarderInfo.prototype.optionId = 0;

                        /**
                         * Creates a new BoarderInfo instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo} BoarderInfo instance
                         */
                        BoarderInfo.create = function create(properties) {
                            return new BoarderInfo(properties);
                        };

                        /**
                         * Encodes the specified BoarderInfo message. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo} message BoarderInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoarderInfo.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.stepId != null && Object.hasOwnProperty.call(message, "stepId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.stepId);
                            if (message.boarderPoint != null && Object.hasOwnProperty.call(message, "boarderPoint"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.boarderPoint);
                            if (message.bonusType != null && Object.hasOwnProperty.call(message, "bonusType"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bonusType);
                            if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.itemId);
                            if (message.itemNum != null && Object.hasOwnProperty.call(message, "itemNum"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.itemNum);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
                            if (message.imagePath != null && Object.hasOwnProperty.call(message, "imagePath"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.imagePath);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.type);
                            if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.kind);
                            if (message.kindText != null && Object.hasOwnProperty.call(message, "kindText"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.kindText);
                            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.description);
                            if (message.advertise != null && Object.hasOwnProperty.call(message, "advertise"))
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.advertise);
                            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.startTime);
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.endTime);
                            if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.optionId);
                            return writer;
                        };

                        /**
                         * Encodes the specified BoarderInfo message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendPointResp.IBoarderInfo} message BoarderInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoarderInfo.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a BoarderInfo message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo} BoarderInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoarderInfo.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.stepId = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.boarderPoint = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.bonusType = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.itemId = reader.int32();
                                        break;
                                    }
                                case 5: {
                                        message.itemNum = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 7: {
                                        message.imagePath = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 9: {
                                        message.kind = reader.int32();
                                        break;
                                    }
                                case 10: {
                                        message.kindText = reader.string();
                                        break;
                                    }
                                case 11: {
                                        message.description = reader.string();
                                        break;
                                    }
                                case 12: {
                                        message.advertise = reader.string();
                                        break;
                                    }
                                case 13: {
                                        message.startTime = reader.int64();
                                        break;
                                    }
                                case 14: {
                                        message.endTime = reader.int64();
                                        break;
                                    }
                                case 15: {
                                        message.optionId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a BoarderInfo message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo} BoarderInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoarderInfo.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a BoarderInfo message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BoarderInfo.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.stepId != null && message.hasOwnProperty("stepId"))
                                if (!$util.isInteger(message.stepId))
                                    return "stepId: integer expected";
                            if (message.boarderPoint != null && message.hasOwnProperty("boarderPoint"))
                                if (!$util.isInteger(message.boarderPoint))
                                    return "boarderPoint: integer expected";
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                if (!$util.isInteger(message.bonusType))
                                    return "bonusType: integer expected";
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                if (!$util.isInteger(message.itemId))
                                    return "itemId: integer expected";
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                if (!$util.isString(message.itemNum))
                                    return "itemNum: string expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                if (!$util.isString(message.imagePath))
                                    return "imagePath: string expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                if (!$util.isInteger(message.type))
                                    return "type: integer expected";
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                if (!$util.isInteger(message.kind))
                                    return "kind: integer expected";
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                if (!$util.isString(message.kindText))
                                    return "kindText: string expected";
                            if (message.description != null && message.hasOwnProperty("description"))
                                if (!$util.isString(message.description))
                                    return "description: string expected";
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                if (!$util.isString(message.advertise))
                                    return "advertise: string expected";
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                    return "startTime: integer|Long expected";
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                    return "endTime: integer|Long expected";
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                if (!$util.isInteger(message.optionId))
                                    return "optionId: integer expected";
                            return null;
                        };

                        /**
                         * Creates a BoarderInfo message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo} BoarderInfo
                         */
                        BoarderInfo.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo();
                            if (object.stepId != null)
                                message.stepId = object.stepId | 0;
                            if (object.boarderPoint != null)
                                message.boarderPoint = object.boarderPoint | 0;
                            if (object.bonusType != null)
                                message.bonusType = object.bonusType | 0;
                            if (object.itemId != null)
                                message.itemId = object.itemId | 0;
                            if (object.itemNum != null)
                                message.itemNum = String(object.itemNum);
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.imagePath != null)
                                message.imagePath = String(object.imagePath);
                            if (object.type != null)
                                message.type = object.type | 0;
                            if (object.kind != null)
                                message.kind = object.kind | 0;
                            if (object.kindText != null)
                                message.kindText = String(object.kindText);
                            if (object.description != null)
                                message.description = String(object.description);
                            if (object.advertise != null)
                                message.advertise = String(object.advertise);
                            if (object.startTime != null)
                                if ($util.Long)
                                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                                else if (typeof object.startTime === "string")
                                    message.startTime = parseInt(object.startTime, 10);
                                else if (typeof object.startTime === "number")
                                    message.startTime = object.startTime;
                                else if (typeof object.startTime === "object")
                                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                            if (object.endTime != null)
                                if ($util.Long)
                                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                                else if (typeof object.endTime === "string")
                                    message.endTime = parseInt(object.endTime, 10);
                                else if (typeof object.endTime === "number")
                                    message.endTime = object.endTime;
                                else if (typeof object.endTime === "object")
                                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                            if (object.optionId != null)
                                message.optionId = object.optionId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a BoarderInfo message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo} message BoarderInfo
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BoarderInfo.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.stepId = 0;
                                object.boarderPoint = 0;
                                object.bonusType = 0;
                                object.itemId = 0;
                                object.itemNum = "";
                                object.name = "";
                                object.imagePath = "";
                                object.type = 0;
                                object.kind = 0;
                                object.kindText = "";
                                object.description = "";
                                object.advertise = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startTime = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endTime = options.longs === String ? "0" : 0;
                                object.optionId = 0;
                            }
                            if (message.stepId != null && message.hasOwnProperty("stepId"))
                                object.stepId = message.stepId;
                            if (message.boarderPoint != null && message.hasOwnProperty("boarderPoint"))
                                object.boarderPoint = message.boarderPoint;
                            if (message.bonusType != null && message.hasOwnProperty("bonusType"))
                                object.bonusType = message.bonusType;
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                object.itemId = message.itemId;
                            if (message.itemNum != null && message.hasOwnProperty("itemNum"))
                                object.itemNum = message.itemNum;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                object.imagePath = message.imagePath;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = message.type;
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                object.kind = message.kind;
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                object.kindText = message.kindText;
                            if (message.description != null && message.hasOwnProperty("description"))
                                object.description = message.description;
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                object.advertise = message.advertise;
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (typeof message.startTime === "number")
                                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                                else
                                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (typeof message.endTime === "number")
                                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                                else
                                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                object.optionId = message.optionId;
                            return object;
                        };

                        /**
                         * Converts this BoarderInfo to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BoarderInfo.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for BoarderInfo
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        BoarderInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.CampaignFriendPointResp.BoarderInfo";
                        };

                        return BoarderInfo;
                    })();

                    return CampaignFriendPointResp;
                })();

                web.CheckWordReq = (function() {

                    /**
                     * Properties of a CheckWordReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICheckWordReq
                     * @property {Array.<string>|null} [words] CheckWordReq words
                     */

                    /**
                     * Constructs a new CheckWordReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CheckWordReq.
                     * @implements ICheckWordReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICheckWordReq=} [properties] Properties to set
                     */
                    function CheckWordReq(properties) {
                        this.words = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CheckWordReq words.
                     * @member {Array.<string>} words
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @instance
                     */
                    CheckWordReq.prototype.words = $util.emptyArray;

                    /**
                     * Creates a new CheckWordReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CheckWordReq} CheckWordReq instance
                     */
                    CheckWordReq.create = function create(properties) {
                        return new CheckWordReq(properties);
                    };

                    /**
                     * Encodes the specified CheckWordReq message. Does not implicitly {@link kuma.jp.protobuf.web.CheckWordReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordReq} message CheckWordReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckWordReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.words != null && message.words.length)
                            for (let i = 0; i < message.words.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.words[i]);
                        return writer;
                    };

                    /**
                     * Encodes the specified CheckWordReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CheckWordReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordReq} message CheckWordReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckWordReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CheckWordReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CheckWordReq} CheckWordReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckWordReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CheckWordReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.words && message.words.length))
                                        message.words = [];
                                    message.words.push(reader.string());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CheckWordReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CheckWordReq} CheckWordReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckWordReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CheckWordReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CheckWordReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.words != null && message.hasOwnProperty("words")) {
                            if (!Array.isArray(message.words))
                                return "words: array expected";
                            for (let i = 0; i < message.words.length; ++i)
                                if (!$util.isString(message.words[i]))
                                    return "words: string[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a CheckWordReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CheckWordReq} CheckWordReq
                     */
                    CheckWordReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CheckWordReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CheckWordReq();
                        if (object.words) {
                            if (!Array.isArray(object.words))
                                throw TypeError(".kuma.jp.protobuf.web.CheckWordReq.words: array expected");
                            message.words = [];
                            for (let i = 0; i < object.words.length; ++i)
                                message.words[i] = String(object.words[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CheckWordReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CheckWordReq} message CheckWordReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CheckWordReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.words = [];
                        if (message.words && message.words.length) {
                            object.words = [];
                            for (let j = 0; j < message.words.length; ++j)
                                object.words[j] = message.words[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this CheckWordReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CheckWordReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CheckWordReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CheckWordReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CheckWordReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CheckWordReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CheckWordReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=80000 COMMAND_NO value
                     */
                    CheckWordReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[80000] = "COMMAND_NO"] = 80000;
                        return values;
                    })();

                    return CheckWordReq;
                })();

                web.CheckWordResp = (function() {

                    /**
                     * Properties of a CheckWordResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICheckWordResp
                     * @property {kuma.jp.protobuf.web.CheckWordResp.Status|null} [status] CheckWordResp status
                     * @property {Array.<boolean>|null} [boolList] CheckWordResp boolList
                     */

                    /**
                     * Constructs a new CheckWordResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CheckWordResp.
                     * @implements ICheckWordResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICheckWordResp=} [properties] Properties to set
                     */
                    function CheckWordResp(properties) {
                        this.boolList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CheckWordResp status.
                     * @member {kuma.jp.protobuf.web.CheckWordResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @instance
                     */
                    CheckWordResp.prototype.status = 0;

                    /**
                     * CheckWordResp boolList.
                     * @member {Array.<boolean>} boolList
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @instance
                     */
                    CheckWordResp.prototype.boolList = $util.emptyArray;

                    /**
                     * Creates a new CheckWordResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CheckWordResp} CheckWordResp instance
                     */
                    CheckWordResp.create = function create(properties) {
                        return new CheckWordResp(properties);
                    };

                    /**
                     * Encodes the specified CheckWordResp message. Does not implicitly {@link kuma.jp.protobuf.web.CheckWordResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordResp} message CheckWordResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckWordResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.boolList != null && message.boolList.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (let i = 0; i < message.boolList.length; ++i)
                                writer.bool(message.boolList[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified CheckWordResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CheckWordResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICheckWordResp} message CheckWordResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CheckWordResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CheckWordResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CheckWordResp} CheckWordResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckWordResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CheckWordResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.boolList && message.boolList.length))
                                        message.boolList = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.boolList.push(reader.bool());
                                    } else
                                        message.boolList.push(reader.bool());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CheckWordResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CheckWordResp} CheckWordResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CheckWordResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CheckWordResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CheckWordResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.boolList != null && message.hasOwnProperty("boolList")) {
                            if (!Array.isArray(message.boolList))
                                return "boolList: array expected";
                            for (let i = 0; i < message.boolList.length; ++i)
                                if (typeof message.boolList[i] !== "boolean")
                                    return "boolList: boolean[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a CheckWordResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CheckWordResp} CheckWordResp
                     */
                    CheckWordResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CheckWordResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CheckWordResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.boolList) {
                            if (!Array.isArray(object.boolList))
                                throw TypeError(".kuma.jp.protobuf.web.CheckWordResp.boolList: array expected");
                            message.boolList = [];
                            for (let i = 0; i < object.boolList.length; ++i)
                                message.boolList[i] = Boolean(object.boolList[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CheckWordResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CheckWordResp} message CheckWordResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CheckWordResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.boolList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CheckWordResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CheckWordResp.Status[message.status] : message.status;
                        if (message.boolList && message.boolList.length) {
                            object.boolList = [];
                            for (let j = 0; j < message.boolList.length; ++j)
                                object.boolList[j] = message.boolList[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this CheckWordResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CheckWordResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CheckWordResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CheckWordResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CheckWordResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CheckWordResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CheckWordResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=80001 COMMAND_NO value
                     */
                    CheckWordResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[80001] = "COMMAND_NO"] = 80001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CheckWordResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    CheckWordResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return CheckWordResp;
                })();

                web.CouponHistoryReq = (function() {

                    /**
                     * Properties of a CouponHistoryReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponHistoryReq
                     */

                    /**
                     * Constructs a new CouponHistoryReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponHistoryReq.
                     * @implements ICouponHistoryReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponHistoryReq=} [properties] Properties to set
                     */
                    function CouponHistoryReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new CouponHistoryReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponHistoryReq} CouponHistoryReq instance
                     */
                    CouponHistoryReq.create = function create(properties) {
                        return new CouponHistoryReq(properties);
                    };

                    /**
                     * Encodes the specified CouponHistoryReq message. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryReq} message CouponHistoryReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponHistoryReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponHistoryReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryReq} message CouponHistoryReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponHistoryReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponHistoryReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponHistoryReq} CouponHistoryReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponHistoryReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponHistoryReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponHistoryReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponHistoryReq} CouponHistoryReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponHistoryReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponHistoryReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponHistoryReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a CouponHistoryReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponHistoryReq} CouponHistoryReq
                     */
                    CouponHistoryReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponHistoryReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.CouponHistoryReq();
                    };

                    /**
                     * Creates a plain object from a CouponHistoryReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponHistoryReq} message CouponHistoryReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponHistoryReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this CouponHistoryReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponHistoryReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponHistoryReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponHistoryReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponHistoryReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponHistoryReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponHistoryReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50400 COMMAND_NO value
                     */
                    CouponHistoryReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50400] = "COMMAND_NO"] = 50400;
                        return values;
                    })();

                    return CouponHistoryReq;
                })();

                web.CouponHistoryResp = (function() {

                    /**
                     * Properties of a CouponHistoryResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponHistoryResp
                     * @property {kuma.jp.protobuf.web.CouponHistoryResp.Status|null} [status] CouponHistoryResp status
                     * @property {Array.<kuma.jp.protobuf.web.CouponHistoryResp.IHistory>|null} [historyList] CouponHistoryResp historyList
                     */

                    /**
                     * Constructs a new CouponHistoryResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponHistoryResp.
                     * @implements ICouponHistoryResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponHistoryResp=} [properties] Properties to set
                     */
                    function CouponHistoryResp(properties) {
                        this.historyList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponHistoryResp status.
                     * @member {kuma.jp.protobuf.web.CouponHistoryResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @instance
                     */
                    CouponHistoryResp.prototype.status = 0;

                    /**
                     * CouponHistoryResp historyList.
                     * @member {Array.<kuma.jp.protobuf.web.CouponHistoryResp.IHistory>} historyList
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @instance
                     */
                    CouponHistoryResp.prototype.historyList = $util.emptyArray;

                    /**
                     * Creates a new CouponHistoryResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponHistoryResp} CouponHistoryResp instance
                     */
                    CouponHistoryResp.create = function create(properties) {
                        return new CouponHistoryResp(properties);
                    };

                    /**
                     * Encodes the specified CouponHistoryResp message. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryResp} message CouponHistoryResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponHistoryResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.historyList != null && message.historyList.length)
                            for (let i = 0; i < message.historyList.length; ++i)
                                $root.kuma.jp.protobuf.web.CouponHistoryResp.History.encode(message.historyList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponHistoryResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponHistoryResp} message CouponHistoryResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponHistoryResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponHistoryResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponHistoryResp} CouponHistoryResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponHistoryResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponHistoryResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.historyList && message.historyList.length))
                                        message.historyList = [];
                                    message.historyList.push($root.kuma.jp.protobuf.web.CouponHistoryResp.History.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponHistoryResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponHistoryResp} CouponHistoryResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponHistoryResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponHistoryResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponHistoryResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.historyList != null && message.hasOwnProperty("historyList")) {
                            if (!Array.isArray(message.historyList))
                                return "historyList: array expected";
                            for (let i = 0; i < message.historyList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.CouponHistoryResp.History.verify(message.historyList[i]);
                                if (error)
                                    return "historyList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a CouponHistoryResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponHistoryResp} CouponHistoryResp
                     */
                    CouponHistoryResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponHistoryResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponHistoryResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.historyList) {
                            if (!Array.isArray(object.historyList))
                                throw TypeError(".kuma.jp.protobuf.web.CouponHistoryResp.historyList: array expected");
                            message.historyList = [];
                            for (let i = 0; i < object.historyList.length; ++i) {
                                if (typeof object.historyList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.CouponHistoryResp.historyList: object expected");
                                message.historyList[i] = $root.kuma.jp.protobuf.web.CouponHistoryResp.History.fromObject(object.historyList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponHistoryResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponHistoryResp} message CouponHistoryResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponHistoryResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.historyList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CouponHistoryResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CouponHistoryResp.Status[message.status] : message.status;
                        if (message.historyList && message.historyList.length) {
                            object.historyList = [];
                            for (let j = 0; j < message.historyList.length; ++j)
                                object.historyList[j] = $root.kuma.jp.protobuf.web.CouponHistoryResp.History.toObject(message.historyList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this CouponHistoryResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponHistoryResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponHistoryResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponHistoryResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponHistoryResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponHistoryResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50401 COMMAND_NO value
                     */
                    CouponHistoryResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50401] = "COMMAND_NO"] = 50401;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CouponHistoryResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    CouponHistoryResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    CouponHistoryResp.History = (function() {

                        /**
                         * Properties of a History.
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                         * @interface IHistory
                         * @property {string|null} [name] History name
                         * @property {number|Long|null} [createTime] History createTime
                         * @property {number|null} [type] History type
                         * @property {string|null} [taget] History taget
                         * @property {string|null} [kindText] History kindText
                         * @property {string|null} [advertiseText] History advertiseText
                         * @property {string|null} [descriptionText] History descriptionText
                         */

                        /**
                         * Constructs a new History.
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp
                         * @classdesc Represents a History.
                         * @implements IHistory
                         * @constructor
                         * @param {kuma.jp.protobuf.web.CouponHistoryResp.IHistory=} [properties] Properties to set
                         */
                        function History(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * History name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.name = "";

                        /**
                         * History createTime.
                         * @member {number|Long} createTime
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * History type.
                         * @member {number} type
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.type = 0;

                        /**
                         * History taget.
                         * @member {string} taget
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.taget = "";

                        /**
                         * History kindText.
                         * @member {string} kindText
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.kindText = "";

                        /**
                         * History advertiseText.
                         * @member {string} advertiseText
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.advertiseText = "";

                        /**
                         * History descriptionText.
                         * @member {string} descriptionText
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         */
                        History.prototype.descriptionText = "";

                        /**
                         * Creates a new History instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponHistoryResp.IHistory=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.CouponHistoryResp.History} History instance
                         */
                        History.create = function create(properties) {
                            return new History(properties);
                        };

                        /**
                         * Encodes the specified History message. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryResp.History.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponHistoryResp.IHistory} message History message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        History.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.createTime);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                            if (message.taget != null && Object.hasOwnProperty.call(message, "taget"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.taget);
                            if (message.kindText != null && Object.hasOwnProperty.call(message, "kindText"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.kindText);
                            if (message.advertiseText != null && Object.hasOwnProperty.call(message, "advertiseText"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.advertiseText);
                            if (message.descriptionText != null && Object.hasOwnProperty.call(message, "descriptionText"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.descriptionText);
                            return writer;
                        };

                        /**
                         * Encodes the specified History message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponHistoryResp.History.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponHistoryResp.IHistory} message History message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        History.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a History message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.CouponHistoryResp.History} History
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        History.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponHistoryResp.History();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.createTime = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.taget = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.kindText = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.advertiseText = reader.string();
                                        break;
                                    }
                                case 7: {
                                        message.descriptionText = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a History message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.CouponHistoryResp.History} History
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        History.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a History message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        History.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.createTime != null && message.hasOwnProperty("createTime"))
                                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                                    return "createTime: integer|Long expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                if (!$util.isInteger(message.type))
                                    return "type: integer expected";
                            if (message.taget != null && message.hasOwnProperty("taget"))
                                if (!$util.isString(message.taget))
                                    return "taget: string expected";
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                if (!$util.isString(message.kindText))
                                    return "kindText: string expected";
                            if (message.advertiseText != null && message.hasOwnProperty("advertiseText"))
                                if (!$util.isString(message.advertiseText))
                                    return "advertiseText: string expected";
                            if (message.descriptionText != null && message.hasOwnProperty("descriptionText"))
                                if (!$util.isString(message.descriptionText))
                                    return "descriptionText: string expected";
                            return null;
                        };

                        /**
                         * Creates a History message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.CouponHistoryResp.History} History
                         */
                        History.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.CouponHistoryResp.History)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.CouponHistoryResp.History();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.createTime != null)
                                if ($util.Long)
                                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                                else if (typeof object.createTime === "string")
                                    message.createTime = parseInt(object.createTime, 10);
                                else if (typeof object.createTime === "number")
                                    message.createTime = object.createTime;
                                else if (typeof object.createTime === "object")
                                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                            if (object.type != null)
                                message.type = object.type | 0;
                            if (object.taget != null)
                                message.taget = String(object.taget);
                            if (object.kindText != null)
                                message.kindText = String(object.kindText);
                            if (object.advertiseText != null)
                                message.advertiseText = String(object.advertiseText);
                            if (object.descriptionText != null)
                                message.descriptionText = String(object.descriptionText);
                            return message;
                        };

                        /**
                         * Creates a plain object from a History message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponHistoryResp.History} message History
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        History.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.name = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.createTime = options.longs === String ? "0" : 0;
                                object.type = 0;
                                object.taget = "";
                                object.kindText = "";
                                object.advertiseText = "";
                                object.descriptionText = "";
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.createTime != null && message.hasOwnProperty("createTime"))
                                if (typeof message.createTime === "number")
                                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                                else
                                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = message.type;
                            if (message.taget != null && message.hasOwnProperty("taget"))
                                object.taget = message.taget;
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                object.kindText = message.kindText;
                            if (message.advertiseText != null && message.hasOwnProperty("advertiseText"))
                                object.advertiseText = message.advertiseText;
                            if (message.descriptionText != null && message.hasOwnProperty("descriptionText"))
                                object.descriptionText = message.descriptionText;
                            return object;
                        };

                        /**
                         * Converts this History to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        History.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for History
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.CouponHistoryResp.History
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        History.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponHistoryResp.History";
                        };

                        return History;
                    })();

                    return CouponHistoryResp;
                })();

                web.CouponListReq = (function() {

                    /**
                     * Properties of a CouponListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponListReq
                     */

                    /**
                     * Constructs a new CouponListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponListReq.
                     * @implements ICouponListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponListReq=} [properties] Properties to set
                     */
                    function CouponListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new CouponListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponListReq} CouponListReq instance
                     */
                    CouponListReq.create = function create(properties) {
                        return new CouponListReq(properties);
                    };

                    /**
                     * Encodes the specified CouponListReq message. Does not implicitly {@link kuma.jp.protobuf.web.CouponListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListReq} message CouponListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListReq} message CouponListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponListReq} CouponListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponListReq} CouponListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a CouponListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponListReq} CouponListReq
                     */
                    CouponListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.CouponListReq();
                    };

                    /**
                     * Creates a plain object from a CouponListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponListReq} message CouponListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this CouponListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50000 COMMAND_NO value
                     */
                    CouponListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50000] = "COMMAND_NO"] = 50000;
                        return values;
                    })();

                    return CouponListReq;
                })();

                web.CouponListResp = (function() {

                    /**
                     * Properties of a CouponListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponListResp
                     * @property {kuma.jp.protobuf.web.CouponListResp.Status|null} [status] CouponListResp status
                     * @property {Array.<kuma.jp.protobuf.web.CouponListResp.ICoupon>|null} [coupons] CouponListResp coupons
                     */

                    /**
                     * Constructs a new CouponListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponListResp.
                     * @implements ICouponListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponListResp=} [properties] Properties to set
                     */
                    function CouponListResp(properties) {
                        this.coupons = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponListResp status.
                     * @member {kuma.jp.protobuf.web.CouponListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @instance
                     */
                    CouponListResp.prototype.status = 0;

                    /**
                     * CouponListResp coupons.
                     * @member {Array.<kuma.jp.protobuf.web.CouponListResp.ICoupon>} coupons
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @instance
                     */
                    CouponListResp.prototype.coupons = $util.emptyArray;

                    /**
                     * Creates a new CouponListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponListResp} CouponListResp instance
                     */
                    CouponListResp.create = function create(properties) {
                        return new CouponListResp(properties);
                    };

                    /**
                     * Encodes the specified CouponListResp message. Does not implicitly {@link kuma.jp.protobuf.web.CouponListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListResp} message CouponListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.coupons != null && message.coupons.length)
                            for (let i = 0; i < message.coupons.length; ++i)
                                $root.kuma.jp.protobuf.web.CouponListResp.Coupon.encode(message.coupons[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponListResp} message CouponListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponListResp} CouponListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.coupons && message.coupons.length))
                                        message.coupons = [];
                                    message.coupons.push($root.kuma.jp.protobuf.web.CouponListResp.Coupon.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponListResp} CouponListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.coupons != null && message.hasOwnProperty("coupons")) {
                            if (!Array.isArray(message.coupons))
                                return "coupons: array expected";
                            for (let i = 0; i < message.coupons.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.CouponListResp.Coupon.verify(message.coupons[i]);
                                if (error)
                                    return "coupons." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a CouponListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponListResp} CouponListResp
                     */
                    CouponListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.coupons) {
                            if (!Array.isArray(object.coupons))
                                throw TypeError(".kuma.jp.protobuf.web.CouponListResp.coupons: array expected");
                            message.coupons = [];
                            for (let i = 0; i < object.coupons.length; ++i) {
                                if (typeof object.coupons[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.CouponListResp.coupons: object expected");
                                message.coupons[i] = $root.kuma.jp.protobuf.web.CouponListResp.Coupon.fromObject(object.coupons[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponListResp} message CouponListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.coupons = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CouponListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CouponListResp.Status[message.status] : message.status;
                        if (message.coupons && message.coupons.length) {
                            object.coupons = [];
                            for (let j = 0; j < message.coupons.length; ++j)
                                object.coupons[j] = $root.kuma.jp.protobuf.web.CouponListResp.Coupon.toObject(message.coupons[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this CouponListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50001 COMMAND_NO value
                     */
                    CouponListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50001] = "COMMAND_NO"] = 50001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CouponListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    CouponListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    /**
                     * Type enum.
                     * @name kuma.jp.protobuf.web.CouponListResp.Type
                     * @enum {number}
                     * @property {number} CABINET=0 CABINET value
                     * @property {number} APP=1 APP value
                     * @property {number} OTHER=2 OTHER value
                     * @property {number} KMA2_ARCADE=3 KMA2_ARCADE value
                     */
                    CouponListResp.Type = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "CABINET"] = 0;
                        values[valuesById[1] = "APP"] = 1;
                        values[valuesById[2] = "OTHER"] = 2;
                        values[valuesById[3] = "KMA2_ARCADE"] = 3;
                        return values;
                    })();

                    /**
                     * Kind enum.
                     * @name kuma.jp.protobuf.web.CouponListResp.Kind
                     * @enum {number}
                     * @property {number} NONE=0 NONE value
                     * @property {number} OFF_100=1 OFF_100 value
                     * @property {number} OFF_200=2 OFF_200 value
                     * @property {number} FREE_PLAY=3 FREE_PLAY value
                     * @property {number} FREE_PURIMOTTO=4 FREE_PURIMOTTO value
                     * @property {number} FREE_PURIMOTTO_ALL=5 FREE_PURIMOTTO_ALL value
                     * @property {number} ALL_DOWNLOAD=6 ALL_DOWNLOAD value
                     */
                    CouponListResp.Kind = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "NONE"] = 0;
                        values[valuesById[1] = "OFF_100"] = 1;
                        values[valuesById[2] = "OFF_200"] = 2;
                        values[valuesById[3] = "FREE_PLAY"] = 3;
                        values[valuesById[4] = "FREE_PURIMOTTO"] = 4;
                        values[valuesById[5] = "FREE_PURIMOTTO_ALL"] = 5;
                        values[valuesById[6] = "ALL_DOWNLOAD"] = 6;
                        return values;
                    })();

                    CouponListResp.Coupon = (function() {

                        /**
                         * Properties of a Coupon.
                         * @memberof kuma.jp.protobuf.web.CouponListResp
                         * @interface ICoupon
                         * @property {number|null} [couponId] Coupon couponId
                         * @property {string|null} [couponName] Coupon couponName
                         * @property {number|Long|null} [limitDate] Coupon limitDate
                         * @property {number|null} [useNum] Coupon useNum
                         * @property {string|null} [imagePath] Coupon imagePath
                         * @property {kuma.jp.protobuf.web.CouponListResp.Type|null} [type] Coupon type
                         * @property {kuma.jp.protobuf.web.CouponListResp.Kind|null} [kind] Coupon kind
                         * @property {string|null} [kindText] Coupon kindText
                         * @property {string|null} [description] Coupon description
                         * @property {string|null} [advertise] Coupon advertise
                         * @property {number|Long|null} [startTime] Coupon startTime
                         * @property {number|Long|null} [endTime] Coupon endTime
                         * @property {number|null} [purimottoId] Coupon purimottoId
                         */

                        /**
                         * Constructs a new Coupon.
                         * @memberof kuma.jp.protobuf.web.CouponListResp
                         * @classdesc Represents a Coupon.
                         * @implements ICoupon
                         * @constructor
                         * @param {kuma.jp.protobuf.web.CouponListResp.ICoupon=} [properties] Properties to set
                         */
                        function Coupon(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Coupon couponId.
                         * @member {number} couponId
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.couponId = 0;

                        /**
                         * Coupon couponName.
                         * @member {string} couponName
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.couponName = "";

                        /**
                         * Coupon limitDate.
                         * @member {number|Long} limitDate
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.limitDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Coupon useNum.
                         * @member {number} useNum
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.useNum = 0;

                        /**
                         * Coupon imagePath.
                         * @member {string} imagePath
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.imagePath = "";

                        /**
                         * Coupon type.
                         * @member {kuma.jp.protobuf.web.CouponListResp.Type} type
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.type = 0;

                        /**
                         * Coupon kind.
                         * @member {kuma.jp.protobuf.web.CouponListResp.Kind} kind
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.kind = 0;

                        /**
                         * Coupon kindText.
                         * @member {string} kindText
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.kindText = "";

                        /**
                         * Coupon description.
                         * @member {string} description
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.description = "";

                        /**
                         * Coupon advertise.
                         * @member {string} advertise
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.advertise = "";

                        /**
                         * Coupon startTime.
                         * @member {number|Long} startTime
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Coupon endTime.
                         * @member {number|Long} endTime
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Coupon purimottoId.
                         * @member {number} purimottoId
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         */
                        Coupon.prototype.purimottoId = 0;

                        /**
                         * Creates a new Coupon instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponListResp.ICoupon=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.CouponListResp.Coupon} Coupon instance
                         */
                        Coupon.create = function create(properties) {
                            return new Coupon(properties);
                        };

                        /**
                         * Encodes the specified Coupon message. Does not implicitly {@link kuma.jp.protobuf.web.CouponListResp.Coupon.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponListResp.ICoupon} message Coupon message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Coupon.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.couponId != null && Object.hasOwnProperty.call(message, "couponId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.couponId);
                            if (message.couponName != null && Object.hasOwnProperty.call(message, "couponName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.couponName);
                            if (message.limitDate != null && Object.hasOwnProperty.call(message, "limitDate"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.limitDate);
                            if (message.useNum != null && Object.hasOwnProperty.call(message, "useNum"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.useNum);
                            if (message.imagePath != null && Object.hasOwnProperty.call(message, "imagePath"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.imagePath);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                            if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.kind);
                            if (message.kindText != null && Object.hasOwnProperty.call(message, "kindText"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.kindText);
                            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                                writer.uint32(/* id 9, wireType 2 =*/74).string(message.description);
                            if (message.advertise != null && Object.hasOwnProperty.call(message, "advertise"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.advertise);
                            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.startTime);
                            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.endTime);
                            if (message.purimottoId != null && Object.hasOwnProperty.call(message, "purimottoId"))
                                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.purimottoId);
                            return writer;
                        };

                        /**
                         * Encodes the specified Coupon message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponListResp.Coupon.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponListResp.ICoupon} message Coupon message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Coupon.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Coupon message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.CouponListResp.Coupon} Coupon
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Coupon.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponListResp.Coupon();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.couponId = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.couponName = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.limitDate = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.useNum = reader.int32();
                                        break;
                                    }
                                case 5: {
                                        message.imagePath = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 7: {
                                        message.kind = reader.int32();
                                        break;
                                    }
                                case 8: {
                                        message.kindText = reader.string();
                                        break;
                                    }
                                case 9: {
                                        message.description = reader.string();
                                        break;
                                    }
                                case 10: {
                                        message.advertise = reader.string();
                                        break;
                                    }
                                case 11: {
                                        message.startTime = reader.int64();
                                        break;
                                    }
                                case 12: {
                                        message.endTime = reader.int64();
                                        break;
                                    }
                                case 13: {
                                        message.purimottoId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Coupon message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.CouponListResp.Coupon} Coupon
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Coupon.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Coupon message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Coupon.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.couponId != null && message.hasOwnProperty("couponId"))
                                if (!$util.isInteger(message.couponId))
                                    return "couponId: integer expected";
                            if (message.couponName != null && message.hasOwnProperty("couponName"))
                                if (!$util.isString(message.couponName))
                                    return "couponName: string expected";
                            if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                                if (!$util.isInteger(message.limitDate) && !(message.limitDate && $util.isInteger(message.limitDate.low) && $util.isInteger(message.limitDate.high)))
                                    return "limitDate: integer|Long expected";
                            if (message.useNum != null && message.hasOwnProperty("useNum"))
                                if (!$util.isInteger(message.useNum))
                                    return "useNum: integer expected";
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                if (!$util.isString(message.imagePath))
                                    return "imagePath: string expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                switch (message.kind) {
                                default:
                                    return "kind: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                    break;
                                }
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                if (!$util.isString(message.kindText))
                                    return "kindText: string expected";
                            if (message.description != null && message.hasOwnProperty("description"))
                                if (!$util.isString(message.description))
                                    return "description: string expected";
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                if (!$util.isString(message.advertise))
                                    return "advertise: string expected";
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                    return "startTime: integer|Long expected";
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                                    return "endTime: integer|Long expected";
                            if (message.purimottoId != null && message.hasOwnProperty("purimottoId"))
                                if (!$util.isInteger(message.purimottoId))
                                    return "purimottoId: integer expected";
                            return null;
                        };

                        /**
                         * Creates a Coupon message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.CouponListResp.Coupon} Coupon
                         */
                        Coupon.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.CouponListResp.Coupon)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.CouponListResp.Coupon();
                            if (object.couponId != null)
                                message.couponId = object.couponId | 0;
                            if (object.couponName != null)
                                message.couponName = String(object.couponName);
                            if (object.limitDate != null)
                                if ($util.Long)
                                    (message.limitDate = $util.Long.fromValue(object.limitDate)).unsigned = false;
                                else if (typeof object.limitDate === "string")
                                    message.limitDate = parseInt(object.limitDate, 10);
                                else if (typeof object.limitDate === "number")
                                    message.limitDate = object.limitDate;
                                else if (typeof object.limitDate === "object")
                                    message.limitDate = new $util.LongBits(object.limitDate.low >>> 0, object.limitDate.high >>> 0).toNumber();
                            if (object.useNum != null)
                                message.useNum = object.useNum | 0;
                            if (object.imagePath != null)
                                message.imagePath = String(object.imagePath);
                            switch (object.type) {
                            default:
                                if (typeof object.type === "number") {
                                    message.type = object.type;
                                    break;
                                }
                                break;
                            case "CABINET":
                            case 0:
                                message.type = 0;
                                break;
                            case "APP":
                            case 1:
                                message.type = 1;
                                break;
                            case "OTHER":
                            case 2:
                                message.type = 2;
                                break;
                            case "KMA2_ARCADE":
                            case 3:
                                message.type = 3;
                                break;
                            }
                            switch (object.kind) {
                            default:
                                if (typeof object.kind === "number") {
                                    message.kind = object.kind;
                                    break;
                                }
                                break;
                            case "NONE":
                            case 0:
                                message.kind = 0;
                                break;
                            case "OFF_100":
                            case 1:
                                message.kind = 1;
                                break;
                            case "OFF_200":
                            case 2:
                                message.kind = 2;
                                break;
                            case "FREE_PLAY":
                            case 3:
                                message.kind = 3;
                                break;
                            case "FREE_PURIMOTTO":
                            case 4:
                                message.kind = 4;
                                break;
                            case "FREE_PURIMOTTO_ALL":
                            case 5:
                                message.kind = 5;
                                break;
                            case "ALL_DOWNLOAD":
                            case 6:
                                message.kind = 6;
                                break;
                            }
                            if (object.kindText != null)
                                message.kindText = String(object.kindText);
                            if (object.description != null)
                                message.description = String(object.description);
                            if (object.advertise != null)
                                message.advertise = String(object.advertise);
                            if (object.startTime != null)
                                if ($util.Long)
                                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                                else if (typeof object.startTime === "string")
                                    message.startTime = parseInt(object.startTime, 10);
                                else if (typeof object.startTime === "number")
                                    message.startTime = object.startTime;
                                else if (typeof object.startTime === "object")
                                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                            if (object.endTime != null)
                                if ($util.Long)
                                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                                else if (typeof object.endTime === "string")
                                    message.endTime = parseInt(object.endTime, 10);
                                else if (typeof object.endTime === "number")
                                    message.endTime = object.endTime;
                                else if (typeof object.endTime === "object")
                                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                            if (object.purimottoId != null)
                                message.purimottoId = object.purimottoId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a Coupon message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {kuma.jp.protobuf.web.CouponListResp.Coupon} message Coupon
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Coupon.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.couponId = 0;
                                object.couponName = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.limitDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.limitDate = options.longs === String ? "0" : 0;
                                object.useNum = 0;
                                object.imagePath = "";
                                object.type = options.enums === String ? "CABINET" : 0;
                                object.kind = options.enums === String ? "NONE" : 0;
                                object.kindText = "";
                                object.description = "";
                                object.advertise = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startTime = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endTime = options.longs === String ? "0" : 0;
                                object.purimottoId = 0;
                            }
                            if (message.couponId != null && message.hasOwnProperty("couponId"))
                                object.couponId = message.couponId;
                            if (message.couponName != null && message.hasOwnProperty("couponName"))
                                object.couponName = message.couponName;
                            if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                                if (typeof message.limitDate === "number")
                                    object.limitDate = options.longs === String ? String(message.limitDate) : message.limitDate;
                                else
                                    object.limitDate = options.longs === String ? $util.Long.prototype.toString.call(message.limitDate) : options.longs === Number ? new $util.LongBits(message.limitDate.low >>> 0, message.limitDate.high >>> 0).toNumber() : message.limitDate;
                            if (message.useNum != null && message.hasOwnProperty("useNum"))
                                object.useNum = message.useNum;
                            if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                                object.imagePath = message.imagePath;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.kuma.jp.protobuf.web.CouponListResp.Type[message.type] === undefined ? message.type : $root.kuma.jp.protobuf.web.CouponListResp.Type[message.type] : message.type;
                            if (message.kind != null && message.hasOwnProperty("kind"))
                                object.kind = options.enums === String ? $root.kuma.jp.protobuf.web.CouponListResp.Kind[message.kind] === undefined ? message.kind : $root.kuma.jp.protobuf.web.CouponListResp.Kind[message.kind] : message.kind;
                            if (message.kindText != null && message.hasOwnProperty("kindText"))
                                object.kindText = message.kindText;
                            if (message.description != null && message.hasOwnProperty("description"))
                                object.description = message.description;
                            if (message.advertise != null && message.hasOwnProperty("advertise"))
                                object.advertise = message.advertise;
                            if (message.startTime != null && message.hasOwnProperty("startTime"))
                                if (typeof message.startTime === "number")
                                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                                else
                                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                            if (message.endTime != null && message.hasOwnProperty("endTime"))
                                if (typeof message.endTime === "number")
                                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                                else
                                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                            if (message.purimottoId != null && message.hasOwnProperty("purimottoId"))
                                object.purimottoId = message.purimottoId;
                            return object;
                        };

                        /**
                         * Converts this Coupon to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Coupon.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Coupon
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.CouponListResp.Coupon
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Coupon.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponListResp.Coupon";
                        };

                        return Coupon;
                    })();

                    return CouponListResp;
                })();

                web.CouponReq = (function() {

                    /**
                     * Properties of a CouponReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponReq
                     * @property {number|null} [couponId] CouponReq couponId
                     */

                    /**
                     * Constructs a new CouponReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponReq.
                     * @implements ICouponReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponReq=} [properties] Properties to set
                     */
                    function CouponReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponReq couponId.
                     * @member {number} couponId
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @instance
                     */
                    CouponReq.prototype.couponId = 0;

                    /**
                     * Creates a new CouponReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponReq} CouponReq instance
                     */
                    CouponReq.create = function create(properties) {
                        return new CouponReq(properties);
                    };

                    /**
                     * Encodes the specified CouponReq message. Does not implicitly {@link kuma.jp.protobuf.web.CouponReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponReq} message CouponReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.couponId != null && Object.hasOwnProperty.call(message, "couponId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.couponId);
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponReq} message CouponReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponReq} CouponReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.couponId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponReq} CouponReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.couponId != null && message.hasOwnProperty("couponId"))
                            if (!$util.isInteger(message.couponId))
                                return "couponId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a CouponReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponReq} CouponReq
                     */
                    CouponReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponReq();
                        if (object.couponId != null)
                            message.couponId = object.couponId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponReq} message CouponReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.couponId = 0;
                        if (message.couponId != null && message.hasOwnProperty("couponId"))
                            object.couponId = message.couponId;
                        return object;
                    };

                    /**
                     * Converts this CouponReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50200 COMMAND_NO value
                     */
                    CouponReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50200] = "COMMAND_NO"] = 50200;
                        return values;
                    })();

                    return CouponReq;
                })();

                web.CouponResp = (function() {

                    /**
                     * Properties of a CouponResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponResp
                     * @property {string|null} [description] CouponResp description
                     * @property {kuma.jp.protobuf.web.CouponResp.Status|null} [status] CouponResp status
                     */

                    /**
                     * Constructs a new CouponResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponResp.
                     * @implements ICouponResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponResp=} [properties] Properties to set
                     */
                    function CouponResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponResp description.
                     * @member {string} description
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @instance
                     */
                    CouponResp.prototype.description = "";

                    /**
                     * CouponResp status.
                     * @member {kuma.jp.protobuf.web.CouponResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @instance
                     */
                    CouponResp.prototype.status = 0;

                    /**
                     * Creates a new CouponResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponResp} CouponResp instance
                     */
                    CouponResp.create = function create(properties) {
                        return new CouponResp(properties);
                    };

                    /**
                     * Encodes the specified CouponResp message. Does not implicitly {@link kuma.jp.protobuf.web.CouponResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponResp} message CouponResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.description);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponResp} message CouponResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponResp} CouponResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.description = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponResp} CouponResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a CouponResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponResp} CouponResp
                     */
                    CouponResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponResp();
                        if (object.description != null)
                            message.description = String(object.description);
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponResp} message CouponResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.description = "";
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        }
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CouponResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CouponResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this CouponResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50201 COMMAND_NO value
                     */
                    CouponResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50201] = "COMMAND_NO"] = 50201;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CouponResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    CouponResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    return CouponResp;
                })();

                web.CouponSettingReq = (function() {

                    /**
                     * Properties of a CouponSettingReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponSettingReq
                     * @property {number|null} [couponDisplaySetting] CouponSettingReq couponDisplaySetting
                     */

                    /**
                     * Constructs a new CouponSettingReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponSettingReq.
                     * @implements ICouponSettingReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponSettingReq=} [properties] Properties to set
                     */
                    function CouponSettingReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponSettingReq couponDisplaySetting.
                     * @member {number} couponDisplaySetting
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @instance
                     */
                    CouponSettingReq.prototype.couponDisplaySetting = 0;

                    /**
                     * Creates a new CouponSettingReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponSettingReq} CouponSettingReq instance
                     */
                    CouponSettingReq.create = function create(properties) {
                        return new CouponSettingReq(properties);
                    };

                    /**
                     * Encodes the specified CouponSettingReq message. Does not implicitly {@link kuma.jp.protobuf.web.CouponSettingReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingReq} message CouponSettingReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponSettingReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.couponDisplaySetting != null && Object.hasOwnProperty.call(message, "couponDisplaySetting"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.couponDisplaySetting);
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponSettingReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponSettingReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingReq} message CouponSettingReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponSettingReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponSettingReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponSettingReq} CouponSettingReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponSettingReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponSettingReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.couponDisplaySetting = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponSettingReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponSettingReq} CouponSettingReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponSettingReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponSettingReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponSettingReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.couponDisplaySetting != null && message.hasOwnProperty("couponDisplaySetting"))
                            if (!$util.isInteger(message.couponDisplaySetting))
                                return "couponDisplaySetting: integer expected";
                        return null;
                    };

                    /**
                     * Creates a CouponSettingReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponSettingReq} CouponSettingReq
                     */
                    CouponSettingReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponSettingReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponSettingReq();
                        if (object.couponDisplaySetting != null)
                            message.couponDisplaySetting = object.couponDisplaySetting | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponSettingReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponSettingReq} message CouponSettingReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponSettingReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.couponDisplaySetting = 0;
                        if (message.couponDisplaySetting != null && message.hasOwnProperty("couponDisplaySetting"))
                            object.couponDisplaySetting = message.couponDisplaySetting;
                        return object;
                    };

                    /**
                     * Converts this CouponSettingReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponSettingReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponSettingReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponSettingReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponSettingReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponSettingReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponSettingReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50500 COMMAND_NO value
                     */
                    CouponSettingReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50500] = "COMMAND_NO"] = 50500;
                        return values;
                    })();

                    return CouponSettingReq;
                })();

                web.CouponSettingResp = (function() {

                    /**
                     * Properties of a CouponSettingResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ICouponSettingResp
                     * @property {number|null} [couponDisplaySetting] CouponSettingResp couponDisplaySetting
                     * @property {kuma.jp.protobuf.web.CouponSettingResp.Status|null} [status] CouponSettingResp status
                     */

                    /**
                     * Constructs a new CouponSettingResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a CouponSettingResp.
                     * @implements ICouponSettingResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ICouponSettingResp=} [properties] Properties to set
                     */
                    function CouponSettingResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CouponSettingResp couponDisplaySetting.
                     * @member {number} couponDisplaySetting
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @instance
                     */
                    CouponSettingResp.prototype.couponDisplaySetting = 0;

                    /**
                     * CouponSettingResp status.
                     * @member {kuma.jp.protobuf.web.CouponSettingResp.Status} status
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @instance
                     */
                    CouponSettingResp.prototype.status = 0;

                    /**
                     * Creates a new CouponSettingResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.CouponSettingResp} CouponSettingResp instance
                     */
                    CouponSettingResp.create = function create(properties) {
                        return new CouponSettingResp(properties);
                    };

                    /**
                     * Encodes the specified CouponSettingResp message. Does not implicitly {@link kuma.jp.protobuf.web.CouponSettingResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingResp} message CouponSettingResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponSettingResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.couponDisplaySetting != null && Object.hasOwnProperty.call(message, "couponDisplaySetting"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.couponDisplaySetting);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified CouponSettingResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.CouponSettingResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ICouponSettingResp} message CouponSettingResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CouponSettingResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CouponSettingResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.CouponSettingResp} CouponSettingResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponSettingResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.CouponSettingResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.couponDisplaySetting = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CouponSettingResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.CouponSettingResp} CouponSettingResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CouponSettingResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CouponSettingResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CouponSettingResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.couponDisplaySetting != null && message.hasOwnProperty("couponDisplaySetting"))
                            if (!$util.isInteger(message.couponDisplaySetting))
                                return "couponDisplaySetting: integer expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a CouponSettingResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.CouponSettingResp} CouponSettingResp
                     */
                    CouponSettingResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.CouponSettingResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.CouponSettingResp();
                        if (object.couponDisplaySetting != null)
                            message.couponDisplaySetting = object.couponDisplaySetting | 0;
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a CouponSettingResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.CouponSettingResp} message CouponSettingResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CouponSettingResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.couponDisplaySetting = 0;
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        }
                        if (message.couponDisplaySetting != null && message.hasOwnProperty("couponDisplaySetting"))
                            object.couponDisplaySetting = message.couponDisplaySetting;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.CouponSettingResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.CouponSettingResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this CouponSettingResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CouponSettingResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CouponSettingResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.CouponSettingResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CouponSettingResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.CouponSettingResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.CouponSettingResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=50501 COMMAND_NO value
                     */
                    CouponSettingResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[50501] = "COMMAND_NO"] = 50501;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.CouponSettingResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    CouponSettingResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return CouponSettingResp;
                })();

                web.KumaMasterSettingReq = (function() {

                    /**
                     * Properties of a KumaMasterSettingReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IKumaMasterSettingReq
                     */

                    /**
                     * Constructs a new KumaMasterSettingReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a KumaMasterSettingReq.
                     * @implements IKumaMasterSettingReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingReq=} [properties] Properties to set
                     */
                    function KumaMasterSettingReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new KumaMasterSettingReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingReq} KumaMasterSettingReq instance
                     */
                    KumaMasterSettingReq.create = function create(properties) {
                        return new KumaMasterSettingReq(properties);
                    };

                    /**
                     * Encodes the specified KumaMasterSettingReq message. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingReq} message KumaMasterSettingReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaMasterSettingReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified KumaMasterSettingReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingReq} message KumaMasterSettingReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaMasterSettingReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a KumaMasterSettingReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingReq} KumaMasterSettingReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaMasterSettingReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.KumaMasterSettingReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a KumaMasterSettingReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingReq} KumaMasterSettingReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaMasterSettingReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a KumaMasterSettingReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    KumaMasterSettingReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a KumaMasterSettingReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingReq} KumaMasterSettingReq
                     */
                    KumaMasterSettingReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.KumaMasterSettingReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.KumaMasterSettingReq();
                    };

                    /**
                     * Creates a plain object from a KumaMasterSettingReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {kuma.jp.protobuf.web.KumaMasterSettingReq} message KumaMasterSettingReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    KumaMasterSettingReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this KumaMasterSettingReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    KumaMasterSettingReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for KumaMasterSettingReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    KumaMasterSettingReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.KumaMasterSettingReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.KumaMasterSettingReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=41500 COMMAND_NO value
                     */
                    KumaMasterSettingReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[41500] = "COMMAND_NO"] = 41500;
                        return values;
                    })();

                    return KumaMasterSettingReq;
                })();

                web.KumaMasterSettingResp = (function() {

                    /**
                     * Properties of a KumaMasterSettingResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IKumaMasterSettingResp
                     * @property {kuma.jp.protobuf.web.KumaMasterSettingResp.Status|null} [status] KumaMasterSettingResp status
                     * @property {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade>|null} [masterArcadeList] KumaMasterSettingResp masterArcadeList
                     * @property {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial>|null} [masterTutorialList] KumaMasterSettingResp masterTutorialList
                     * @property {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg>|null} [masterMainVisualImgList] KumaMasterSettingResp masterMainVisualImgList
                     * @property {string|null} [maintenanceTitle] KumaMasterSettingResp maintenanceTitle
                     * @property {string|null} [maintenanceInfo] KumaMasterSettingResp maintenanceInfo
                     * @property {boolean|null} [isMaintenanceNow] KumaMasterSettingResp isMaintenanceNow
                     * @property {number|null} [termsOfServiceNo] KumaMasterSettingResp termsOfServiceNo
                     */

                    /**
                     * Constructs a new KumaMasterSettingResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a KumaMasterSettingResp.
                     * @implements IKumaMasterSettingResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingResp=} [properties] Properties to set
                     */
                    function KumaMasterSettingResp(properties) {
                        this.masterArcadeList = [];
                        this.masterTutorialList = [];
                        this.masterMainVisualImgList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * KumaMasterSettingResp status.
                     * @member {kuma.jp.protobuf.web.KumaMasterSettingResp.Status} status
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.status = 0;

                    /**
                     * KumaMasterSettingResp masterArcadeList.
                     * @member {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade>} masterArcadeList
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.masterArcadeList = $util.emptyArray;

                    /**
                     * KumaMasterSettingResp masterTutorialList.
                     * @member {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial>} masterTutorialList
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.masterTutorialList = $util.emptyArray;

                    /**
                     * KumaMasterSettingResp masterMainVisualImgList.
                     * @member {Array.<kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg>} masterMainVisualImgList
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.masterMainVisualImgList = $util.emptyArray;

                    /**
                     * KumaMasterSettingResp maintenanceTitle.
                     * @member {string} maintenanceTitle
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.maintenanceTitle = "";

                    /**
                     * KumaMasterSettingResp maintenanceInfo.
                     * @member {string} maintenanceInfo
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.maintenanceInfo = "";

                    /**
                     * KumaMasterSettingResp isMaintenanceNow.
                     * @member {boolean} isMaintenanceNow
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.isMaintenanceNow = false;

                    /**
                     * KumaMasterSettingResp termsOfServiceNo.
                     * @member {number} termsOfServiceNo
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     */
                    KumaMasterSettingResp.prototype.termsOfServiceNo = 0;

                    /**
                     * Creates a new KumaMasterSettingResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp} KumaMasterSettingResp instance
                     */
                    KumaMasterSettingResp.create = function create(properties) {
                        return new KumaMasterSettingResp(properties);
                    };

                    /**
                     * Encodes the specified KumaMasterSettingResp message. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingResp} message KumaMasterSettingResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaMasterSettingResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.masterArcadeList != null && message.masterArcadeList.length)
                            for (let i = 0; i < message.masterArcadeList.length; ++i)
                                $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.encode(message.masterArcadeList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.masterTutorialList != null && message.masterTutorialList.length)
                            for (let i = 0; i < message.masterTutorialList.length; ++i)
                                $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.encode(message.masterTutorialList[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.masterMainVisualImgList != null && message.masterMainVisualImgList.length)
                            for (let i = 0; i < message.masterMainVisualImgList.length; ++i)
                                $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.encode(message.masterMainVisualImgList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.maintenanceTitle != null && Object.hasOwnProperty.call(message, "maintenanceTitle"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.maintenanceTitle);
                        if (message.maintenanceInfo != null && Object.hasOwnProperty.call(message, "maintenanceInfo"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.maintenanceInfo);
                        if (message.isMaintenanceNow != null && Object.hasOwnProperty.call(message, "isMaintenanceNow"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isMaintenanceNow);
                        if (message.termsOfServiceNo != null && Object.hasOwnProperty.call(message, "termsOfServiceNo"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.termsOfServiceNo);
                        return writer;
                    };

                    /**
                     * Encodes the specified KumaMasterSettingResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IKumaMasterSettingResp} message KumaMasterSettingResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    KumaMasterSettingResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a KumaMasterSettingResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp} KumaMasterSettingResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaMasterSettingResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.masterArcadeList && message.masterArcadeList.length))
                                        message.masterArcadeList = [];
                                    message.masterArcadeList.push($root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 3: {
                                    if (!(message.masterTutorialList && message.masterTutorialList.length))
                                        message.masterTutorialList = [];
                                    message.masterTutorialList.push($root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 4: {
                                    if (!(message.masterMainVisualImgList && message.masterMainVisualImgList.length))
                                        message.masterMainVisualImgList = [];
                                    message.masterMainVisualImgList.push($root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 5: {
                                    message.maintenanceTitle = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.maintenanceInfo = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.isMaintenanceNow = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.termsOfServiceNo = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a KumaMasterSettingResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp} KumaMasterSettingResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    KumaMasterSettingResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a KumaMasterSettingResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    KumaMasterSettingResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.masterArcadeList != null && message.hasOwnProperty("masterArcadeList")) {
                            if (!Array.isArray(message.masterArcadeList))
                                return "masterArcadeList: array expected";
                            for (let i = 0; i < message.masterArcadeList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.verify(message.masterArcadeList[i]);
                                if (error)
                                    return "masterArcadeList." + error;
                            }
                        }
                        if (message.masterTutorialList != null && message.hasOwnProperty("masterTutorialList")) {
                            if (!Array.isArray(message.masterTutorialList))
                                return "masterTutorialList: array expected";
                            for (let i = 0; i < message.masterTutorialList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.verify(message.masterTutorialList[i]);
                                if (error)
                                    return "masterTutorialList." + error;
                            }
                        }
                        if (message.masterMainVisualImgList != null && message.hasOwnProperty("masterMainVisualImgList")) {
                            if (!Array.isArray(message.masterMainVisualImgList))
                                return "masterMainVisualImgList: array expected";
                            for (let i = 0; i < message.masterMainVisualImgList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.verify(message.masterMainVisualImgList[i]);
                                if (error)
                                    return "masterMainVisualImgList." + error;
                            }
                        }
                        if (message.maintenanceTitle != null && message.hasOwnProperty("maintenanceTitle"))
                            if (!$util.isString(message.maintenanceTitle))
                                return "maintenanceTitle: string expected";
                        if (message.maintenanceInfo != null && message.hasOwnProperty("maintenanceInfo"))
                            if (!$util.isString(message.maintenanceInfo))
                                return "maintenanceInfo: string expected";
                        if (message.isMaintenanceNow != null && message.hasOwnProperty("isMaintenanceNow"))
                            if (typeof message.isMaintenanceNow !== "boolean")
                                return "isMaintenanceNow: boolean expected";
                        if (message.termsOfServiceNo != null && message.hasOwnProperty("termsOfServiceNo"))
                            if (!$util.isInteger(message.termsOfServiceNo))
                                return "termsOfServiceNo: integer expected";
                        return null;
                    };

                    /**
                     * Creates a KumaMasterSettingResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp} KumaMasterSettingResp
                     */
                    KumaMasterSettingResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.KumaMasterSettingResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.masterArcadeList) {
                            if (!Array.isArray(object.masterArcadeList))
                                throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterArcadeList: array expected");
                            message.masterArcadeList = [];
                            for (let i = 0; i < object.masterArcadeList.length; ++i) {
                                if (typeof object.masterArcadeList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterArcadeList: object expected");
                                message.masterArcadeList[i] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.fromObject(object.masterArcadeList[i]);
                            }
                        }
                        if (object.masterTutorialList) {
                            if (!Array.isArray(object.masterTutorialList))
                                throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterTutorialList: array expected");
                            message.masterTutorialList = [];
                            for (let i = 0; i < object.masterTutorialList.length; ++i) {
                                if (typeof object.masterTutorialList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterTutorialList: object expected");
                                message.masterTutorialList[i] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.fromObject(object.masterTutorialList[i]);
                            }
                        }
                        if (object.masterMainVisualImgList) {
                            if (!Array.isArray(object.masterMainVisualImgList))
                                throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterMainVisualImgList: array expected");
                            message.masterMainVisualImgList = [];
                            for (let i = 0; i < object.masterMainVisualImgList.length; ++i) {
                                if (typeof object.masterMainVisualImgList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.KumaMasterSettingResp.masterMainVisualImgList: object expected");
                                message.masterMainVisualImgList[i] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.fromObject(object.masterMainVisualImgList[i]);
                            }
                        }
                        if (object.maintenanceTitle != null)
                            message.maintenanceTitle = String(object.maintenanceTitle);
                        if (object.maintenanceInfo != null)
                            message.maintenanceInfo = String(object.maintenanceInfo);
                        if (object.isMaintenanceNow != null)
                            message.isMaintenanceNow = Boolean(object.isMaintenanceNow);
                        if (object.termsOfServiceNo != null)
                            message.termsOfServiceNo = object.termsOfServiceNo | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a KumaMasterSettingResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {kuma.jp.protobuf.web.KumaMasterSettingResp} message KumaMasterSettingResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    KumaMasterSettingResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.masterArcadeList = [];
                            object.masterTutorialList = [];
                            object.masterMainVisualImgList = [];
                        }
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.maintenanceTitle = "";
                            object.maintenanceInfo = "";
                            object.isMaintenanceNow = false;
                            object.termsOfServiceNo = 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.KumaMasterSettingResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.KumaMasterSettingResp.Status[message.status] : message.status;
                        if (message.masterArcadeList && message.masterArcadeList.length) {
                            object.masterArcadeList = [];
                            for (let j = 0; j < message.masterArcadeList.length; ++j)
                                object.masterArcadeList[j] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.toObject(message.masterArcadeList[j], options);
                        }
                        if (message.masterTutorialList && message.masterTutorialList.length) {
                            object.masterTutorialList = [];
                            for (let j = 0; j < message.masterTutorialList.length; ++j)
                                object.masterTutorialList[j] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.toObject(message.masterTutorialList[j], options);
                        }
                        if (message.masterMainVisualImgList && message.masterMainVisualImgList.length) {
                            object.masterMainVisualImgList = [];
                            for (let j = 0; j < message.masterMainVisualImgList.length; ++j)
                                object.masterMainVisualImgList[j] = $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.toObject(message.masterMainVisualImgList[j], options);
                        }
                        if (message.maintenanceTitle != null && message.hasOwnProperty("maintenanceTitle"))
                            object.maintenanceTitle = message.maintenanceTitle;
                        if (message.maintenanceInfo != null && message.hasOwnProperty("maintenanceInfo"))
                            object.maintenanceInfo = message.maintenanceInfo;
                        if (message.isMaintenanceNow != null && message.hasOwnProperty("isMaintenanceNow"))
                            object.isMaintenanceNow = message.isMaintenanceNow;
                        if (message.termsOfServiceNo != null && message.hasOwnProperty("termsOfServiceNo"))
                            object.termsOfServiceNo = message.termsOfServiceNo;
                        return object;
                    };

                    /**
                     * Converts this KumaMasterSettingResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    KumaMasterSettingResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for KumaMasterSettingResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    KumaMasterSettingResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.KumaMasterSettingResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.KumaMasterSettingResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=41501 COMMAND_NO value
                     */
                    KumaMasterSettingResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[41501] = "COMMAND_NO"] = 41501;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.KumaMasterSettingResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    KumaMasterSettingResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    KumaMasterSettingResp.MasterArcade = (function() {

                        /**
                         * Properties of a MasterArcade.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @interface IMasterArcade
                         * @property {number|null} [arcadeId] MasterArcade arcadeId
                         * @property {string|null} [name] MasterArcade name
                         * @property {number|null} [displayOrder] MasterArcade displayOrder
                         * @property {boolean|null} [isDisplayTop] MasterArcade isDisplayTop
                         * @property {boolean|null} [isDisplaySearch] MasterArcade isDisplaySearch
                         * @property {boolean|null} [isDisplayNew] MasterArcade isDisplayNew
                         * @property {boolean|null} [isDisplayOld] MasterArcade isDisplayOld
                         * @property {boolean|null} [graffBtn] MasterArcade graffBtn
                         * @property {boolean|null} [makeBtn] MasterArcade makeBtn
                         * @property {boolean|null} [bgBtn] MasterArcade bgBtn
                         * @property {string|null} [informationUrl] MasterArcade informationUrl
                         * @property {string|null} [placeUrl] MasterArcade placeUrl
                         * @property {string|null} [arcadeImg] MasterArcade arcadeImg
                         * @property {string|null} [arcadeLogoImg] MasterArcade arcadeLogoImg
                         * @property {boolean|null} [isMovie] MasterArcade isMovie
                         */

                        /**
                         * Constructs a new MasterArcade.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @classdesc Represents a MasterArcade.
                         * @implements IMasterArcade
                         * @constructor
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade=} [properties] Properties to set
                         */
                        function MasterArcade(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * MasterArcade arcadeId.
                         * @member {number} arcadeId
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.arcadeId = 0;

                        /**
                         * MasterArcade name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.name = "";

                        /**
                         * MasterArcade displayOrder.
                         * @member {number} displayOrder
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.displayOrder = 0;

                        /**
                         * MasterArcade isDisplayTop.
                         * @member {boolean} isDisplayTop
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.isDisplayTop = false;

                        /**
                         * MasterArcade isDisplaySearch.
                         * @member {boolean} isDisplaySearch
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.isDisplaySearch = false;

                        /**
                         * MasterArcade isDisplayNew.
                         * @member {boolean} isDisplayNew
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.isDisplayNew = false;

                        /**
                         * MasterArcade isDisplayOld.
                         * @member {boolean} isDisplayOld
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.isDisplayOld = false;

                        /**
                         * MasterArcade graffBtn.
                         * @member {boolean} graffBtn
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.graffBtn = false;

                        /**
                         * MasterArcade makeBtn.
                         * @member {boolean} makeBtn
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.makeBtn = false;

                        /**
                         * MasterArcade bgBtn.
                         * @member {boolean} bgBtn
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.bgBtn = false;

                        /**
                         * MasterArcade informationUrl.
                         * @member {string} informationUrl
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.informationUrl = "";

                        /**
                         * MasterArcade placeUrl.
                         * @member {string} placeUrl
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.placeUrl = "";

                        /**
                         * MasterArcade arcadeImg.
                         * @member {string} arcadeImg
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.arcadeImg = "";

                        /**
                         * MasterArcade arcadeLogoImg.
                         * @member {string} arcadeLogoImg
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.arcadeLogoImg = "";

                        /**
                         * MasterArcade isMovie.
                         * @member {boolean} isMovie
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         */
                        MasterArcade.prototype.isMovie = false;

                        /**
                         * Creates a new MasterArcade instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade} MasterArcade instance
                         */
                        MasterArcade.create = function create(properties) {
                            return new MasterArcade(properties);
                        };

                        /**
                         * Encodes the specified MasterArcade message. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade} message MasterArcade message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterArcade.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.arcadeId != null && Object.hasOwnProperty.call(message, "arcadeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.arcadeId);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                            if (message.displayOrder != null && Object.hasOwnProperty.call(message, "displayOrder"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.displayOrder);
                            if (message.isDisplayTop != null && Object.hasOwnProperty.call(message, "isDisplayTop"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isDisplayTop);
                            if (message.isDisplaySearch != null && Object.hasOwnProperty.call(message, "isDisplaySearch"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isDisplaySearch);
                            if (message.isDisplayNew != null && Object.hasOwnProperty.call(message, "isDisplayNew"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isDisplayNew);
                            if (message.isDisplayOld != null && Object.hasOwnProperty.call(message, "isDisplayOld"))
                                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isDisplayOld);
                            if (message.graffBtn != null && Object.hasOwnProperty.call(message, "graffBtn"))
                                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.graffBtn);
                            if (message.makeBtn != null && Object.hasOwnProperty.call(message, "makeBtn"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.makeBtn);
                            if (message.bgBtn != null && Object.hasOwnProperty.call(message, "bgBtn"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.bgBtn);
                            if (message.informationUrl != null && Object.hasOwnProperty.call(message, "informationUrl"))
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.informationUrl);
                            if (message.placeUrl != null && Object.hasOwnProperty.call(message, "placeUrl"))
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.placeUrl);
                            if (message.arcadeImg != null && Object.hasOwnProperty.call(message, "arcadeImg"))
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.arcadeImg);
                            if (message.arcadeLogoImg != null && Object.hasOwnProperty.call(message, "arcadeLogoImg"))
                                writer.uint32(/* id 14, wireType 2 =*/114).string(message.arcadeLogoImg);
                            if (message.isMovie != null && Object.hasOwnProperty.call(message, "isMovie"))
                                writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isMovie);
                            return writer;
                        };

                        /**
                         * Encodes the specified MasterArcade message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterArcade} message MasterArcade message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterArcade.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a MasterArcade message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade} MasterArcade
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterArcade.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.arcadeId = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.displayOrder = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.isDisplayTop = reader.bool();
                                        break;
                                    }
                                case 5: {
                                        message.isDisplaySearch = reader.bool();
                                        break;
                                    }
                                case 6: {
                                        message.isDisplayNew = reader.bool();
                                        break;
                                    }
                                case 7: {
                                        message.isDisplayOld = reader.bool();
                                        break;
                                    }
                                case 8: {
                                        message.graffBtn = reader.bool();
                                        break;
                                    }
                                case 9: {
                                        message.makeBtn = reader.bool();
                                        break;
                                    }
                                case 10: {
                                        message.bgBtn = reader.bool();
                                        break;
                                    }
                                case 11: {
                                        message.informationUrl = reader.string();
                                        break;
                                    }
                                case 12: {
                                        message.placeUrl = reader.string();
                                        break;
                                    }
                                case 13: {
                                        message.arcadeImg = reader.string();
                                        break;
                                    }
                                case 14: {
                                        message.arcadeLogoImg = reader.string();
                                        break;
                                    }
                                case 15: {
                                        message.isMovie = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a MasterArcade message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade} MasterArcade
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterArcade.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a MasterArcade message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MasterArcade.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                if (!$util.isInteger(message.arcadeId))
                                    return "arcadeId: integer expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                                if (!$util.isInteger(message.displayOrder))
                                    return "displayOrder: integer expected";
                            if (message.isDisplayTop != null && message.hasOwnProperty("isDisplayTop"))
                                if (typeof message.isDisplayTop !== "boolean")
                                    return "isDisplayTop: boolean expected";
                            if (message.isDisplaySearch != null && message.hasOwnProperty("isDisplaySearch"))
                                if (typeof message.isDisplaySearch !== "boolean")
                                    return "isDisplaySearch: boolean expected";
                            if (message.isDisplayNew != null && message.hasOwnProperty("isDisplayNew"))
                                if (typeof message.isDisplayNew !== "boolean")
                                    return "isDisplayNew: boolean expected";
                            if (message.isDisplayOld != null && message.hasOwnProperty("isDisplayOld"))
                                if (typeof message.isDisplayOld !== "boolean")
                                    return "isDisplayOld: boolean expected";
                            if (message.graffBtn != null && message.hasOwnProperty("graffBtn"))
                                if (typeof message.graffBtn !== "boolean")
                                    return "graffBtn: boolean expected";
                            if (message.makeBtn != null && message.hasOwnProperty("makeBtn"))
                                if (typeof message.makeBtn !== "boolean")
                                    return "makeBtn: boolean expected";
                            if (message.bgBtn != null && message.hasOwnProperty("bgBtn"))
                                if (typeof message.bgBtn !== "boolean")
                                    return "bgBtn: boolean expected";
                            if (message.informationUrl != null && message.hasOwnProperty("informationUrl"))
                                if (!$util.isString(message.informationUrl))
                                    return "informationUrl: string expected";
                            if (message.placeUrl != null && message.hasOwnProperty("placeUrl"))
                                if (!$util.isString(message.placeUrl))
                                    return "placeUrl: string expected";
                            if (message.arcadeImg != null && message.hasOwnProperty("arcadeImg"))
                                if (!$util.isString(message.arcadeImg))
                                    return "arcadeImg: string expected";
                            if (message.arcadeLogoImg != null && message.hasOwnProperty("arcadeLogoImg"))
                                if (!$util.isString(message.arcadeLogoImg))
                                    return "arcadeLogoImg: string expected";
                            if (message.isMovie != null && message.hasOwnProperty("isMovie"))
                                if (typeof message.isMovie !== "boolean")
                                    return "isMovie: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a MasterArcade message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade} MasterArcade
                         */
                        MasterArcade.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade();
                            if (object.arcadeId != null)
                                message.arcadeId = object.arcadeId | 0;
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.displayOrder != null)
                                message.displayOrder = object.displayOrder | 0;
                            if (object.isDisplayTop != null)
                                message.isDisplayTop = Boolean(object.isDisplayTop);
                            if (object.isDisplaySearch != null)
                                message.isDisplaySearch = Boolean(object.isDisplaySearch);
                            if (object.isDisplayNew != null)
                                message.isDisplayNew = Boolean(object.isDisplayNew);
                            if (object.isDisplayOld != null)
                                message.isDisplayOld = Boolean(object.isDisplayOld);
                            if (object.graffBtn != null)
                                message.graffBtn = Boolean(object.graffBtn);
                            if (object.makeBtn != null)
                                message.makeBtn = Boolean(object.makeBtn);
                            if (object.bgBtn != null)
                                message.bgBtn = Boolean(object.bgBtn);
                            if (object.informationUrl != null)
                                message.informationUrl = String(object.informationUrl);
                            if (object.placeUrl != null)
                                message.placeUrl = String(object.placeUrl);
                            if (object.arcadeImg != null)
                                message.arcadeImg = String(object.arcadeImg);
                            if (object.arcadeLogoImg != null)
                                message.arcadeLogoImg = String(object.arcadeLogoImg);
                            if (object.isMovie != null)
                                message.isMovie = Boolean(object.isMovie);
                            return message;
                        };

                        /**
                         * Creates a plain object from a MasterArcade message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade} message MasterArcade
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MasterArcade.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.arcadeId = 0;
                                object.name = "";
                                object.displayOrder = 0;
                                object.isDisplayTop = false;
                                object.isDisplaySearch = false;
                                object.isDisplayNew = false;
                                object.isDisplayOld = false;
                                object.graffBtn = false;
                                object.makeBtn = false;
                                object.bgBtn = false;
                                object.informationUrl = "";
                                object.placeUrl = "";
                                object.arcadeImg = "";
                                object.arcadeLogoImg = "";
                                object.isMovie = false;
                            }
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                object.arcadeId = message.arcadeId;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                                object.displayOrder = message.displayOrder;
                            if (message.isDisplayTop != null && message.hasOwnProperty("isDisplayTop"))
                                object.isDisplayTop = message.isDisplayTop;
                            if (message.isDisplaySearch != null && message.hasOwnProperty("isDisplaySearch"))
                                object.isDisplaySearch = message.isDisplaySearch;
                            if (message.isDisplayNew != null && message.hasOwnProperty("isDisplayNew"))
                                object.isDisplayNew = message.isDisplayNew;
                            if (message.isDisplayOld != null && message.hasOwnProperty("isDisplayOld"))
                                object.isDisplayOld = message.isDisplayOld;
                            if (message.graffBtn != null && message.hasOwnProperty("graffBtn"))
                                object.graffBtn = message.graffBtn;
                            if (message.makeBtn != null && message.hasOwnProperty("makeBtn"))
                                object.makeBtn = message.makeBtn;
                            if (message.bgBtn != null && message.hasOwnProperty("bgBtn"))
                                object.bgBtn = message.bgBtn;
                            if (message.informationUrl != null && message.hasOwnProperty("informationUrl"))
                                object.informationUrl = message.informationUrl;
                            if (message.placeUrl != null && message.hasOwnProperty("placeUrl"))
                                object.placeUrl = message.placeUrl;
                            if (message.arcadeImg != null && message.hasOwnProperty("arcadeImg"))
                                object.arcadeImg = message.arcadeImg;
                            if (message.arcadeLogoImg != null && message.hasOwnProperty("arcadeLogoImg"))
                                object.arcadeLogoImg = message.arcadeLogoImg;
                            if (message.isMovie != null && message.hasOwnProperty("isMovie"))
                                object.isMovie = message.isMovie;
                            return object;
                        };

                        /**
                         * Converts this MasterArcade to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MasterArcade.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for MasterArcade
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        MasterArcade.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.KumaMasterSettingResp.MasterArcade";
                        };

                        return MasterArcade;
                    })();

                    KumaMasterSettingResp.MasterTutorial = (function() {

                        /**
                         * Properties of a MasterTutorial.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @interface IMasterTutorial
                         * @property {number|null} [displayOrder] MasterTutorial displayOrder
                         * @property {string|null} [imgPath] MasterTutorial imgPath
                         */

                        /**
                         * Constructs a new MasterTutorial.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @classdesc Represents a MasterTutorial.
                         * @implements IMasterTutorial
                         * @constructor
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial=} [properties] Properties to set
                         */
                        function MasterTutorial(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * MasterTutorial displayOrder.
                         * @member {number} displayOrder
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @instance
                         */
                        MasterTutorial.prototype.displayOrder = 0;

                        /**
                         * MasterTutorial imgPath.
                         * @member {string} imgPath
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @instance
                         */
                        MasterTutorial.prototype.imgPath = "";

                        /**
                         * Creates a new MasterTutorial instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial} MasterTutorial instance
                         */
                        MasterTutorial.create = function create(properties) {
                            return new MasterTutorial(properties);
                        };

                        /**
                         * Encodes the specified MasterTutorial message. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial} message MasterTutorial message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterTutorial.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.displayOrder != null && Object.hasOwnProperty.call(message, "displayOrder"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.displayOrder);
                            if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.imgPath);
                            return writer;
                        };

                        /**
                         * Encodes the specified MasterTutorial message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterTutorial} message MasterTutorial message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterTutorial.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a MasterTutorial message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial} MasterTutorial
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterTutorial.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.displayOrder = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.imgPath = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a MasterTutorial message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial} MasterTutorial
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterTutorial.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a MasterTutorial message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MasterTutorial.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                                if (!$util.isInteger(message.displayOrder))
                                    return "displayOrder: integer expected";
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                if (!$util.isString(message.imgPath))
                                    return "imgPath: string expected";
                            return null;
                        };

                        /**
                         * Creates a MasterTutorial message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial} MasterTutorial
                         */
                        MasterTutorial.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial();
                            if (object.displayOrder != null)
                                message.displayOrder = object.displayOrder | 0;
                            if (object.imgPath != null)
                                message.imgPath = String(object.imgPath);
                            return message;
                        };

                        /**
                         * Creates a plain object from a MasterTutorial message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial} message MasterTutorial
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MasterTutorial.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.displayOrder = 0;
                                object.imgPath = "";
                            }
                            if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                                object.displayOrder = message.displayOrder;
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                object.imgPath = message.imgPath;
                            return object;
                        };

                        /**
                         * Converts this MasterTutorial to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MasterTutorial.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for MasterTutorial
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        MasterTutorial.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.KumaMasterSettingResp.MasterTutorial";
                        };

                        return MasterTutorial;
                    })();

                    KumaMasterSettingResp.MasterMainVisualImg = (function() {

                        /**
                         * Properties of a MasterMainVisualImg.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @interface IMasterMainVisualImg
                         * @property {string|null} [imgPath] MasterMainVisualImg imgPath
                         */

                        /**
                         * Constructs a new MasterMainVisualImg.
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp
                         * @classdesc Represents a MasterMainVisualImg.
                         * @implements IMasterMainVisualImg
                         * @constructor
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg=} [properties] Properties to set
                         */
                        function MasterMainVisualImg(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * MasterMainVisualImg imgPath.
                         * @member {string} imgPath
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @instance
                         */
                        MasterMainVisualImg.prototype.imgPath = "";

                        /**
                         * Creates a new MasterMainVisualImg instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg} MasterMainVisualImg instance
                         */
                        MasterMainVisualImg.create = function create(properties) {
                            return new MasterMainVisualImg(properties);
                        };

                        /**
                         * Encodes the specified MasterMainVisualImg message. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg} message MasterMainVisualImg message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterMainVisualImg.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.imgPath);
                            return writer;
                        };

                        /**
                         * Encodes the specified MasterMainVisualImg message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.IMasterMainVisualImg} message MasterMainVisualImg message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MasterMainVisualImg.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a MasterMainVisualImg message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg} MasterMainVisualImg
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterMainVisualImg.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.imgPath = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a MasterMainVisualImg message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg} MasterMainVisualImg
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MasterMainVisualImg.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a MasterMainVisualImg message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MasterMainVisualImg.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                if (!$util.isString(message.imgPath))
                                    return "imgPath: string expected";
                            return null;
                        };

                        /**
                         * Creates a MasterMainVisualImg message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg} MasterMainVisualImg
                         */
                        MasterMainVisualImg.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg();
                            if (object.imgPath != null)
                                message.imgPath = String(object.imgPath);
                            return message;
                        };

                        /**
                         * Creates a plain object from a MasterMainVisualImg message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg} message MasterMainVisualImg
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MasterMainVisualImg.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults)
                                object.imgPath = "";
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                object.imgPath = message.imgPath;
                            return object;
                        };

                        /**
                         * Converts this MasterMainVisualImg to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MasterMainVisualImg.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for MasterMainVisualImg
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        MasterMainVisualImg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.KumaMasterSettingResp.MasterMainVisualImg";
                        };

                        return MasterMainVisualImg;
                    })();

                    return KumaMasterSettingResp;
                })();

                web.LoginReq = (function() {

                    /**
                     * Properties of a LoginReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ILoginReq
                     * @property {kuma.jp.protobuf.web.LoginReq.LoginType|null} [loginType] LoginReq loginType
                     * @property {string|null} [mailAddress] LoginReq mailAddress
                     * @property {string|null} [password] LoginReq password
                     * @property {string|null} [twitterUserId] LoginReq twitterUserId
                     * @property {string|null} [twitterAccessToken] LoginReq twitterAccessToken
                     * @property {string|null} [lineUserId] LoginReq lineUserId
                     * @property {string|null} [lineAccessToken] LoginReq lineAccessToken
                     */

                    /**
                     * Constructs a new LoginReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a LoginReq.
                     * @implements ILoginReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ILoginReq=} [properties] Properties to set
                     */
                    function LoginReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LoginReq loginType.
                     * @member {kuma.jp.protobuf.web.LoginReq.LoginType} loginType
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.loginType = 0;

                    /**
                     * LoginReq mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.mailAddress = "";

                    /**
                     * LoginReq password.
                     * @member {string} password
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.password = "";

                    /**
                     * LoginReq twitterUserId.
                     * @member {string} twitterUserId
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.twitterUserId = "";

                    /**
                     * LoginReq twitterAccessToken.
                     * @member {string} twitterAccessToken
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.twitterAccessToken = "";

                    /**
                     * LoginReq lineUserId.
                     * @member {string} lineUserId
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.lineUserId = "";

                    /**
                     * LoginReq lineAccessToken.
                     * @member {string} lineAccessToken
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     */
                    LoginReq.prototype.lineAccessToken = "";

                    /**
                     * Creates a new LoginReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.LoginReq} LoginReq instance
                     */
                    LoginReq.create = function create(properties) {
                        return new LoginReq(properties);
                    };

                    /**
                     * Encodes the specified LoginReq message. Does not implicitly {@link kuma.jp.protobuf.web.LoginReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginReq} message LoginReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.loginType != null && Object.hasOwnProperty.call(message, "loginType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.loginType);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.mailAddress);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.password);
                        if (message.twitterUserId != null && Object.hasOwnProperty.call(message, "twitterUserId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.twitterUserId);
                        if (message.twitterAccessToken != null && Object.hasOwnProperty.call(message, "twitterAccessToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.twitterAccessToken);
                        if (message.lineUserId != null && Object.hasOwnProperty.call(message, "lineUserId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.lineUserId);
                        if (message.lineAccessToken != null && Object.hasOwnProperty.call(message, "lineAccessToken"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.lineAccessToken);
                        return writer;
                    };

                    /**
                     * Encodes the specified LoginReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.LoginReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginReq} message LoginReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LoginReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.LoginReq} LoginReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.LoginReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2: {
                                    message.loginType = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.password = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.twitterUserId = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.twitterAccessToken = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.lineUserId = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.lineAccessToken = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LoginReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.LoginReq} LoginReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LoginReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LoginReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.loginType != null && message.hasOwnProperty("loginType"))
                            switch (message.loginType) {
                            default:
                                return "loginType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            if (!$util.isString(message.twitterUserId))
                                return "twitterUserId: string expected";
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            if (!$util.isString(message.twitterAccessToken))
                                return "twitterAccessToken: string expected";
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            if (!$util.isString(message.lineUserId))
                                return "lineUserId: string expected";
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            if (!$util.isString(message.lineAccessToken))
                                return "lineAccessToken: string expected";
                        return null;
                    };

                    /**
                     * Creates a LoginReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.LoginReq} LoginReq
                     */
                    LoginReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.LoginReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.LoginReq();
                        switch (object.loginType) {
                        default:
                            if (typeof object.loginType === "number") {
                                message.loginType = object.loginType;
                                break;
                            }
                            break;
                        case "MAIL_ADDRESS":
                        case 0:
                            message.loginType = 0;
                            break;
                        case "TWITTER":
                        case 1:
                            message.loginType = 1;
                            break;
                        case "LINE":
                        case 2:
                            message.loginType = 2;
                            break;
                        }
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        if (object.password != null)
                            message.password = String(object.password);
                        if (object.twitterUserId != null)
                            message.twitterUserId = String(object.twitterUserId);
                        if (object.twitterAccessToken != null)
                            message.twitterAccessToken = String(object.twitterAccessToken);
                        if (object.lineUserId != null)
                            message.lineUserId = String(object.lineUserId);
                        if (object.lineAccessToken != null)
                            message.lineAccessToken = String(object.lineAccessToken);
                        return message;
                    };

                    /**
                     * Creates a plain object from a LoginReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {kuma.jp.protobuf.web.LoginReq} message LoginReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LoginReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.loginType = options.enums === String ? "MAIL_ADDRESS" : 0;
                            object.mailAddress = "";
                            object.password = "";
                            object.twitterUserId = "";
                            object.twitterAccessToken = "";
                            object.lineUserId = "";
                            object.lineAccessToken = "";
                        }
                        if (message.loginType != null && message.hasOwnProperty("loginType"))
                            object.loginType = options.enums === String ? $root.kuma.jp.protobuf.web.LoginReq.LoginType[message.loginType] === undefined ? message.loginType : $root.kuma.jp.protobuf.web.LoginReq.LoginType[message.loginType] : message.loginType;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            object.twitterUserId = message.twitterUserId;
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            object.twitterAccessToken = message.twitterAccessToken;
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            object.lineUserId = message.lineUserId;
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            object.lineAccessToken = message.lineAccessToken;
                        return object;
                    };

                    /**
                     * Converts this LoginReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LoginReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LoginReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.LoginReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LoginReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.LoginReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.LoginReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10100 COMMAND_NO value
                     */
                    LoginReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10100] = "COMMAND_NO"] = 10100;
                        return values;
                    })();

                    /**
                     * LoginType enum.
                     * @name kuma.jp.protobuf.web.LoginReq.LoginType
                     * @enum {number}
                     * @property {number} MAIL_ADDRESS=0 MAIL_ADDRESS value
                     * @property {number} TWITTER=1 TWITTER value
                     * @property {number} LINE=2 LINE value
                     */
                    LoginReq.LoginType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "MAIL_ADDRESS"] = 0;
                        values[valuesById[1] = "TWITTER"] = 1;
                        values[valuesById[2] = "LINE"] = 2;
                        return values;
                    })();

                    return LoginReq;
                })();

                web.LoginResp = (function() {

                    /**
                     * Properties of a LoginResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ILoginResp
                     * @property {kuma.jp.protobuf.web.LoginResp.Status|null} [status] LoginResp status
                     * @property {Uint8Array|null} [token] LoginResp token
                     * @property {boolean|null} [isChecking] LoginResp isChecking
                     * @property {kuma.jp.protobuf.web.LoginResp.MembershipGrade|null} [membershipGrade] LoginResp membershipGrade
                     * @property {string|null} [mailAddress] LoginResp mailAddress
                     * @property {number|Long|null} [playerId] LoginResp playerId
                     * @property {kuma.jp.protobuf.web.LoginResp.RegistrationType|null} [registrationType] LoginResp registrationType
                     */

                    /**
                     * Constructs a new LoginResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a LoginResp.
                     * @implements ILoginResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ILoginResp=} [properties] Properties to set
                     */
                    function LoginResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LoginResp status.
                     * @member {kuma.jp.protobuf.web.LoginResp.Status} status
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.status = 0;

                    /**
                     * LoginResp token.
                     * @member {Uint8Array} token
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.token = $util.newBuffer([]);

                    /**
                     * LoginResp isChecking.
                     * @member {boolean} isChecking
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.isChecking = false;

                    /**
                     * LoginResp membershipGrade.
                     * @member {kuma.jp.protobuf.web.LoginResp.MembershipGrade} membershipGrade
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.membershipGrade = 0;

                    /**
                     * LoginResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.mailAddress = "";

                    /**
                     * LoginResp playerId.
                     * @member {number|Long} playerId
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.playerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * LoginResp registrationType.
                     * @member {kuma.jp.protobuf.web.LoginResp.RegistrationType} registrationType
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     */
                    LoginResp.prototype.registrationType = 0;

                    /**
                     * Creates a new LoginResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.LoginResp} LoginResp instance
                     */
                    LoginResp.create = function create(properties) {
                        return new LoginResp(properties);
                    };

                    /**
                     * Encodes the specified LoginResp message. Does not implicitly {@link kuma.jp.protobuf.web.LoginResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginResp} message LoginResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
                        if (message.isChecking != null && Object.hasOwnProperty.call(message, "isChecking"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isChecking);
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.membershipGrade);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mailAddress);
                        if (message.playerId != null && Object.hasOwnProperty.call(message, "playerId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.playerId);
                        if (message.registrationType != null && Object.hasOwnProperty.call(message, "registrationType"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.registrationType);
                        return writer;
                    };

                    /**
                     * Encodes the specified LoginResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.LoginResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILoginResp} message LoginResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LoginResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.LoginResp} LoginResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.LoginResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.token = reader.bytes();
                                    break;
                                }
                            case 3: {
                                    message.isChecking = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.playerId = reader.int64();
                                    break;
                                }
                            case 7: {
                                    message.registrationType = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LoginResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.LoginResp} LoginResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LoginResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LoginResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                                return "token: buffer expected";
                        if (message.isChecking != null && message.hasOwnProperty("isChecking"))
                            if (typeof message.isChecking !== "boolean")
                                return "isChecking: boolean expected";
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            switch (message.membershipGrade) {
                            default:
                                return "membershipGrade: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (!$util.isInteger(message.playerId) && !(message.playerId && $util.isInteger(message.playerId.low) && $util.isInteger(message.playerId.high)))
                                return "playerId: integer|Long expected";
                        if (message.registrationType != null && message.hasOwnProperty("registrationType"))
                            switch (message.registrationType) {
                            default:
                                return "registrationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a LoginResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.LoginResp} LoginResp
                     */
                    LoginResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.LoginResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.LoginResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.token != null)
                            if (typeof object.token === "string")
                                $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                            else if (object.token.length >= 0)
                                message.token = object.token;
                        if (object.isChecking != null)
                            message.isChecking = Boolean(object.isChecking);
                        switch (object.membershipGrade) {
                        default:
                            if (typeof object.membershipGrade === "number") {
                                message.membershipGrade = object.membershipGrade;
                                break;
                            }
                            break;
                        case "GUEST":
                        case 0:
                            message.membershipGrade = 0;
                            break;
                        case "FREE":
                        case 1:
                            message.membershipGrade = 1;
                            break;
                        case "GOLD":
                        case 2:
                            message.membershipGrade = 2;
                            break;
                        case "PLATINUM":
                        case 3:
                            message.membershipGrade = 3;
                            break;
                        }
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        if (object.playerId != null)
                            if ($util.Long)
                                (message.playerId = $util.Long.fromValue(object.playerId)).unsigned = false;
                            else if (typeof object.playerId === "string")
                                message.playerId = parseInt(object.playerId, 10);
                            else if (typeof object.playerId === "number")
                                message.playerId = object.playerId;
                            else if (typeof object.playerId === "object")
                                message.playerId = new $util.LongBits(object.playerId.low >>> 0, object.playerId.high >>> 0).toNumber();
                        switch (object.registrationType) {
                        default:
                            if (typeof object.registrationType === "number") {
                                message.registrationType = object.registrationType;
                                break;
                            }
                            break;
                        case "IOS_REGIST":
                        case 0:
                            message.registrationType = 0;
                            break;
                        case "ANDROID_REGIST":
                        case 1:
                            message.registrationType = 1;
                            break;
                        case "WEB_REGIST":
                        case 2:
                            message.registrationType = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a LoginResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {kuma.jp.protobuf.web.LoginResp} message LoginResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LoginResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            if (options.bytes === String)
                                object.token = "";
                            else {
                                object.token = [];
                                if (options.bytes !== Array)
                                    object.token = $util.newBuffer(object.token);
                            }
                            object.isChecking = false;
                            object.membershipGrade = options.enums === String ? "GUEST" : 0;
                            object.mailAddress = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.playerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.playerId = options.longs === String ? "0" : 0;
                            object.registrationType = options.enums === String ? "IOS_REGIST" : 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.LoginResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.LoginResp.Status[message.status] : message.status;
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                        if (message.isChecking != null && message.hasOwnProperty("isChecking"))
                            object.isChecking = message.isChecking;
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = options.enums === String ? $root.kuma.jp.protobuf.web.LoginResp.MembershipGrade[message.membershipGrade] === undefined ? message.membershipGrade : $root.kuma.jp.protobuf.web.LoginResp.MembershipGrade[message.membershipGrade] : message.membershipGrade;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (typeof message.playerId === "number")
                                object.playerId = options.longs === String ? String(message.playerId) : message.playerId;
                            else
                                object.playerId = options.longs === String ? $util.Long.prototype.toString.call(message.playerId) : options.longs === Number ? new $util.LongBits(message.playerId.low >>> 0, message.playerId.high >>> 0).toNumber() : message.playerId;
                        if (message.registrationType != null && message.hasOwnProperty("registrationType"))
                            object.registrationType = options.enums === String ? $root.kuma.jp.protobuf.web.LoginResp.RegistrationType[message.registrationType] === undefined ? message.registrationType : $root.kuma.jp.protobuf.web.LoginResp.RegistrationType[message.registrationType] : message.registrationType;
                        return object;
                    };

                    /**
                     * Converts this LoginResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LoginResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LoginResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.LoginResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LoginResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.LoginResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.LoginResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10101 COMMAND_NO value
                     */
                    LoginResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10101] = "COMMAND_NO"] = 10101;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.LoginResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    LoginResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    /**
                     * MembershipGrade enum.
                     * @name kuma.jp.protobuf.web.LoginResp.MembershipGrade
                     * @enum {number}
                     * @property {number} GUEST=0 GUEST value
                     * @property {number} FREE=1 FREE value
                     * @property {number} GOLD=2 GOLD value
                     * @property {number} PLATINUM=3 PLATINUM value
                     */
                    LoginResp.MembershipGrade = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "GUEST"] = 0;
                        values[valuesById[1] = "FREE"] = 1;
                        values[valuesById[2] = "GOLD"] = 2;
                        values[valuesById[3] = "PLATINUM"] = 3;
                        return values;
                    })();

                    /**
                     * RegistrationType enum.
                     * @name kuma.jp.protobuf.web.LoginResp.RegistrationType
                     * @enum {number}
                     * @property {number} IOS_REGIST=0 IOS_REGIST value
                     * @property {number} ANDROID_REGIST=1 ANDROID_REGIST value
                     * @property {number} WEB_REGIST=2 WEB_REGIST value
                     */
                    LoginResp.RegistrationType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "IOS_REGIST"] = 0;
                        values[valuesById[1] = "ANDROID_REGIST"] = 1;
                        values[valuesById[2] = "WEB_REGIST"] = 2;
                        return values;
                    })();

                    return LoginResp;
                })();

                web.LogoutReq = (function() {

                    /**
                     * Properties of a LogoutReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ILogoutReq
                     * @property {Uint8Array|null} [token] LogoutReq token
                     */

                    /**
                     * Constructs a new LogoutReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a LogoutReq.
                     * @implements ILogoutReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ILogoutReq=} [properties] Properties to set
                     */
                    function LogoutReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LogoutReq token.
                     * @member {Uint8Array} token
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @instance
                     */
                    LogoutReq.prototype.token = $util.newBuffer([]);

                    /**
                     * Creates a new LogoutReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.LogoutReq} LogoutReq instance
                     */
                    LogoutReq.create = function create(properties) {
                        return new LogoutReq(properties);
                    };

                    /**
                     * Encodes the specified LogoutReq message. Does not implicitly {@link kuma.jp.protobuf.web.LogoutReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutReq} message LogoutReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.token);
                        return writer;
                    };

                    /**
                     * Encodes the specified LogoutReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.LogoutReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutReq} message LogoutReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LogoutReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.LogoutReq} LogoutReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.LogoutReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.token = reader.bytes();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LogoutReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.LogoutReq} LogoutReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LogoutReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LogoutReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                                return "token: buffer expected";
                        return null;
                    };

                    /**
                     * Creates a LogoutReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.LogoutReq} LogoutReq
                     */
                    LogoutReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.LogoutReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.LogoutReq();
                        if (object.token != null)
                            if (typeof object.token === "string")
                                $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                            else if (object.token.length >= 0)
                                message.token = object.token;
                        return message;
                    };

                    /**
                     * Creates a plain object from a LogoutReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {kuma.jp.protobuf.web.LogoutReq} message LogoutReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LogoutReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            if (options.bytes === String)
                                object.token = "";
                            else {
                                object.token = [];
                                if (options.bytes !== Array)
                                    object.token = $util.newBuffer(object.token);
                            }
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                        return object;
                    };

                    /**
                     * Converts this LogoutReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LogoutReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LogoutReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.LogoutReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LogoutReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.LogoutReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.LogoutReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10200 COMMAND_NO value
                     */
                    LogoutReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10200] = "COMMAND_NO"] = 10200;
                        return values;
                    })();

                    return LogoutReq;
                })();

                web.LogoutResp = (function() {

                    /**
                     * Properties of a LogoutResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ILogoutResp
                     * @property {kuma.jp.protobuf.web.LogoutResp.Status|null} [status] LogoutResp status
                     */

                    /**
                     * Constructs a new LogoutResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a LogoutResp.
                     * @implements ILogoutResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ILogoutResp=} [properties] Properties to set
                     */
                    function LogoutResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LogoutResp status.
                     * @member {kuma.jp.protobuf.web.LogoutResp.Status} status
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @instance
                     */
                    LogoutResp.prototype.status = 0;

                    /**
                     * Creates a new LogoutResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.LogoutResp} LogoutResp instance
                     */
                    LogoutResp.create = function create(properties) {
                        return new LogoutResp(properties);
                    };

                    /**
                     * Encodes the specified LogoutResp message. Does not implicitly {@link kuma.jp.protobuf.web.LogoutResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutResp} message LogoutResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified LogoutResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.LogoutResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ILogoutResp} message LogoutResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LogoutResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.LogoutResp} LogoutResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.LogoutResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LogoutResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.LogoutResp} LogoutResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LogoutResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LogoutResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a LogoutResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.LogoutResp} LogoutResp
                     */
                    LogoutResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.LogoutResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.LogoutResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a LogoutResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {kuma.jp.protobuf.web.LogoutResp} message LogoutResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LogoutResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.LogoutResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.LogoutResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this LogoutResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LogoutResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LogoutResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.LogoutResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LogoutResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.LogoutResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.LogoutResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10201 COMMAND_NO value
                     */
                    LogoutResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10201] = "COMMAND_NO"] = 10201;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.LogoutResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    LogoutResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return LogoutResp;
                })();

                web.MailAddressRegistrationReq = (function() {

                    /**
                     * Properties of a MailAddressRegistrationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IMailAddressRegistrationReq
                     * @property {string|null} [mailAddress] MailAddressRegistrationReq mailAddress
                     */

                    /**
                     * Constructs a new MailAddressRegistrationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a MailAddressRegistrationReq.
                     * @implements IMailAddressRegistrationReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationReq=} [properties] Properties to set
                     */
                    function MailAddressRegistrationReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * MailAddressRegistrationReq mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @instance
                     */
                    MailAddressRegistrationReq.prototype.mailAddress = "";

                    /**
                     * Creates a new MailAddressRegistrationReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationReq} MailAddressRegistrationReq instance
                     */
                    MailAddressRegistrationReq.create = function create(properties) {
                        return new MailAddressRegistrationReq(properties);
                    };

                    /**
                     * Encodes the specified MailAddressRegistrationReq message. Does not implicitly {@link kuma.jp.protobuf.web.MailAddressRegistrationReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationReq} message MailAddressRegistrationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MailAddressRegistrationReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.mailAddress);
                        return writer;
                    };

                    /**
                     * Encodes the specified MailAddressRegistrationReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.MailAddressRegistrationReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationReq} message MailAddressRegistrationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MailAddressRegistrationReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a MailAddressRegistrationReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationReq} MailAddressRegistrationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MailAddressRegistrationReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.MailAddressRegistrationReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a MailAddressRegistrationReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationReq} MailAddressRegistrationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MailAddressRegistrationReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a MailAddressRegistrationReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MailAddressRegistrationReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        return null;
                    };

                    /**
                     * Creates a MailAddressRegistrationReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationReq} MailAddressRegistrationReq
                     */
                    MailAddressRegistrationReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.MailAddressRegistrationReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.MailAddressRegistrationReq();
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        return message;
                    };

                    /**
                     * Creates a plain object from a MailAddressRegistrationReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.MailAddressRegistrationReq} message MailAddressRegistrationReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MailAddressRegistrationReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.mailAddress = "";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        return object;
                    };

                    /**
                     * Converts this MailAddressRegistrationReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MailAddressRegistrationReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for MailAddressRegistrationReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    MailAddressRegistrationReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.MailAddressRegistrationReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.MailAddressRegistrationReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10000 COMMAND_NO value
                     */
                    MailAddressRegistrationReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10000] = "COMMAND_NO"] = 10000;
                        return values;
                    })();

                    return MailAddressRegistrationReq;
                })();

                web.MailAddressRegistrationResp = (function() {

                    /**
                     * Properties of a MailAddressRegistrationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IMailAddressRegistrationResp
                     * @property {kuma.jp.protobuf.web.MailAddressRegistrationResp.Status|null} [status] MailAddressRegistrationResp status
                     * @property {string|null} [failureReason] MailAddressRegistrationResp failureReason
                     */

                    /**
                     * Constructs a new MailAddressRegistrationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a MailAddressRegistrationResp.
                     * @implements IMailAddressRegistrationResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationResp=} [properties] Properties to set
                     */
                    function MailAddressRegistrationResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * MailAddressRegistrationResp status.
                     * @member {kuma.jp.protobuf.web.MailAddressRegistrationResp.Status} status
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @instance
                     */
                    MailAddressRegistrationResp.prototype.status = 0;

                    /**
                     * MailAddressRegistrationResp failureReason.
                     * @member {string} failureReason
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @instance
                     */
                    MailAddressRegistrationResp.prototype.failureReason = "";

                    /**
                     * Creates a new MailAddressRegistrationResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationResp} MailAddressRegistrationResp instance
                     */
                    MailAddressRegistrationResp.create = function create(properties) {
                        return new MailAddressRegistrationResp(properties);
                    };

                    /**
                     * Encodes the specified MailAddressRegistrationResp message. Does not implicitly {@link kuma.jp.protobuf.web.MailAddressRegistrationResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationResp} message MailAddressRegistrationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MailAddressRegistrationResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.failureReason != null && Object.hasOwnProperty.call(message, "failureReason"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.failureReason);
                        return writer;
                    };

                    /**
                     * Encodes the specified MailAddressRegistrationResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.MailAddressRegistrationResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IMailAddressRegistrationResp} message MailAddressRegistrationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MailAddressRegistrationResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a MailAddressRegistrationResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationResp} MailAddressRegistrationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MailAddressRegistrationResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.MailAddressRegistrationResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.failureReason = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a MailAddressRegistrationResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationResp} MailAddressRegistrationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MailAddressRegistrationResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a MailAddressRegistrationResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MailAddressRegistrationResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.failureReason != null && message.hasOwnProperty("failureReason"))
                            if (!$util.isString(message.failureReason))
                                return "failureReason: string expected";
                        return null;
                    };

                    /**
                     * Creates a MailAddressRegistrationResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.MailAddressRegistrationResp} MailAddressRegistrationResp
                     */
                    MailAddressRegistrationResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.MailAddressRegistrationResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.MailAddressRegistrationResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.failureReason != null)
                            message.failureReason = String(object.failureReason);
                        return message;
                    };

                    /**
                     * Creates a plain object from a MailAddressRegistrationResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.MailAddressRegistrationResp} message MailAddressRegistrationResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MailAddressRegistrationResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.failureReason = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.MailAddressRegistrationResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.MailAddressRegistrationResp.Status[message.status] : message.status;
                        if (message.failureReason != null && message.hasOwnProperty("failureReason"))
                            object.failureReason = message.failureReason;
                        return object;
                    };

                    /**
                     * Converts this MailAddressRegistrationResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MailAddressRegistrationResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for MailAddressRegistrationResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.MailAddressRegistrationResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    MailAddressRegistrationResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.MailAddressRegistrationResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.MailAddressRegistrationResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10001 COMMAND_NO value
                     */
                    MailAddressRegistrationResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10001] = "COMMAND_NO"] = 10001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.MailAddressRegistrationResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    MailAddressRegistrationResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return MailAddressRegistrationResp;
                })();

                web.NewsListReq = (function() {

                    /**
                     * Properties of a NewsListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface INewsListReq
                     * @property {kuma.jp.protobuf.web.NewsListReq.Type|null} [type] NewsListReq type
                     */

                    /**
                     * Constructs a new NewsListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a NewsListReq.
                     * @implements INewsListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.INewsListReq=} [properties] Properties to set
                     */
                    function NewsListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NewsListReq type.
                     * @member {kuma.jp.protobuf.web.NewsListReq.Type} type
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @instance
                     */
                    NewsListReq.prototype.type = 0;

                    /**
                     * Creates a new NewsListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.NewsListReq} NewsListReq instance
                     */
                    NewsListReq.create = function create(properties) {
                        return new NewsListReq(properties);
                    };

                    /**
                     * Encodes the specified NewsListReq message. Does not implicitly {@link kuma.jp.protobuf.web.NewsListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListReq} message NewsListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        return writer;
                    };

                    /**
                     * Encodes the specified NewsListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListReq} message NewsListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NewsListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.NewsListReq} NewsListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.type = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NewsListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.NewsListReq} NewsListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NewsListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NewsListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a NewsListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.NewsListReq} NewsListReq
                     */
                    NewsListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.NewsListReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.NewsListReq();
                        switch (object.type) {
                        default:
                            if (typeof object.type === "number") {
                                message.type = object.type;
                                break;
                            }
                            break;
                        case "NONE":
                        case 0:
                            message.type = 0;
                            break;
                        case "NEWS":
                        case 1:
                            message.type = 1;
                            break;
                        case "TARGET":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a NewsListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.NewsListReq} message NewsListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NewsListReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.type = options.enums === String ? "NONE" : 0;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.kuma.jp.protobuf.web.NewsListReq.Type[message.type] === undefined ? message.type : $root.kuma.jp.protobuf.web.NewsListReq.Type[message.type] : message.type;
                        return object;
                    };

                    /**
                     * Converts this NewsListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NewsListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NewsListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.NewsListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NewsListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.NewsListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40100 COMMAND_NO value
                     */
                    NewsListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40100] = "COMMAND_NO"] = 40100;
                        return values;
                    })();

                    /**
                     * Type enum.
                     * @name kuma.jp.protobuf.web.NewsListReq.Type
                     * @enum {number}
                     * @property {number} NONE=0 NONE value
                     * @property {number} NEWS=1 NEWS value
                     * @property {number} TARGET=2 TARGET value
                     */
                    NewsListReq.Type = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "NONE"] = 0;
                        values[valuesById[1] = "NEWS"] = 1;
                        values[valuesById[2] = "TARGET"] = 2;
                        return values;
                    })();

                    return NewsListReq;
                })();

                web.NewsListResp = (function() {

                    /**
                     * Properties of a NewsListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface INewsListResp
                     * @property {kuma.jp.protobuf.web.NewsListResp.Status|null} [status] NewsListResp status
                     * @property {Array.<kuma.jp.protobuf.web.NewsListResp.INews>|null} [newsList] NewsListResp newsList
                     */

                    /**
                     * Constructs a new NewsListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a NewsListResp.
                     * @implements INewsListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.INewsListResp=} [properties] Properties to set
                     */
                    function NewsListResp(properties) {
                        this.newsList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NewsListResp status.
                     * @member {kuma.jp.protobuf.web.NewsListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @instance
                     */
                    NewsListResp.prototype.status = 0;

                    /**
                     * NewsListResp newsList.
                     * @member {Array.<kuma.jp.protobuf.web.NewsListResp.INews>} newsList
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @instance
                     */
                    NewsListResp.prototype.newsList = $util.emptyArray;

                    /**
                     * Creates a new NewsListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.NewsListResp} NewsListResp instance
                     */
                    NewsListResp.create = function create(properties) {
                        return new NewsListResp(properties);
                    };

                    /**
                     * Encodes the specified NewsListResp message. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListResp} message NewsListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.newsList != null && message.newsList.length)
                            for (let i = 0; i < message.newsList.length; ++i)
                                $root.kuma.jp.protobuf.web.NewsListResp.News.encode(message.newsList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified NewsListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsListResp} message NewsListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NewsListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.NewsListResp} NewsListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.newsList && message.newsList.length))
                                        message.newsList = [];
                                    message.newsList.push($root.kuma.jp.protobuf.web.NewsListResp.News.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NewsListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.NewsListResp} NewsListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NewsListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NewsListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.newsList != null && message.hasOwnProperty("newsList")) {
                            if (!Array.isArray(message.newsList))
                                return "newsList: array expected";
                            for (let i = 0; i < message.newsList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.NewsListResp.News.verify(message.newsList[i]);
                                if (error)
                                    return "newsList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a NewsListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.NewsListResp} NewsListResp
                     */
                    NewsListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.NewsListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.NewsListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ERROR_NOT_LOGGED_IN":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.newsList) {
                            if (!Array.isArray(object.newsList))
                                throw TypeError(".kuma.jp.protobuf.web.NewsListResp.newsList: array expected");
                            message.newsList = [];
                            for (let i = 0; i < object.newsList.length; ++i) {
                                if (typeof object.newsList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.NewsListResp.newsList: object expected");
                                message.newsList[i] = $root.kuma.jp.protobuf.web.NewsListResp.News.fromObject(object.newsList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a NewsListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.NewsListResp} message NewsListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NewsListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.newsList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.NewsListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.NewsListResp.Status[message.status] : message.status;
                        if (message.newsList && message.newsList.length) {
                            object.newsList = [];
                            for (let j = 0; j < message.newsList.length; ++j)
                                object.newsList[j] = $root.kuma.jp.protobuf.web.NewsListResp.News.toObject(message.newsList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this NewsListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NewsListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NewsListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.NewsListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NewsListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.NewsListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40101 COMMAND_NO value
                     */
                    NewsListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40101] = "COMMAND_NO"] = 40101;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.NewsListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ERROR_NOT_LOGGED_IN=2 ERROR_NOT_LOGGED_IN value
                     */
                    NewsListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ERROR_NOT_LOGGED_IN"] = 2;
                        return values;
                    })();

                    NewsListResp.Category = (function() {

                        /**
                         * Properties of a Category.
                         * @memberof kuma.jp.protobuf.web.NewsListResp
                         * @interface ICategory
                         * @property {number|null} [id] Category id
                         * @property {string|null} [name] Category name
                         */

                        /**
                         * Constructs a new Category.
                         * @memberof kuma.jp.protobuf.web.NewsListResp
                         * @classdesc Represents a Category.
                         * @implements ICategory
                         * @constructor
                         * @param {kuma.jp.protobuf.web.NewsListResp.ICategory=} [properties] Properties to set
                         */
                        function Category(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Category id.
                         * @member {number} id
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @instance
                         */
                        Category.prototype.id = 0;

                        /**
                         * Category name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @instance
                         */
                        Category.prototype.name = "";

                        /**
                         * Creates a new Category instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.ICategory=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.NewsListResp.Category} Category instance
                         */
                        Category.create = function create(properties) {
                            return new Category(properties);
                        };

                        /**
                         * Encodes the specified Category message. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.Category.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.ICategory} message Category message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Category.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                            return writer;
                        };

                        /**
                         * Encodes the specified Category message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.Category.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.ICategory} message Category message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Category.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Category message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.NewsListResp.Category} Category
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Category.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsListResp.Category();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.name = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Category message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.NewsListResp.Category} Category
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Category.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Category message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Category.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id))
                                    return "id: integer expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };

                        /**
                         * Creates a Category message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.NewsListResp.Category} Category
                         */
                        Category.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.NewsListResp.Category)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.NewsListResp.Category();
                            if (object.id != null)
                                message.id = object.id | 0;
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Category message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.Category} message Category
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Category.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.id = 0;
                                object.name = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };

                        /**
                         * Converts this Category to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Category.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Category
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.NewsListResp.Category
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Category.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsListResp.Category";
                        };

                        return Category;
                    })();

                    NewsListResp.News = (function() {

                        /**
                         * Properties of a News.
                         * @memberof kuma.jp.protobuf.web.NewsListResp
                         * @interface INews
                         * @property {number|null} [id] News id
                         * @property {string|null} [title] News title
                         * @property {number|Long|null} [startDate] News startDate
                         * @property {number|Long|null} [endDate] News endDate
                         * @property {kuma.jp.protobuf.web.NewsListResp.ICategory|null} [category] News category
                         * @property {boolean|null} [imgFlg] News imgFlg
                         * @property {string|null} [imgPath] News imgPath
                         * @property {string|null} [url] News url
                         * @property {boolean|null} [important] News important
                         * @property {boolean|null} [target] News target
                         * @property {string|null} [description] News description
                         * @property {string|null} [dialogButtonTxt] News dialogButtonTxt
                         * @property {string|null} [dialogImgPath] News dialogImgPath
                         * @property {boolean|null} [isOpen] News isOpen
                         */

                        /**
                         * Constructs a new News.
                         * @memberof kuma.jp.protobuf.web.NewsListResp
                         * @classdesc Represents a News.
                         * @implements INews
                         * @constructor
                         * @param {kuma.jp.protobuf.web.NewsListResp.INews=} [properties] Properties to set
                         */
                        function News(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * News id.
                         * @member {number} id
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.id = 0;

                        /**
                         * News title.
                         * @member {string} title
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.title = "";

                        /**
                         * News startDate.
                         * @member {number|Long} startDate
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.startDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * News endDate.
                         * @member {number|Long} endDate
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.endDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * News category.
                         * @member {kuma.jp.protobuf.web.NewsListResp.ICategory|null|undefined} category
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.category = null;

                        /**
                         * News imgFlg.
                         * @member {boolean} imgFlg
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.imgFlg = false;

                        /**
                         * News imgPath.
                         * @member {string} imgPath
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.imgPath = "";

                        /**
                         * News url.
                         * @member {string} url
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.url = "";

                        /**
                         * News important.
                         * @member {boolean} important
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.important = false;

                        /**
                         * News target.
                         * @member {boolean} target
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.target = false;

                        /**
                         * News description.
                         * @member {string} description
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.description = "";

                        /**
                         * News dialogButtonTxt.
                         * @member {string} dialogButtonTxt
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.dialogButtonTxt = "";

                        /**
                         * News dialogImgPath.
                         * @member {string} dialogImgPath
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.dialogImgPath = "";

                        /**
                         * News isOpen.
                         * @member {boolean} isOpen
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         */
                        News.prototype.isOpen = false;

                        /**
                         * Creates a new News instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.INews=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.NewsListResp.News} News instance
                         */
                        News.create = function create(properties) {
                            return new News(properties);
                        };

                        /**
                         * Encodes the specified News message. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.News.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.INews} message News message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        News.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
                            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startDate);
                            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.endDate);
                            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                                $root.kuma.jp.protobuf.web.NewsListResp.Category.encode(message.category, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            if (message.imgFlg != null && Object.hasOwnProperty.call(message, "imgFlg"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.imgFlg);
                            if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.imgPath);
                            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.url);
                            if (message.important != null && Object.hasOwnProperty.call(message, "important"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.important);
                            if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.target);
                            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.description);
                            if (message.dialogButtonTxt != null && Object.hasOwnProperty.call(message, "dialogButtonTxt"))
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.dialogButtonTxt);
                            if (message.dialogImgPath != null && Object.hasOwnProperty.call(message, "dialogImgPath"))
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.dialogImgPath);
                            if (message.isOpen != null && Object.hasOwnProperty.call(message, "isOpen"))
                                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isOpen);
                            return writer;
                        };

                        /**
                         * Encodes the specified News message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsListResp.News.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.INews} message News message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        News.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a News message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.NewsListResp.News} News
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        News.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsListResp.News();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.title = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.startDate = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.endDate = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.category = $root.kuma.jp.protobuf.web.NewsListResp.Category.decode(reader, reader.uint32());
                                        break;
                                    }
                                case 6: {
                                        message.imgFlg = reader.bool();
                                        break;
                                    }
                                case 7: {
                                        message.imgPath = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.url = reader.string();
                                        break;
                                    }
                                case 9: {
                                        message.important = reader.bool();
                                        break;
                                    }
                                case 10: {
                                        message.target = reader.bool();
                                        break;
                                    }
                                case 11: {
                                        message.description = reader.string();
                                        break;
                                    }
                                case 12: {
                                        message.dialogButtonTxt = reader.string();
                                        break;
                                    }
                                case 13: {
                                        message.dialogImgPath = reader.string();
                                        break;
                                    }
                                case 14: {
                                        message.isOpen = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a News message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.NewsListResp.News} News
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        News.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a News message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        News.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id))
                                    return "id: integer expected";
                            if (message.title != null && message.hasOwnProperty("title"))
                                if (!$util.isString(message.title))
                                    return "title: string expected";
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (!$util.isInteger(message.startDate) && !(message.startDate && $util.isInteger(message.startDate.low) && $util.isInteger(message.startDate.high)))
                                    return "startDate: integer|Long expected";
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (!$util.isInteger(message.endDate) && !(message.endDate && $util.isInteger(message.endDate.low) && $util.isInteger(message.endDate.high)))
                                    return "endDate: integer|Long expected";
                            if (message.category != null && message.hasOwnProperty("category")) {
                                let error = $root.kuma.jp.protobuf.web.NewsListResp.Category.verify(message.category);
                                if (error)
                                    return "category." + error;
                            }
                            if (message.imgFlg != null && message.hasOwnProperty("imgFlg"))
                                if (typeof message.imgFlg !== "boolean")
                                    return "imgFlg: boolean expected";
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                if (!$util.isString(message.imgPath))
                                    return "imgPath: string expected";
                            if (message.url != null && message.hasOwnProperty("url"))
                                if (!$util.isString(message.url))
                                    return "url: string expected";
                            if (message.important != null && message.hasOwnProperty("important"))
                                if (typeof message.important !== "boolean")
                                    return "important: boolean expected";
                            if (message.target != null && message.hasOwnProperty("target"))
                                if (typeof message.target !== "boolean")
                                    return "target: boolean expected";
                            if (message.description != null && message.hasOwnProperty("description"))
                                if (!$util.isString(message.description))
                                    return "description: string expected";
                            if (message.dialogButtonTxt != null && message.hasOwnProperty("dialogButtonTxt"))
                                if (!$util.isString(message.dialogButtonTxt))
                                    return "dialogButtonTxt: string expected";
                            if (message.dialogImgPath != null && message.hasOwnProperty("dialogImgPath"))
                                if (!$util.isString(message.dialogImgPath))
                                    return "dialogImgPath: string expected";
                            if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                                if (typeof message.isOpen !== "boolean")
                                    return "isOpen: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a News message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.NewsListResp.News} News
                         */
                        News.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.NewsListResp.News)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.NewsListResp.News();
                            if (object.id != null)
                                message.id = object.id | 0;
                            if (object.title != null)
                                message.title = String(object.title);
                            if (object.startDate != null)
                                if ($util.Long)
                                    (message.startDate = $util.Long.fromValue(object.startDate)).unsigned = false;
                                else if (typeof object.startDate === "string")
                                    message.startDate = parseInt(object.startDate, 10);
                                else if (typeof object.startDate === "number")
                                    message.startDate = object.startDate;
                                else if (typeof object.startDate === "object")
                                    message.startDate = new $util.LongBits(object.startDate.low >>> 0, object.startDate.high >>> 0).toNumber();
                            if (object.endDate != null)
                                if ($util.Long)
                                    (message.endDate = $util.Long.fromValue(object.endDate)).unsigned = false;
                                else if (typeof object.endDate === "string")
                                    message.endDate = parseInt(object.endDate, 10);
                                else if (typeof object.endDate === "number")
                                    message.endDate = object.endDate;
                                else if (typeof object.endDate === "object")
                                    message.endDate = new $util.LongBits(object.endDate.low >>> 0, object.endDate.high >>> 0).toNumber();
                            if (object.category != null) {
                                if (typeof object.category !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.NewsListResp.News.category: object expected");
                                message.category = $root.kuma.jp.protobuf.web.NewsListResp.Category.fromObject(object.category);
                            }
                            if (object.imgFlg != null)
                                message.imgFlg = Boolean(object.imgFlg);
                            if (object.imgPath != null)
                                message.imgPath = String(object.imgPath);
                            if (object.url != null)
                                message.url = String(object.url);
                            if (object.important != null)
                                message.important = Boolean(object.important);
                            if (object.target != null)
                                message.target = Boolean(object.target);
                            if (object.description != null)
                                message.description = String(object.description);
                            if (object.dialogButtonTxt != null)
                                message.dialogButtonTxt = String(object.dialogButtonTxt);
                            if (object.dialogImgPath != null)
                                message.dialogImgPath = String(object.dialogImgPath);
                            if (object.isOpen != null)
                                message.isOpen = Boolean(object.isOpen);
                            return message;
                        };

                        /**
                         * Creates a plain object from a News message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsListResp.News} message News
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        News.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.id = 0;
                                object.title = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.startDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startDate = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.endDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endDate = options.longs === String ? "0" : 0;
                                object.category = null;
                                object.imgFlg = false;
                                object.imgPath = "";
                                object.url = "";
                                object.important = false;
                                object.target = false;
                                object.description = "";
                                object.dialogButtonTxt = "";
                                object.dialogImgPath = "";
                                object.isOpen = false;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.title != null && message.hasOwnProperty("title"))
                                object.title = message.title;
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (typeof message.startDate === "number")
                                    object.startDate = options.longs === String ? String(message.startDate) : message.startDate;
                                else
                                    object.startDate = options.longs === String ? $util.Long.prototype.toString.call(message.startDate) : options.longs === Number ? new $util.LongBits(message.startDate.low >>> 0, message.startDate.high >>> 0).toNumber() : message.startDate;
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (typeof message.endDate === "number")
                                    object.endDate = options.longs === String ? String(message.endDate) : message.endDate;
                                else
                                    object.endDate = options.longs === String ? $util.Long.prototype.toString.call(message.endDate) : options.longs === Number ? new $util.LongBits(message.endDate.low >>> 0, message.endDate.high >>> 0).toNumber() : message.endDate;
                            if (message.category != null && message.hasOwnProperty("category"))
                                object.category = $root.kuma.jp.protobuf.web.NewsListResp.Category.toObject(message.category, options);
                            if (message.imgFlg != null && message.hasOwnProperty("imgFlg"))
                                object.imgFlg = message.imgFlg;
                            if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                                object.imgPath = message.imgPath;
                            if (message.url != null && message.hasOwnProperty("url"))
                                object.url = message.url;
                            if (message.important != null && message.hasOwnProperty("important"))
                                object.important = message.important;
                            if (message.target != null && message.hasOwnProperty("target"))
                                object.target = message.target;
                            if (message.description != null && message.hasOwnProperty("description"))
                                object.description = message.description;
                            if (message.dialogButtonTxt != null && message.hasOwnProperty("dialogButtonTxt"))
                                object.dialogButtonTxt = message.dialogButtonTxt;
                            if (message.dialogImgPath != null && message.hasOwnProperty("dialogImgPath"))
                                object.dialogImgPath = message.dialogImgPath;
                            if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                                object.isOpen = message.isOpen;
                            return object;
                        };

                        /**
                         * Converts this News to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        News.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for News
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.NewsListResp.News
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        News.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsListResp.News";
                        };

                        return News;
                    })();

                    return NewsListResp;
                })();

                web.NewsReq = (function() {

                    /**
                     * Properties of a NewsReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface INewsReq
                     * @property {number|null} [id] NewsReq id
                     */

                    /**
                     * Constructs a new NewsReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a NewsReq.
                     * @implements INewsReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.INewsReq=} [properties] Properties to set
                     */
                    function NewsReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NewsReq id.
                     * @member {number} id
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @instance
                     */
                    NewsReq.prototype.id = 0;

                    /**
                     * Creates a new NewsReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.NewsReq} NewsReq instance
                     */
                    NewsReq.create = function create(properties) {
                        return new NewsReq(properties);
                    };

                    /**
                     * Encodes the specified NewsReq message. Does not implicitly {@link kuma.jp.protobuf.web.NewsReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsReq} message NewsReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                        return writer;
                    };

                    /**
                     * Encodes the specified NewsReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsReq} message NewsReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NewsReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.NewsReq} NewsReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NewsReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.NewsReq} NewsReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NewsReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NewsReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id))
                                return "id: integer expected";
                        return null;
                    };

                    /**
                     * Creates a NewsReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.NewsReq} NewsReq
                     */
                    NewsReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.NewsReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.NewsReq();
                        if (object.id != null)
                            message.id = object.id | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a NewsReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {kuma.jp.protobuf.web.NewsReq} message NewsReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NewsReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.id = 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        return object;
                    };

                    /**
                     * Converts this NewsReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NewsReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NewsReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.NewsReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NewsReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.NewsReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40200 COMMAND_NO value
                     */
                    NewsReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40200] = "COMMAND_NO"] = 40200;
                        return values;
                    })();

                    return NewsReq;
                })();

                web.NewsResp = (function() {

                    /**
                     * Properties of a NewsResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface INewsResp
                     * @property {kuma.jp.protobuf.web.NewsResp.Status|null} [status] NewsResp status
                     * @property {number|null} [id] NewsResp id
                     * @property {string|null} [title] NewsResp title
                     * @property {number|Long|null} [startDate] NewsResp startDate
                     * @property {number|Long|null} [endDate] NewsResp endDate
                     * @property {kuma.jp.protobuf.web.NewsResp.ICategory|null} [category] NewsResp category
                     * @property {boolean|null} [imgFlg] NewsResp imgFlg
                     * @property {string|null} [imgPath] NewsResp imgPath
                     * @property {string|null} [description] NewsResp description
                     * @property {boolean|null} [important] NewsResp important
                     * @property {boolean|null} [isOpen] NewsResp isOpen
                     */

                    /**
                     * Constructs a new NewsResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a NewsResp.
                     * @implements INewsResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.INewsResp=} [properties] Properties to set
                     */
                    function NewsResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NewsResp status.
                     * @member {kuma.jp.protobuf.web.NewsResp.Status} status
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.status = 0;

                    /**
                     * NewsResp id.
                     * @member {number} id
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.id = 0;

                    /**
                     * NewsResp title.
                     * @member {string} title
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.title = "";

                    /**
                     * NewsResp startDate.
                     * @member {number|Long} startDate
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.startDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * NewsResp endDate.
                     * @member {number|Long} endDate
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.endDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * NewsResp category.
                     * @member {kuma.jp.protobuf.web.NewsResp.ICategory|null|undefined} category
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.category = null;

                    /**
                     * NewsResp imgFlg.
                     * @member {boolean} imgFlg
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.imgFlg = false;

                    /**
                     * NewsResp imgPath.
                     * @member {string} imgPath
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.imgPath = "";

                    /**
                     * NewsResp description.
                     * @member {string} description
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.description = "";

                    /**
                     * NewsResp important.
                     * @member {boolean} important
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.important = false;

                    /**
                     * NewsResp isOpen.
                     * @member {boolean} isOpen
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     */
                    NewsResp.prototype.isOpen = false;

                    /**
                     * Creates a new NewsResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.NewsResp} NewsResp instance
                     */
                    NewsResp.create = function create(properties) {
                        return new NewsResp(properties);
                    };

                    /**
                     * Encodes the specified NewsResp message. Does not implicitly {@link kuma.jp.protobuf.web.NewsResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsResp} message NewsResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.id);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.endDate);
                        if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                            $root.kuma.jp.protobuf.web.NewsResp.Category.encode(message.category, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.imgFlg != null && Object.hasOwnProperty.call(message, "imgFlg"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.imgFlg);
                        if (message.imgPath != null && Object.hasOwnProperty.call(message, "imgPath"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.imgPath);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.description);
                        if (message.important != null && Object.hasOwnProperty.call(message, "important"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.important);
                        if (message.isOpen != null && Object.hasOwnProperty.call(message, "isOpen"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isOpen);
                        return writer;
                    };

                    /**
                     * Encodes the specified NewsResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {kuma.jp.protobuf.web.INewsResp} message NewsResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewsResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NewsResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.NewsResp} NewsResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.id = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.title = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.startDate = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.endDate = reader.int64();
                                    break;
                                }
                            case 6: {
                                    message.category = $root.kuma.jp.protobuf.web.NewsResp.Category.decode(reader, reader.uint32());
                                    break;
                                }
                            case 7: {
                                    message.imgFlg = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.imgPath = reader.string();
                                    break;
                                }
                            case 9: {
                                    message.description = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.important = reader.bool();
                                    break;
                                }
                            case 11: {
                                    message.isOpen = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NewsResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.NewsResp} NewsResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewsResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NewsResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NewsResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id))
                                return "id: integer expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isInteger(message.startDate) && !(message.startDate && $util.isInteger(message.startDate.low) && $util.isInteger(message.startDate.high)))
                                return "startDate: integer|Long expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isInteger(message.endDate) && !(message.endDate && $util.isInteger(message.endDate.low) && $util.isInteger(message.endDate.high)))
                                return "endDate: integer|Long expected";
                        if (message.category != null && message.hasOwnProperty("category")) {
                            let error = $root.kuma.jp.protobuf.web.NewsResp.Category.verify(message.category);
                            if (error)
                                return "category." + error;
                        }
                        if (message.imgFlg != null && message.hasOwnProperty("imgFlg"))
                            if (typeof message.imgFlg !== "boolean")
                                return "imgFlg: boolean expected";
                        if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                            if (!$util.isString(message.imgPath))
                                return "imgPath: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.important != null && message.hasOwnProperty("important"))
                            if (typeof message.important !== "boolean")
                                return "important: boolean expected";
                        if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                            if (typeof message.isOpen !== "boolean")
                                return "isOpen: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a NewsResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.NewsResp} NewsResp
                     */
                    NewsResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.NewsResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.NewsResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.id != null)
                            message.id = object.id | 0;
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.startDate != null)
                            if ($util.Long)
                                (message.startDate = $util.Long.fromValue(object.startDate)).unsigned = false;
                            else if (typeof object.startDate === "string")
                                message.startDate = parseInt(object.startDate, 10);
                            else if (typeof object.startDate === "number")
                                message.startDate = object.startDate;
                            else if (typeof object.startDate === "object")
                                message.startDate = new $util.LongBits(object.startDate.low >>> 0, object.startDate.high >>> 0).toNumber();
                        if (object.endDate != null)
                            if ($util.Long)
                                (message.endDate = $util.Long.fromValue(object.endDate)).unsigned = false;
                            else if (typeof object.endDate === "string")
                                message.endDate = parseInt(object.endDate, 10);
                            else if (typeof object.endDate === "number")
                                message.endDate = object.endDate;
                            else if (typeof object.endDate === "object")
                                message.endDate = new $util.LongBits(object.endDate.low >>> 0, object.endDate.high >>> 0).toNumber();
                        if (object.category != null) {
                            if (typeof object.category !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.NewsResp.category: object expected");
                            message.category = $root.kuma.jp.protobuf.web.NewsResp.Category.fromObject(object.category);
                        }
                        if (object.imgFlg != null)
                            message.imgFlg = Boolean(object.imgFlg);
                        if (object.imgPath != null)
                            message.imgPath = String(object.imgPath);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.important != null)
                            message.important = Boolean(object.important);
                        if (object.isOpen != null)
                            message.isOpen = Boolean(object.isOpen);
                        return message;
                    };

                    /**
                     * Creates a plain object from a NewsResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {kuma.jp.protobuf.web.NewsResp} message NewsResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NewsResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.id = 0;
                            object.title = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.startDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startDate = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.endDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.endDate = options.longs === String ? "0" : 0;
                            object.category = null;
                            object.imgFlg = false;
                            object.imgPath = "";
                            object.description = "";
                            object.important = false;
                            object.isOpen = false;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.NewsResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.NewsResp.Status[message.status] : message.status;
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (typeof message.startDate === "number")
                                object.startDate = options.longs === String ? String(message.startDate) : message.startDate;
                            else
                                object.startDate = options.longs === String ? $util.Long.prototype.toString.call(message.startDate) : options.longs === Number ? new $util.LongBits(message.startDate.low >>> 0, message.startDate.high >>> 0).toNumber() : message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (typeof message.endDate === "number")
                                object.endDate = options.longs === String ? String(message.endDate) : message.endDate;
                            else
                                object.endDate = options.longs === String ? $util.Long.prototype.toString.call(message.endDate) : options.longs === Number ? new $util.LongBits(message.endDate.low >>> 0, message.endDate.high >>> 0).toNumber() : message.endDate;
                        if (message.category != null && message.hasOwnProperty("category"))
                            object.category = $root.kuma.jp.protobuf.web.NewsResp.Category.toObject(message.category, options);
                        if (message.imgFlg != null && message.hasOwnProperty("imgFlg"))
                            object.imgFlg = message.imgFlg;
                        if (message.imgPath != null && message.hasOwnProperty("imgPath"))
                            object.imgPath = message.imgPath;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.important != null && message.hasOwnProperty("important"))
                            object.important = message.important;
                        if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                            object.isOpen = message.isOpen;
                        return object;
                    };

                    /**
                     * Converts this NewsResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NewsResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NewsResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.NewsResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NewsResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.NewsResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=40201 COMMAND_NO value
                     */
                    NewsResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[40201] = "COMMAND_NO"] = 40201;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.NewsResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    NewsResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    NewsResp.Category = (function() {

                        /**
                         * Properties of a Category.
                         * @memberof kuma.jp.protobuf.web.NewsResp
                         * @interface ICategory
                         * @property {number|null} [id] Category id
                         * @property {string|null} [name] Category name
                         */

                        /**
                         * Constructs a new Category.
                         * @memberof kuma.jp.protobuf.web.NewsResp
                         * @classdesc Represents a Category.
                         * @implements ICategory
                         * @constructor
                         * @param {kuma.jp.protobuf.web.NewsResp.ICategory=} [properties] Properties to set
                         */
                        function Category(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Category id.
                         * @member {number} id
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @instance
                         */
                        Category.prototype.id = 0;

                        /**
                         * Category name.
                         * @member {string} name
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @instance
                         */
                        Category.prototype.name = "";

                        /**
                         * Creates a new Category instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsResp.ICategory=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.NewsResp.Category} Category instance
                         */
                        Category.create = function create(properties) {
                            return new Category(properties);
                        };

                        /**
                         * Encodes the specified Category message. Does not implicitly {@link kuma.jp.protobuf.web.NewsResp.Category.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsResp.ICategory} message Category message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Category.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                            return writer;
                        };

                        /**
                         * Encodes the specified Category message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.NewsResp.Category.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsResp.ICategory} message Category message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Category.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Category message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.NewsResp.Category} Category
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Category.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.NewsResp.Category();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.name = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Category message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.NewsResp.Category} Category
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Category.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Category message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Category.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id))
                                    return "id: integer expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            return null;
                        };

                        /**
                         * Creates a Category message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.NewsResp.Category} Category
                         */
                        Category.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.NewsResp.Category)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.NewsResp.Category();
                            if (object.id != null)
                                message.id = object.id | 0;
                            if (object.name != null)
                                message.name = String(object.name);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Category message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {kuma.jp.protobuf.web.NewsResp.Category} message Category
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Category.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.id = 0;
                                object.name = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            return object;
                        };

                        /**
                         * Converts this Category to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Category.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Category
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.NewsResp.Category
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Category.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.NewsResp.Category";
                        };

                        return Category;
                    })();

                    return NewsResp;
                })();

                web.PlayerCampPitInfoReq = (function() {

                    /**
                     * Properties of a PlayerCampPitInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerCampPitInfoReq
                     */

                    /**
                     * Constructs a new PlayerCampPitInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerCampPitInfoReq.
                     * @implements IPlayerCampPitInfoReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoReq=} [properties] Properties to set
                     */
                    function PlayerCampPitInfoReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new PlayerCampPitInfoReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoReq} PlayerCampPitInfoReq instance
                     */
                    PlayerCampPitInfoReq.create = function create(properties) {
                        return new PlayerCampPitInfoReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerCampPitInfoReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerCampPitInfoReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoReq} message PlayerCampPitInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerCampPitInfoReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerCampPitInfoReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerCampPitInfoReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoReq} message PlayerCampPitInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerCampPitInfoReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerCampPitInfoReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoReq} PlayerCampPitInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerCampPitInfoReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerCampPitInfoReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerCampPitInfoReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoReq} PlayerCampPitInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerCampPitInfoReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerCampPitInfoReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerCampPitInfoReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerCampPitInfoReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoReq} PlayerCampPitInfoReq
                     */
                    PlayerCampPitInfoReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerCampPitInfoReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.PlayerCampPitInfoReq();
                    };

                    /**
                     * Creates a plain object from a PlayerCampPitInfoReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerCampPitInfoReq} message PlayerCampPitInfoReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerCampPitInfoReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this PlayerCampPitInfoReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerCampPitInfoReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerCampPitInfoReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerCampPitInfoReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerCampPitInfoReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerCampPitInfoReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10800 COMMAND_NO value
                     */
                    PlayerCampPitInfoReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10800] = "COMMAND_NO"] = 10800;
                        return values;
                    })();

                    return PlayerCampPitInfoReq;
                })();

                web.PlayerCampPitInfoResp = (function() {

                    /**
                     * Properties of a PlayerCampPitInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerCampPitInfoResp
                     * @property {kuma.jp.protobuf.web.PlayerCampPitInfoResp.Status|null} [status] PlayerCampPitInfoResp status
                     * @property {boolean|null} [isOkOpenDialog] PlayerCampPitInfoResp isOkOpenDialog
                     * @property {Array.<string>|null} [informationList] PlayerCampPitInfoResp informationList
                     * @property {Array.<string>|null} [imagePathList] PlayerCampPitInfoResp imagePathList
                     * @property {string|null} [informationToPit] PlayerCampPitInfoResp informationToPit
                     * @property {string|null} [imagePathToPit] PlayerCampPitInfoResp imagePathToPit
                     * @property {string|null} [bannerImagePath] PlayerCampPitInfoResp bannerImagePath
                     * @property {string|null} [buttonUrl] PlayerCampPitInfoResp buttonUrl
                     * @property {kuma.jp.protobuf.common.CampPitDialogType|null} [dialogType] PlayerCampPitInfoResp dialogType
                     * @property {number|null} [campId] PlayerCampPitInfoResp campId
                     */

                    /**
                     * Constructs a new PlayerCampPitInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerCampPitInfoResp.
                     * @implements IPlayerCampPitInfoResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoResp=} [properties] Properties to set
                     */
                    function PlayerCampPitInfoResp(properties) {
                        this.informationList = [];
                        this.imagePathList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerCampPitInfoResp status.
                     * @member {kuma.jp.protobuf.web.PlayerCampPitInfoResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.status = 0;

                    /**
                     * PlayerCampPitInfoResp isOkOpenDialog.
                     * @member {boolean} isOkOpenDialog
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.isOkOpenDialog = false;

                    /**
                     * PlayerCampPitInfoResp informationList.
                     * @member {Array.<string>} informationList
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.informationList = $util.emptyArray;

                    /**
                     * PlayerCampPitInfoResp imagePathList.
                     * @member {Array.<string>} imagePathList
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.imagePathList = $util.emptyArray;

                    /**
                     * PlayerCampPitInfoResp informationToPit.
                     * @member {string} informationToPit
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.informationToPit = "";

                    /**
                     * PlayerCampPitInfoResp imagePathToPit.
                     * @member {string} imagePathToPit
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.imagePathToPit = "";

                    /**
                     * PlayerCampPitInfoResp bannerImagePath.
                     * @member {string} bannerImagePath
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.bannerImagePath = "";

                    /**
                     * PlayerCampPitInfoResp buttonUrl.
                     * @member {string} buttonUrl
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.buttonUrl = "";

                    /**
                     * PlayerCampPitInfoResp dialogType.
                     * @member {kuma.jp.protobuf.common.CampPitDialogType} dialogType
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.dialogType = 0;

                    /**
                     * PlayerCampPitInfoResp campId.
                     * @member {number} campId
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     */
                    PlayerCampPitInfoResp.prototype.campId = 0;

                    /**
                     * Creates a new PlayerCampPitInfoResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoResp} PlayerCampPitInfoResp instance
                     */
                    PlayerCampPitInfoResp.create = function create(properties) {
                        return new PlayerCampPitInfoResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerCampPitInfoResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerCampPitInfoResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoResp} message PlayerCampPitInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerCampPitInfoResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.isOkOpenDialog != null && Object.hasOwnProperty.call(message, "isOkOpenDialog"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isOkOpenDialog);
                        if (message.informationList != null && message.informationList.length)
                            for (let i = 0; i < message.informationList.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.informationList[i]);
                        if (message.imagePathList != null && message.imagePathList.length)
                            for (let i = 0; i < message.imagePathList.length; ++i)
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.imagePathList[i]);
                        if (message.informationToPit != null && Object.hasOwnProperty.call(message, "informationToPit"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.informationToPit);
                        if (message.imagePathToPit != null && Object.hasOwnProperty.call(message, "imagePathToPit"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.imagePathToPit);
                        if (message.bannerImagePath != null && Object.hasOwnProperty.call(message, "bannerImagePath"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.bannerImagePath);
                        if (message.buttonUrl != null && Object.hasOwnProperty.call(message, "buttonUrl"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.buttonUrl);
                        if (message.dialogType != null && Object.hasOwnProperty.call(message, "dialogType"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dialogType);
                        if (message.campId != null && Object.hasOwnProperty.call(message, "campId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.campId);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerCampPitInfoResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerCampPitInfoResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerCampPitInfoResp} message PlayerCampPitInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerCampPitInfoResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerCampPitInfoResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoResp} PlayerCampPitInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerCampPitInfoResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerCampPitInfoResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.isOkOpenDialog = reader.bool();
                                    break;
                                }
                            case 3: {
                                    if (!(message.informationList && message.informationList.length))
                                        message.informationList = [];
                                    message.informationList.push(reader.string());
                                    break;
                                }
                            case 4: {
                                    if (!(message.imagePathList && message.imagePathList.length))
                                        message.imagePathList = [];
                                    message.imagePathList.push(reader.string());
                                    break;
                                }
                            case 5: {
                                    message.informationToPit = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.imagePathToPit = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.bannerImagePath = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.buttonUrl = reader.string();
                                    break;
                                }
                            case 9: {
                                    message.dialogType = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.campId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerCampPitInfoResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoResp} PlayerCampPitInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerCampPitInfoResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerCampPitInfoResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerCampPitInfoResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.isOkOpenDialog != null && message.hasOwnProperty("isOkOpenDialog"))
                            if (typeof message.isOkOpenDialog !== "boolean")
                                return "isOkOpenDialog: boolean expected";
                        if (message.informationList != null && message.hasOwnProperty("informationList")) {
                            if (!Array.isArray(message.informationList))
                                return "informationList: array expected";
                            for (let i = 0; i < message.informationList.length; ++i)
                                if (!$util.isString(message.informationList[i]))
                                    return "informationList: string[] expected";
                        }
                        if (message.imagePathList != null && message.hasOwnProperty("imagePathList")) {
                            if (!Array.isArray(message.imagePathList))
                                return "imagePathList: array expected";
                            for (let i = 0; i < message.imagePathList.length; ++i)
                                if (!$util.isString(message.imagePathList[i]))
                                    return "imagePathList: string[] expected";
                        }
                        if (message.informationToPit != null && message.hasOwnProperty("informationToPit"))
                            if (!$util.isString(message.informationToPit))
                                return "informationToPit: string expected";
                        if (message.imagePathToPit != null && message.hasOwnProperty("imagePathToPit"))
                            if (!$util.isString(message.imagePathToPit))
                                return "imagePathToPit: string expected";
                        if (message.bannerImagePath != null && message.hasOwnProperty("bannerImagePath"))
                            if (!$util.isString(message.bannerImagePath))
                                return "bannerImagePath: string expected";
                        if (message.buttonUrl != null && message.hasOwnProperty("buttonUrl"))
                            if (!$util.isString(message.buttonUrl))
                                return "buttonUrl: string expected";
                        if (message.dialogType != null && message.hasOwnProperty("dialogType"))
                            switch (message.dialogType) {
                            default:
                                return "dialogType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case -2:
                                break;
                            }
                        if (message.campId != null && message.hasOwnProperty("campId"))
                            if (!$util.isInteger(message.campId))
                                return "campId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerCampPitInfoResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerCampPitInfoResp} PlayerCampPitInfoResp
                     */
                    PlayerCampPitInfoResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerCampPitInfoResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerCampPitInfoResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.isOkOpenDialog != null)
                            message.isOkOpenDialog = Boolean(object.isOkOpenDialog);
                        if (object.informationList) {
                            if (!Array.isArray(object.informationList))
                                throw TypeError(".kuma.jp.protobuf.web.PlayerCampPitInfoResp.informationList: array expected");
                            message.informationList = [];
                            for (let i = 0; i < object.informationList.length; ++i)
                                message.informationList[i] = String(object.informationList[i]);
                        }
                        if (object.imagePathList) {
                            if (!Array.isArray(object.imagePathList))
                                throw TypeError(".kuma.jp.protobuf.web.PlayerCampPitInfoResp.imagePathList: array expected");
                            message.imagePathList = [];
                            for (let i = 0; i < object.imagePathList.length; ++i)
                                message.imagePathList[i] = String(object.imagePathList[i]);
                        }
                        if (object.informationToPit != null)
                            message.informationToPit = String(object.informationToPit);
                        if (object.imagePathToPit != null)
                            message.imagePathToPit = String(object.imagePathToPit);
                        if (object.bannerImagePath != null)
                            message.bannerImagePath = String(object.bannerImagePath);
                        if (object.buttonUrl != null)
                            message.buttonUrl = String(object.buttonUrl);
                        switch (object.dialogType) {
                        default:
                            if (typeof object.dialogType === "number") {
                                message.dialogType = object.dialogType;
                                break;
                            }
                            break;
                        case "PRE":
                        case 0:
                            message.dialogType = 0;
                            break;
                        case "PRE_AND_OK":
                        case 1:
                            message.dialogType = 1;
                            break;
                        case "OK":
                        case 2:
                            message.dialogType = 2;
                            break;
                        case "INVALID":
                        case -2:
                            message.dialogType = -2;
                            break;
                        }
                        if (object.campId != null)
                            message.campId = object.campId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerCampPitInfoResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerCampPitInfoResp} message PlayerCampPitInfoResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerCampPitInfoResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.informationList = [];
                            object.imagePathList = [];
                        }
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.isOkOpenDialog = false;
                            object.informationToPit = "";
                            object.imagePathToPit = "";
                            object.bannerImagePath = "";
                            object.buttonUrl = "";
                            object.dialogType = options.enums === String ? "PRE" : 0;
                            object.campId = 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerCampPitInfoResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerCampPitInfoResp.Status[message.status] : message.status;
                        if (message.isOkOpenDialog != null && message.hasOwnProperty("isOkOpenDialog"))
                            object.isOkOpenDialog = message.isOkOpenDialog;
                        if (message.informationList && message.informationList.length) {
                            object.informationList = [];
                            for (let j = 0; j < message.informationList.length; ++j)
                                object.informationList[j] = message.informationList[j];
                        }
                        if (message.imagePathList && message.imagePathList.length) {
                            object.imagePathList = [];
                            for (let j = 0; j < message.imagePathList.length; ++j)
                                object.imagePathList[j] = message.imagePathList[j];
                        }
                        if (message.informationToPit != null && message.hasOwnProperty("informationToPit"))
                            object.informationToPit = message.informationToPit;
                        if (message.imagePathToPit != null && message.hasOwnProperty("imagePathToPit"))
                            object.imagePathToPit = message.imagePathToPit;
                        if (message.bannerImagePath != null && message.hasOwnProperty("bannerImagePath"))
                            object.bannerImagePath = message.bannerImagePath;
                        if (message.buttonUrl != null && message.hasOwnProperty("buttonUrl"))
                            object.buttonUrl = message.buttonUrl;
                        if (message.dialogType != null && message.hasOwnProperty("dialogType"))
                            object.dialogType = options.enums === String ? $root.kuma.jp.protobuf.common.CampPitDialogType[message.dialogType] === undefined ? message.dialogType : $root.kuma.jp.protobuf.common.CampPitDialogType[message.dialogType] : message.dialogType;
                        if (message.campId != null && message.hasOwnProperty("campId"))
                            object.campId = message.campId;
                        return object;
                    };

                    /**
                     * Converts this PlayerCampPitInfoResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerCampPitInfoResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerCampPitInfoResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerCampPitInfoResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerCampPitInfoResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerCampPitInfoResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerCampPitInfoResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10801 COMMAND_NO value
                     */
                    PlayerCampPitInfoResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10801] = "COMMAND_NO"] = 10801;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerCampPitInfoResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerCampPitInfoResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerCampPitInfoResp;
                })();

                web.PlayerDigitalPassReq = (function() {

                    /**
                     * Properties of a PlayerDigitalPassReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerDigitalPassReq
                     */

                    /**
                     * Constructs a new PlayerDigitalPassReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerDigitalPassReq.
                     * @implements IPlayerDigitalPassReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassReq=} [properties] Properties to set
                     */
                    function PlayerDigitalPassReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new PlayerDigitalPassReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassReq} PlayerDigitalPassReq instance
                     */
                    PlayerDigitalPassReq.create = function create(properties) {
                        return new PlayerDigitalPassReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerDigitalPassReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerDigitalPassReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassReq} message PlayerDigitalPassReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerDigitalPassReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerDigitalPassReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerDigitalPassReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassReq} message PlayerDigitalPassReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerDigitalPassReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerDigitalPassReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassReq} PlayerDigitalPassReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerDigitalPassReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerDigitalPassReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerDigitalPassReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassReq} PlayerDigitalPassReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerDigitalPassReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerDigitalPassReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerDigitalPassReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerDigitalPassReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassReq} PlayerDigitalPassReq
                     */
                    PlayerDigitalPassReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerDigitalPassReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.PlayerDigitalPassReq();
                    };

                    /**
                     * Creates a plain object from a PlayerDigitalPassReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerDigitalPassReq} message PlayerDigitalPassReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerDigitalPassReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this PlayerDigitalPassReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerDigitalPassReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerDigitalPassReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerDigitalPassReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerDigitalPassReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerDigitalPassReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10302 COMMAND_NO value
                     */
                    PlayerDigitalPassReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10302] = "COMMAND_NO"] = 10302;
                        return values;
                    })();

                    return PlayerDigitalPassReq;
                })();

                web.PlayerDigitalPassResp = (function() {

                    /**
                     * Properties of a PlayerDigitalPassResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerDigitalPassResp
                     * @property {Uint8Array|null} [digitalPass] PlayerDigitalPassResp digitalPass
                     * @property {number|Long|null} [limitSecs] PlayerDigitalPassResp limitSecs
                     */

                    /**
                     * Constructs a new PlayerDigitalPassResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerDigitalPassResp.
                     * @implements IPlayerDigitalPassResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassResp=} [properties] Properties to set
                     */
                    function PlayerDigitalPassResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerDigitalPassResp digitalPass.
                     * @member {Uint8Array} digitalPass
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @instance
                     */
                    PlayerDigitalPassResp.prototype.digitalPass = $util.newBuffer([]);

                    /**
                     * PlayerDigitalPassResp limitSecs.
                     * @member {number|Long} limitSecs
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @instance
                     */
                    PlayerDigitalPassResp.prototype.limitSecs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new PlayerDigitalPassResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassResp} PlayerDigitalPassResp instance
                     */
                    PlayerDigitalPassResp.create = function create(properties) {
                        return new PlayerDigitalPassResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerDigitalPassResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerDigitalPassResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassResp} message PlayerDigitalPassResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerDigitalPassResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.digitalPass != null && Object.hasOwnProperty.call(message, "digitalPass"))
                            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.digitalPass);
                        if (message.limitSecs != null && Object.hasOwnProperty.call(message, "limitSecs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.limitSecs);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerDigitalPassResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerDigitalPassResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerDigitalPassResp} message PlayerDigitalPassResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerDigitalPassResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerDigitalPassResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassResp} PlayerDigitalPassResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerDigitalPassResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerDigitalPassResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.digitalPass = reader.bytes();
                                    break;
                                }
                            case 2: {
                                    message.limitSecs = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerDigitalPassResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassResp} PlayerDigitalPassResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerDigitalPassResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerDigitalPassResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerDigitalPassResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.digitalPass != null && message.hasOwnProperty("digitalPass"))
                            if (!(message.digitalPass && typeof message.digitalPass.length === "number" || $util.isString(message.digitalPass)))
                                return "digitalPass: buffer expected";
                        if (message.limitSecs != null && message.hasOwnProperty("limitSecs"))
                            if (!$util.isInteger(message.limitSecs) && !(message.limitSecs && $util.isInteger(message.limitSecs.low) && $util.isInteger(message.limitSecs.high)))
                                return "limitSecs: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerDigitalPassResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerDigitalPassResp} PlayerDigitalPassResp
                     */
                    PlayerDigitalPassResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerDigitalPassResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerDigitalPassResp();
                        if (object.digitalPass != null)
                            if (typeof object.digitalPass === "string")
                                $util.base64.decode(object.digitalPass, message.digitalPass = $util.newBuffer($util.base64.length(object.digitalPass)), 0);
                            else if (object.digitalPass.length >= 0)
                                message.digitalPass = object.digitalPass;
                        if (object.limitSecs != null)
                            if ($util.Long)
                                (message.limitSecs = $util.Long.fromValue(object.limitSecs)).unsigned = false;
                            else if (typeof object.limitSecs === "string")
                                message.limitSecs = parseInt(object.limitSecs, 10);
                            else if (typeof object.limitSecs === "number")
                                message.limitSecs = object.limitSecs;
                            else if (typeof object.limitSecs === "object")
                                message.limitSecs = new $util.LongBits(object.limitSecs.low >>> 0, object.limitSecs.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerDigitalPassResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerDigitalPassResp} message PlayerDigitalPassResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerDigitalPassResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if (options.bytes === String)
                                object.digitalPass = "";
                            else {
                                object.digitalPass = [];
                                if (options.bytes !== Array)
                                    object.digitalPass = $util.newBuffer(object.digitalPass);
                            }
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.limitSecs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.limitSecs = options.longs === String ? "0" : 0;
                        }
                        if (message.digitalPass != null && message.hasOwnProperty("digitalPass"))
                            object.digitalPass = options.bytes === String ? $util.base64.encode(message.digitalPass, 0, message.digitalPass.length) : options.bytes === Array ? Array.prototype.slice.call(message.digitalPass) : message.digitalPass;
                        if (message.limitSecs != null && message.hasOwnProperty("limitSecs"))
                            if (typeof message.limitSecs === "number")
                                object.limitSecs = options.longs === String ? String(message.limitSecs) : message.limitSecs;
                            else
                                object.limitSecs = options.longs === String ? $util.Long.prototype.toString.call(message.limitSecs) : options.longs === Number ? new $util.LongBits(message.limitSecs.low >>> 0, message.limitSecs.high >>> 0).toNumber() : message.limitSecs;
                        return object;
                    };

                    /**
                     * Converts this PlayerDigitalPassResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerDigitalPassResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerDigitalPassResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerDigitalPassResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerDigitalPassResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerDigitalPassResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerDigitalPassResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10303 COMMAND_NO value
                     */
                    PlayerDigitalPassResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10303] = "COMMAND_NO"] = 10303;
                        return values;
                    })();

                    return PlayerDigitalPassResp;
                })();

                web.PlayerGeneralInformationReq = (function() {

                    /**
                     * Properties of a PlayerGeneralInformationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerGeneralInformationReq
                     * @property {boolean|null} [isSave] PlayerGeneralInformationReq isSave
                     * @property {number|null} [informationId] PlayerGeneralInformationReq informationId
                     * @property {number|null} [intInformation] PlayerGeneralInformationReq intInformation
                     * @property {Uint8Array|null} [bytesInformation] PlayerGeneralInformationReq bytesInformation
                     * @property {string|null} [stringInformation] PlayerGeneralInformationReq stringInformation
                     */

                    /**
                     * Constructs a new PlayerGeneralInformationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerGeneralInformationReq.
                     * @implements IPlayerGeneralInformationReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationReq=} [properties] Properties to set
                     */
                    function PlayerGeneralInformationReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerGeneralInformationReq isSave.
                     * @member {boolean} isSave
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     */
                    PlayerGeneralInformationReq.prototype.isSave = false;

                    /**
                     * PlayerGeneralInformationReq informationId.
                     * @member {number} informationId
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     */
                    PlayerGeneralInformationReq.prototype.informationId = 0;

                    /**
                     * PlayerGeneralInformationReq intInformation.
                     * @member {number} intInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     */
                    PlayerGeneralInformationReq.prototype.intInformation = 0;

                    /**
                     * PlayerGeneralInformationReq bytesInformation.
                     * @member {Uint8Array} bytesInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     */
                    PlayerGeneralInformationReq.prototype.bytesInformation = $util.newBuffer([]);

                    /**
                     * PlayerGeneralInformationReq stringInformation.
                     * @member {string} stringInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     */
                    PlayerGeneralInformationReq.prototype.stringInformation = "";

                    /**
                     * Creates a new PlayerGeneralInformationReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationReq} PlayerGeneralInformationReq instance
                     */
                    PlayerGeneralInformationReq.create = function create(properties) {
                        return new PlayerGeneralInformationReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerGeneralInformationReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerGeneralInformationReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationReq} message PlayerGeneralInformationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerGeneralInformationReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isSave != null && Object.hasOwnProperty.call(message, "isSave"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isSave);
                        if (message.informationId != null && Object.hasOwnProperty.call(message, "informationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.informationId);
                        if (message.intInformation != null && Object.hasOwnProperty.call(message, "intInformation"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.intInformation);
                        if (message.bytesInformation != null && Object.hasOwnProperty.call(message, "bytesInformation"))
                            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.bytesInformation);
                        if (message.stringInformation != null && Object.hasOwnProperty.call(message, "stringInformation"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.stringInformation);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerGeneralInformationReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerGeneralInformationReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationReq} message PlayerGeneralInformationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerGeneralInformationReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerGeneralInformationReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationReq} PlayerGeneralInformationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerGeneralInformationReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerGeneralInformationReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isSave = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.informationId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.intInformation = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.bytesInformation = reader.bytes();
                                    break;
                                }
                            case 5: {
                                    message.stringInformation = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerGeneralInformationReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationReq} PlayerGeneralInformationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerGeneralInformationReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerGeneralInformationReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerGeneralInformationReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isSave != null && message.hasOwnProperty("isSave"))
                            if (typeof message.isSave !== "boolean")
                                return "isSave: boolean expected";
                        if (message.informationId != null && message.hasOwnProperty("informationId"))
                            if (!$util.isInteger(message.informationId))
                                return "informationId: integer expected";
                        if (message.intInformation != null && message.hasOwnProperty("intInformation"))
                            if (!$util.isInteger(message.intInformation))
                                return "intInformation: integer expected";
                        if (message.bytesInformation != null && message.hasOwnProperty("bytesInformation"))
                            if (!(message.bytesInformation && typeof message.bytesInformation.length === "number" || $util.isString(message.bytesInformation)))
                                return "bytesInformation: buffer expected";
                        if (message.stringInformation != null && message.hasOwnProperty("stringInformation"))
                            if (!$util.isString(message.stringInformation))
                                return "stringInformation: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerGeneralInformationReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationReq} PlayerGeneralInformationReq
                     */
                    PlayerGeneralInformationReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerGeneralInformationReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerGeneralInformationReq();
                        if (object.isSave != null)
                            message.isSave = Boolean(object.isSave);
                        if (object.informationId != null)
                            message.informationId = object.informationId | 0;
                        if (object.intInformation != null)
                            message.intInformation = object.intInformation | 0;
                        if (object.bytesInformation != null)
                            if (typeof object.bytesInformation === "string")
                                $util.base64.decode(object.bytesInformation, message.bytesInformation = $util.newBuffer($util.base64.length(object.bytesInformation)), 0);
                            else if (object.bytesInformation.length >= 0)
                                message.bytesInformation = object.bytesInformation;
                        if (object.stringInformation != null)
                            message.stringInformation = String(object.stringInformation);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerGeneralInformationReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerGeneralInformationReq} message PlayerGeneralInformationReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerGeneralInformationReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.isSave = false;
                            object.informationId = 0;
                            object.intInformation = 0;
                            if (options.bytes === String)
                                object.bytesInformation = "";
                            else {
                                object.bytesInformation = [];
                                if (options.bytes !== Array)
                                    object.bytesInformation = $util.newBuffer(object.bytesInformation);
                            }
                            object.stringInformation = "";
                        }
                        if (message.isSave != null && message.hasOwnProperty("isSave"))
                            object.isSave = message.isSave;
                        if (message.informationId != null && message.hasOwnProperty("informationId"))
                            object.informationId = message.informationId;
                        if (message.intInformation != null && message.hasOwnProperty("intInformation"))
                            object.intInformation = message.intInformation;
                        if (message.bytesInformation != null && message.hasOwnProperty("bytesInformation"))
                            object.bytesInformation = options.bytes === String ? $util.base64.encode(message.bytesInformation, 0, message.bytesInformation.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytesInformation) : message.bytesInformation;
                        if (message.stringInformation != null && message.hasOwnProperty("stringInformation"))
                            object.stringInformation = message.stringInformation;
                        return object;
                    };

                    /**
                     * Converts this PlayerGeneralInformationReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerGeneralInformationReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerGeneralInformationReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerGeneralInformationReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerGeneralInformationReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerGeneralInformationReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=81000 COMMAND_NO value
                     */
                    PlayerGeneralInformationReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[81000] = "COMMAND_NO"] = 81000;
                        return values;
                    })();

                    return PlayerGeneralInformationReq;
                })();

                web.PlayerGeneralInformationResp = (function() {

                    /**
                     * Properties of a PlayerGeneralInformationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerGeneralInformationResp
                     * @property {number|null} [informationId] PlayerGeneralInformationResp informationId
                     * @property {number|null} [intInformation] PlayerGeneralInformationResp intInformation
                     * @property {Uint8Array|null} [bytesInformation] PlayerGeneralInformationResp bytesInformation
                     * @property {string|null} [stringInformation] PlayerGeneralInformationResp stringInformation
                     * @property {kuma.jp.protobuf.web.PlayerGeneralInformationResp.Status|null} [status] PlayerGeneralInformationResp status
                     */

                    /**
                     * Constructs a new PlayerGeneralInformationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerGeneralInformationResp.
                     * @implements IPlayerGeneralInformationResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationResp=} [properties] Properties to set
                     */
                    function PlayerGeneralInformationResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerGeneralInformationResp informationId.
                     * @member {number} informationId
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     */
                    PlayerGeneralInformationResp.prototype.informationId = 0;

                    /**
                     * PlayerGeneralInformationResp intInformation.
                     * @member {number} intInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     */
                    PlayerGeneralInformationResp.prototype.intInformation = 0;

                    /**
                     * PlayerGeneralInformationResp bytesInformation.
                     * @member {Uint8Array} bytesInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     */
                    PlayerGeneralInformationResp.prototype.bytesInformation = $util.newBuffer([]);

                    /**
                     * PlayerGeneralInformationResp stringInformation.
                     * @member {string} stringInformation
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     */
                    PlayerGeneralInformationResp.prototype.stringInformation = "";

                    /**
                     * PlayerGeneralInformationResp status.
                     * @member {kuma.jp.protobuf.web.PlayerGeneralInformationResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     */
                    PlayerGeneralInformationResp.prototype.status = 0;

                    /**
                     * Creates a new PlayerGeneralInformationResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationResp} PlayerGeneralInformationResp instance
                     */
                    PlayerGeneralInformationResp.create = function create(properties) {
                        return new PlayerGeneralInformationResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerGeneralInformationResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerGeneralInformationResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationResp} message PlayerGeneralInformationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerGeneralInformationResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.informationId != null && Object.hasOwnProperty.call(message, "informationId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.informationId);
                        if (message.intInformation != null && Object.hasOwnProperty.call(message, "intInformation"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.intInformation);
                        if (message.bytesInformation != null && Object.hasOwnProperty.call(message, "bytesInformation"))
                            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.bytesInformation);
                        if (message.stringInformation != null && Object.hasOwnProperty.call(message, "stringInformation"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stringInformation);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerGeneralInformationResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerGeneralInformationResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerGeneralInformationResp} message PlayerGeneralInformationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerGeneralInformationResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerGeneralInformationResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationResp} PlayerGeneralInformationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerGeneralInformationResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerGeneralInformationResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.informationId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.intInformation = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.bytesInformation = reader.bytes();
                                    break;
                                }
                            case 4: {
                                    message.stringInformation = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerGeneralInformationResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationResp} PlayerGeneralInformationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerGeneralInformationResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerGeneralInformationResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerGeneralInformationResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.informationId != null && message.hasOwnProperty("informationId"))
                            if (!$util.isInteger(message.informationId))
                                return "informationId: integer expected";
                        if (message.intInformation != null && message.hasOwnProperty("intInformation"))
                            if (!$util.isInteger(message.intInformation))
                                return "intInformation: integer expected";
                        if (message.bytesInformation != null && message.hasOwnProperty("bytesInformation"))
                            if (!(message.bytesInformation && typeof message.bytesInformation.length === "number" || $util.isString(message.bytesInformation)))
                                return "bytesInformation: buffer expected";
                        if (message.stringInformation != null && message.hasOwnProperty("stringInformation"))
                            if (!$util.isString(message.stringInformation))
                                return "stringInformation: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a PlayerGeneralInformationResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerGeneralInformationResp} PlayerGeneralInformationResp
                     */
                    PlayerGeneralInformationResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerGeneralInformationResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerGeneralInformationResp();
                        if (object.informationId != null)
                            message.informationId = object.informationId | 0;
                        if (object.intInformation != null)
                            message.intInformation = object.intInformation | 0;
                        if (object.bytesInformation != null)
                            if (typeof object.bytesInformation === "string")
                                $util.base64.decode(object.bytesInformation, message.bytesInformation = $util.newBuffer($util.base64.length(object.bytesInformation)), 0);
                            else if (object.bytesInformation.length >= 0)
                                message.bytesInformation = object.bytesInformation;
                        if (object.stringInformation != null)
                            message.stringInformation = String(object.stringInformation);
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerGeneralInformationResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerGeneralInformationResp} message PlayerGeneralInformationResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerGeneralInformationResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.informationId = 0;
                            object.intInformation = 0;
                            if (options.bytes === String)
                                object.bytesInformation = "";
                            else {
                                object.bytesInformation = [];
                                if (options.bytes !== Array)
                                    object.bytesInformation = $util.newBuffer(object.bytesInformation);
                            }
                            object.stringInformation = "";
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        }
                        if (message.informationId != null && message.hasOwnProperty("informationId"))
                            object.informationId = message.informationId;
                        if (message.intInformation != null && message.hasOwnProperty("intInformation"))
                            object.intInformation = message.intInformation;
                        if (message.bytesInformation != null && message.hasOwnProperty("bytesInformation"))
                            object.bytesInformation = options.bytes === String ? $util.base64.encode(message.bytesInformation, 0, message.bytesInformation.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytesInformation) : message.bytesInformation;
                        if (message.stringInformation != null && message.hasOwnProperty("stringInformation"))
                            object.stringInformation = message.stringInformation;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerGeneralInformationResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerGeneralInformationResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this PlayerGeneralInformationResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerGeneralInformationResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerGeneralInformationResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerGeneralInformationResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerGeneralInformationResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerGeneralInformationResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerGeneralInformationResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=81001 COMMAND_NO value
                     */
                    PlayerGeneralInformationResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[81001] = "COMMAND_NO"] = 81001;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerGeneralInformationResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerGeneralInformationResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerGeneralInformationResp;
                })();

                web.PlayerInfoReq = (function() {

                    /**
                     * Properties of a PlayerInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerInfoReq
                     */

                    /**
                     * Constructs a new PlayerInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerInfoReq.
                     * @implements IPlayerInfoReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerInfoReq=} [properties] Properties to set
                     */
                    function PlayerInfoReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new PlayerInfoReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerInfoReq} PlayerInfoReq instance
                     */
                    PlayerInfoReq.create = function create(properties) {
                        return new PlayerInfoReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerInfoReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerInfoReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoReq} message PlayerInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerInfoReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerInfoReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerInfoReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoReq} message PlayerInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerInfoReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerInfoReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerInfoReq} PlayerInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerInfoReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerInfoReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerInfoReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerInfoReq} PlayerInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerInfoReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerInfoReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerInfoReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerInfoReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerInfoReq} PlayerInfoReq
                     */
                    PlayerInfoReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerInfoReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.PlayerInfoReq();
                    };

                    /**
                     * Creates a plain object from a PlayerInfoReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerInfoReq} message PlayerInfoReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerInfoReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this PlayerInfoReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerInfoReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerInfoReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerInfoReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerInfoReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerInfoReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerInfoReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10300 COMMAND_NO value
                     */
                    PlayerInfoReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10300] = "COMMAND_NO"] = 10300;
                        return values;
                    })();

                    return PlayerInfoReq;
                })();

                web.PlayerInfoResp = (function() {

                    /**
                     * Properties of a PlayerInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerInfoResp
                     * @property {number|Long|null} [playerId] PlayerInfoResp playerId
                     * @property {string|null} [nickname] PlayerInfoResp nickname
                     * @property {number|null} [birthYear] PlayerInfoResp birthYear
                     * @property {number|null} [birthMonth] PlayerInfoResp birthMonth
                     * @property {string|null} [mailAddress] PlayerInfoResp mailAddress
                     * @property {kuma.jp.protobuf.web.PlayerInfoResp.MembershipGrade|null} [membershipGrade] PlayerInfoResp membershipGrade
                     * @property {kuma.jp.protobuf.web.PlayerInfoResp.PaymentType|null} [paymentType] PlayerInfoResp paymentType
                     * @property {kuma.jp.protobuf.web.PlayerInfoResp.RegistrationType|null} [registrationType] PlayerInfoResp registrationType
                     * @property {string|null} [twitterUserId] PlayerInfoResp twitterUserId
                     * @property {string|null} [twitterAccessTokenSecret] PlayerInfoResp twitterAccessTokenSecret
                     * @property {string|null} [lineUserId] PlayerInfoResp lineUserId
                     * @property {number|Long|null} [memberExpireDate] PlayerInfoResp memberExpireDate
                     * @property {string|null} [playerIdString] PlayerInfoResp playerIdString
                     */

                    /**
                     * Constructs a new PlayerInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerInfoResp.
                     * @implements IPlayerInfoResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerInfoResp=} [properties] Properties to set
                     */
                    function PlayerInfoResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerInfoResp playerId.
                     * @member {number|Long} playerId
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.playerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PlayerInfoResp nickname.
                     * @member {string} nickname
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.nickname = "";

                    /**
                     * PlayerInfoResp birthYear.
                     * @member {number} birthYear
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.birthYear = 0;

                    /**
                     * PlayerInfoResp birthMonth.
                     * @member {number} birthMonth
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.birthMonth = 0;

                    /**
                     * PlayerInfoResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.mailAddress = "";

                    /**
                     * PlayerInfoResp membershipGrade.
                     * @member {kuma.jp.protobuf.web.PlayerInfoResp.MembershipGrade} membershipGrade
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.membershipGrade = 0;

                    /**
                     * PlayerInfoResp paymentType.
                     * @member {kuma.jp.protobuf.web.PlayerInfoResp.PaymentType} paymentType
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.paymentType = 0;

                    /**
                     * PlayerInfoResp registrationType.
                     * @member {kuma.jp.protobuf.web.PlayerInfoResp.RegistrationType} registrationType
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.registrationType = 0;

                    /**
                     * PlayerInfoResp twitterUserId.
                     * @member {string} twitterUserId
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.twitterUserId = "";

                    /**
                     * PlayerInfoResp twitterAccessTokenSecret.
                     * @member {string} twitterAccessTokenSecret
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.twitterAccessTokenSecret = "";

                    /**
                     * PlayerInfoResp lineUserId.
                     * @member {string} lineUserId
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.lineUserId = "";

                    /**
                     * PlayerInfoResp memberExpireDate.
                     * @member {number|Long} memberExpireDate
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.memberExpireDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PlayerInfoResp playerIdString.
                     * @member {string} playerIdString
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     */
                    PlayerInfoResp.prototype.playerIdString = "";

                    /**
                     * Creates a new PlayerInfoResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerInfoResp} PlayerInfoResp instance
                     */
                    PlayerInfoResp.create = function create(properties) {
                        return new PlayerInfoResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerInfoResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerInfoResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoResp} message PlayerInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerInfoResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.playerId != null && Object.hasOwnProperty.call(message, "playerId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.playerId);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
                        if (message.birthYear != null && Object.hasOwnProperty.call(message, "birthYear"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.birthYear);
                        if (message.birthMonth != null && Object.hasOwnProperty.call(message, "birthMonth"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.birthMonth);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mailAddress);
                        if (message.membershipGrade != null && Object.hasOwnProperty.call(message, "membershipGrade"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.membershipGrade);
                        if (message.paymentType != null && Object.hasOwnProperty.call(message, "paymentType"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.paymentType);
                        if (message.registrationType != null && Object.hasOwnProperty.call(message, "registrationType"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.registrationType);
                        if (message.twitterUserId != null && Object.hasOwnProperty.call(message, "twitterUserId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.twitterUserId);
                        if (message.twitterAccessTokenSecret != null && Object.hasOwnProperty.call(message, "twitterAccessTokenSecret"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.twitterAccessTokenSecret);
                        if (message.lineUserId != null && Object.hasOwnProperty.call(message, "lineUserId"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.lineUserId);
                        if (message.memberExpireDate != null && Object.hasOwnProperty.call(message, "memberExpireDate"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.memberExpireDate);
                        if (message.playerIdString != null && Object.hasOwnProperty.call(message, "playerIdString"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.playerIdString);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerInfoResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerInfoResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerInfoResp} message PlayerInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerInfoResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerInfoResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerInfoResp} PlayerInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerInfoResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerInfoResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.playerId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.birthYear = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.birthMonth = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.membershipGrade = reader.int32();
                                    break;
                                }
                            case 7: {
                                    message.paymentType = reader.int32();
                                    break;
                                }
                            case 8: {
                                    message.registrationType = reader.int32();
                                    break;
                                }
                            case 9: {
                                    message.twitterUserId = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.twitterAccessTokenSecret = reader.string();
                                    break;
                                }
                            case 11: {
                                    message.lineUserId = reader.string();
                                    break;
                                }
                            case 12: {
                                    message.memberExpireDate = reader.int64();
                                    break;
                                }
                            case 13: {
                                    message.playerIdString = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerInfoResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerInfoResp} PlayerInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerInfoResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerInfoResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerInfoResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (!$util.isInteger(message.playerId) && !(message.playerId && $util.isInteger(message.playerId.low) && $util.isInteger(message.playerId.high)))
                                return "playerId: integer|Long expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            if (!$util.isInteger(message.birthYear))
                                return "birthYear: integer expected";
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            if (!$util.isInteger(message.birthMonth))
                                return "birthMonth: integer expected";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            switch (message.membershipGrade) {
                            default:
                                return "membershipGrade: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.paymentType != null && message.hasOwnProperty("paymentType"))
                            switch (message.paymentType) {
                            default:
                                return "paymentType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 11:
                            case 21:
                            case 31:
                            case 99:
                                break;
                            }
                        if (message.registrationType != null && message.hasOwnProperty("registrationType"))
                            switch (message.registrationType) {
                            default:
                                return "registrationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            if (!$util.isString(message.twitterUserId))
                                return "twitterUserId: string expected";
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            if (!$util.isString(message.twitterAccessTokenSecret))
                                return "twitterAccessTokenSecret: string expected";
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            if (!$util.isString(message.lineUserId))
                                return "lineUserId: string expected";
                        if (message.memberExpireDate != null && message.hasOwnProperty("memberExpireDate"))
                            if (!$util.isInteger(message.memberExpireDate) && !(message.memberExpireDate && $util.isInteger(message.memberExpireDate.low) && $util.isInteger(message.memberExpireDate.high)))
                                return "memberExpireDate: integer|Long expected";
                        if (message.playerIdString != null && message.hasOwnProperty("playerIdString"))
                            if (!$util.isString(message.playerIdString))
                                return "playerIdString: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerInfoResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerInfoResp} PlayerInfoResp
                     */
                    PlayerInfoResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerInfoResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerInfoResp();
                        if (object.playerId != null)
                            if ($util.Long)
                                (message.playerId = $util.Long.fromValue(object.playerId)).unsigned = false;
                            else if (typeof object.playerId === "string")
                                message.playerId = parseInt(object.playerId, 10);
                            else if (typeof object.playerId === "number")
                                message.playerId = object.playerId;
                            else if (typeof object.playerId === "object")
                                message.playerId = new $util.LongBits(object.playerId.low >>> 0, object.playerId.high >>> 0).toNumber();
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.birthYear != null)
                            message.birthYear = object.birthYear | 0;
                        if (object.birthMonth != null)
                            message.birthMonth = object.birthMonth | 0;
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        switch (object.membershipGrade) {
                        default:
                            if (typeof object.membershipGrade === "number") {
                                message.membershipGrade = object.membershipGrade;
                                break;
                            }
                            break;
                        case "GUEST":
                        case 0:
                            message.membershipGrade = 0;
                            break;
                        case "FREE":
                        case 1:
                            message.membershipGrade = 1;
                            break;
                        case "GOLD":
                        case 2:
                            message.membershipGrade = 2;
                            break;
                        case "PLATINUM":
                        case 3:
                            message.membershipGrade = 3;
                            break;
                        }
                        switch (object.paymentType) {
                        default:
                            if (typeof object.paymentType === "number") {
                                message.paymentType = object.paymentType;
                                break;
                            }
                            break;
                        case "WEB_AIME":
                        case 0:
                            message.paymentType = 0;
                            break;
                        case "WEB_DOCOMO":
                        case 1:
                            message.paymentType = 1;
                            break;
                        case "WEB_AU":
                        case 2:
                            message.paymentType = 2;
                            break;
                        case "WEB_SOFTBANK":
                        case 3:
                            message.paymentType = 3;
                            break;
                        case "WEB_CARD":
                        case 11:
                            message.paymentType = 11;
                            break;
                        case "APPLE":
                        case 21:
                            message.paymentType = 21;
                            break;
                        case "GOOGLE":
                        case 31:
                            message.paymentType = 31;
                            break;
                        case "NONE":
                        case 99:
                            message.paymentType = 99;
                            break;
                        }
                        switch (object.registrationType) {
                        default:
                            if (typeof object.registrationType === "number") {
                                message.registrationType = object.registrationType;
                                break;
                            }
                            break;
                        case "IOS_REGIST":
                        case 0:
                            message.registrationType = 0;
                            break;
                        case "ANDROID_REGIST":
                        case 1:
                            message.registrationType = 1;
                            break;
                        case "WEB_REGIST":
                        case 2:
                            message.registrationType = 2;
                            break;
                        }
                        if (object.twitterUserId != null)
                            message.twitterUserId = String(object.twitterUserId);
                        if (object.twitterAccessTokenSecret != null)
                            message.twitterAccessTokenSecret = String(object.twitterAccessTokenSecret);
                        if (object.lineUserId != null)
                            message.lineUserId = String(object.lineUserId);
                        if (object.memberExpireDate != null)
                            if ($util.Long)
                                (message.memberExpireDate = $util.Long.fromValue(object.memberExpireDate)).unsigned = false;
                            else if (typeof object.memberExpireDate === "string")
                                message.memberExpireDate = parseInt(object.memberExpireDate, 10);
                            else if (typeof object.memberExpireDate === "number")
                                message.memberExpireDate = object.memberExpireDate;
                            else if (typeof object.memberExpireDate === "object")
                                message.memberExpireDate = new $util.LongBits(object.memberExpireDate.low >>> 0, object.memberExpireDate.high >>> 0).toNumber();
                        if (object.playerIdString != null)
                            message.playerIdString = String(object.playerIdString);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerInfoResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerInfoResp} message PlayerInfoResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerInfoResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.playerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.playerId = options.longs === String ? "0" : 0;
                            object.nickname = "";
                            object.birthYear = 0;
                            object.birthMonth = 0;
                            object.mailAddress = "";
                            object.membershipGrade = options.enums === String ? "GUEST" : 0;
                            object.paymentType = options.enums === String ? "WEB_AIME" : 0;
                            object.registrationType = options.enums === String ? "IOS_REGIST" : 0;
                            object.twitterUserId = "";
                            object.twitterAccessTokenSecret = "";
                            object.lineUserId = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.memberExpireDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.memberExpireDate = options.longs === String ? "0" : 0;
                            object.playerIdString = "";
                        }
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (typeof message.playerId === "number")
                                object.playerId = options.longs === String ? String(message.playerId) : message.playerId;
                            else
                                object.playerId = options.longs === String ? $util.Long.prototype.toString.call(message.playerId) : options.longs === Number ? new $util.LongBits(message.playerId.low >>> 0, message.playerId.high >>> 0).toNumber() : message.playerId;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            object.birthYear = message.birthYear;
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            object.birthMonth = message.birthMonth;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        if (message.membershipGrade != null && message.hasOwnProperty("membershipGrade"))
                            object.membershipGrade = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerInfoResp.MembershipGrade[message.membershipGrade] === undefined ? message.membershipGrade : $root.kuma.jp.protobuf.web.PlayerInfoResp.MembershipGrade[message.membershipGrade] : message.membershipGrade;
                        if (message.paymentType != null && message.hasOwnProperty("paymentType"))
                            object.paymentType = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerInfoResp.PaymentType[message.paymentType] === undefined ? message.paymentType : $root.kuma.jp.protobuf.web.PlayerInfoResp.PaymentType[message.paymentType] : message.paymentType;
                        if (message.registrationType != null && message.hasOwnProperty("registrationType"))
                            object.registrationType = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerInfoResp.RegistrationType[message.registrationType] === undefined ? message.registrationType : $root.kuma.jp.protobuf.web.PlayerInfoResp.RegistrationType[message.registrationType] : message.registrationType;
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            object.twitterUserId = message.twitterUserId;
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            object.twitterAccessTokenSecret = message.twitterAccessTokenSecret;
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            object.lineUserId = message.lineUserId;
                        if (message.memberExpireDate != null && message.hasOwnProperty("memberExpireDate"))
                            if (typeof message.memberExpireDate === "number")
                                object.memberExpireDate = options.longs === String ? String(message.memberExpireDate) : message.memberExpireDate;
                            else
                                object.memberExpireDate = options.longs === String ? $util.Long.prototype.toString.call(message.memberExpireDate) : options.longs === Number ? new $util.LongBits(message.memberExpireDate.low >>> 0, message.memberExpireDate.high >>> 0).toNumber() : message.memberExpireDate;
                        if (message.playerIdString != null && message.hasOwnProperty("playerIdString"))
                            object.playerIdString = message.playerIdString;
                        return object;
                    };

                    /**
                     * Converts this PlayerInfoResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerInfoResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerInfoResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerInfoResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerInfoResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerInfoResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerInfoResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10301 COMMAND_NO value
                     */
                    PlayerInfoResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10301] = "COMMAND_NO"] = 10301;
                        return values;
                    })();

                    /**
                     * MembershipGrade enum.
                     * @name kuma.jp.protobuf.web.PlayerInfoResp.MembershipGrade
                     * @enum {number}
                     * @property {number} GUEST=0 GUEST value
                     * @property {number} FREE=1 FREE value
                     * @property {number} GOLD=2 GOLD value
                     * @property {number} PLATINUM=3 PLATINUM value
                     */
                    PlayerInfoResp.MembershipGrade = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "GUEST"] = 0;
                        values[valuesById[1] = "FREE"] = 1;
                        values[valuesById[2] = "GOLD"] = 2;
                        values[valuesById[3] = "PLATINUM"] = 3;
                        return values;
                    })();

                    /**
                     * PaymentType enum.
                     * @name kuma.jp.protobuf.web.PlayerInfoResp.PaymentType
                     * @enum {number}
                     * @property {number} WEB_AIME=0 WEB_AIME value
                     * @property {number} WEB_DOCOMO=1 WEB_DOCOMO value
                     * @property {number} WEB_AU=2 WEB_AU value
                     * @property {number} WEB_SOFTBANK=3 WEB_SOFTBANK value
                     * @property {number} WEB_CARD=11 WEB_CARD value
                     * @property {number} APPLE=21 APPLE value
                     * @property {number} GOOGLE=31 GOOGLE value
                     * @property {number} NONE=99 NONE value
                     */
                    PlayerInfoResp.PaymentType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "WEB_AIME"] = 0;
                        values[valuesById[1] = "WEB_DOCOMO"] = 1;
                        values[valuesById[2] = "WEB_AU"] = 2;
                        values[valuesById[3] = "WEB_SOFTBANK"] = 3;
                        values[valuesById[11] = "WEB_CARD"] = 11;
                        values[valuesById[21] = "APPLE"] = 21;
                        values[valuesById[31] = "GOOGLE"] = 31;
                        values[valuesById[99] = "NONE"] = 99;
                        return values;
                    })();

                    /**
                     * RegistrationType enum.
                     * @name kuma.jp.protobuf.web.PlayerInfoResp.RegistrationType
                     * @enum {number}
                     * @property {number} IOS_REGIST=0 IOS_REGIST value
                     * @property {number} ANDROID_REGIST=1 ANDROID_REGIST value
                     * @property {number} WEB_REGIST=2 WEB_REGIST value
                     */
                    PlayerInfoResp.RegistrationType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "IOS_REGIST"] = 0;
                        values[valuesById[1] = "ANDROID_REGIST"] = 1;
                        values[valuesById[2] = "WEB_REGIST"] = 2;
                        return values;
                    })();

                    return PlayerInfoResp;
                })();

                web.PlayerLineTokenReq = (function() {

                    /**
                     * Properties of a PlayerLineTokenReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerLineTokenReq
                     * @property {string|null} [code] PlayerLineTokenReq code
                     * @property {string|null} [redirectUrl] PlayerLineTokenReq redirectUrl
                     */

                    /**
                     * Constructs a new PlayerLineTokenReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerLineTokenReq.
                     * @implements IPlayerLineTokenReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenReq=} [properties] Properties to set
                     */
                    function PlayerLineTokenReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerLineTokenReq code.
                     * @member {string} code
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @instance
                     */
                    PlayerLineTokenReq.prototype.code = "";

                    /**
                     * PlayerLineTokenReq redirectUrl.
                     * @member {string} redirectUrl
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @instance
                     */
                    PlayerLineTokenReq.prototype.redirectUrl = "";

                    /**
                     * Creates a new PlayerLineTokenReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenReq} PlayerLineTokenReq instance
                     */
                    PlayerLineTokenReq.create = function create(properties) {
                        return new PlayerLineTokenReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerLineTokenReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerLineTokenReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenReq} message PlayerLineTokenReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerLineTokenReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                        if (message.redirectUrl != null && Object.hasOwnProperty.call(message, "redirectUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.redirectUrl);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerLineTokenReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerLineTokenReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenReq} message PlayerLineTokenReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerLineTokenReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerLineTokenReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenReq} PlayerLineTokenReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerLineTokenReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerLineTokenReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.redirectUrl = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerLineTokenReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenReq} PlayerLineTokenReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerLineTokenReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerLineTokenReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerLineTokenReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl"))
                            if (!$util.isString(message.redirectUrl))
                                return "redirectUrl: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerLineTokenReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenReq} PlayerLineTokenReq
                     */
                    PlayerLineTokenReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerLineTokenReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerLineTokenReq();
                        if (object.code != null)
                            message.code = String(object.code);
                        if (object.redirectUrl != null)
                            message.redirectUrl = String(object.redirectUrl);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerLineTokenReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerLineTokenReq} message PlayerLineTokenReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerLineTokenReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = "";
                            object.redirectUrl = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.redirectUrl != null && message.hasOwnProperty("redirectUrl"))
                            object.redirectUrl = message.redirectUrl;
                        return object;
                    };

                    /**
                     * Converts this PlayerLineTokenReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerLineTokenReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerLineTokenReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerLineTokenReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerLineTokenReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerLineTokenReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10406 COMMAND_NO value
                     */
                    PlayerLineTokenReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10406] = "COMMAND_NO"] = 10406;
                        return values;
                    })();

                    return PlayerLineTokenReq;
                })();

                web.PlayerLineTokenResp = (function() {

                    /**
                     * Properties of a PlayerLineTokenResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerLineTokenResp
                     * @property {kuma.jp.protobuf.web.PlayerLineTokenResp.Status|null} [status] PlayerLineTokenResp status
                     * @property {string|null} [token] PlayerLineTokenResp token
                     * @property {string|null} [refreshToken] PlayerLineTokenResp refreshToken
                     * @property {number|null} [expiresIn] PlayerLineTokenResp expiresIn
                     * @property {string|null} [userId] PlayerLineTokenResp userId
                     * @property {string|null} [screenName] PlayerLineTokenResp screenName
                     */

                    /**
                     * Constructs a new PlayerLineTokenResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerLineTokenResp.
                     * @implements IPlayerLineTokenResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenResp=} [properties] Properties to set
                     */
                    function PlayerLineTokenResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerLineTokenResp status.
                     * @member {kuma.jp.protobuf.web.PlayerLineTokenResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.status = 0;

                    /**
                     * PlayerLineTokenResp token.
                     * @member {string} token
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.token = "";

                    /**
                     * PlayerLineTokenResp refreshToken.
                     * @member {string} refreshToken
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.refreshToken = "";

                    /**
                     * PlayerLineTokenResp expiresIn.
                     * @member {number} expiresIn
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.expiresIn = 0;

                    /**
                     * PlayerLineTokenResp userId.
                     * @member {string} userId
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.userId = "";

                    /**
                     * PlayerLineTokenResp screenName.
                     * @member {string} screenName
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     */
                    PlayerLineTokenResp.prototype.screenName = "";

                    /**
                     * Creates a new PlayerLineTokenResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenResp} PlayerLineTokenResp instance
                     */
                    PlayerLineTokenResp.create = function create(properties) {
                        return new PlayerLineTokenResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerLineTokenResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerLineTokenResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenResp} message PlayerLineTokenResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerLineTokenResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                        if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.refreshToken);
                        if (message.expiresIn != null && Object.hasOwnProperty.call(message, "expiresIn"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.expiresIn);
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.userId);
                        if (message.screenName != null && Object.hasOwnProperty.call(message, "screenName"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.screenName);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerLineTokenResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerLineTokenResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerLineTokenResp} message PlayerLineTokenResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerLineTokenResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerLineTokenResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenResp} PlayerLineTokenResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerLineTokenResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerLineTokenResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.token = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.refreshToken = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.expiresIn = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.userId = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.screenName = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerLineTokenResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenResp} PlayerLineTokenResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerLineTokenResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerLineTokenResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerLineTokenResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!$util.isString(message.token))
                                return "token: string expected";
                        if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                            if (!$util.isString(message.refreshToken))
                                return "refreshToken: string expected";
                        if (message.expiresIn != null && message.hasOwnProperty("expiresIn"))
                            if (!$util.isInteger(message.expiresIn))
                                return "expiresIn: integer expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isString(message.userId))
                                return "userId: string expected";
                        if (message.screenName != null && message.hasOwnProperty("screenName"))
                            if (!$util.isString(message.screenName))
                                return "screenName: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerLineTokenResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerLineTokenResp} PlayerLineTokenResp
                     */
                    PlayerLineTokenResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerLineTokenResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerLineTokenResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.token != null)
                            message.token = String(object.token);
                        if (object.refreshToken != null)
                            message.refreshToken = String(object.refreshToken);
                        if (object.expiresIn != null)
                            message.expiresIn = object.expiresIn | 0;
                        if (object.userId != null)
                            message.userId = String(object.userId);
                        if (object.screenName != null)
                            message.screenName = String(object.screenName);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerLineTokenResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerLineTokenResp} message PlayerLineTokenResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerLineTokenResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.token = "";
                            object.refreshToken = "";
                            object.expiresIn = 0;
                            object.userId = "";
                            object.screenName = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerLineTokenResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerLineTokenResp.Status[message.status] : message.status;
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = message.token;
                        if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                            object.refreshToken = message.refreshToken;
                        if (message.expiresIn != null && message.hasOwnProperty("expiresIn"))
                            object.expiresIn = message.expiresIn;
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            object.userId = message.userId;
                        if (message.screenName != null && message.hasOwnProperty("screenName"))
                            object.screenName = message.screenName;
                        return object;
                    };

                    /**
                     * Converts this PlayerLineTokenResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerLineTokenResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerLineTokenResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerLineTokenResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerLineTokenResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerLineTokenResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerLineTokenResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10407 COMMAND_NO value
                     */
                    PlayerLineTokenResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10407] = "COMMAND_NO"] = 10407;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerLineTokenResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerLineTokenResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerLineTokenResp;
                })();

                web.PlayerRegistrationReq = (function() {

                    /**
                     * Properties of a PlayerRegistrationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerRegistrationReq
                     * @property {kuma.jp.protobuf.web.PlayerRegistrationReq.AuthType|null} [authType] PlayerRegistrationReq authType
                     * @property {string|null} [validateKey] PlayerRegistrationReq validateKey
                     * @property {string|null} [password] PlayerRegistrationReq password
                     * @property {string|null} [nickname] PlayerRegistrationReq nickname
                     * @property {number|null} [birthYear] PlayerRegistrationReq birthYear
                     * @property {number|null} [birthMonth] PlayerRegistrationReq birthMonth
                     * @property {string|null} [twitterUserId] PlayerRegistrationReq twitterUserId
                     * @property {string|null} [twitterAccessToken] PlayerRegistrationReq twitterAccessToken
                     * @property {string|null} [twitterAccessTokenSecret] PlayerRegistrationReq twitterAccessTokenSecret
                     * @property {string|null} [lineUserId] PlayerRegistrationReq lineUserId
                     * @property {string|null} [lineAccessToken] PlayerRegistrationReq lineAccessToken
                     */

                    /**
                     * Constructs a new PlayerRegistrationReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerRegistrationReq.
                     * @implements IPlayerRegistrationReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationReq=} [properties] Properties to set
                     */
                    function PlayerRegistrationReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerRegistrationReq authType.
                     * @member {kuma.jp.protobuf.web.PlayerRegistrationReq.AuthType} authType
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.authType = 0;

                    /**
                     * PlayerRegistrationReq validateKey.
                     * @member {string} validateKey
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.validateKey = "";

                    /**
                     * PlayerRegistrationReq password.
                     * @member {string} password
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.password = "";

                    /**
                     * PlayerRegistrationReq nickname.
                     * @member {string} nickname
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.nickname = "";

                    /**
                     * PlayerRegistrationReq birthYear.
                     * @member {number} birthYear
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.birthYear = 0;

                    /**
                     * PlayerRegistrationReq birthMonth.
                     * @member {number} birthMonth
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.birthMonth = 0;

                    /**
                     * PlayerRegistrationReq twitterUserId.
                     * @member {string} twitterUserId
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.twitterUserId = "";

                    /**
                     * PlayerRegistrationReq twitterAccessToken.
                     * @member {string} twitterAccessToken
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.twitterAccessToken = "";

                    /**
                     * PlayerRegistrationReq twitterAccessTokenSecret.
                     * @member {string} twitterAccessTokenSecret
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.twitterAccessTokenSecret = "";

                    /**
                     * PlayerRegistrationReq lineUserId.
                     * @member {string} lineUserId
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.lineUserId = "";

                    /**
                     * PlayerRegistrationReq lineAccessToken.
                     * @member {string} lineAccessToken
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     */
                    PlayerRegistrationReq.prototype.lineAccessToken = "";

                    /**
                     * Creates a new PlayerRegistrationReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationReq} PlayerRegistrationReq instance
                     */
                    PlayerRegistrationReq.create = function create(properties) {
                        return new PlayerRegistrationReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerRegistrationReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerRegistrationReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationReq} message PlayerRegistrationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerRegistrationReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.authType != null && Object.hasOwnProperty.call(message, "authType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.authType);
                        if (message.validateKey != null && Object.hasOwnProperty.call(message, "validateKey"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.validateKey);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
                        if (message.birthYear != null && Object.hasOwnProperty.call(message, "birthYear"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.birthYear);
                        if (message.birthMonth != null && Object.hasOwnProperty.call(message, "birthMonth"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.birthMonth);
                        if (message.twitterUserId != null && Object.hasOwnProperty.call(message, "twitterUserId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.twitterUserId);
                        if (message.twitterAccessToken != null && Object.hasOwnProperty.call(message, "twitterAccessToken"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.twitterAccessToken);
                        if (message.twitterAccessTokenSecret != null && Object.hasOwnProperty.call(message, "twitterAccessTokenSecret"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.twitterAccessTokenSecret);
                        if (message.lineUserId != null && Object.hasOwnProperty.call(message, "lineUserId"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.lineUserId);
                        if (message.lineAccessToken != null && Object.hasOwnProperty.call(message, "lineAccessToken"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.lineAccessToken);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerRegistrationReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerRegistrationReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationReq} message PlayerRegistrationReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerRegistrationReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerRegistrationReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationReq} PlayerRegistrationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerRegistrationReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerRegistrationReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.authType = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.validateKey = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.password = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.birthYear = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.birthMonth = reader.int32();
                                    break;
                                }
                            case 7: {
                                    message.twitterUserId = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.twitterAccessToken = reader.string();
                                    break;
                                }
                            case 9: {
                                    message.twitterAccessTokenSecret = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.lineUserId = reader.string();
                                    break;
                                }
                            case 11: {
                                    message.lineAccessToken = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerRegistrationReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationReq} PlayerRegistrationReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerRegistrationReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerRegistrationReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerRegistrationReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.authType != null && message.hasOwnProperty("authType"))
                            switch (message.authType) {
                            default:
                                return "authType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            if (!$util.isString(message.validateKey))
                                return "validateKey: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            if (!$util.isInteger(message.birthYear))
                                return "birthYear: integer expected";
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            if (!$util.isInteger(message.birthMonth))
                                return "birthMonth: integer expected";
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            if (!$util.isString(message.twitterUserId))
                                return "twitterUserId: string expected";
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            if (!$util.isString(message.twitterAccessToken))
                                return "twitterAccessToken: string expected";
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            if (!$util.isString(message.twitterAccessTokenSecret))
                                return "twitterAccessTokenSecret: string expected";
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            if (!$util.isString(message.lineUserId))
                                return "lineUserId: string expected";
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            if (!$util.isString(message.lineAccessToken))
                                return "lineAccessToken: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerRegistrationReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationReq} PlayerRegistrationReq
                     */
                    PlayerRegistrationReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerRegistrationReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerRegistrationReq();
                        switch (object.authType) {
                        default:
                            if (typeof object.authType === "number") {
                                message.authType = object.authType;
                                break;
                            }
                            break;
                        case "MAIL_ADDRESS":
                        case 0:
                            message.authType = 0;
                            break;
                        case "TWITTER":
                        case 1:
                            message.authType = 1;
                            break;
                        case "LINE":
                        case 2:
                            message.authType = 2;
                            break;
                        }
                        if (object.validateKey != null)
                            message.validateKey = String(object.validateKey);
                        if (object.password != null)
                            message.password = String(object.password);
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.birthYear != null)
                            message.birthYear = object.birthYear | 0;
                        if (object.birthMonth != null)
                            message.birthMonth = object.birthMonth | 0;
                        if (object.twitterUserId != null)
                            message.twitterUserId = String(object.twitterUserId);
                        if (object.twitterAccessToken != null)
                            message.twitterAccessToken = String(object.twitterAccessToken);
                        if (object.twitterAccessTokenSecret != null)
                            message.twitterAccessTokenSecret = String(object.twitterAccessTokenSecret);
                        if (object.lineUserId != null)
                            message.lineUserId = String(object.lineUserId);
                        if (object.lineAccessToken != null)
                            message.lineAccessToken = String(object.lineAccessToken);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerRegistrationReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerRegistrationReq} message PlayerRegistrationReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerRegistrationReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.authType = options.enums === String ? "MAIL_ADDRESS" : 0;
                            object.validateKey = "";
                            object.password = "";
                            object.nickname = "";
                            object.birthYear = 0;
                            object.birthMonth = 0;
                            object.twitterUserId = "";
                            object.twitterAccessToken = "";
                            object.twitterAccessTokenSecret = "";
                            object.lineUserId = "";
                            object.lineAccessToken = "";
                        }
                        if (message.authType != null && message.hasOwnProperty("authType"))
                            object.authType = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerRegistrationReq.AuthType[message.authType] === undefined ? message.authType : $root.kuma.jp.protobuf.web.PlayerRegistrationReq.AuthType[message.authType] : message.authType;
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            object.validateKey = message.validateKey;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            object.birthYear = message.birthYear;
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            object.birthMonth = message.birthMonth;
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            object.twitterUserId = message.twitterUserId;
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            object.twitterAccessToken = message.twitterAccessToken;
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            object.twitterAccessTokenSecret = message.twitterAccessTokenSecret;
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            object.lineUserId = message.lineUserId;
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            object.lineAccessToken = message.lineAccessToken;
                        return object;
                    };

                    /**
                     * Converts this PlayerRegistrationReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerRegistrationReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerRegistrationReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerRegistrationReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerRegistrationReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerRegistrationReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10400 COMMAND_NO value
                     */
                    PlayerRegistrationReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10400] = "COMMAND_NO"] = 10400;
                        return values;
                    })();

                    /**
                     * AuthType enum.
                     * @name kuma.jp.protobuf.web.PlayerRegistrationReq.AuthType
                     * @enum {number}
                     * @property {number} MAIL_ADDRESS=0 MAIL_ADDRESS value
                     * @property {number} TWITTER=1 TWITTER value
                     * @property {number} LINE=2 LINE value
                     */
                    PlayerRegistrationReq.AuthType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "MAIL_ADDRESS"] = 0;
                        values[valuesById[1] = "TWITTER"] = 1;
                        values[valuesById[2] = "LINE"] = 2;
                        return values;
                    })();

                    return PlayerRegistrationReq;
                })();

                web.PlayerRegistrationResp = (function() {

                    /**
                     * Properties of a PlayerRegistrationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerRegistrationResp
                     * @property {kuma.jp.protobuf.web.PlayerRegistrationResp.Status|null} [status] PlayerRegistrationResp status
                     * @property {string|null} [failureReason] PlayerRegistrationResp failureReason
                     * @property {Uint8Array|null} [token] PlayerRegistrationResp token
                     * @property {string|null} [mailAddress] PlayerRegistrationResp mailAddress
                     * @property {number|Long|null} [playerId] PlayerRegistrationResp playerId
                     */

                    /**
                     * Constructs a new PlayerRegistrationResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerRegistrationResp.
                     * @implements IPlayerRegistrationResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationResp=} [properties] Properties to set
                     */
                    function PlayerRegistrationResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerRegistrationResp status.
                     * @member {kuma.jp.protobuf.web.PlayerRegistrationResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     */
                    PlayerRegistrationResp.prototype.status = 0;

                    /**
                     * PlayerRegistrationResp failureReason.
                     * @member {string} failureReason
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     */
                    PlayerRegistrationResp.prototype.failureReason = "";

                    /**
                     * PlayerRegistrationResp token.
                     * @member {Uint8Array} token
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     */
                    PlayerRegistrationResp.prototype.token = $util.newBuffer([]);

                    /**
                     * PlayerRegistrationResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     */
                    PlayerRegistrationResp.prototype.mailAddress = "";

                    /**
                     * PlayerRegistrationResp playerId.
                     * @member {number|Long} playerId
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     */
                    PlayerRegistrationResp.prototype.playerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new PlayerRegistrationResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationResp} PlayerRegistrationResp instance
                     */
                    PlayerRegistrationResp.create = function create(properties) {
                        return new PlayerRegistrationResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerRegistrationResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerRegistrationResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationResp} message PlayerRegistrationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerRegistrationResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.failureReason != null && Object.hasOwnProperty.call(message, "failureReason"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.failureReason);
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.token);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.mailAddress);
                        if (message.playerId != null && Object.hasOwnProperty.call(message, "playerId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.playerId);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerRegistrationResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerRegistrationResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerRegistrationResp} message PlayerRegistrationResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerRegistrationResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerRegistrationResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationResp} PlayerRegistrationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerRegistrationResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerRegistrationResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.failureReason = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.token = reader.bytes();
                                    break;
                                }
                            case 4: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.playerId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerRegistrationResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationResp} PlayerRegistrationResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerRegistrationResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerRegistrationResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerRegistrationResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.failureReason != null && message.hasOwnProperty("failureReason"))
                            if (!$util.isString(message.failureReason))
                                return "failureReason: string expected";
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                                return "token: buffer expected";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (!$util.isInteger(message.playerId) && !(message.playerId && $util.isInteger(message.playerId.low) && $util.isInteger(message.playerId.high)))
                                return "playerId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerRegistrationResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerRegistrationResp} PlayerRegistrationResp
                     */
                    PlayerRegistrationResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerRegistrationResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerRegistrationResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.failureReason != null)
                            message.failureReason = String(object.failureReason);
                        if (object.token != null)
                            if (typeof object.token === "string")
                                $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                            else if (object.token.length >= 0)
                                message.token = object.token;
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        if (object.playerId != null)
                            if ($util.Long)
                                (message.playerId = $util.Long.fromValue(object.playerId)).unsigned = false;
                            else if (typeof object.playerId === "string")
                                message.playerId = parseInt(object.playerId, 10);
                            else if (typeof object.playerId === "number")
                                message.playerId = object.playerId;
                            else if (typeof object.playerId === "object")
                                message.playerId = new $util.LongBits(object.playerId.low >>> 0, object.playerId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerRegistrationResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerRegistrationResp} message PlayerRegistrationResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerRegistrationResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.failureReason = "";
                            if (options.bytes === String)
                                object.token = "";
                            else {
                                object.token = [];
                                if (options.bytes !== Array)
                                    object.token = $util.newBuffer(object.token);
                            }
                            object.mailAddress = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.playerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.playerId = options.longs === String ? "0" : 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerRegistrationResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerRegistrationResp.Status[message.status] : message.status;
                        if (message.failureReason != null && message.hasOwnProperty("failureReason"))
                            object.failureReason = message.failureReason;
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        if (message.playerId != null && message.hasOwnProperty("playerId"))
                            if (typeof message.playerId === "number")
                                object.playerId = options.longs === String ? String(message.playerId) : message.playerId;
                            else
                                object.playerId = options.longs === String ? $util.Long.prototype.toString.call(message.playerId) : options.longs === Number ? new $util.LongBits(message.playerId.low >>> 0, message.playerId.high >>> 0).toNumber() : message.playerId;
                        return object;
                    };

                    /**
                     * Converts this PlayerRegistrationResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerRegistrationResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerRegistrationResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerRegistrationResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerRegistrationResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerRegistrationResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerRegistrationResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10401 COMMAND_NO value
                     */
                    PlayerRegistrationResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10401] = "COMMAND_NO"] = 10401;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerRegistrationResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerRegistrationResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerRegistrationResp;
                })();

                web.PlayerResetPassMailReq = (function() {

                    /**
                     * Properties of a PlayerResetPassMailReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerResetPassMailReq
                     * @property {string|null} [mailAddress] PlayerResetPassMailReq mailAddress
                     */

                    /**
                     * Constructs a new PlayerResetPassMailReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerResetPassMailReq.
                     * @implements IPlayerResetPassMailReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailReq=} [properties] Properties to set
                     */
                    function PlayerResetPassMailReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerResetPassMailReq mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @instance
                     */
                    PlayerResetPassMailReq.prototype.mailAddress = "";

                    /**
                     * Creates a new PlayerResetPassMailReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailReq} PlayerResetPassMailReq instance
                     */
                    PlayerResetPassMailReq.create = function create(properties) {
                        return new PlayerResetPassMailReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerResetPassMailReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassMailReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailReq} message PlayerResetPassMailReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassMailReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.mailAddress);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerResetPassMailReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassMailReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailReq} message PlayerResetPassMailReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassMailReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerResetPassMailReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailReq} PlayerResetPassMailReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassMailReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerResetPassMailReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerResetPassMailReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailReq} PlayerResetPassMailReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassMailReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerResetPassMailReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerResetPassMailReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerResetPassMailReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailReq} PlayerResetPassMailReq
                     */
                    PlayerResetPassMailReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerResetPassMailReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerResetPassMailReq();
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerResetPassMailReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerResetPassMailReq} message PlayerResetPassMailReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerResetPassMailReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.mailAddress = "";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        return object;
                    };

                    /**
                     * Converts this PlayerResetPassMailReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerResetPassMailReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerResetPassMailReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerResetPassMailReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerResetPassMailReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassMailReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10602 COMMAND_NO value
                     */
                    PlayerResetPassMailReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10602] = "COMMAND_NO"] = 10602;
                        return values;
                    })();

                    return PlayerResetPassMailReq;
                })();

                web.PlayerResetPassMailResp = (function() {

                    /**
                     * Properties of a PlayerResetPassMailResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerResetPassMailResp
                     * @property {kuma.jp.protobuf.web.PlayerResetPassMailResp.Status|null} [status] PlayerResetPassMailResp status
                     */

                    /**
                     * Constructs a new PlayerResetPassMailResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerResetPassMailResp.
                     * @implements IPlayerResetPassMailResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailResp=} [properties] Properties to set
                     */
                    function PlayerResetPassMailResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerResetPassMailResp status.
                     * @member {kuma.jp.protobuf.web.PlayerResetPassMailResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @instance
                     */
                    PlayerResetPassMailResp.prototype.status = 0;

                    /**
                     * Creates a new PlayerResetPassMailResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailResp} PlayerResetPassMailResp instance
                     */
                    PlayerResetPassMailResp.create = function create(properties) {
                        return new PlayerResetPassMailResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerResetPassMailResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassMailResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailResp} message PlayerResetPassMailResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassMailResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerResetPassMailResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassMailResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassMailResp} message PlayerResetPassMailResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassMailResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerResetPassMailResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailResp} PlayerResetPassMailResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassMailResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerResetPassMailResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerResetPassMailResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailResp} PlayerResetPassMailResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassMailResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerResetPassMailResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerResetPassMailResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a PlayerResetPassMailResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassMailResp} PlayerResetPassMailResp
                     */
                    PlayerResetPassMailResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerResetPassMailResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerResetPassMailResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerResetPassMailResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerResetPassMailResp} message PlayerResetPassMailResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerResetPassMailResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerResetPassMailResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerResetPassMailResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this PlayerResetPassMailResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerResetPassMailResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerResetPassMailResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassMailResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerResetPassMailResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerResetPassMailResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassMailResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10603 COMMAND_NO value
                     */
                    PlayerResetPassMailResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10603] = "COMMAND_NO"] = 10603;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassMailResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerResetPassMailResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerResetPassMailResp;
                })();

                web.PlayerResetPassReq = (function() {

                    /**
                     * Properties of a PlayerResetPassReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerResetPassReq
                     * @property {string|null} [validateKey] PlayerResetPassReq validateKey
                     * @property {string|null} [password] PlayerResetPassReq password
                     */

                    /**
                     * Constructs a new PlayerResetPassReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerResetPassReq.
                     * @implements IPlayerResetPassReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassReq=} [properties] Properties to set
                     */
                    function PlayerResetPassReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerResetPassReq validateKey.
                     * @member {string} validateKey
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @instance
                     */
                    PlayerResetPassReq.prototype.validateKey = "";

                    /**
                     * PlayerResetPassReq password.
                     * @member {string} password
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @instance
                     */
                    PlayerResetPassReq.prototype.password = "";

                    /**
                     * Creates a new PlayerResetPassReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassReq} PlayerResetPassReq instance
                     */
                    PlayerResetPassReq.create = function create(properties) {
                        return new PlayerResetPassReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerResetPassReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassReq} message PlayerResetPassReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.validateKey != null && Object.hasOwnProperty.call(message, "validateKey"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.validateKey);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerResetPassReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassReq} message PlayerResetPassReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerResetPassReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassReq} PlayerResetPassReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerResetPassReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.validateKey = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.password = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerResetPassReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassReq} PlayerResetPassReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerResetPassReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerResetPassReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            if (!$util.isString(message.validateKey))
                                return "validateKey: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerResetPassReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassReq} PlayerResetPassReq
                     */
                    PlayerResetPassReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerResetPassReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerResetPassReq();
                        if (object.validateKey != null)
                            message.validateKey = String(object.validateKey);
                        if (object.password != null)
                            message.password = String(object.password);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerResetPassReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerResetPassReq} message PlayerResetPassReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerResetPassReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.validateKey = "";
                            object.password = "";
                        }
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            object.validateKey = message.validateKey;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        return object;
                    };

                    /**
                     * Converts this PlayerResetPassReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerResetPassReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerResetPassReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerResetPassReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerResetPassReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10600 COMMAND_NO value
                     */
                    PlayerResetPassReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10600] = "COMMAND_NO"] = 10600;
                        return values;
                    })();

                    return PlayerResetPassReq;
                })();

                web.PlayerResetPassResp = (function() {

                    /**
                     * Properties of a PlayerResetPassResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerResetPassResp
                     * @property {kuma.jp.protobuf.web.PlayerResetPassResp.Status|null} [status] PlayerResetPassResp status
                     * @property {string|null} [mailAddress] PlayerResetPassResp mailAddress
                     */

                    /**
                     * Constructs a new PlayerResetPassResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerResetPassResp.
                     * @implements IPlayerResetPassResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassResp=} [properties] Properties to set
                     */
                    function PlayerResetPassResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerResetPassResp status.
                     * @member {kuma.jp.protobuf.web.PlayerResetPassResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @instance
                     */
                    PlayerResetPassResp.prototype.status = 0;

                    /**
                     * PlayerResetPassResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @instance
                     */
                    PlayerResetPassResp.prototype.mailAddress = "";

                    /**
                     * Creates a new PlayerResetPassResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassResp} PlayerResetPassResp instance
                     */
                    PlayerResetPassResp.create = function create(properties) {
                        return new PlayerResetPassResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerResetPassResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassResp} message PlayerResetPassResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mailAddress);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerResetPassResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerResetPassResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerResetPassResp} message PlayerResetPassResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerResetPassResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerResetPassResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassResp} PlayerResetPassResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerResetPassResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerResetPassResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassResp} PlayerResetPassResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerResetPassResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerResetPassResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerResetPassResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerResetPassResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerResetPassResp} PlayerResetPassResp
                     */
                    PlayerResetPassResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerResetPassResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerResetPassResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerResetPassResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerResetPassResp} message PlayerResetPassResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerResetPassResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.mailAddress = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerResetPassResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerResetPassResp.Status[message.status] : message.status;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        return object;
                    };

                    /**
                     * Converts this PlayerResetPassResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerResetPassResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerResetPassResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerResetPassResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerResetPassResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerResetPassResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10601 COMMAND_NO value
                     */
                    PlayerResetPassResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10601] = "COMMAND_NO"] = 10601;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerResetPassResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerResetPassResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerResetPassResp;
                })();

                web.PlayerTutorialListReq = (function() {

                    /**
                     * Properties of a PlayerTutorialListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTutorialListReq
                     */

                    /**
                     * Constructs a new PlayerTutorialListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTutorialListReq.
                     * @implements IPlayerTutorialListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListReq=} [properties] Properties to set
                     */
                    function PlayerTutorialListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new PlayerTutorialListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListReq} PlayerTutorialListReq instance
                     */
                    PlayerTutorialListReq.create = function create(properties) {
                        return new PlayerTutorialListReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerTutorialListReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListReq} message PlayerTutorialListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTutorialListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListReq} message PlayerTutorialListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTutorialListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListReq} PlayerTutorialListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTutorialListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTutorialListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListReq} PlayerTutorialListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTutorialListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTutorialListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerTutorialListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListReq} PlayerTutorialListReq
                     */
                    PlayerTutorialListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTutorialListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.PlayerTutorialListReq();
                    };

                    /**
                     * Creates a plain object from a PlayerTutorialListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTutorialListReq} message PlayerTutorialListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTutorialListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this PlayerTutorialListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTutorialListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTutorialListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTutorialListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTutorialListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10700 COMMAND_NO value
                     */
                    PlayerTutorialListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10700] = "COMMAND_NO"] = 10700;
                        return values;
                    })();

                    return PlayerTutorialListReq;
                })();

                web.PlayerTutorialListResp = (function() {

                    /**
                     * Properties of a PlayerTutorialListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTutorialListResp
                     * @property {kuma.jp.protobuf.web.PlayerTutorialListResp.Status|null} [status] PlayerTutorialListResp status
                     * @property {boolean|null} [site] PlayerTutorialListResp site
                     * @property {boolean|null} [home] PlayerTutorialListResp home
                     * @property {boolean|null} [puriDl] PlayerTutorialListResp puriDl
                     * @property {boolean|null} [album] PlayerTutorialListResp album
                     * @property {boolean|null} [digitalPass] PlayerTutorialListResp digitalPass
                     * @property {boolean|null} [setting] PlayerTutorialListResp setting
                     */

                    /**
                     * Constructs a new PlayerTutorialListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTutorialListResp.
                     * @implements IPlayerTutorialListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListResp=} [properties] Properties to set
                     */
                    function PlayerTutorialListResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerTutorialListResp status.
                     * @member {kuma.jp.protobuf.web.PlayerTutorialListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.status = 0;

                    /**
                     * PlayerTutorialListResp site.
                     * @member {boolean} site
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.site = false;

                    /**
                     * PlayerTutorialListResp home.
                     * @member {boolean} home
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.home = false;

                    /**
                     * PlayerTutorialListResp puriDl.
                     * @member {boolean} puriDl
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.puriDl = false;

                    /**
                     * PlayerTutorialListResp album.
                     * @member {boolean} album
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.album = false;

                    /**
                     * PlayerTutorialListResp digitalPass.
                     * @member {boolean} digitalPass
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.digitalPass = false;

                    /**
                     * PlayerTutorialListResp setting.
                     * @member {boolean} setting
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     */
                    PlayerTutorialListResp.prototype.setting = false;

                    /**
                     * Creates a new PlayerTutorialListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListResp} PlayerTutorialListResp instance
                     */
                    PlayerTutorialListResp.create = function create(properties) {
                        return new PlayerTutorialListResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerTutorialListResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListResp} message PlayerTutorialListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.site != null && Object.hasOwnProperty.call(message, "site"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.site);
                        if (message.home != null && Object.hasOwnProperty.call(message, "home"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.home);
                        if (message.puriDl != null && Object.hasOwnProperty.call(message, "puriDl"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.puriDl);
                        if (message.album != null && Object.hasOwnProperty.call(message, "album"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.album);
                        if (message.digitalPass != null && Object.hasOwnProperty.call(message, "digitalPass"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.digitalPass);
                        if (message.setting != null && Object.hasOwnProperty.call(message, "setting"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.setting);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTutorialListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialListResp} message PlayerTutorialListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTutorialListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListResp} PlayerTutorialListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTutorialListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.site = reader.bool();
                                    break;
                                }
                            case 3: {
                                    message.home = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.puriDl = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.album = reader.bool();
                                    break;
                                }
                            case 6: {
                                    message.digitalPass = reader.bool();
                                    break;
                                }
                            case 7: {
                                    message.setting = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTutorialListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListResp} PlayerTutorialListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTutorialListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTutorialListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.site != null && message.hasOwnProperty("site"))
                            if (typeof message.site !== "boolean")
                                return "site: boolean expected";
                        if (message.home != null && message.hasOwnProperty("home"))
                            if (typeof message.home !== "boolean")
                                return "home: boolean expected";
                        if (message.puriDl != null && message.hasOwnProperty("puriDl"))
                            if (typeof message.puriDl !== "boolean")
                                return "puriDl: boolean expected";
                        if (message.album != null && message.hasOwnProperty("album"))
                            if (typeof message.album !== "boolean")
                                return "album: boolean expected";
                        if (message.digitalPass != null && message.hasOwnProperty("digitalPass"))
                            if (typeof message.digitalPass !== "boolean")
                                return "digitalPass: boolean expected";
                        if (message.setting != null && message.hasOwnProperty("setting"))
                            if (typeof message.setting !== "boolean")
                                return "setting: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerTutorialListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialListResp} PlayerTutorialListResp
                     */
                    PlayerTutorialListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTutorialListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerTutorialListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.site != null)
                            message.site = Boolean(object.site);
                        if (object.home != null)
                            message.home = Boolean(object.home);
                        if (object.puriDl != null)
                            message.puriDl = Boolean(object.puriDl);
                        if (object.album != null)
                            message.album = Boolean(object.album);
                        if (object.digitalPass != null)
                            message.digitalPass = Boolean(object.digitalPass);
                        if (object.setting != null)
                            message.setting = Boolean(object.setting);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerTutorialListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTutorialListResp} message PlayerTutorialListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTutorialListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.site = false;
                            object.home = false;
                            object.puriDl = false;
                            object.album = false;
                            object.digitalPass = false;
                            object.setting = false;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerTutorialListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerTutorialListResp.Status[message.status] : message.status;
                        if (message.site != null && message.hasOwnProperty("site"))
                            object.site = message.site;
                        if (message.home != null && message.hasOwnProperty("home"))
                            object.home = message.home;
                        if (message.puriDl != null && message.hasOwnProperty("puriDl"))
                            object.puriDl = message.puriDl;
                        if (message.album != null && message.hasOwnProperty("album"))
                            object.album = message.album;
                        if (message.digitalPass != null && message.hasOwnProperty("digitalPass"))
                            object.digitalPass = message.digitalPass;
                        if (message.setting != null && message.hasOwnProperty("setting"))
                            object.setting = message.setting;
                        return object;
                    };

                    /**
                     * Converts this PlayerTutorialListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTutorialListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTutorialListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTutorialListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTutorialListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10701 COMMAND_NO value
                     */
                    PlayerTutorialListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10701] = "COMMAND_NO"] = 10701;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerTutorialListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerTutorialListResp;
                })();

                web.PlayerTutorialShowReq = (function() {

                    /**
                     * Properties of a PlayerTutorialShowReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTutorialShowReq
                     * @property {Array.<kuma.jp.protobuf.web.PlayerTutorialShowReq.Page>|null} [page] PlayerTutorialShowReq page
                     */

                    /**
                     * Constructs a new PlayerTutorialShowReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTutorialShowReq.
                     * @implements IPlayerTutorialShowReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowReq=} [properties] Properties to set
                     */
                    function PlayerTutorialShowReq(properties) {
                        this.page = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerTutorialShowReq page.
                     * @member {Array.<kuma.jp.protobuf.web.PlayerTutorialShowReq.Page>} page
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @instance
                     */
                    PlayerTutorialShowReq.prototype.page = $util.emptyArray;

                    /**
                     * Creates a new PlayerTutorialShowReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowReq} PlayerTutorialShowReq instance
                     */
                    PlayerTutorialShowReq.create = function create(properties) {
                        return new PlayerTutorialShowReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerTutorialShowReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialShowReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowReq} message PlayerTutorialShowReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialShowReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.page != null && message.page.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (let i = 0; i < message.page.length; ++i)
                                writer.int32(message.page[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTutorialShowReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialShowReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowReq} message PlayerTutorialShowReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialShowReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTutorialShowReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowReq} PlayerTutorialShowReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialShowReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTutorialShowReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.page && message.page.length))
                                        message.page = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.page.push(reader.int32());
                                    } else
                                        message.page.push(reader.int32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTutorialShowReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowReq} PlayerTutorialShowReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialShowReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTutorialShowReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTutorialShowReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.page != null && message.hasOwnProperty("page")) {
                            if (!Array.isArray(message.page))
                                return "page: array expected";
                            for (let i = 0; i < message.page.length; ++i)
                                switch (message.page[i]) {
                                default:
                                    return "page: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                        }
                        return null;
                    };

                    /**
                     * Creates a PlayerTutorialShowReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowReq} PlayerTutorialShowReq
                     */
                    PlayerTutorialShowReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTutorialShowReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerTutorialShowReq();
                        if (object.page) {
                            if (!Array.isArray(object.page))
                                throw TypeError(".kuma.jp.protobuf.web.PlayerTutorialShowReq.page: array expected");
                            message.page = [];
                            for (let i = 0; i < object.page.length; ++i)
                                switch (object.page[i]) {
                                default:
                                    if (typeof object.page[i] === "number") {
                                        message.page[i] = object.page[i];
                                        break;
                                    }
                                    break;
                                case "SITE":
                                case 0:
                                    message.page[i] = 0;
                                    break;
                                case "HOME":
                                case 1:
                                    message.page[i] = 1;
                                    break;
                                case "PURIDL":
                                case 2:
                                    message.page[i] = 2;
                                    break;
                                case "ALBUM":
                                case 3:
                                    message.page[i] = 3;
                                    break;
                                case "DIGITAL_PASS":
                                case 4:
                                    message.page[i] = 4;
                                    break;
                                case "SETTING":
                                case 5:
                                    message.page[i] = 5;
                                    break;
                                }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerTutorialShowReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTutorialShowReq} message PlayerTutorialShowReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTutorialShowReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.page = [];
                        if (message.page && message.page.length) {
                            object.page = [];
                            for (let j = 0; j < message.page.length; ++j)
                                object.page[j] = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerTutorialShowReq.Page[message.page[j]] === undefined ? message.page[j] : $root.kuma.jp.protobuf.web.PlayerTutorialShowReq.Page[message.page[j]] : message.page[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this PlayerTutorialShowReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTutorialShowReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTutorialShowReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTutorialShowReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTutorialShowReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialShowReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10702 COMMAND_NO value
                     */
                    PlayerTutorialShowReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10702] = "COMMAND_NO"] = 10702;
                        return values;
                    })();

                    /**
                     * Page enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialShowReq.Page
                     * @enum {number}
                     * @property {number} SITE=0 SITE value
                     * @property {number} HOME=1 HOME value
                     * @property {number} PURIDL=2 PURIDL value
                     * @property {number} ALBUM=3 ALBUM value
                     * @property {number} DIGITAL_PASS=4 DIGITAL_PASS value
                     * @property {number} SETTING=5 SETTING value
                     */
                    PlayerTutorialShowReq.Page = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SITE"] = 0;
                        values[valuesById[1] = "HOME"] = 1;
                        values[valuesById[2] = "PURIDL"] = 2;
                        values[valuesById[3] = "ALBUM"] = 3;
                        values[valuesById[4] = "DIGITAL_PASS"] = 4;
                        values[valuesById[5] = "SETTING"] = 5;
                        return values;
                    })();

                    return PlayerTutorialShowReq;
                })();

                web.PlayerTutorialShowResp = (function() {

                    /**
                     * Properties of a PlayerTutorialShowResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTutorialShowResp
                     * @property {kuma.jp.protobuf.web.PlayerTutorialShowResp.Status|null} [status] PlayerTutorialShowResp status
                     */

                    /**
                     * Constructs a new PlayerTutorialShowResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTutorialShowResp.
                     * @implements IPlayerTutorialShowResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowResp=} [properties] Properties to set
                     */
                    function PlayerTutorialShowResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerTutorialShowResp status.
                     * @member {kuma.jp.protobuf.web.PlayerTutorialShowResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @instance
                     */
                    PlayerTutorialShowResp.prototype.status = 0;

                    /**
                     * Creates a new PlayerTutorialShowResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowResp} PlayerTutorialShowResp instance
                     */
                    PlayerTutorialShowResp.create = function create(properties) {
                        return new PlayerTutorialShowResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerTutorialShowResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialShowResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowResp} message PlayerTutorialShowResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialShowResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTutorialShowResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTutorialShowResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTutorialShowResp} message PlayerTutorialShowResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTutorialShowResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTutorialShowResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowResp} PlayerTutorialShowResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialShowResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTutorialShowResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTutorialShowResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowResp} PlayerTutorialShowResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTutorialShowResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTutorialShowResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTutorialShowResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a PlayerTutorialShowResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTutorialShowResp} PlayerTutorialShowResp
                     */
                    PlayerTutorialShowResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTutorialShowResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerTutorialShowResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerTutorialShowResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTutorialShowResp} message PlayerTutorialShowResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTutorialShowResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerTutorialShowResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerTutorialShowResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this PlayerTutorialShowResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTutorialShowResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTutorialShowResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTutorialShowResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTutorialShowResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTutorialShowResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialShowResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10703 COMMAND_NO value
                     */
                    PlayerTutorialShowResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10703] = "COMMAND_NO"] = 10703;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerTutorialShowResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerTutorialShowResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerTutorialShowResp;
                })();

                web.PlayerTwitterTokenReq = (function() {

                    /**
                     * Properties of a PlayerTwitterTokenReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTwitterTokenReq
                     * @property {string|null} [token] PlayerTwitterTokenReq token
                     * @property {string|null} [verifier] PlayerTwitterTokenReq verifier
                     */

                    /**
                     * Constructs a new PlayerTwitterTokenReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTwitterTokenReq.
                     * @implements IPlayerTwitterTokenReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenReq=} [properties] Properties to set
                     */
                    function PlayerTwitterTokenReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerTwitterTokenReq token.
                     * @member {string} token
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @instance
                     */
                    PlayerTwitterTokenReq.prototype.token = "";

                    /**
                     * PlayerTwitterTokenReq verifier.
                     * @member {string} verifier
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @instance
                     */
                    PlayerTwitterTokenReq.prototype.verifier = "";

                    /**
                     * Creates a new PlayerTwitterTokenReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenReq} PlayerTwitterTokenReq instance
                     */
                    PlayerTwitterTokenReq.create = function create(properties) {
                        return new PlayerTwitterTokenReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerTwitterTokenReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTwitterTokenReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenReq} message PlayerTwitterTokenReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTwitterTokenReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                        if (message.verifier != null && Object.hasOwnProperty.call(message, "verifier"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.verifier);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTwitterTokenReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTwitterTokenReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenReq} message PlayerTwitterTokenReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTwitterTokenReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTwitterTokenReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenReq} PlayerTwitterTokenReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTwitterTokenReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTwitterTokenReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.token = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.verifier = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTwitterTokenReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenReq} PlayerTwitterTokenReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTwitterTokenReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTwitterTokenReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTwitterTokenReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!$util.isString(message.token))
                                return "token: string expected";
                        if (message.verifier != null && message.hasOwnProperty("verifier"))
                            if (!$util.isString(message.verifier))
                                return "verifier: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerTwitterTokenReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenReq} PlayerTwitterTokenReq
                     */
                    PlayerTwitterTokenReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTwitterTokenReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerTwitterTokenReq();
                        if (object.token != null)
                            message.token = String(object.token);
                        if (object.verifier != null)
                            message.verifier = String(object.verifier);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerTwitterTokenReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTwitterTokenReq} message PlayerTwitterTokenReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTwitterTokenReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.token = "";
                            object.verifier = "";
                        }
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = message.token;
                        if (message.verifier != null && message.hasOwnProperty("verifier"))
                            object.verifier = message.verifier;
                        return object;
                    };

                    /**
                     * Converts this PlayerTwitterTokenReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTwitterTokenReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTwitterTokenReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTwitterTokenReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTwitterTokenReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTwitterTokenReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10404 COMMAND_NO value
                     */
                    PlayerTwitterTokenReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10404] = "COMMAND_NO"] = 10404;
                        return values;
                    })();

                    return PlayerTwitterTokenReq;
                })();

                web.PlayerTwitterTokenResp = (function() {

                    /**
                     * Properties of a PlayerTwitterTokenResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerTwitterTokenResp
                     * @property {kuma.jp.protobuf.web.PlayerTwitterTokenResp.Status|null} [status] PlayerTwitterTokenResp status
                     * @property {string|null} [token] PlayerTwitterTokenResp token
                     * @property {string|null} [tokenSecret] PlayerTwitterTokenResp tokenSecret
                     * @property {string|null} [userId] PlayerTwitterTokenResp userId
                     * @property {string|null} [screenName] PlayerTwitterTokenResp screenName
                     */

                    /**
                     * Constructs a new PlayerTwitterTokenResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerTwitterTokenResp.
                     * @implements IPlayerTwitterTokenResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenResp=} [properties] Properties to set
                     */
                    function PlayerTwitterTokenResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerTwitterTokenResp status.
                     * @member {kuma.jp.protobuf.web.PlayerTwitterTokenResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     */
                    PlayerTwitterTokenResp.prototype.status = 0;

                    /**
                     * PlayerTwitterTokenResp token.
                     * @member {string} token
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     */
                    PlayerTwitterTokenResp.prototype.token = "";

                    /**
                     * PlayerTwitterTokenResp tokenSecret.
                     * @member {string} tokenSecret
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     */
                    PlayerTwitterTokenResp.prototype.tokenSecret = "";

                    /**
                     * PlayerTwitterTokenResp userId.
                     * @member {string} userId
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     */
                    PlayerTwitterTokenResp.prototype.userId = "";

                    /**
                     * PlayerTwitterTokenResp screenName.
                     * @member {string} screenName
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     */
                    PlayerTwitterTokenResp.prototype.screenName = "";

                    /**
                     * Creates a new PlayerTwitterTokenResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenResp} PlayerTwitterTokenResp instance
                     */
                    PlayerTwitterTokenResp.create = function create(properties) {
                        return new PlayerTwitterTokenResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerTwitterTokenResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTwitterTokenResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenResp} message PlayerTwitterTokenResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTwitterTokenResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                        if (message.tokenSecret != null && Object.hasOwnProperty.call(message, "tokenSecret"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.tokenSecret);
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
                        if (message.screenName != null && Object.hasOwnProperty.call(message, "screenName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.screenName);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerTwitterTokenResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerTwitterTokenResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerTwitterTokenResp} message PlayerTwitterTokenResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerTwitterTokenResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerTwitterTokenResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenResp} PlayerTwitterTokenResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTwitterTokenResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerTwitterTokenResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.token = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.tokenSecret = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.userId = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.screenName = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerTwitterTokenResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenResp} PlayerTwitterTokenResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerTwitterTokenResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerTwitterTokenResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerTwitterTokenResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!$util.isString(message.token))
                                return "token: string expected";
                        if (message.tokenSecret != null && message.hasOwnProperty("tokenSecret"))
                            if (!$util.isString(message.tokenSecret))
                                return "tokenSecret: string expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isString(message.userId))
                                return "userId: string expected";
                        if (message.screenName != null && message.hasOwnProperty("screenName"))
                            if (!$util.isString(message.screenName))
                                return "screenName: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerTwitterTokenResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerTwitterTokenResp} PlayerTwitterTokenResp
                     */
                    PlayerTwitterTokenResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerTwitterTokenResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerTwitterTokenResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.token != null)
                            message.token = String(object.token);
                        if (object.tokenSecret != null)
                            message.tokenSecret = String(object.tokenSecret);
                        if (object.userId != null)
                            message.userId = String(object.userId);
                        if (object.screenName != null)
                            message.screenName = String(object.screenName);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerTwitterTokenResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerTwitterTokenResp} message PlayerTwitterTokenResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerTwitterTokenResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.token = "";
                            object.tokenSecret = "";
                            object.userId = "";
                            object.screenName = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerTwitterTokenResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerTwitterTokenResp.Status[message.status] : message.status;
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = message.token;
                        if (message.tokenSecret != null && message.hasOwnProperty("tokenSecret"))
                            object.tokenSecret = message.tokenSecret;
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            object.userId = message.userId;
                        if (message.screenName != null && message.hasOwnProperty("screenName"))
                            object.screenName = message.screenName;
                        return object;
                    };

                    /**
                     * Converts this PlayerTwitterTokenResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerTwitterTokenResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerTwitterTokenResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerTwitterTokenResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerTwitterTokenResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerTwitterTokenResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerTwitterTokenResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10405 COMMAND_NO value
                     */
                    PlayerTwitterTokenResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10405] = "COMMAND_NO"] = 10405;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerTwitterTokenResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerTwitterTokenResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerTwitterTokenResp;
                })();

                web.PlayerUnsubscribeReq = (function() {

                    /**
                     * Properties of a PlayerUnsubscribeReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUnsubscribeReq
                     */

                    /**
                     * Constructs a new PlayerUnsubscribeReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUnsubscribeReq.
                     * @implements IPlayerUnsubscribeReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeReq=} [properties] Properties to set
                     */
                    function PlayerUnsubscribeReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new PlayerUnsubscribeReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeReq} PlayerUnsubscribeReq instance
                     */
                    PlayerUnsubscribeReq.create = function create(properties) {
                        return new PlayerUnsubscribeReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerUnsubscribeReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUnsubscribeReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeReq} message PlayerUnsubscribeReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUnsubscribeReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUnsubscribeReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUnsubscribeReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeReq} message PlayerUnsubscribeReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUnsubscribeReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUnsubscribeReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeReq} PlayerUnsubscribeReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUnsubscribeReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUnsubscribeReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUnsubscribeReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeReq} PlayerUnsubscribeReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUnsubscribeReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUnsubscribeReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUnsubscribeReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerUnsubscribeReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeReq} PlayerUnsubscribeReq
                     */
                    PlayerUnsubscribeReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUnsubscribeReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.PlayerUnsubscribeReq();
                    };

                    /**
                     * Creates a plain object from a PlayerUnsubscribeReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUnsubscribeReq} message PlayerUnsubscribeReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUnsubscribeReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this PlayerUnsubscribeReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUnsubscribeReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUnsubscribeReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUnsubscribeReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUnsubscribeReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUnsubscribeReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10500 COMMAND_NO value
                     */
                    PlayerUnsubscribeReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10500] = "COMMAND_NO"] = 10500;
                        return values;
                    })();

                    return PlayerUnsubscribeReq;
                })();

                web.PlayerUnsubscribeResp = (function() {

                    /**
                     * Properties of a PlayerUnsubscribeResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUnsubscribeResp
                     * @property {kuma.jp.protobuf.web.PlayerUnsubscribeResp.Status|null} [status] PlayerUnsubscribeResp status
                     */

                    /**
                     * Constructs a new PlayerUnsubscribeResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUnsubscribeResp.
                     * @implements IPlayerUnsubscribeResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeResp=} [properties] Properties to set
                     */
                    function PlayerUnsubscribeResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerUnsubscribeResp status.
                     * @member {kuma.jp.protobuf.web.PlayerUnsubscribeResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @instance
                     */
                    PlayerUnsubscribeResp.prototype.status = 0;

                    /**
                     * Creates a new PlayerUnsubscribeResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeResp} PlayerUnsubscribeResp instance
                     */
                    PlayerUnsubscribeResp.create = function create(properties) {
                        return new PlayerUnsubscribeResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerUnsubscribeResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUnsubscribeResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeResp} message PlayerUnsubscribeResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUnsubscribeResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUnsubscribeResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUnsubscribeResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUnsubscribeResp} message PlayerUnsubscribeResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUnsubscribeResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUnsubscribeResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeResp} PlayerUnsubscribeResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUnsubscribeResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUnsubscribeResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUnsubscribeResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeResp} PlayerUnsubscribeResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUnsubscribeResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUnsubscribeResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUnsubscribeResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a PlayerUnsubscribeResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUnsubscribeResp} PlayerUnsubscribeResp
                     */
                    PlayerUnsubscribeResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUnsubscribeResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerUnsubscribeResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerUnsubscribeResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUnsubscribeResp} message PlayerUnsubscribeResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUnsubscribeResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerUnsubscribeResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerUnsubscribeResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this PlayerUnsubscribeResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUnsubscribeResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUnsubscribeResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUnsubscribeResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUnsubscribeResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUnsubscribeResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUnsubscribeResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10501 COMMAND_NO value
                     */
                    PlayerUnsubscribeResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10501] = "COMMAND_NO"] = 10501;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerUnsubscribeResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerUnsubscribeResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerUnsubscribeResp;
                })();

                web.PlayerUpdateInfoReq = (function() {

                    /**
                     * Properties of a PlayerUpdateInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUpdateInfoReq
                     * @property {kuma.jp.protobuf.web.PlayerUpdateInfoReq.UpdateType|null} [updateType] PlayerUpdateInfoReq updateType
                     * @property {string|null} [password] PlayerUpdateInfoReq password
                     * @property {string|null} [nickname] PlayerUpdateInfoReq nickname
                     * @property {number|null} [birthYear] PlayerUpdateInfoReq birthYear
                     * @property {number|null} [birthMonth] PlayerUpdateInfoReq birthMonth
                     * @property {string|null} [mailAddress] PlayerUpdateInfoReq mailAddress
                     * @property {string|null} [twitterUserId] PlayerUpdateInfoReq twitterUserId
                     * @property {string|null} [twitterAccessToken] PlayerUpdateInfoReq twitterAccessToken
                     * @property {string|null} [twitterAccessTokenSecret] PlayerUpdateInfoReq twitterAccessTokenSecret
                     * @property {string|null} [lineUserId] PlayerUpdateInfoReq lineUserId
                     * @property {string|null} [lineAccessToken] PlayerUpdateInfoReq lineAccessToken
                     */

                    /**
                     * Constructs a new PlayerUpdateInfoReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUpdateInfoReq.
                     * @implements IPlayerUpdateInfoReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoReq=} [properties] Properties to set
                     */
                    function PlayerUpdateInfoReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerUpdateInfoReq updateType.
                     * @member {kuma.jp.protobuf.web.PlayerUpdateInfoReq.UpdateType} updateType
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.updateType = 0;

                    /**
                     * PlayerUpdateInfoReq password.
                     * @member {string} password
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.password = "";

                    /**
                     * PlayerUpdateInfoReq nickname.
                     * @member {string} nickname
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.nickname = "";

                    /**
                     * PlayerUpdateInfoReq birthYear.
                     * @member {number} birthYear
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.birthYear = 0;

                    /**
                     * PlayerUpdateInfoReq birthMonth.
                     * @member {number} birthMonth
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.birthMonth = 0;

                    /**
                     * PlayerUpdateInfoReq mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.mailAddress = "";

                    /**
                     * PlayerUpdateInfoReq twitterUserId.
                     * @member {string} twitterUserId
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.twitterUserId = "";

                    /**
                     * PlayerUpdateInfoReq twitterAccessToken.
                     * @member {string} twitterAccessToken
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.twitterAccessToken = "";

                    /**
                     * PlayerUpdateInfoReq twitterAccessTokenSecret.
                     * @member {string} twitterAccessTokenSecret
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.twitterAccessTokenSecret = "";

                    /**
                     * PlayerUpdateInfoReq lineUserId.
                     * @member {string} lineUserId
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.lineUserId = "";

                    /**
                     * PlayerUpdateInfoReq lineAccessToken.
                     * @member {string} lineAccessToken
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     */
                    PlayerUpdateInfoReq.prototype.lineAccessToken = "";

                    /**
                     * Creates a new PlayerUpdateInfoReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoReq} PlayerUpdateInfoReq instance
                     */
                    PlayerUpdateInfoReq.create = function create(properties) {
                        return new PlayerUpdateInfoReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerUpdateInfoReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateInfoReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoReq} message PlayerUpdateInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateInfoReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.updateType != null && Object.hasOwnProperty.call(message, "updateType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.updateType);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
                        if (message.birthYear != null && Object.hasOwnProperty.call(message, "birthYear"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.birthYear);
                        if (message.birthMonth != null && Object.hasOwnProperty.call(message, "birthMonth"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.birthMonth);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.mailAddress);
                        if (message.twitterUserId != null && Object.hasOwnProperty.call(message, "twitterUserId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.twitterUserId);
                        if (message.twitterAccessToken != null && Object.hasOwnProperty.call(message, "twitterAccessToken"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.twitterAccessToken);
                        if (message.twitterAccessTokenSecret != null && Object.hasOwnProperty.call(message, "twitterAccessTokenSecret"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.twitterAccessTokenSecret);
                        if (message.lineUserId != null && Object.hasOwnProperty.call(message, "lineUserId"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.lineUserId);
                        if (message.lineAccessToken != null && Object.hasOwnProperty.call(message, "lineAccessToken"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.lineAccessToken);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUpdateInfoReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateInfoReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoReq} message PlayerUpdateInfoReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateInfoReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUpdateInfoReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoReq} PlayerUpdateInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateInfoReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUpdateInfoReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.updateType = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.password = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.birthYear = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.birthMonth = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.twitterUserId = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.twitterAccessToken = reader.string();
                                    break;
                                }
                            case 9: {
                                    message.twitterAccessTokenSecret = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.lineUserId = reader.string();
                                    break;
                                }
                            case 11: {
                                    message.lineAccessToken = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUpdateInfoReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoReq} PlayerUpdateInfoReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateInfoReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUpdateInfoReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUpdateInfoReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.updateType != null && message.hasOwnProperty("updateType"))
                            switch (message.updateType) {
                            default:
                                return "updateType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            if (!$util.isInteger(message.birthYear))
                                return "birthYear: integer expected";
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            if (!$util.isInteger(message.birthMonth))
                                return "birthMonth: integer expected";
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            if (!$util.isString(message.twitterUserId))
                                return "twitterUserId: string expected";
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            if (!$util.isString(message.twitterAccessToken))
                                return "twitterAccessToken: string expected";
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            if (!$util.isString(message.twitterAccessTokenSecret))
                                return "twitterAccessTokenSecret: string expected";
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            if (!$util.isString(message.lineUserId))
                                return "lineUserId: string expected";
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            if (!$util.isString(message.lineAccessToken))
                                return "lineAccessToken: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerUpdateInfoReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoReq} PlayerUpdateInfoReq
                     */
                    PlayerUpdateInfoReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUpdateInfoReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerUpdateInfoReq();
                        switch (object.updateType) {
                        default:
                            if (typeof object.updateType === "number") {
                                message.updateType = object.updateType;
                                break;
                            }
                            break;
                        case "PASSWORD":
                        case 0:
                            message.updateType = 0;
                            break;
                        case "NICK_NAME":
                        case 1:
                            message.updateType = 1;
                            break;
                        case "BIRTH_DATE":
                        case 2:
                            message.updateType = 2;
                            break;
                        case "MAIL_ADDRESS":
                        case 3:
                            message.updateType = 3;
                            break;
                        case "TWITTER":
                        case 4:
                            message.updateType = 4;
                            break;
                        case "LINE":
                        case 5:
                            message.updateType = 5;
                            break;
                        }
                        if (object.password != null)
                            message.password = String(object.password);
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.birthYear != null)
                            message.birthYear = object.birthYear | 0;
                        if (object.birthMonth != null)
                            message.birthMonth = object.birthMonth | 0;
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        if (object.twitterUserId != null)
                            message.twitterUserId = String(object.twitterUserId);
                        if (object.twitterAccessToken != null)
                            message.twitterAccessToken = String(object.twitterAccessToken);
                        if (object.twitterAccessTokenSecret != null)
                            message.twitterAccessTokenSecret = String(object.twitterAccessTokenSecret);
                        if (object.lineUserId != null)
                            message.lineUserId = String(object.lineUserId);
                        if (object.lineAccessToken != null)
                            message.lineAccessToken = String(object.lineAccessToken);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerUpdateInfoReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUpdateInfoReq} message PlayerUpdateInfoReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUpdateInfoReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.updateType = options.enums === String ? "PASSWORD" : 0;
                            object.password = "";
                            object.nickname = "";
                            object.birthYear = 0;
                            object.birthMonth = 0;
                            object.mailAddress = "";
                            object.twitterUserId = "";
                            object.twitterAccessToken = "";
                            object.twitterAccessTokenSecret = "";
                            object.lineUserId = "";
                            object.lineAccessToken = "";
                        }
                        if (message.updateType != null && message.hasOwnProperty("updateType"))
                            object.updateType = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerUpdateInfoReq.UpdateType[message.updateType] === undefined ? message.updateType : $root.kuma.jp.protobuf.web.PlayerUpdateInfoReq.UpdateType[message.updateType] : message.updateType;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.birthYear != null && message.hasOwnProperty("birthYear"))
                            object.birthYear = message.birthYear;
                        if (message.birthMonth != null && message.hasOwnProperty("birthMonth"))
                            object.birthMonth = message.birthMonth;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        if (message.twitterUserId != null && message.hasOwnProperty("twitterUserId"))
                            object.twitterUserId = message.twitterUserId;
                        if (message.twitterAccessToken != null && message.hasOwnProperty("twitterAccessToken"))
                            object.twitterAccessToken = message.twitterAccessToken;
                        if (message.twitterAccessTokenSecret != null && message.hasOwnProperty("twitterAccessTokenSecret"))
                            object.twitterAccessTokenSecret = message.twitterAccessTokenSecret;
                        if (message.lineUserId != null && message.hasOwnProperty("lineUserId"))
                            object.lineUserId = message.lineUserId;
                        if (message.lineAccessToken != null && message.hasOwnProperty("lineAccessToken"))
                            object.lineAccessToken = message.lineAccessToken;
                        return object;
                    };

                    /**
                     * Converts this PlayerUpdateInfoReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUpdateInfoReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUpdateInfoReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUpdateInfoReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUpdateInfoReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateInfoReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10402 COMMAND_NO value
                     */
                    PlayerUpdateInfoReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10402] = "COMMAND_NO"] = 10402;
                        return values;
                    })();

                    /**
                     * UpdateType enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateInfoReq.UpdateType
                     * @enum {number}
                     * @property {number} PASSWORD=0 PASSWORD value
                     * @property {number} NICK_NAME=1 NICK_NAME value
                     * @property {number} BIRTH_DATE=2 BIRTH_DATE value
                     * @property {number} MAIL_ADDRESS=3 MAIL_ADDRESS value
                     * @property {number} TWITTER=4 TWITTER value
                     * @property {number} LINE=5 LINE value
                     */
                    PlayerUpdateInfoReq.UpdateType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PASSWORD"] = 0;
                        values[valuesById[1] = "NICK_NAME"] = 1;
                        values[valuesById[2] = "BIRTH_DATE"] = 2;
                        values[valuesById[3] = "MAIL_ADDRESS"] = 3;
                        values[valuesById[4] = "TWITTER"] = 4;
                        values[valuesById[5] = "LINE"] = 5;
                        return values;
                    })();

                    return PlayerUpdateInfoReq;
                })();

                web.PlayerUpdateInfoResp = (function() {

                    /**
                     * Properties of a PlayerUpdateInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUpdateInfoResp
                     * @property {kuma.jp.protobuf.web.PlayerUpdateInfoResp.Status|null} [status] PlayerUpdateInfoResp status
                     */

                    /**
                     * Constructs a new PlayerUpdateInfoResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUpdateInfoResp.
                     * @implements IPlayerUpdateInfoResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoResp=} [properties] Properties to set
                     */
                    function PlayerUpdateInfoResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerUpdateInfoResp status.
                     * @member {kuma.jp.protobuf.web.PlayerUpdateInfoResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @instance
                     */
                    PlayerUpdateInfoResp.prototype.status = 0;

                    /**
                     * Creates a new PlayerUpdateInfoResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoResp} PlayerUpdateInfoResp instance
                     */
                    PlayerUpdateInfoResp.create = function create(properties) {
                        return new PlayerUpdateInfoResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerUpdateInfoResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateInfoResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoResp} message PlayerUpdateInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateInfoResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUpdateInfoResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateInfoResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateInfoResp} message PlayerUpdateInfoResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateInfoResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUpdateInfoResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoResp} PlayerUpdateInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateInfoResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUpdateInfoResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUpdateInfoResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoResp} PlayerUpdateInfoResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateInfoResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUpdateInfoResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUpdateInfoResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a PlayerUpdateInfoResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateInfoResp} PlayerUpdateInfoResp
                     */
                    PlayerUpdateInfoResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUpdateInfoResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerUpdateInfoResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerUpdateInfoResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUpdateInfoResp} message PlayerUpdateInfoResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUpdateInfoResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerUpdateInfoResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerUpdateInfoResp.Status[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this PlayerUpdateInfoResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUpdateInfoResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUpdateInfoResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateInfoResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUpdateInfoResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUpdateInfoResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateInfoResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10403 COMMAND_NO value
                     */
                    PlayerUpdateInfoResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10403] = "COMMAND_NO"] = 10403;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateInfoResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PlayerUpdateInfoResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PlayerUpdateInfoResp;
                })();

                web.PlayerUpdateMailAddressReq = (function() {

                    /**
                     * Properties of a PlayerUpdateMailAddressReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUpdateMailAddressReq
                     * @property {string|null} [validateKey] PlayerUpdateMailAddressReq validateKey
                     * @property {string|null} [password] PlayerUpdateMailAddressReq password
                     */

                    /**
                     * Constructs a new PlayerUpdateMailAddressReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUpdateMailAddressReq.
                     * @implements IPlayerUpdateMailAddressReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressReq=} [properties] Properties to set
                     */
                    function PlayerUpdateMailAddressReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerUpdateMailAddressReq validateKey.
                     * @member {string} validateKey
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @instance
                     */
                    PlayerUpdateMailAddressReq.prototype.validateKey = "";

                    /**
                     * PlayerUpdateMailAddressReq password.
                     * @member {string} password
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @instance
                     */
                    PlayerUpdateMailAddressReq.prototype.password = "";

                    /**
                     * Creates a new PlayerUpdateMailAddressReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressReq} PlayerUpdateMailAddressReq instance
                     */
                    PlayerUpdateMailAddressReq.create = function create(properties) {
                        return new PlayerUpdateMailAddressReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerUpdateMailAddressReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateMailAddressReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressReq} message PlayerUpdateMailAddressReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateMailAddressReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.validateKey != null && Object.hasOwnProperty.call(message, "validateKey"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.validateKey);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUpdateMailAddressReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateMailAddressReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressReq} message PlayerUpdateMailAddressReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateMailAddressReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUpdateMailAddressReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressReq} PlayerUpdateMailAddressReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateMailAddressReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.validateKey = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.password = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUpdateMailAddressReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressReq} PlayerUpdateMailAddressReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateMailAddressReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUpdateMailAddressReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUpdateMailAddressReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            if (!$util.isString(message.validateKey))
                                return "validateKey: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerUpdateMailAddressReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressReq} PlayerUpdateMailAddressReq
                     */
                    PlayerUpdateMailAddressReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressReq();
                        if (object.validateKey != null)
                            message.validateKey = String(object.validateKey);
                        if (object.password != null)
                            message.password = String(object.password);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerUpdateMailAddressReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUpdateMailAddressReq} message PlayerUpdateMailAddressReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUpdateMailAddressReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.validateKey = "";
                            object.password = "";
                        }
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            object.validateKey = message.validateKey;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        return object;
                    };

                    /**
                     * Converts this PlayerUpdateMailAddressReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUpdateMailAddressReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUpdateMailAddressReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUpdateMailAddressReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUpdateMailAddressReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateMailAddressReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10410 COMMAND_NO value
                     */
                    PlayerUpdateMailAddressReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10410] = "COMMAND_NO"] = 10410;
                        return values;
                    })();

                    return PlayerUpdateMailAddressReq;
                })();

                web.PlayerUpdateMailAddressResp = (function() {

                    /**
                     * Properties of a PlayerUpdateMailAddressResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerUpdateMailAddressResp
                     * @property {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.Status|null} [status] PlayerUpdateMailAddressResp status
                     * @property {string|null} [mailAddress] PlayerUpdateMailAddressResp mailAddress
                     */

                    /**
                     * Constructs a new PlayerUpdateMailAddressResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerUpdateMailAddressResp.
                     * @implements IPlayerUpdateMailAddressResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressResp=} [properties] Properties to set
                     */
                    function PlayerUpdateMailAddressResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerUpdateMailAddressResp status.
                     * @member {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @instance
                     */
                    PlayerUpdateMailAddressResp.prototype.status = 0;

                    /**
                     * PlayerUpdateMailAddressResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @instance
                     */
                    PlayerUpdateMailAddressResp.prototype.mailAddress = "";

                    /**
                     * Creates a new PlayerUpdateMailAddressResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp} PlayerUpdateMailAddressResp instance
                     */
                    PlayerUpdateMailAddressResp.create = function create(properties) {
                        return new PlayerUpdateMailAddressResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerUpdateMailAddressResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressResp} message PlayerUpdateMailAddressResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateMailAddressResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mailAddress);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerUpdateMailAddressResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerUpdateMailAddressResp} message PlayerUpdateMailAddressResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerUpdateMailAddressResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerUpdateMailAddressResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp} PlayerUpdateMailAddressResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateMailAddressResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerUpdateMailAddressResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp} PlayerUpdateMailAddressResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerUpdateMailAddressResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerUpdateMailAddressResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerUpdateMailAddressResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerUpdateMailAddressResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp} PlayerUpdateMailAddressResp
                     */
                    PlayerUpdateMailAddressResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "EXPIRED":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerUpdateMailAddressResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerUpdateMailAddressResp} message PlayerUpdateMailAddressResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerUpdateMailAddressResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.mailAddress = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.Status[message.status] : message.status;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        return object;
                    };

                    /**
                     * Converts this PlayerUpdateMailAddressResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerUpdateMailAddressResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerUpdateMailAddressResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerUpdateMailAddressResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerUpdateMailAddressResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerUpdateMailAddressResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10411 COMMAND_NO value
                     */
                    PlayerUpdateMailAddressResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10411] = "COMMAND_NO"] = 10411;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerUpdateMailAddressResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} EXPIRED=2 EXPIRED value
                     */
                    PlayerUpdateMailAddressResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "EXPIRED"] = 2;
                        return values;
                    })();

                    return PlayerUpdateMailAddressResp;
                })();

                web.PlayerValidateKeyCheckReq = (function() {

                    /**
                     * Properties of a PlayerValidateKeyCheckReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerValidateKeyCheckReq
                     * @property {string|null} [validateKey] PlayerValidateKeyCheckReq validateKey
                     */

                    /**
                     * Constructs a new PlayerValidateKeyCheckReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerValidateKeyCheckReq.
                     * @implements IPlayerValidateKeyCheckReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckReq=} [properties] Properties to set
                     */
                    function PlayerValidateKeyCheckReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerValidateKeyCheckReq validateKey.
                     * @member {string} validateKey
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @instance
                     */
                    PlayerValidateKeyCheckReq.prototype.validateKey = "";

                    /**
                     * Creates a new PlayerValidateKeyCheckReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckReq} PlayerValidateKeyCheckReq instance
                     */
                    PlayerValidateKeyCheckReq.create = function create(properties) {
                        return new PlayerValidateKeyCheckReq(properties);
                    };

                    /**
                     * Encodes the specified PlayerValidateKeyCheckReq message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerValidateKeyCheckReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckReq} message PlayerValidateKeyCheckReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerValidateKeyCheckReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.validateKey != null && Object.hasOwnProperty.call(message, "validateKey"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.validateKey);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerValidateKeyCheckReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerValidateKeyCheckReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckReq} message PlayerValidateKeyCheckReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerValidateKeyCheckReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerValidateKeyCheckReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckReq} PlayerValidateKeyCheckReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerValidateKeyCheckReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.validateKey = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerValidateKeyCheckReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckReq} PlayerValidateKeyCheckReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerValidateKeyCheckReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerValidateKeyCheckReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerValidateKeyCheckReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            if (!$util.isString(message.validateKey))
                                return "validateKey: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerValidateKeyCheckReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckReq} PlayerValidateKeyCheckReq
                     */
                    PlayerValidateKeyCheckReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckReq();
                        if (object.validateKey != null)
                            message.validateKey = String(object.validateKey);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerValidateKeyCheckReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerValidateKeyCheckReq} message PlayerValidateKeyCheckReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerValidateKeyCheckReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.validateKey = "";
                        if (message.validateKey != null && message.hasOwnProperty("validateKey"))
                            object.validateKey = message.validateKey;
                        return object;
                    };

                    /**
                     * Converts this PlayerValidateKeyCheckReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerValidateKeyCheckReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerValidateKeyCheckReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerValidateKeyCheckReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerValidateKeyCheckReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerValidateKeyCheckReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10408 COMMAND_NO value
                     */
                    PlayerValidateKeyCheckReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10408] = "COMMAND_NO"] = 10408;
                        return values;
                    })();

                    return PlayerValidateKeyCheckReq;
                })();

                web.PlayerValidateKeyCheckResp = (function() {

                    /**
                     * Properties of a PlayerValidateKeyCheckResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPlayerValidateKeyCheckResp
                     * @property {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.Status|null} [status] PlayerValidateKeyCheckResp status
                     * @property {string|null} [mailAddress] PlayerValidateKeyCheckResp mailAddress
                     */

                    /**
                     * Constructs a new PlayerValidateKeyCheckResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PlayerValidateKeyCheckResp.
                     * @implements IPlayerValidateKeyCheckResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckResp=} [properties] Properties to set
                     */
                    function PlayerValidateKeyCheckResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerValidateKeyCheckResp status.
                     * @member {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @instance
                     */
                    PlayerValidateKeyCheckResp.prototype.status = 0;

                    /**
                     * PlayerValidateKeyCheckResp mailAddress.
                     * @member {string} mailAddress
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @instance
                     */
                    PlayerValidateKeyCheckResp.prototype.mailAddress = "";

                    /**
                     * Creates a new PlayerValidateKeyCheckResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp} PlayerValidateKeyCheckResp instance
                     */
                    PlayerValidateKeyCheckResp.create = function create(properties) {
                        return new PlayerValidateKeyCheckResp(properties);
                    };

                    /**
                     * Encodes the specified PlayerValidateKeyCheckResp message. Does not implicitly {@link kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckResp} message PlayerValidateKeyCheckResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerValidateKeyCheckResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.mailAddress != null && Object.hasOwnProperty.call(message, "mailAddress"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mailAddress);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerValidateKeyCheckResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPlayerValidateKeyCheckResp} message PlayerValidateKeyCheckResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerValidateKeyCheckResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerValidateKeyCheckResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp} PlayerValidateKeyCheckResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerValidateKeyCheckResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.mailAddress = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerValidateKeyCheckResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp} PlayerValidateKeyCheckResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerValidateKeyCheckResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerValidateKeyCheckResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerValidateKeyCheckResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            if (!$util.isString(message.mailAddress))
                                return "mailAddress: string expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerValidateKeyCheckResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp} PlayerValidateKeyCheckResp
                     */
                    PlayerValidateKeyCheckResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "EXPIRED":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.mailAddress != null)
                            message.mailAddress = String(object.mailAddress);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerValidateKeyCheckResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PlayerValidateKeyCheckResp} message PlayerValidateKeyCheckResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerValidateKeyCheckResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            object.mailAddress = "";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.Status[message.status] : message.status;
                        if (message.mailAddress != null && message.hasOwnProperty("mailAddress"))
                            object.mailAddress = message.mailAddress;
                        return object;
                    };

                    /**
                     * Converts this PlayerValidateKeyCheckResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerValidateKeyCheckResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerValidateKeyCheckResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PlayerValidateKeyCheckResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerValidateKeyCheckResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PlayerValidateKeyCheckResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=10409 COMMAND_NO value
                     */
                    PlayerValidateKeyCheckResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[10409] = "COMMAND_NO"] = 10409;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PlayerValidateKeyCheckResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} EXPIRED=2 EXPIRED value
                     */
                    PlayerValidateKeyCheckResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "EXPIRED"] = 2;
                        return values;
                    })();

                    return PlayerValidateKeyCheckResp;
                })();

                web.PuriContentListReq = (function() {

                    /**
                     * Properties of a PuriContentListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPuriContentListReq
                     * @property {number|Long|null} [id] PuriContentListReq id
                     */

                    /**
                     * Constructs a new PuriContentListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PuriContentListReq.
                     * @implements IPuriContentListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPuriContentListReq=} [properties] Properties to set
                     */
                    function PuriContentListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PuriContentListReq id.
                     * @member {number|Long} id
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @instance
                     */
                    PuriContentListReq.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new PuriContentListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PuriContentListReq} PuriContentListReq instance
                     */
                    PuriContentListReq.create = function create(properties) {
                        return new PuriContentListReq(properties);
                    };

                    /**
                     * Encodes the specified PuriContentListReq message. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListReq} message PuriContentListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };

                    /**
                     * Encodes the specified PuriContentListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListReq} message PuriContentListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PuriContentListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PuriContentListReq} PuriContentListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PuriContentListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PuriContentListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PuriContentListReq} PuriContentListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PuriContentListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PuriContentListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a PuriContentListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PuriContentListReq} PuriContentListReq
                     */
                    PuriContentListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PuriContentListReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PuriContentListReq();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a PuriContentListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PuriContentListReq} message PuriContentListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PuriContentListReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };

                    /**
                     * Converts this PuriContentListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PuriContentListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PuriContentListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PuriContentListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PuriContentListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PuriContentListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PuriContentListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20202 COMMAND_NO value
                     */
                    PuriContentListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20202] = "COMMAND_NO"] = 20202;
                        return values;
                    })();

                    return PuriContentListReq;
                })();

                web.PuriContentListResp = (function() {

                    /**
                     * Properties of a PuriContentListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPuriContentListResp
                     * @property {kuma.jp.protobuf.web.PuriContentListResp.Status|null} [status] PuriContentListResp status
                     * @property {Array.<kuma.jp.protobuf.web.PuriContentListResp.IPuriContent>|null} [puriList] PuriContentListResp puriList
                     */

                    /**
                     * Constructs a new PuriContentListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PuriContentListResp.
                     * @implements IPuriContentListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPuriContentListResp=} [properties] Properties to set
                     */
                    function PuriContentListResp(properties) {
                        this.puriList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PuriContentListResp status.
                     * @member {kuma.jp.protobuf.web.PuriContentListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @instance
                     */
                    PuriContentListResp.prototype.status = 0;

                    /**
                     * PuriContentListResp puriList.
                     * @member {Array.<kuma.jp.protobuf.web.PuriContentListResp.IPuriContent>} puriList
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @instance
                     */
                    PuriContentListResp.prototype.puriList = $util.emptyArray;

                    /**
                     * Creates a new PuriContentListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PuriContentListResp} PuriContentListResp instance
                     */
                    PuriContentListResp.create = function create(properties) {
                        return new PuriContentListResp(properties);
                    };

                    /**
                     * Encodes the specified PuriContentListResp message. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListResp} message PuriContentListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.puriList != null && message.puriList.length)
                            for (let i = 0; i < message.puriList.length; ++i)
                                $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent.encode(message.puriList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified PuriContentListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentListResp} message PuriContentListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PuriContentListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PuriContentListResp} PuriContentListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PuriContentListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.puriList && message.puriList.length))
                                        message.puriList = [];
                                    message.puriList.push($root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PuriContentListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PuriContentListResp} PuriContentListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PuriContentListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PuriContentListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.puriList != null && message.hasOwnProperty("puriList")) {
                            if (!Array.isArray(message.puriList))
                                return "puriList: array expected";
                            for (let i = 0; i < message.puriList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent.verify(message.puriList[i]);
                                if (error)
                                    return "puriList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a PuriContentListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PuriContentListResp} PuriContentListResp
                     */
                    PuriContentListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PuriContentListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PuriContentListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.puriList) {
                            if (!Array.isArray(object.puriList))
                                throw TypeError(".kuma.jp.protobuf.web.PuriContentListResp.puriList: array expected");
                            message.puriList = [];
                            for (let i = 0; i < object.puriList.length; ++i) {
                                if (typeof object.puriList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.PuriContentListResp.puriList: object expected");
                                message.puriList[i] = $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent.fromObject(object.puriList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a PuriContentListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PuriContentListResp} message PuriContentListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PuriContentListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.puriList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PuriContentListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PuriContentListResp.Status[message.status] : message.status;
                        if (message.puriList && message.puriList.length) {
                            object.puriList = [];
                            for (let j = 0; j < message.puriList.length; ++j)
                                object.puriList[j] = $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent.toObject(message.puriList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this PuriContentListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PuriContentListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PuriContentListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PuriContentListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PuriContentListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PuriContentListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PuriContentListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20203 COMMAND_NO value
                     */
                    PuriContentListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20203] = "COMMAND_NO"] = 20203;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PuriContentListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PuriContentListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    PuriContentListResp.PuriContent = (function() {

                        /**
                         * Properties of a PuriContent.
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp
                         * @interface IPuriContent
                         * @property {number|Long|null} [id] PuriContent id
                         * @property {number|null} [seqIndex] PuriContent seqIndex
                         * @property {number|null} [deleteStatus] PuriContent deleteStatus
                         * @property {number|null} [deleteReason] PuriContent deleteReason
                         * @property {boolean|null} [album] PuriContent album
                         * @property {boolean|null} [selected] PuriContent selected
                         * @property {boolean|null} [surpriseShot] PuriContent surpriseShot
                         * @property {boolean|null} [surpriseShot2] PuriContent surpriseShot2
                         * @property {boolean|null} [hasgraff] PuriContent hasgraff
                         */

                        /**
                         * Constructs a new PuriContent.
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp
                         * @classdesc Represents a PuriContent.
                         * @implements IPuriContent
                         * @constructor
                         * @param {kuma.jp.protobuf.web.PuriContentListResp.IPuriContent=} [properties] Properties to set
                         */
                        function PuriContent(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * PuriContent id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * PuriContent seqIndex.
                         * @member {number} seqIndex
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.seqIndex = 0;

                        /**
                         * PuriContent deleteStatus.
                         * @member {number} deleteStatus
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.deleteStatus = 0;

                        /**
                         * PuriContent deleteReason.
                         * @member {number} deleteReason
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.deleteReason = 0;

                        /**
                         * PuriContent album.
                         * @member {boolean} album
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.album = false;

                        /**
                         * PuriContent selected.
                         * @member {boolean} selected
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.selected = false;

                        /**
                         * PuriContent surpriseShot.
                         * @member {boolean} surpriseShot
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.surpriseShot = false;

                        /**
                         * PuriContent surpriseShot2.
                         * @member {boolean} surpriseShot2
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.surpriseShot2 = false;

                        /**
                         * PuriContent hasgraff.
                         * @member {boolean} hasgraff
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         */
                        PuriContent.prototype.hasgraff = false;

                        /**
                         * Creates a new PuriContent instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {kuma.jp.protobuf.web.PuriContentListResp.IPuriContent=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.PuriContentListResp.PuriContent} PuriContent instance
                         */
                        PuriContent.create = function create(properties) {
                            return new PuriContent(properties);
                        };

                        /**
                         * Encodes the specified PuriContent message. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListResp.PuriContent.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {kuma.jp.protobuf.web.PuriContentListResp.IPuriContent} message PuriContent message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PuriContent.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.seqIndex != null && Object.hasOwnProperty.call(message, "seqIndex"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seqIndex);
                            if (message.deleteStatus != null && Object.hasOwnProperty.call(message, "deleteStatus"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.deleteStatus);
                            if (message.deleteReason != null && Object.hasOwnProperty.call(message, "deleteReason"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.deleteReason);
                            if (message.album != null && Object.hasOwnProperty.call(message, "album"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.album);
                            if (message.selected != null && Object.hasOwnProperty.call(message, "selected"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.selected);
                            if (message.surpriseShot != null && Object.hasOwnProperty.call(message, "surpriseShot"))
                                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.surpriseShot);
                            if (message.surpriseShot2 != null && Object.hasOwnProperty.call(message, "surpriseShot2"))
                                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.surpriseShot2);
                            if (message.hasgraff != null && Object.hasOwnProperty.call(message, "hasgraff"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.hasgraff);
                            return writer;
                        };

                        /**
                         * Encodes the specified PuriContent message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentListResp.PuriContent.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {kuma.jp.protobuf.web.PuriContentListResp.IPuriContent} message PuriContent message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PuriContent.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a PuriContent message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.PuriContentListResp.PuriContent} PuriContent
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PuriContent.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.seqIndex = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.deleteStatus = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.deleteReason = reader.int32();
                                        break;
                                    }
                                case 5: {
                                        message.album = reader.bool();
                                        break;
                                    }
                                case 6: {
                                        message.selected = reader.bool();
                                        break;
                                    }
                                case 7: {
                                        message.surpriseShot = reader.bool();
                                        break;
                                    }
                                case 8: {
                                        message.surpriseShot2 = reader.bool();
                                        break;
                                    }
                                case 9: {
                                        message.hasgraff = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a PuriContent message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.PuriContentListResp.PuriContent} PuriContent
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PuriContent.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a PuriContent message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PuriContent.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.seqIndex != null && message.hasOwnProperty("seqIndex"))
                                if (!$util.isInteger(message.seqIndex))
                                    return "seqIndex: integer expected";
                            if (message.deleteStatus != null && message.hasOwnProperty("deleteStatus"))
                                if (!$util.isInteger(message.deleteStatus))
                                    return "deleteStatus: integer expected";
                            if (message.deleteReason != null && message.hasOwnProperty("deleteReason"))
                                if (!$util.isInteger(message.deleteReason))
                                    return "deleteReason: integer expected";
                            if (message.album != null && message.hasOwnProperty("album"))
                                if (typeof message.album !== "boolean")
                                    return "album: boolean expected";
                            if (message.selected != null && message.hasOwnProperty("selected"))
                                if (typeof message.selected !== "boolean")
                                    return "selected: boolean expected";
                            if (message.surpriseShot != null && message.hasOwnProperty("surpriseShot"))
                                if (typeof message.surpriseShot !== "boolean")
                                    return "surpriseShot: boolean expected";
                            if (message.surpriseShot2 != null && message.hasOwnProperty("surpriseShot2"))
                                if (typeof message.surpriseShot2 !== "boolean")
                                    return "surpriseShot2: boolean expected";
                            if (message.hasgraff != null && message.hasOwnProperty("hasgraff"))
                                if (typeof message.hasgraff !== "boolean")
                                    return "hasgraff: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a PuriContent message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.PuriContentListResp.PuriContent} PuriContent
                         */
                        PuriContent.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.PuriContentListResp.PuriContent();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.seqIndex != null)
                                message.seqIndex = object.seqIndex | 0;
                            if (object.deleteStatus != null)
                                message.deleteStatus = object.deleteStatus | 0;
                            if (object.deleteReason != null)
                                message.deleteReason = object.deleteReason | 0;
                            if (object.album != null)
                                message.album = Boolean(object.album);
                            if (object.selected != null)
                                message.selected = Boolean(object.selected);
                            if (object.surpriseShot != null)
                                message.surpriseShot = Boolean(object.surpriseShot);
                            if (object.surpriseShot2 != null)
                                message.surpriseShot2 = Boolean(object.surpriseShot2);
                            if (object.hasgraff != null)
                                message.hasgraff = Boolean(object.hasgraff);
                            return message;
                        };

                        /**
                         * Creates a plain object from a PuriContent message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {kuma.jp.protobuf.web.PuriContentListResp.PuriContent} message PuriContent
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PuriContent.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                object.seqIndex = 0;
                                object.deleteStatus = 0;
                                object.deleteReason = 0;
                                object.album = false;
                                object.selected = false;
                                object.surpriseShot = false;
                                object.surpriseShot2 = false;
                                object.hasgraff = false;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.seqIndex != null && message.hasOwnProperty("seqIndex"))
                                object.seqIndex = message.seqIndex;
                            if (message.deleteStatus != null && message.hasOwnProperty("deleteStatus"))
                                object.deleteStatus = message.deleteStatus;
                            if (message.deleteReason != null && message.hasOwnProperty("deleteReason"))
                                object.deleteReason = message.deleteReason;
                            if (message.album != null && message.hasOwnProperty("album"))
                                object.album = message.album;
                            if (message.selected != null && message.hasOwnProperty("selected"))
                                object.selected = message.selected;
                            if (message.surpriseShot != null && message.hasOwnProperty("surpriseShot"))
                                object.surpriseShot = message.surpriseShot;
                            if (message.surpriseShot2 != null && message.hasOwnProperty("surpriseShot2"))
                                object.surpriseShot2 = message.surpriseShot2;
                            if (message.hasgraff != null && message.hasOwnProperty("hasgraff"))
                                object.hasgraff = message.hasgraff;
                            return object;
                        };

                        /**
                         * Converts this PuriContent to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PuriContent.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for PuriContent
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.PuriContentListResp.PuriContent
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        PuriContent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.PuriContentListResp.PuriContent";
                        };

                        return PuriContent;
                    })();

                    return PuriContentListResp;
                })();

                web.PuriContentReq = (function() {

                    /**
                     * Properties of a PuriContentReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPuriContentReq
                     * @property {number|Long|null} [id] PuriContentReq id
                     * @property {Array.<kuma.jp.protobuf.common.PuriContentType>|null} [types] PuriContentReq types
                     * @property {number|null} [tag] PuriContentReq tag
                     */

                    /**
                     * Constructs a new PuriContentReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PuriContentReq.
                     * @implements IPuriContentReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPuriContentReq=} [properties] Properties to set
                     */
                    function PuriContentReq(properties) {
                        this.types = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PuriContentReq id.
                     * @member {number|Long} id
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @instance
                     */
                    PuriContentReq.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PuriContentReq types.
                     * @member {Array.<kuma.jp.protobuf.common.PuriContentType>} types
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @instance
                     */
                    PuriContentReq.prototype.types = $util.emptyArray;

                    /**
                     * PuriContentReq tag.
                     * @member {number} tag
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @instance
                     */
                    PuriContentReq.prototype.tag = 0;

                    /**
                     * Creates a new PuriContentReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PuriContentReq} PuriContentReq instance
                     */
                    PuriContentReq.create = function create(properties) {
                        return new PuriContentReq(properties);
                    };

                    /**
                     * Encodes the specified PuriContentReq message. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentReq} message PuriContentReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.types != null && message.types.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (let i = 0; i < message.types.length; ++i)
                                writer.int32(message.types[i]);
                            writer.ldelim();
                        }
                        if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.tag);
                        return writer;
                    };

                    /**
                     * Encodes the specified PuriContentReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentReq} message PuriContentReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PuriContentReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PuriContentReq} PuriContentReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PuriContentReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    if (!(message.types && message.types.length))
                                        message.types = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.types.push(reader.int32());
                                    } else
                                        message.types.push(reader.int32());
                                    break;
                                }
                            case 3: {
                                    message.tag = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PuriContentReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PuriContentReq} PuriContentReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PuriContentReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PuriContentReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.types != null && message.hasOwnProperty("types")) {
                            if (!Array.isArray(message.types))
                                return "types: array expected";
                            for (let i = 0; i < message.types.length; ++i)
                                switch (message.types[i]) {
                                default:
                                    return "types: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                    break;
                                }
                        }
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            if (!$util.isInteger(message.tag))
                                return "tag: integer expected";
                        return null;
                    };

                    /**
                     * Creates a PuriContentReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PuriContentReq} PuriContentReq
                     */
                    PuriContentReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PuriContentReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PuriContentReq();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.types) {
                            if (!Array.isArray(object.types))
                                throw TypeError(".kuma.jp.protobuf.web.PuriContentReq.types: array expected");
                            message.types = [];
                            for (let i = 0; i < object.types.length; ++i)
                                switch (object.types[i]) {
                                default:
                                    if (typeof object.types[i] === "number") {
                                        message.types[i] = object.types[i];
                                        break;
                                    }
                                    break;
                                case "OUT_JSON":
                                case 0:
                                    message.types[i] = 0;
                                    break;
                                case "GRAFFITI_JSON":
                                case 1:
                                    message.types[i] = 1;
                                    break;
                                case "FINAL_IMAGE":
                                case 2:
                                    message.types[i] = 2;
                                    break;
                                case "THUMBNAIL":
                                case 3:
                                    message.types[i] = 3;
                                    break;
                                case "BACKGROUND":
                                case 4:
                                    message.types[i] = 4;
                                    break;
                                case "ORIGINAL_IMAGE":
                                case 5:
                                    message.types[i] = 5;
                                    break;
                                case "OUT":
                                case 6:
                                    message.types[i] = 6;
                                    break;
                                case "OUT_MASK":
                                case 7:
                                    message.types[i] = 7;
                                    break;
                                case "OUT_SHADOW":
                                case 8:
                                    message.types[i] = 8;
                                    break;
                                case "MAKEUP":
                                case 9:
                                    message.types[i] = 9;
                                    break;
                                case "MAKEUP_MASK":
                                case 10:
                                    message.types[i] = 10;
                                    break;
                                case "GRAFFITI":
                                case 11:
                                    message.types[i] = 11;
                                    break;
                                case "GRAFFITI_MASK":
                                case 12:
                                    message.types[i] = 12;
                                    break;
                                case "LIP_C0":
                                case 13:
                                    message.types[i] = 13;
                                    break;
                                case "LIP_C1":
                                case 14:
                                    message.types[i] = 14;
                                    break;
                                case "LIP_MA0":
                                case 15:
                                    message.types[i] = 15;
                                    break;
                                case "LIP_MA1":
                                case 16:
                                    message.types[i] = 16;
                                    break;
                                case "LIP_MB0":
                                case 17:
                                    message.types[i] = 17;
                                    break;
                                case "LIP_MB1":
                                case 18:
                                    message.types[i] = 18;
                                    break;
                                case "LIP_MC0":
                                case 19:
                                    message.types[i] = 19;
                                    break;
                                case "LIP_MC1":
                                case 20:
                                    message.types[i] = 20;
                                    break;
                                case "LIP_HA0":
                                case 21:
                                    message.types[i] = 21;
                                    break;
                                case "LIP_HA1":
                                case 22:
                                    message.types[i] = 22;
                                    break;
                                case "LIP_HB0":
                                case 23:
                                    message.types[i] = 23;
                                    break;
                                case "LIP_HB1":
                                case 24:
                                    message.types[i] = 24;
                                    break;
                                case "LIP_HC0":
                                case 25:
                                    message.types[i] = 25;
                                    break;
                                case "LIP_HC1":
                                case 26:
                                    message.types[i] = 26;
                                    break;
                                case "CHEEK_MA0":
                                case 27:
                                    message.types[i] = 27;
                                    break;
                                case "CHEEK_MA1":
                                case 28:
                                    message.types[i] = 28;
                                    break;
                                case "CHEEK_MB0":
                                case 29:
                                    message.types[i] = 29;
                                    break;
                                case "CHEEK_MB1":
                                case 30:
                                    message.types[i] = 30;
                                    break;
                                case "CHEEK_MC0":
                                case 31:
                                    message.types[i] = 31;
                                    break;
                                case "CHEEK_MC1":
                                case 32:
                                    message.types[i] = 32;
                                    break;
                                case "ORIGINAL_VIDEO":
                                case 33:
                                    message.types[i] = 33;
                                    break;
                                case "FINAL_VIDEO":
                                case 34:
                                    message.types[i] = 34;
                                    break;
                                case "THUMBNAIL_BASE":
                                case 35:
                                    message.types[i] = 35;
                                    break;
                                case "MAKEUP1":
                                case 36:
                                    message.types[i] = 36;
                                    break;
                                case "MAKEUP1_MASK":
                                case 37:
                                    message.types[i] = 37;
                                    break;
                                case "MAKEUP2":
                                case 38:
                                    message.types[i] = 38;
                                    break;
                                case "MAKEUP2_MASK":
                                case 39:
                                    message.types[i] = 39;
                                    break;
                                case "MAKEUP_JSON":
                                case 40:
                                    message.types[i] = 40;
                                    break;
                                case "COLORLINER1_MASK":
                                case 41:
                                    message.types[i] = 41;
                                    break;
                                case "COLORLINER2_MASK":
                                case 42:
                                    message.types[i] = 42;
                                    break;
                                case "COLORLINER3_MASK":
                                case 43:
                                    message.types[i] = 43;
                                    break;
                                case "COLORLINER4_MASK":
                                case 44:
                                    message.types[i] = 44;
                                    break;
                                case "COLORDODGE":
                                case 45:
                                    message.types[i] = 45;
                                    break;
                                case "MAKEUP_NOBG":
                                case 46:
                                    message.types[i] = 46;
                                    break;
                                case "MAKEUP_NOBG_MASK":
                                case 47:
                                    message.types[i] = 47;
                                    break;
                                case "MOSAIC":
                                case 48:
                                    message.types[i] = 48;
                                    break;
                                case "COLLABO":
                                case 49:
                                    message.types[i] = 49;
                                    break;
                                case "BLENDORDER":
                                case 50:
                                    message.types[i] = 50;
                                    break;
                                case "COPY_RIGHT":
                                case 51:
                                    message.types[i] = 51;
                                    break;
                                case "CAMERA_FRAME":
                                case 52:
                                    message.types[i] = 52;
                                    break;
                                case "FINALBMGYYY_IMAGE":
                                case 53:
                                    message.types[i] = 53;
                                    break;
                                case "FINALBMGYYN_IMAGE":
                                case 54:
                                    message.types[i] = 54;
                                    break;
                                case "FINALBMGYNY_IMAGE":
                                case 55:
                                    message.types[i] = 55;
                                    break;
                                case "FINALBMGYNN_IMAGE":
                                case 56:
                                    message.types[i] = 56;
                                    break;
                                case "FINALBMGNYY_IMAGE":
                                case 57:
                                    message.types[i] = 57;
                                    break;
                                case "FINALBMGNYN_IMAGE":
                                case 58:
                                    message.types[i] = 58;
                                    break;
                                case "FINALBMGNNY_IMAGE":
                                case 59:
                                    message.types[i] = 59;
                                    break;
                                case "FINALBMGNNN_IMAGE":
                                case 60:
                                    message.types[i] = 60;
                                    break;
                                }
                        }
                        if (object.tag != null)
                            message.tag = object.tag | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a PuriContentReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {kuma.jp.protobuf.web.PuriContentReq} message PuriContentReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PuriContentReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.types = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.tag = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.types && message.types.length) {
                            object.types = [];
                            for (let j = 0; j < message.types.length; ++j)
                                object.types[j] = options.enums === String ? $root.kuma.jp.protobuf.common.PuriContentType[message.types[j]] === undefined ? message.types[j] : $root.kuma.jp.protobuf.common.PuriContentType[message.types[j]] : message.types[j];
                        }
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            object.tag = message.tag;
                        return object;
                    };

                    /**
                     * Converts this PuriContentReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PuriContentReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PuriContentReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PuriContentReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PuriContentReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PuriContentReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PuriContentReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=21100 COMMAND_NO value
                     */
                    PuriContentReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[21100] = "COMMAND_NO"] = 21100;
                        return values;
                    })();

                    return PuriContentReq;
                })();

                web.PuriContentResp = (function() {

                    /**
                     * Properties of a PuriContentResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface IPuriContentResp
                     * @property {kuma.jp.protobuf.web.PuriContentResp.Status|null} [status] PuriContentResp status
                     * @property {number|Long|null} [id] PuriContentResp id
                     * @property {number|null} [tag] PuriContentResp tag
                     * @property {number|null} [deleteStatus] PuriContentResp deleteStatus
                     * @property {number|null} [deleteReason] PuriContentResp deleteReason
                     * @property {Object.<string,Uint8Array>|null} [contents] PuriContentResp contents
                     * @property {boolean|null} [needflip] PuriContentResp needflip
                     * @property {boolean|null} [hasgraff] PuriContentResp hasgraff
                     * @property {boolean|null} [surprise] PuriContentResp surprise
                     */

                    /**
                     * Constructs a new PuriContentResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a PuriContentResp.
                     * @implements IPuriContentResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.IPuriContentResp=} [properties] Properties to set
                     */
                    function PuriContentResp(properties) {
                        this.contents = {};
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PuriContentResp status.
                     * @member {kuma.jp.protobuf.web.PuriContentResp.Status} status
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.status = 0;

                    /**
                     * PuriContentResp id.
                     * @member {number|Long} id
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PuriContentResp tag.
                     * @member {number} tag
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.tag = 0;

                    /**
                     * PuriContentResp deleteStatus.
                     * @member {number} deleteStatus
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.deleteStatus = 0;

                    /**
                     * PuriContentResp deleteReason.
                     * @member {number} deleteReason
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.deleteReason = 0;

                    /**
                     * PuriContentResp contents.
                     * @member {Object.<string,Uint8Array>} contents
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.contents = $util.emptyObject;

                    /**
                     * PuriContentResp needflip.
                     * @member {boolean} needflip
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.needflip = false;

                    /**
                     * PuriContentResp hasgraff.
                     * @member {boolean} hasgraff
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.hasgraff = false;

                    /**
                     * PuriContentResp surprise.
                     * @member {boolean} surprise
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     */
                    PuriContentResp.prototype.surprise = false;

                    /**
                     * Creates a new PuriContentResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.PuriContentResp} PuriContentResp instance
                     */
                    PuriContentResp.create = function create(properties) {
                        return new PuriContentResp(properties);
                    };

                    /**
                     * Encodes the specified PuriContentResp message. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentResp} message PuriContentResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.id);
                        if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.tag);
                        if (message.deleteStatus != null && Object.hasOwnProperty.call(message, "deleteStatus"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.deleteStatus);
                        if (message.deleteReason != null && Object.hasOwnProperty.call(message, "deleteReason"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.deleteReason);
                        if (message.contents != null && Object.hasOwnProperty.call(message, "contents"))
                            for (let keys = Object.keys(message.contents), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 0 =*/8).int32(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.contents[keys[i]]).ldelim();
                        if (message.needflip != null && Object.hasOwnProperty.call(message, "needflip"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.needflip);
                        if (message.hasgraff != null && Object.hasOwnProperty.call(message, "hasgraff"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.hasgraff);
                        if (message.surprise != null && Object.hasOwnProperty.call(message, "surprise"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.surprise);
                        return writer;
                    };

                    /**
                     * Encodes the specified PuriContentResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.PuriContentResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {kuma.jp.protobuf.web.IPuriContentResp} message PuriContentResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PuriContentResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PuriContentResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.PuriContentResp} PuriContentResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.PuriContentResp(), key, value;
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.tag = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.deleteStatus = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.deleteReason = reader.int32();
                                    break;
                                }
                            case 6: {
                                    if (message.contents === $util.emptyObject)
                                        message.contents = {};
                                    let end2 = reader.uint32() + reader.pos;
                                    key = 0;
                                    value = [];
                                    while (reader.pos < end2) {
                                        let tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.int32();
                                            break;
                                        case 2:
                                            value = reader.bytes();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.contents[key] = value;
                                    break;
                                }
                            case 7: {
                                    message.needflip = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.hasgraff = reader.bool();
                                    break;
                                }
                            case 9: {
                                    message.surprise = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PuriContentResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.PuriContentResp} PuriContentResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PuriContentResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PuriContentResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PuriContentResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            if (!$util.isInteger(message.tag))
                                return "tag: integer expected";
                        if (message.deleteStatus != null && message.hasOwnProperty("deleteStatus"))
                            if (!$util.isInteger(message.deleteStatus))
                                return "deleteStatus: integer expected";
                        if (message.deleteReason != null && message.hasOwnProperty("deleteReason"))
                            if (!$util.isInteger(message.deleteReason))
                                return "deleteReason: integer expected";
                        if (message.contents != null && message.hasOwnProperty("contents")) {
                            if (!$util.isObject(message.contents))
                                return "contents: object expected";
                            let key = Object.keys(message.contents);
                            for (let i = 0; i < key.length; ++i) {
                                if (!$util.key32Re.test(key[i]))
                                    return "contents: integer key{k:int32} expected";
                                if (!(message.contents[key[i]] && typeof message.contents[key[i]].length === "number" || $util.isString(message.contents[key[i]])))
                                    return "contents: buffer{k:int32} expected";
                            }
                        }
                        if (message.needflip != null && message.hasOwnProperty("needflip"))
                            if (typeof message.needflip !== "boolean")
                                return "needflip: boolean expected";
                        if (message.hasgraff != null && message.hasOwnProperty("hasgraff"))
                            if (typeof message.hasgraff !== "boolean")
                                return "hasgraff: boolean expected";
                        if (message.surprise != null && message.hasOwnProperty("surprise"))
                            if (typeof message.surprise !== "boolean")
                                return "surprise: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PuriContentResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.PuriContentResp} PuriContentResp
                     */
                    PuriContentResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.PuriContentResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.PuriContentResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.tag != null)
                            message.tag = object.tag | 0;
                        if (object.deleteStatus != null)
                            message.deleteStatus = object.deleteStatus | 0;
                        if (object.deleteReason != null)
                            message.deleteReason = object.deleteReason | 0;
                        if (object.contents) {
                            if (typeof object.contents !== "object")
                                throw TypeError(".kuma.jp.protobuf.web.PuriContentResp.contents: object expected");
                            message.contents = {};
                            for (let keys = Object.keys(object.contents), i = 0; i < keys.length; ++i)
                                if (typeof object.contents[keys[i]] === "string")
                                    $util.base64.decode(object.contents[keys[i]], message.contents[keys[i]] = $util.newBuffer($util.base64.length(object.contents[keys[i]])), 0);
                                else if (object.contents[keys[i]].length >= 0)
                                    message.contents[keys[i]] = object.contents[keys[i]];
                        }
                        if (object.needflip != null)
                            message.needflip = Boolean(object.needflip);
                        if (object.hasgraff != null)
                            message.hasgraff = Boolean(object.hasgraff);
                        if (object.surprise != null)
                            message.surprise = Boolean(object.surprise);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PuriContentResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {kuma.jp.protobuf.web.PuriContentResp} message PuriContentResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PuriContentResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.objects || options.defaults)
                            object.contents = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.tag = 0;
                            object.deleteStatus = 0;
                            object.deleteReason = 0;
                            object.needflip = false;
                            object.hasgraff = false;
                            object.surprise = false;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.PuriContentResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.PuriContentResp.Status[message.status] : message.status;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            object.tag = message.tag;
                        if (message.deleteStatus != null && message.hasOwnProperty("deleteStatus"))
                            object.deleteStatus = message.deleteStatus;
                        if (message.deleteReason != null && message.hasOwnProperty("deleteReason"))
                            object.deleteReason = message.deleteReason;
                        let keys2;
                        if (message.contents && (keys2 = Object.keys(message.contents)).length) {
                            object.contents = {};
                            for (let j = 0; j < keys2.length; ++j)
                                object.contents[keys2[j]] = options.bytes === String ? $util.base64.encode(message.contents[keys2[j]], 0, message.contents[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.contents[keys2[j]]) : message.contents[keys2[j]];
                        }
                        if (message.needflip != null && message.hasOwnProperty("needflip"))
                            object.needflip = message.needflip;
                        if (message.hasgraff != null && message.hasOwnProperty("hasgraff"))
                            object.hasgraff = message.hasgraff;
                        if (message.surprise != null && message.hasOwnProperty("surprise"))
                            object.surprise = message.surprise;
                        return object;
                    };

                    /**
                     * Converts this PuriContentResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PuriContentResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PuriContentResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.PuriContentResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PuriContentResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.PuriContentResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.PuriContentResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=21101 COMMAND_NO value
                     */
                    PuriContentResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[21101] = "COMMAND_NO"] = 21101;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.PuriContentResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    PuriContentResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return PuriContentResp;
                })();

                web.SheetAddReq = (function() {

                    /**
                     * Properties of a SheetAddReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetAddReq
                     * @property {number|Long|null} [id] SheetAddReq id
                     * @property {boolean|null} [reserve] SheetAddReq reserve
                     * @property {string|null} [encSheetId] SheetAddReq encSheetId
                     */

                    /**
                     * Constructs a new SheetAddReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetAddReq.
                     * @implements ISheetAddReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetAddReq=} [properties] Properties to set
                     */
                    function SheetAddReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SheetAddReq id.
                     * @member {number|Long} id
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @instance
                     */
                    SheetAddReq.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SheetAddReq reserve.
                     * @member {boolean} reserve
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @instance
                     */
                    SheetAddReq.prototype.reserve = false;

                    /**
                     * SheetAddReq encSheetId.
                     * @member {string} encSheetId
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @instance
                     */
                    SheetAddReq.prototype.encSheetId = "";

                    /**
                     * Creates a new SheetAddReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetAddReq} SheetAddReq instance
                     */
                    SheetAddReq.create = function create(properties) {
                        return new SheetAddReq(properties);
                    };

                    /**
                     * Encodes the specified SheetAddReq message. Does not implicitly {@link kuma.jp.protobuf.web.SheetAddReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddReq} message SheetAddReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetAddReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.reserve != null && Object.hasOwnProperty.call(message, "reserve"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.reserve);
                        if (message.encSheetId != null && Object.hasOwnProperty.call(message, "encSheetId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.encSheetId);
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetAddReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetAddReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddReq} message SheetAddReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetAddReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetAddReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetAddReq} SheetAddReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetAddReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetAddReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.reserve = reader.bool();
                                    break;
                                }
                            case 3: {
                                    message.encSheetId = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetAddReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetAddReq} SheetAddReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetAddReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetAddReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetAddReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.reserve != null && message.hasOwnProperty("reserve"))
                            if (typeof message.reserve !== "boolean")
                                return "reserve: boolean expected";
                        if (message.encSheetId != null && message.hasOwnProperty("encSheetId"))
                            if (!$util.isString(message.encSheetId))
                                return "encSheetId: string expected";
                        return null;
                    };

                    /**
                     * Creates a SheetAddReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetAddReq} SheetAddReq
                     */
                    SheetAddReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetAddReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.SheetAddReq();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.reserve != null)
                            message.reserve = Boolean(object.reserve);
                        if (object.encSheetId != null)
                            message.encSheetId = String(object.encSheetId);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SheetAddReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetAddReq} message SheetAddReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetAddReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.reserve = false;
                            object.encSheetId = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.reserve != null && message.hasOwnProperty("reserve"))
                            object.reserve = message.reserve;
                        if (message.encSheetId != null && message.hasOwnProperty("encSheetId"))
                            object.encSheetId = message.encSheetId;
                        return object;
                    };

                    /**
                     * Converts this SheetAddReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetAddReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetAddReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetAddReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetAddReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetAddReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetAddReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20206 COMMAND_NO value
                     */
                    SheetAddReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20206] = "COMMAND_NO"] = 20206;
                        return values;
                    })();

                    return SheetAddReq;
                })();

                web.SheetAddResp = (function() {

                    /**
                     * Properties of a SheetAddResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetAddResp
                     * @property {kuma.jp.protobuf.web.SheetAddResp.Status|null} [status] SheetAddResp status
                     * @property {number|Long|null} [id] SheetAddResp id
                     * @property {number|Long|null} [limitDate] SheetAddResp limitDate
                     * @property {number|Long|null} [createDate] SheetAddResp createDate
                     * @property {string|null} [arcadeName] SheetAddResp arcadeName
                     * @property {number|null} [arcadeId] SheetAddResp arcadeId
                     */

                    /**
                     * Constructs a new SheetAddResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetAddResp.
                     * @implements ISheetAddResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetAddResp=} [properties] Properties to set
                     */
                    function SheetAddResp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SheetAddResp status.
                     * @member {kuma.jp.protobuf.web.SheetAddResp.Status} status
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.status = 0;

                    /**
                     * SheetAddResp id.
                     * @member {number|Long} id
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SheetAddResp limitDate.
                     * @member {number|Long} limitDate
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.limitDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SheetAddResp createDate.
                     * @member {number|Long} createDate
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.createDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SheetAddResp arcadeName.
                     * @member {string} arcadeName
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.arcadeName = "";

                    /**
                     * SheetAddResp arcadeId.
                     * @member {number} arcadeId
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     */
                    SheetAddResp.prototype.arcadeId = 0;

                    /**
                     * Creates a new SheetAddResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetAddResp} SheetAddResp instance
                     */
                    SheetAddResp.create = function create(properties) {
                        return new SheetAddResp(properties);
                    };

                    /**
                     * Encodes the specified SheetAddResp message. Does not implicitly {@link kuma.jp.protobuf.web.SheetAddResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddResp} message SheetAddResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetAddResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.id);
                        if (message.limitDate != null && Object.hasOwnProperty.call(message, "limitDate"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.limitDate);
                        if (message.createDate != null && Object.hasOwnProperty.call(message, "createDate"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createDate);
                        if (message.arcadeName != null && Object.hasOwnProperty.call(message, "arcadeName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.arcadeName);
                        if (message.arcadeId != null && Object.hasOwnProperty.call(message, "arcadeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.arcadeId);
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetAddResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetAddResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetAddResp} message SheetAddResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetAddResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetAddResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetAddResp} SheetAddResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetAddResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetAddResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.limitDate = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.createDate = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.arcadeName = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.arcadeId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetAddResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetAddResp} SheetAddResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetAddResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetAddResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetAddResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 10:
                            case 11:
                            case 12:
                                break;
                            }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                            if (!$util.isInteger(message.limitDate) && !(message.limitDate && $util.isInteger(message.limitDate.low) && $util.isInteger(message.limitDate.high)))
                                return "limitDate: integer|Long expected";
                        if (message.createDate != null && message.hasOwnProperty("createDate"))
                            if (!$util.isInteger(message.createDate) && !(message.createDate && $util.isInteger(message.createDate.low) && $util.isInteger(message.createDate.high)))
                                return "createDate: integer|Long expected";
                        if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                            if (!$util.isString(message.arcadeName))
                                return "arcadeName: string expected";
                        if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                            if (!$util.isInteger(message.arcadeId))
                                return "arcadeId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a SheetAddResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetAddResp} SheetAddResp
                     */
                    SheetAddResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetAddResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.SheetAddResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        case "ALREADY_EXISTS":
                        case 2:
                            message.status = 2;
                            break;
                        case "ACCOUNT_MAX":
                        case 3:
                            message.status = 3;
                            break;
                        case "EXPIRED":
                        case 4:
                            message.status = 4;
                            break;
                        case "RESERVE":
                        case 10:
                            message.status = 10;
                            break;
                        case "ALREADY_RESERVED":
                        case 11:
                            message.status = 11;
                            break;
                        case "RESERVE_LIMIT":
                        case 12:
                            message.status = 12;
                            break;
                        }
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.limitDate != null)
                            if ($util.Long)
                                (message.limitDate = $util.Long.fromValue(object.limitDate)).unsigned = false;
                            else if (typeof object.limitDate === "string")
                                message.limitDate = parseInt(object.limitDate, 10);
                            else if (typeof object.limitDate === "number")
                                message.limitDate = object.limitDate;
                            else if (typeof object.limitDate === "object")
                                message.limitDate = new $util.LongBits(object.limitDate.low >>> 0, object.limitDate.high >>> 0).toNumber();
                        if (object.createDate != null)
                            if ($util.Long)
                                (message.createDate = $util.Long.fromValue(object.createDate)).unsigned = false;
                            else if (typeof object.createDate === "string")
                                message.createDate = parseInt(object.createDate, 10);
                            else if (typeof object.createDate === "number")
                                message.createDate = object.createDate;
                            else if (typeof object.createDate === "object")
                                message.createDate = new $util.LongBits(object.createDate.low >>> 0, object.createDate.high >>> 0).toNumber();
                        if (object.arcadeName != null)
                            message.arcadeName = String(object.arcadeName);
                        if (object.arcadeId != null)
                            message.arcadeId = object.arcadeId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a SheetAddResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetAddResp} message SheetAddResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetAddResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.status = options.enums === String ? "SUCCESS" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.limitDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.limitDate = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.createDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createDate = options.longs === String ? "0" : 0;
                            object.arcadeName = "";
                            object.arcadeId = 0;
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.SheetAddResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.SheetAddResp.Status[message.status] : message.status;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                            if (typeof message.limitDate === "number")
                                object.limitDate = options.longs === String ? String(message.limitDate) : message.limitDate;
                            else
                                object.limitDate = options.longs === String ? $util.Long.prototype.toString.call(message.limitDate) : options.longs === Number ? new $util.LongBits(message.limitDate.low >>> 0, message.limitDate.high >>> 0).toNumber() : message.limitDate;
                        if (message.createDate != null && message.hasOwnProperty("createDate"))
                            if (typeof message.createDate === "number")
                                object.createDate = options.longs === String ? String(message.createDate) : message.createDate;
                            else
                                object.createDate = options.longs === String ? $util.Long.prototype.toString.call(message.createDate) : options.longs === Number ? new $util.LongBits(message.createDate.low >>> 0, message.createDate.high >>> 0).toNumber() : message.createDate;
                        if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                            object.arcadeName = message.arcadeName;
                        if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                            object.arcadeId = message.arcadeId;
                        return object;
                    };

                    /**
                     * Converts this SheetAddResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetAddResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetAddResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetAddResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetAddResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetAddResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetAddResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20207 COMMAND_NO value
                     */
                    SheetAddResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20207] = "COMMAND_NO"] = 20207;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.SheetAddResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} ALREADY_EXISTS=2 ALREADY_EXISTS value
                     * @property {number} ACCOUNT_MAX=3 ACCOUNT_MAX value
                     * @property {number} EXPIRED=4 EXPIRED value
                     * @property {number} RESERVE=10 RESERVE value
                     * @property {number} ALREADY_RESERVED=11 ALREADY_RESERVED value
                     * @property {number} RESERVE_LIMIT=12 RESERVE_LIMIT value
                     */
                    SheetAddResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "ALREADY_EXISTS"] = 2;
                        values[valuesById[3] = "ACCOUNT_MAX"] = 3;
                        values[valuesById[4] = "EXPIRED"] = 4;
                        values[valuesById[10] = "RESERVE"] = 10;
                        values[valuesById[11] = "ALREADY_RESERVED"] = 11;
                        values[valuesById[12] = "RESERVE_LIMIT"] = 12;
                        return values;
                    })();

                    return SheetAddResp;
                })();

                web.SheetListReq = (function() {

                    /**
                     * Properties of a SheetListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetListReq
                     */

                    /**
                     * Constructs a new SheetListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetListReq.
                     * @implements ISheetListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetListReq=} [properties] Properties to set
                     */
                    function SheetListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new SheetListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetListReq} SheetListReq instance
                     */
                    SheetListReq.create = function create(properties) {
                        return new SheetListReq(properties);
                    };

                    /**
                     * Encodes the specified SheetListReq message. Does not implicitly {@link kuma.jp.protobuf.web.SheetListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListReq} message SheetListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListReq} message SheetListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetListReq} SheetListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetListReq} SheetListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a SheetListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetListReq} SheetListReq
                     */
                    SheetListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.SheetListReq();
                    };

                    /**
                     * Creates a plain object from a SheetListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetListReq} message SheetListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this SheetListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20200 COMMAND_NO value
                     */
                    SheetListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20200] = "COMMAND_NO"] = 20200;
                        return values;
                    })();

                    return SheetListReq;
                })();

                web.SheetListResp = (function() {

                    /**
                     * Properties of a SheetListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetListResp
                     * @property {kuma.jp.protobuf.web.SheetListResp.Status|null} [status] SheetListResp status
                     * @property {Array.<kuma.jp.protobuf.web.SheetListResp.ISheet>|null} [sheetList] SheetListResp sheetList
                     */

                    /**
                     * Constructs a new SheetListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetListResp.
                     * @implements ISheetListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetListResp=} [properties] Properties to set
                     */
                    function SheetListResp(properties) {
                        this.sheetList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SheetListResp status.
                     * @member {kuma.jp.protobuf.web.SheetListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @instance
                     */
                    SheetListResp.prototype.status = 0;

                    /**
                     * SheetListResp sheetList.
                     * @member {Array.<kuma.jp.protobuf.web.SheetListResp.ISheet>} sheetList
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @instance
                     */
                    SheetListResp.prototype.sheetList = $util.emptyArray;

                    /**
                     * Creates a new SheetListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetListResp} SheetListResp instance
                     */
                    SheetListResp.create = function create(properties) {
                        return new SheetListResp(properties);
                    };

                    /**
                     * Encodes the specified SheetListResp message. Does not implicitly {@link kuma.jp.protobuf.web.SheetListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListResp} message SheetListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.sheetList != null && message.sheetList.length)
                            for (let i = 0; i < message.sheetList.length; ++i)
                                $root.kuma.jp.protobuf.web.SheetListResp.Sheet.encode(message.sheetList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetListResp} message SheetListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetListResp} SheetListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.sheetList && message.sheetList.length))
                                        message.sheetList = [];
                                    message.sheetList.push($root.kuma.jp.protobuf.web.SheetListResp.Sheet.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetListResp} SheetListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.sheetList != null && message.hasOwnProperty("sheetList")) {
                            if (!Array.isArray(message.sheetList))
                                return "sheetList: array expected";
                            for (let i = 0; i < message.sheetList.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.SheetListResp.Sheet.verify(message.sheetList[i]);
                                if (error)
                                    return "sheetList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a SheetListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetListResp} SheetListResp
                     */
                    SheetListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.SheetListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.sheetList) {
                            if (!Array.isArray(object.sheetList))
                                throw TypeError(".kuma.jp.protobuf.web.SheetListResp.sheetList: array expected");
                            message.sheetList = [];
                            for (let i = 0; i < object.sheetList.length; ++i) {
                                if (typeof object.sheetList[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.SheetListResp.sheetList: object expected");
                                message.sheetList[i] = $root.kuma.jp.protobuf.web.SheetListResp.Sheet.fromObject(object.sheetList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a SheetListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetListResp} message SheetListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.sheetList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.SheetListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.SheetListResp.Status[message.status] : message.status;
                        if (message.sheetList && message.sheetList.length) {
                            object.sheetList = [];
                            for (let j = 0; j < message.sheetList.length; ++j)
                                object.sheetList[j] = $root.kuma.jp.protobuf.web.SheetListResp.Sheet.toObject(message.sheetList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this SheetListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20201 COMMAND_NO value
                     */
                    SheetListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20201] = "COMMAND_NO"] = 20201;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.SheetListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    SheetListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    SheetListResp.Sheet = (function() {

                        /**
                         * Properties of a Sheet.
                         * @memberof kuma.jp.protobuf.web.SheetListResp
                         * @interface ISheet
                         * @property {number|Long|null} [id] Sheet id
                         * @property {number|Long|null} [limitDate] Sheet limitDate
                         * @property {number|Long|null} [createDate] Sheet createDate
                         * @property {string|null} [arcadeName] Sheet arcadeName
                         * @property {string|null} [arcadeId] Sheet arcadeId
                         */

                        /**
                         * Constructs a new Sheet.
                         * @memberof kuma.jp.protobuf.web.SheetListResp
                         * @classdesc Represents a Sheet.
                         * @implements ISheet
                         * @constructor
                         * @param {kuma.jp.protobuf.web.SheetListResp.ISheet=} [properties] Properties to set
                         */
                        function Sheet(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Sheet id.
                         * @member {number|Long} id
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         */
                        Sheet.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Sheet limitDate.
                         * @member {number|Long} limitDate
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         */
                        Sheet.prototype.limitDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Sheet createDate.
                         * @member {number|Long} createDate
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         */
                        Sheet.prototype.createDate = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Sheet arcadeName.
                         * @member {string} arcadeName
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         */
                        Sheet.prototype.arcadeName = "";

                        /**
                         * Sheet arcadeId.
                         * @member {string} arcadeId
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         */
                        Sheet.prototype.arcadeId = "";

                        /**
                         * Creates a new Sheet instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {kuma.jp.protobuf.web.SheetListResp.ISheet=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.SheetListResp.Sheet} Sheet instance
                         */
                        Sheet.create = function create(properties) {
                            return new Sheet(properties);
                        };

                        /**
                         * Encodes the specified Sheet message. Does not implicitly {@link kuma.jp.protobuf.web.SheetListResp.Sheet.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {kuma.jp.protobuf.web.SheetListResp.ISheet} message Sheet message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Sheet.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                            if (message.limitDate != null && Object.hasOwnProperty.call(message, "limitDate"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.limitDate);
                            if (message.createDate != null && Object.hasOwnProperty.call(message, "createDate"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createDate);
                            if (message.arcadeName != null && Object.hasOwnProperty.call(message, "arcadeName"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.arcadeName);
                            if (message.arcadeId != null && Object.hasOwnProperty.call(message, "arcadeId"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.arcadeId);
                            return writer;
                        };

                        /**
                         * Encodes the specified Sheet message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetListResp.Sheet.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {kuma.jp.protobuf.web.SheetListResp.ISheet} message Sheet message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Sheet.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Sheet message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.SheetListResp.Sheet} Sheet
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Sheet.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetListResp.Sheet();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.limitDate = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.createDate = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.arcadeName = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.arcadeId = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Sheet message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.SheetListResp.Sheet} Sheet
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Sheet.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Sheet message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Sheet.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                    return "id: integer|Long expected";
                            if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                                if (!$util.isInteger(message.limitDate) && !(message.limitDate && $util.isInteger(message.limitDate.low) && $util.isInteger(message.limitDate.high)))
                                    return "limitDate: integer|Long expected";
                            if (message.createDate != null && message.hasOwnProperty("createDate"))
                                if (!$util.isInteger(message.createDate) && !(message.createDate && $util.isInteger(message.createDate.low) && $util.isInteger(message.createDate.high)))
                                    return "createDate: integer|Long expected";
                            if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                                if (!$util.isString(message.arcadeName))
                                    return "arcadeName: string expected";
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                if (!$util.isString(message.arcadeId))
                                    return "arcadeId: string expected";
                            return null;
                        };

                        /**
                         * Creates a Sheet message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.SheetListResp.Sheet} Sheet
                         */
                        Sheet.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.SheetListResp.Sheet)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.SheetListResp.Sheet();
                            if (object.id != null)
                                if ($util.Long)
                                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                                else if (typeof object.id === "string")
                                    message.id = parseInt(object.id, 10);
                                else if (typeof object.id === "number")
                                    message.id = object.id;
                                else if (typeof object.id === "object")
                                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                            if (object.limitDate != null)
                                if ($util.Long)
                                    (message.limitDate = $util.Long.fromValue(object.limitDate)).unsigned = false;
                                else if (typeof object.limitDate === "string")
                                    message.limitDate = parseInt(object.limitDate, 10);
                                else if (typeof object.limitDate === "number")
                                    message.limitDate = object.limitDate;
                                else if (typeof object.limitDate === "object")
                                    message.limitDate = new $util.LongBits(object.limitDate.low >>> 0, object.limitDate.high >>> 0).toNumber();
                            if (object.createDate != null)
                                if ($util.Long)
                                    (message.createDate = $util.Long.fromValue(object.createDate)).unsigned = false;
                                else if (typeof object.createDate === "string")
                                    message.createDate = parseInt(object.createDate, 10);
                                else if (typeof object.createDate === "number")
                                    message.createDate = object.createDate;
                                else if (typeof object.createDate === "object")
                                    message.createDate = new $util.LongBits(object.createDate.low >>> 0, object.createDate.high >>> 0).toNumber();
                            if (object.arcadeName != null)
                                message.arcadeName = String(object.arcadeName);
                            if (object.arcadeId != null)
                                message.arcadeId = String(object.arcadeId);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Sheet message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {kuma.jp.protobuf.web.SheetListResp.Sheet} message Sheet
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Sheet.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.id = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.limitDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.limitDate = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.createDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.createDate = options.longs === String ? "0" : 0;
                                object.arcadeName = "";
                                object.arcadeId = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (typeof message.id === "number")
                                    object.id = options.longs === String ? String(message.id) : message.id;
                                else
                                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (message.limitDate != null && message.hasOwnProperty("limitDate"))
                                if (typeof message.limitDate === "number")
                                    object.limitDate = options.longs === String ? String(message.limitDate) : message.limitDate;
                                else
                                    object.limitDate = options.longs === String ? $util.Long.prototype.toString.call(message.limitDate) : options.longs === Number ? new $util.LongBits(message.limitDate.low >>> 0, message.limitDate.high >>> 0).toNumber() : message.limitDate;
                            if (message.createDate != null && message.hasOwnProperty("createDate"))
                                if (typeof message.createDate === "number")
                                    object.createDate = options.longs === String ? String(message.createDate) : message.createDate;
                                else
                                    object.createDate = options.longs === String ? $util.Long.prototype.toString.call(message.createDate) : options.longs === Number ? new $util.LongBits(message.createDate.low >>> 0, message.createDate.high >>> 0).toNumber() : message.createDate;
                            if (message.arcadeName != null && message.hasOwnProperty("arcadeName"))
                                object.arcadeName = message.arcadeName;
                            if (message.arcadeId != null && message.hasOwnProperty("arcadeId"))
                                object.arcadeId = message.arcadeId;
                            return object;
                        };

                        /**
                         * Converts this Sheet to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Sheet.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Sheet
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.SheetListResp.Sheet
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Sheet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetListResp.Sheet";
                        };

                        return Sheet;
                    })();

                    return SheetListResp;
                })();

                web.SheetNewListReq = (function() {

                    /**
                     * Properties of a SheetNewListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetNewListReq
                     */

                    /**
                     * Constructs a new SheetNewListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetNewListReq.
                     * @implements ISheetNewListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetNewListReq=} [properties] Properties to set
                     */
                    function SheetNewListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Creates a new SheetNewListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetNewListReq} SheetNewListReq instance
                     */
                    SheetNewListReq.create = function create(properties) {
                        return new SheetNewListReq(properties);
                    };

                    /**
                     * Encodes the specified SheetNewListReq message. Does not implicitly {@link kuma.jp.protobuf.web.SheetNewListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListReq} message SheetNewListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetNewListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetNewListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetNewListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListReq} message SheetNewListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetNewListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetNewListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetNewListReq} SheetNewListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetNewListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetNewListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetNewListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetNewListReq} SheetNewListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetNewListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetNewListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetNewListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };

                    /**
                     * Creates a SheetNewListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetNewListReq} SheetNewListReq
                     */
                    SheetNewListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetNewListReq)
                            return object;
                        return new $root.kuma.jp.protobuf.web.SheetNewListReq();
                    };

                    /**
                     * Creates a plain object from a SheetNewListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetNewListReq} message SheetNewListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetNewListReq.toObject = function toObject() {
                        return {};
                    };

                    /**
                     * Converts this SheetNewListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetNewListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetNewListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetNewListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetNewListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetNewListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetNewListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20208 COMMAND_NO value
                     */
                    SheetNewListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20208] = "COMMAND_NO"] = 20208;
                        return values;
                    })();

                    return SheetNewListReq;
                })();

                web.SheetNewListResp = (function() {

                    /**
                     * Properties of a SheetNewListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ISheetNewListResp
                     * @property {kuma.jp.protobuf.web.SheetNewListResp.Status|null} [status] SheetNewListResp status
                     * @property {Array.<number|Long>|null} [sheetList] SheetNewListResp sheetList
                     */

                    /**
                     * Constructs a new SheetNewListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a SheetNewListResp.
                     * @implements ISheetNewListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ISheetNewListResp=} [properties] Properties to set
                     */
                    function SheetNewListResp(properties) {
                        this.sheetList = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SheetNewListResp status.
                     * @member {kuma.jp.protobuf.web.SheetNewListResp.Status} status
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @instance
                     */
                    SheetNewListResp.prototype.status = 0;

                    /**
                     * SheetNewListResp sheetList.
                     * @member {Array.<number|Long>} sheetList
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @instance
                     */
                    SheetNewListResp.prototype.sheetList = $util.emptyArray;

                    /**
                     * Creates a new SheetNewListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.SheetNewListResp} SheetNewListResp instance
                     */
                    SheetNewListResp.create = function create(properties) {
                        return new SheetNewListResp(properties);
                    };

                    /**
                     * Encodes the specified SheetNewListResp message. Does not implicitly {@link kuma.jp.protobuf.web.SheetNewListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListResp} message SheetNewListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetNewListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
                        if (message.sheetList != null && message.sheetList.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (let i = 0; i < message.sheetList.length; ++i)
                                writer.int64(message.sheetList[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified SheetNewListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.SheetNewListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ISheetNewListResp} message SheetNewListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SheetNewListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SheetNewListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.SheetNewListResp} SheetNewListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetNewListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.SheetNewListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.sheetList && message.sheetList.length))
                                        message.sheetList = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.sheetList.push(reader.int64());
                                    } else
                                        message.sheetList.push(reader.int64());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SheetNewListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.SheetNewListResp} SheetNewListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SheetNewListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SheetNewListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SheetNewListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.sheetList != null && message.hasOwnProperty("sheetList")) {
                            if (!Array.isArray(message.sheetList))
                                return "sheetList: array expected";
                            for (let i = 0; i < message.sheetList.length; ++i)
                                if (!$util.isInteger(message.sheetList[i]) && !(message.sheetList[i] && $util.isInteger(message.sheetList[i].low) && $util.isInteger(message.sheetList[i].high)))
                                    return "sheetList: integer|Long[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a SheetNewListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.SheetNewListResp} SheetNewListResp
                     */
                    SheetNewListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.SheetNewListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.SheetNewListResp();
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "SUCCESS":
                        case 0:
                            message.status = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.status = 1;
                            break;
                        }
                        if (object.sheetList) {
                            if (!Array.isArray(object.sheetList))
                                throw TypeError(".kuma.jp.protobuf.web.SheetNewListResp.sheetList: array expected");
                            message.sheetList = [];
                            for (let i = 0; i < object.sheetList.length; ++i)
                                if ($util.Long)
                                    (message.sheetList[i] = $util.Long.fromValue(object.sheetList[i])).unsigned = false;
                                else if (typeof object.sheetList[i] === "string")
                                    message.sheetList[i] = parseInt(object.sheetList[i], 10);
                                else if (typeof object.sheetList[i] === "number")
                                    message.sheetList[i] = object.sheetList[i];
                                else if (typeof object.sheetList[i] === "object")
                                    message.sheetList[i] = new $util.LongBits(object.sheetList[i].low >>> 0, object.sheetList[i].high >>> 0).toNumber();
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a SheetNewListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.SheetNewListResp} message SheetNewListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SheetNewListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.sheetList = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "SUCCESS" : 0;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.kuma.jp.protobuf.web.SheetNewListResp.Status[message.status] === undefined ? message.status : $root.kuma.jp.protobuf.web.SheetNewListResp.Status[message.status] : message.status;
                        if (message.sheetList && message.sheetList.length) {
                            object.sheetList = [];
                            for (let j = 0; j < message.sheetList.length; ++j)
                                if (typeof message.sheetList[j] === "number")
                                    object.sheetList[j] = options.longs === String ? String(message.sheetList[j]) : message.sheetList[j];
                                else
                                    object.sheetList[j] = options.longs === String ? $util.Long.prototype.toString.call(message.sheetList[j]) : options.longs === Number ? new $util.LongBits(message.sheetList[j].low >>> 0, message.sheetList[j].high >>> 0).toNumber() : message.sheetList[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this SheetNewListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SheetNewListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SheetNewListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.SheetNewListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SheetNewListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.SheetNewListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.SheetNewListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=20209 COMMAND_NO value
                     */
                    SheetNewListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[20209] = "COMMAND_NO"] = 20209;
                        return values;
                    })();

                    /**
                     * Status enum.
                     * @name kuma.jp.protobuf.web.SheetNewListResp.Status
                     * @enum {number}
                     * @property {number} SUCCESS=0 SUCCESS value
                     * @property {number} FAILED=1 FAILED value
                     */
                    SheetNewListResp.Status = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SUCCESS"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return SheetNewListResp;
                })();

                web.TutorialListReq = (function() {

                    /**
                     * Properties of a TutorialListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ITutorialListReq
                     * @property {kuma.jp.protobuf.web.TutorialListReq.Page|null} [page] TutorialListReq page
                     */

                    /**
                     * Constructs a new TutorialListReq.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a TutorialListReq.
                     * @implements ITutorialListReq
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ITutorialListReq=} [properties] Properties to set
                     */
                    function TutorialListReq(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TutorialListReq page.
                     * @member {kuma.jp.protobuf.web.TutorialListReq.Page} page
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @instance
                     */
                    TutorialListReq.prototype.page = 0;

                    /**
                     * Creates a new TutorialListReq instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListReq=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.TutorialListReq} TutorialListReq instance
                     */
                    TutorialListReq.create = function create(properties) {
                        return new TutorialListReq(properties);
                    };

                    /**
                     * Encodes the specified TutorialListReq message. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListReq.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListReq} message TutorialListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TutorialListReq.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.page);
                        return writer;
                    };

                    /**
                     * Encodes the specified TutorialListReq message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListReq.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListReq} message TutorialListReq message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TutorialListReq.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TutorialListReq message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.TutorialListReq} TutorialListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TutorialListReq.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.TutorialListReq();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.page = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TutorialListReq message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.TutorialListReq} TutorialListReq
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TutorialListReq.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TutorialListReq message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TutorialListReq.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.page != null && message.hasOwnProperty("page"))
                            switch (message.page) {
                            default:
                                return "page: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a TutorialListReq message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.TutorialListReq} TutorialListReq
                     */
                    TutorialListReq.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.TutorialListReq)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.TutorialListReq();
                        switch (object.page) {
                        default:
                            if (typeof object.page === "number") {
                                message.page = object.page;
                                break;
                            }
                            break;
                        case "SITE":
                        case 0:
                            message.page = 0;
                            break;
                        case "HOME":
                        case 1:
                            message.page = 1;
                            break;
                        case "PURIDL":
                        case 2:
                            message.page = 2;
                            break;
                        case "ALBUM":
                        case 3:
                            message.page = 3;
                            break;
                        case "DIGITAL_PASS":
                        case 4:
                            message.page = 4;
                            break;
                        case "SETTING":
                        case 5:
                            message.page = 5;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TutorialListReq message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {kuma.jp.protobuf.web.TutorialListReq} message TutorialListReq
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TutorialListReq.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.page = options.enums === String ? "SITE" : 0;
                        if (message.page != null && message.hasOwnProperty("page"))
                            object.page = options.enums === String ? $root.kuma.jp.protobuf.web.TutorialListReq.Page[message.page] === undefined ? message.page : $root.kuma.jp.protobuf.web.TutorialListReq.Page[message.page] : message.page;
                        return object;
                    };

                    /**
                     * Converts this TutorialListReq to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TutorialListReq.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TutorialListReq
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.TutorialListReq
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TutorialListReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.TutorialListReq";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.TutorialListReq.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=60000 COMMAND_NO value
                     */
                    TutorialListReq.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[60000] = "COMMAND_NO"] = 60000;
                        return values;
                    })();

                    /**
                     * Page enum.
                     * @name kuma.jp.protobuf.web.TutorialListReq.Page
                     * @enum {number}
                     * @property {number} SITE=0 SITE value
                     * @property {number} HOME=1 HOME value
                     * @property {number} PURIDL=2 PURIDL value
                     * @property {number} ALBUM=3 ALBUM value
                     * @property {number} DIGITAL_PASS=4 DIGITAL_PASS value
                     * @property {number} SETTING=5 SETTING value
                     */
                    TutorialListReq.Page = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SITE"] = 0;
                        values[valuesById[1] = "HOME"] = 1;
                        values[valuesById[2] = "PURIDL"] = 2;
                        values[valuesById[3] = "ALBUM"] = 3;
                        values[valuesById[4] = "DIGITAL_PASS"] = 4;
                        values[valuesById[5] = "SETTING"] = 5;
                        return values;
                    })();

                    return TutorialListReq;
                })();

                web.TutorialListResp = (function() {

                    /**
                     * Properties of a TutorialListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @interface ITutorialListResp
                     * @property {string|null} [title] TutorialListResp title
                     * @property {Array.<kuma.jp.protobuf.web.TutorialListResp.ITutorial>|null} [tutorial] TutorialListResp tutorial
                     */

                    /**
                     * Constructs a new TutorialListResp.
                     * @memberof kuma.jp.protobuf.web
                     * @classdesc Represents a TutorialListResp.
                     * @implements ITutorialListResp
                     * @constructor
                     * @param {kuma.jp.protobuf.web.ITutorialListResp=} [properties] Properties to set
                     */
                    function TutorialListResp(properties) {
                        this.tutorial = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TutorialListResp title.
                     * @member {string} title
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @instance
                     */
                    TutorialListResp.prototype.title = "";

                    /**
                     * TutorialListResp tutorial.
                     * @member {Array.<kuma.jp.protobuf.web.TutorialListResp.ITutorial>} tutorial
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @instance
                     */
                    TutorialListResp.prototype.tutorial = $util.emptyArray;

                    /**
                     * Creates a new TutorialListResp instance using the specified properties.
                     * @function create
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListResp=} [properties] Properties to set
                     * @returns {kuma.jp.protobuf.web.TutorialListResp} TutorialListResp instance
                     */
                    TutorialListResp.create = function create(properties) {
                        return new TutorialListResp(properties);
                    };

                    /**
                     * Encodes the specified TutorialListResp message. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListResp.verify|verify} messages.
                     * @function encode
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListResp} message TutorialListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TutorialListResp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
                        if (message.tutorial != null && message.tutorial.length)
                            for (let i = 0; i < message.tutorial.length; ++i)
                                $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial.encode(message.tutorial[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified TutorialListResp message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListResp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.ITutorialListResp} message TutorialListResp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TutorialListResp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TutorialListResp message from the specified reader or buffer.
                     * @function decode
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {kuma.jp.protobuf.web.TutorialListResp} TutorialListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TutorialListResp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.TutorialListResp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.title = reader.string();
                                    break;
                                }
                            case 2: {
                                    if (!(message.tutorial && message.tutorial.length))
                                        message.tutorial = [];
                                    message.tutorial.push($root.kuma.jp.protobuf.web.TutorialListResp.Tutorial.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TutorialListResp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {kuma.jp.protobuf.web.TutorialListResp} TutorialListResp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TutorialListResp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TutorialListResp message.
                     * @function verify
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TutorialListResp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.tutorial != null && message.hasOwnProperty("tutorial")) {
                            if (!Array.isArray(message.tutorial))
                                return "tutorial: array expected";
                            for (let i = 0; i < message.tutorial.length; ++i) {
                                let error = $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial.verify(message.tutorial[i]);
                                if (error)
                                    return "tutorial." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a TutorialListResp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {kuma.jp.protobuf.web.TutorialListResp} TutorialListResp
                     */
                    TutorialListResp.fromObject = function fromObject(object) {
                        if (object instanceof $root.kuma.jp.protobuf.web.TutorialListResp)
                            return object;
                        let message = new $root.kuma.jp.protobuf.web.TutorialListResp();
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.tutorial) {
                            if (!Array.isArray(object.tutorial))
                                throw TypeError(".kuma.jp.protobuf.web.TutorialListResp.tutorial: array expected");
                            message.tutorial = [];
                            for (let i = 0; i < object.tutorial.length; ++i) {
                                if (typeof object.tutorial[i] !== "object")
                                    throw TypeError(".kuma.jp.protobuf.web.TutorialListResp.tutorial: object expected");
                                message.tutorial[i] = $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial.fromObject(object.tutorial[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TutorialListResp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {kuma.jp.protobuf.web.TutorialListResp} message TutorialListResp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TutorialListResp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.tutorial = [];
                        if (options.defaults)
                            object.title = "";
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.tutorial && message.tutorial.length) {
                            object.tutorial = [];
                            for (let j = 0; j < message.tutorial.length; ++j)
                                object.tutorial[j] = $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial.toObject(message.tutorial[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this TutorialListResp to JSON.
                     * @function toJSON
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TutorialListResp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TutorialListResp
                     * @function getTypeUrl
                     * @memberof kuma.jp.protobuf.web.TutorialListResp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TutorialListResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/kuma.jp.protobuf.web.TutorialListResp";
                    };

                    /**
                     * CommandNo enum.
                     * @name kuma.jp.protobuf.web.TutorialListResp.CommandNo
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} COMMAND_NO=60001 COMMAND_NO value
                     */
                    TutorialListResp.CommandNo = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[60001] = "COMMAND_NO"] = 60001;
                        return values;
                    })();

                    TutorialListResp.Tutorial = (function() {

                        /**
                         * Properties of a Tutorial.
                         * @memberof kuma.jp.protobuf.web.TutorialListResp
                         * @interface ITutorial
                         * @property {number|null} [id] Tutorial id
                         * @property {number|null} [seqIdx] Tutorial seqIdx
                         * @property {string|null} [img] Tutorial img
                         */

                        /**
                         * Constructs a new Tutorial.
                         * @memberof kuma.jp.protobuf.web.TutorialListResp
                         * @classdesc Represents a Tutorial.
                         * @implements ITutorial
                         * @constructor
                         * @param {kuma.jp.protobuf.web.TutorialListResp.ITutorial=} [properties] Properties to set
                         */
                        function Tutorial(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Tutorial id.
                         * @member {number} id
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @instance
                         */
                        Tutorial.prototype.id = 0;

                        /**
                         * Tutorial seqIdx.
                         * @member {number} seqIdx
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @instance
                         */
                        Tutorial.prototype.seqIdx = 0;

                        /**
                         * Tutorial img.
                         * @member {string} img
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @instance
                         */
                        Tutorial.prototype.img = "";

                        /**
                         * Creates a new Tutorial instance using the specified properties.
                         * @function create
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.TutorialListResp.ITutorial=} [properties] Properties to set
                         * @returns {kuma.jp.protobuf.web.TutorialListResp.Tutorial} Tutorial instance
                         */
                        Tutorial.create = function create(properties) {
                            return new Tutorial(properties);
                        };

                        /**
                         * Encodes the specified Tutorial message. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListResp.Tutorial.verify|verify} messages.
                         * @function encode
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.TutorialListResp.ITutorial} message Tutorial message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Tutorial.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                            if (message.seqIdx != null && Object.hasOwnProperty.call(message, "seqIdx"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seqIdx);
                            if (message.img != null && Object.hasOwnProperty.call(message, "img"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.img);
                            return writer;
                        };

                        /**
                         * Encodes the specified Tutorial message, length delimited. Does not implicitly {@link kuma.jp.protobuf.web.TutorialListResp.Tutorial.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.TutorialListResp.ITutorial} message Tutorial message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Tutorial.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Tutorial message from the specified reader or buffer.
                         * @function decode
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {kuma.jp.protobuf.web.TutorialListResp.Tutorial} Tutorial
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Tutorial.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.id = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.seqIdx = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.img = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Tutorial message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {kuma.jp.protobuf.web.TutorialListResp.Tutorial} Tutorial
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Tutorial.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Tutorial message.
                         * @function verify
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Tutorial.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isInteger(message.id))
                                    return "id: integer expected";
                            if (message.seqIdx != null && message.hasOwnProperty("seqIdx"))
                                if (!$util.isInteger(message.seqIdx))
                                    return "seqIdx: integer expected";
                            if (message.img != null && message.hasOwnProperty("img"))
                                if (!$util.isString(message.img))
                                    return "img: string expected";
                            return null;
                        };

                        /**
                         * Creates a Tutorial message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {kuma.jp.protobuf.web.TutorialListResp.Tutorial} Tutorial
                         */
                        Tutorial.fromObject = function fromObject(object) {
                            if (object instanceof $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial)
                                return object;
                            let message = new $root.kuma.jp.protobuf.web.TutorialListResp.Tutorial();
                            if (object.id != null)
                                message.id = object.id | 0;
                            if (object.seqIdx != null)
                                message.seqIdx = object.seqIdx | 0;
                            if (object.img != null)
                                message.img = String(object.img);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Tutorial message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {kuma.jp.protobuf.web.TutorialListResp.Tutorial} message Tutorial
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Tutorial.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.id = 0;
                                object.seqIdx = 0;
                                object.img = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.seqIdx != null && message.hasOwnProperty("seqIdx"))
                                object.seqIdx = message.seqIdx;
                            if (message.img != null && message.hasOwnProperty("img"))
                                object.img = message.img;
                            return object;
                        };

                        /**
                         * Converts this Tutorial to JSON.
                         * @function toJSON
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Tutorial.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Tutorial
                         * @function getTypeUrl
                         * @memberof kuma.jp.protobuf.web.TutorialListResp.Tutorial
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Tutorial.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/kuma.jp.protobuf.web.TutorialListResp.Tutorial";
                        };

                        return Tutorial;
                    })();

                    return TutorialListResp;
                })();

                return web;
            })();

            return protobuf;
        })();

        return jp;
    })();

    return kuma;
})();

export { $root as default };
